// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (modules, entry, mainEntry, parcelRequireName, globalName) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        this
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });

      // <script>
    } else if (globalName) {
      this[globalName] = mainExports;
    }
  }
})({"hbuyN":[function(require,module,exports) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "btnStyles", ()=>btnStyles);
parcelHelpers.export(exports, "ActionButtonContext", ()=>ActionButtonContext);
parcelHelpers.export(exports, "ActionButton", ()=>_ActionButton);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _centerBaseline = require("./CenterBaseline");
var _react = require("react");
var _icon = require("./Icon");
var _pressScale = require("./pressScale");
var _skeleton = require("./Skeleton");
var _content = require("./Content");
var _utils = require("@react-spectrum/utils");
var _form = require("./Form");
var _useSpectrumContextProps = require("./useSpectrumContextProps");
const btnStyles = function anonymous(props, overrides) {
    let rules = " .";
    let matches = (overrides || '').match(/(?:^|\s)(?:y|z|A|B|_9|_8|h|_5|_4|__A|__c|__d|__a|__b|U|__Q|X|Z|V|W|l|q|r)[^\s]+/g) || [];
    rules += matches.join('');
    let $q = false;
    for (let p of matches)if (/^\s*q/.test(p)) $q = true;
    if (props.isFocusVisible) rules += ' _Lb';
    else rules += ' _La';
    rules += ' da_____z';
    if (props.staticColor === "black") rules += ' db';
    else if (props.staticColor === "white") rules += ' dc';
    else rules += ' dx';
    rules += ' _Nc';
    rules += ' _M-3t1z';
    rules += ' _Zd';
    rules += ' _1c';
    rules += ' _2d';
    rules += ' jbH';
    rules += ' jG';
    rules += ' _c-bc1l9oh';
    rules += ' _c-1uotwbwg';
    rules += ' _c-eo0c6sf';
    rules += ' _c-enzzrge';
    rules += ' _c-enzykdd';
    rules += ' _c-enzwzjc';
    rules += ' _c-enzrfpb';
    rules += ' _ca';
    if (props.size === "XL") {
        rules += ' _dbj';
        rules += ' _di';
    } else if (props.size === "L") {
        rules += ' _dbh';
        rules += ' _dg';
    } else if (props.size === "S") {
        rules += ' _dbd';
        rules += ' _dc';
    } else if (props.size === "XS") {
        rules += ' _dbb';
        rules += ' _da';
    } else {
        rules += ' _dbf';
        rules += ' _de';
    }
    rules += ' _ec';
    rules += ' _f-1x99dlob';
    rules += ' _fa';
    if (props.isDisabled) rules += ' aa_____B';
    else if (props.isSelected) rules += ' aa_____A';
    else rules += ' aa_____x';
    if (props.staticColor === "black") {
        if (props.isDisabled) rules += ' a_____n';
        else if (props.isSelected) rules += ' ac';
        else {
            if (props.isPressed) rules += ' a_____s';
            else if (props.isFocusVisible) rules += ' a_____s';
            else if (props.isHovered) rules += ' a_____s';
            else rules += ' a_____r';
        }
    } else if (props.staticColor === "white") {
        if (props.isDisabled) rules += ' a_____a';
        else if (props.isSelected) rules += ' ab';
        else {
            if (props.isPressed) rules += ' a_____f';
            else if (props.isFocusVisible) rules += ' a_____f';
            else if (props.isHovered) rules += ' a_____f';
            else rules += ' a_____e';
        }
    } else if (props.isDisabled) rules += ' aj';
    else if (props.isSelected) {
        if (props.isEmphasized) rules += ' ac';
        else rules += ' ad';
    } else {
        if (props.isPressed) rules += ' ao';
        else if (props.isFocusVisible) rules += ' ao';
        else if (props.isHovered) rules += ' ao';
        else rules += ' an';
    }
    rules += ' __Da';
    rules += ' k-375toq';
    if (!$q) {
        if (props.size === "XL") rules += ' qn';
        else if (props.size === "L") rules += ' ql';
        else if (props.size === "S") rules += ' qh';
        else if (props.size === "XS") rules += ' qg';
        else rules += ' qj';
    }
    rules += ' _Oa';
    rules += ' _Q-375x7f';
    rules += ' _Ra';
    rules += ' _zb';
    if (props.isSelected) {
        if (props.isDisabled) rules += ' ba_____w';
        else rules += ' ba_____z';
    } else rules += ' ba_____w';
    if (props.staticColor === "black") {
        if (props.isSelected) {
            if (props.isDisabled) {
                if (props.isQuiet) rules += ' ba';
                else rules += ' b_____k';
            } else {
                if (props.isPressed) rules += ' b_____s';
                else if (props.isFocusVisible) rules += ' b_____s';
                else if (props.isHovered) rules += ' b_____s';
                else rules += ' b_____r';
            }
        } else if (props.isPressed) rules += ' b_____l';
        else if (props.isFocusVisible) rules += ' b_____l';
        else if (props.isHovered) rules += ' b_____l';
        else if (props.isQuiet) rules += ' ba';
        else rules += ' b_____k';
    } else if (props.staticColor === "white") {
        if (props.isSelected) {
            if (props.isDisabled) {
                if (props.isQuiet) rules += ' ba';
                else rules += ' b____7';
            } else {
                if (props.isPressed) rules += ' b_____f';
                else if (props.isFocusVisible) rules += ' b_____f';
                else if (props.isHovered) rules += ' b_____f';
                else rules += ' b_____e';
            }
        } else if (props.isPressed) rules += ' b____8';
        else if (props.isFocusVisible) rules += ' b____8';
        else if (props.isHovered) rules += ' b____8';
        else if (props.isQuiet) rules += ' ba';
        else rules += ' b____7';
    } else if (props.isSelected) {
        if (props.isDisabled) {
            if (props.isQuiet) rules += ' ba';
            else rules += ' bg';
        } else if (props.isEmphasized) {
            if (props.isPressed) rules += ' b_____F';
            else if (props.isFocusVisible) rules += ' b_____F';
            else if (props.isHovered) rules += ' b_____F';
            else rules += ' b_____E';
        } else {
            if (props.isPressed) rules += ' bo';
            else if (props.isFocusVisible) rules += ' bo';
            else if (props.isHovered) rules += ' bo';
            else rules += ' bn';
        }
    } else {
        if (props.isPressed) rules += ' bh';
        else if (props.isFocusVisible) rules += ' bh';
        else if (props.isHovered) rules += ' bh';
        else if (props.isQuiet) rules += ' ba';
        else rules += ' bg';
    }
    rules += ' -rwx0fg_e-b';
    rules += ' wf';
    rules += ' C-1dz4pg9a';
    rules += ' CI';
    rules += ' D-1dz4pg9a';
    rules += ' DI';
    rules += ' Ea';
    rules += ' Fa';
    rules += ' _vh';
    rules += ' _wh';
    rules += ' _xh';
    rules += ' _yh';
    rules += ' -oelgqu_A--1dz4pg9a';
    rules += ' -oelgqu_A--177861o';
    rules += ' __R-yksgrp';
    if (props.size === "XL") rules += ' -_375toq_k-n';
    else if (props.size === "L") rules += ' -_375toq_k-l';
    else if (props.size === "S") rules += ' -_375toq_k-h';
    else if (props.size === "XS") rules += ' -_375toq_k-g';
    else rules += ' -_375toq_k-j';
    return rules;
};
const ActionButtonContext = /*#__PURE__*/ (0, _react.createContext)(null);
function ActionButton(props, ref) {
    [props, ref] = (0, _useSpectrumContextProps.useSpectrumContextProps)(props, ref, ActionButtonContext);
    props = (0, _form.useFormProps)(props);
    let domRef = (0, _utils.useFocusableRef)(ref);
    let overlayTriggerState = (0, _react.useContext)((0, _reactAriaComponents.OverlayTriggerStateContext));
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Button), {
        ...props,
        ref: domRef,
        style: (0, _pressScale.pressScale)(domRef, props.UNSAFE_style),
        className: (renderProps)=>(props.UNSAFE_className || '') + btnStyles({
                ...renderProps,
                // Retain hover styles when an overlay is open.
                isHovered: renderProps.isHovered || overlayTriggerState?.isOpen || false,
                staticColor: props.staticColor,
                size: props.size || 'M',
                isQuiet: props.isQuiet
            }, props.styles),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Provider), {
            values: [
                [
                    (0, _skeleton.SkeletonContext),
                    null
                ],
                [
                    (0, _content.TextContext),
                    {
                        styles: " . E-1gogtue F-1gogtue __A-3t1y __vb __wb _ma _pb"
                    }
                ],
                [
                    (0, _icon.IconContext),
                    {
                        render: (0, _centerBaseline.centerBaseline)({
                            slot: 'icon',
                            styles: " . __A-3t1x"
                        }),
                        styles: " . l-1sthc3k k-1sthc3k y-oelgqu _8-3t1x"
                    }
                ]
            ],
            children: typeof props.children === 'string' ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _content.Text), {
                children: props.children
            }) : props.children
        })
    });
}
/**
 * ActionButtons allow users to perform an action.
 * They’re used for similar, task-based options within a workflow, and are ideal for interfaces where buttons aren’t meant to draw a lot of attention.
 */ let _ActionButton = /*#__PURE__*/ (0, _react.forwardRef)(ActionButton);
try {
    // @ts-ignore
    btnStyles.displayName = "btnStyles";
    // @ts-ignore
    btnStyles.__docgenInfo = {
        "description": "",
        "displayName": "btnStyles",
        "props": {
            "isDisabled": {
                "defaultValue": null,
                "description": "Whether the button is disabled.\n@selector [data-disabled]",
                "name": "isDisabled",
                "required": true,
                "type": {
                    "name": "boolean"
                }
            },
            "isFocused": {
                "defaultValue": null,
                "description": "Whether the button is focused, either via a mouse or keyboard.\n@selector [data-focused]",
                "name": "isFocused",
                "required": true,
                "type": {
                    "name": "boolean"
                }
            },
            "isFocusVisible": {
                "defaultValue": null,
                "description": "Whether the button is keyboard focused.\n@selector [data-focus-visible]",
                "name": "isFocusVisible",
                "required": true,
                "type": {
                    "name": "boolean"
                }
            },
            "isHovered": {
                "defaultValue": null,
                "description": "Whether the button is currently hovered with a mouse.\n@selector [data-hovered]",
                "name": "isHovered",
                "required": true,
                "type": {
                    "name": "boolean"
                }
            },
            "isPending": {
                "defaultValue": null,
                "description": "Whether the button is currently in a pending state.\n@selector [data-pending]",
                "name": "isPending",
                "required": true,
                "type": {
                    "name": "boolean"
                }
            },
            "isPressed": {
                "defaultValue": null,
                "description": "Whether the button is currently in a pressed state.\n@selector [data-pressed]",
                "name": "isPressed",
                "required": true,
                "type": {
                    "name": "boolean"
                }
            },
            "isEmphasized": {
                "defaultValue": null,
                "description": "Whether the button should be displayed with an [emphasized style](https://spectrum.adobe.com/page/action-button/#Emphasis).",
                "name": "isEmphasized",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isQuiet": {
                "defaultValue": null,
                "description": "Whether the button should be displayed with a [quiet style](https://spectrum.adobe.com/page/action-button/#Quiet).",
                "name": "isQuiet",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isSelected": {
                "defaultValue": null,
                "description": "Whether the ActionButton should be selected (controlled).",
                "name": "isSelected",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "size": {
                "defaultValue": {
                    value: "'M'"
                },
                "description": "The size of the ActionButton.",
                "name": "size",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"S\""
                        },
                        {
                            "value": "\"M\""
                        },
                        {
                            "value": "\"L\""
                        },
                        {
                            "value": "\"XL\""
                        },
                        {
                            "value": "\"XS\""
                        }
                    ]
                }
            },
            "staticColor": {
                "defaultValue": null,
                "description": "The static color style to apply. Useful when the ActionButton appears over a color background.",
                "name": "staticColor",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"white\""
                        },
                        {
                            "value": "\"black\""
                        }
                    ]
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/ActionButton.tsx#btnStyles"] = {
        docgenInfo: btnStyles.__docgenInfo,
        name: "btnStyles",
        path: "packages/@react-spectrum/s2/src/ActionButton.tsx#btnStyles"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    ActionButtonContext.displayName = "ActionButtonContext";
    // @ts-ignore
    ActionButtonContext.__docgenInfo = {
        "description": "",
        "displayName": "ActionButtonContext",
        "props": {
            "value": {
                "defaultValue": null,
                "description": "",
                "name": "value",
                "required": true,
                "type": {
                    "name": "ContextValue<ActionButtonProps, FocusableRefValue<HTMLButtonElement, HTMLButtonElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/ActionButton.tsx#ActionButtonContext"] = {
        docgenInfo: ActionButtonContext.__docgenInfo,
        name: "ActionButtonContext",
        path: "packages/@react-spectrum/s2/src/ActionButton.tsx#ActionButtonContext"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    _ActionButton.displayName = "_ActionButton";
    // @ts-ignore
    _ActionButton.__docgenInfo = {
        "description": "ActionButtons allow users to perform an action.\nThey\u2019re used for similar, task-based options within a workflow, and are ideal for interfaces where buttons aren\u2019t meant to draw a lot of attention.",
        "displayName": "_ActionButton",
        "props": {
            "autoFocus": {
                "defaultValue": null,
                "description": "Whether the element should receive focus on render.",
                "name": "autoFocus",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "children": {
                "defaultValue": null,
                "description": "The content to display in the ActionButton.",
                "name": "children",
                "required": false,
                "type": {
                    "name": "ReactNode"
                }
            },
            "excludeFromTabOrder": {
                "defaultValue": null,
                "description": "Whether to exclude the element from the sequential tab order. If true,\nthe element will not be focusable via the keyboard by tabbing. This should\nbe avoided except in rare scenarios where an alternative means of accessing\nthe element or its functionality via the keyboard is available.",
                "name": "excludeFromTabOrder",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "form": {
                "defaultValue": null,
                "description": "The `<form>` element to associate the button with.\nThe value of this attribute must be the id of a `<form>` in the same document.",
                "name": "form",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "formAction": {
                "defaultValue": null,
                "description": "The URL that processes the information submitted by the button.\nOverrides the action attribute of the button's form owner.",
                "name": "formAction",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "formEncType": {
                "defaultValue": null,
                "description": "Indicates how to encode the form data that is submitted.",
                "name": "formEncType",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "formMethod": {
                "defaultValue": null,
                "description": "Indicates the HTTP method used to submit the form.",
                "name": "formMethod",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "formNoValidate": {
                "defaultValue": null,
                "description": "Indicates that the form is not to be validated when it is submitted.",
                "name": "formNoValidate",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "formTarget": {
                "defaultValue": null,
                "description": "Overrides the target attribute of the button's form owner.",
                "name": "formTarget",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "isDisabled": {
                "defaultValue": null,
                "description": "Whether the button is disabled.",
                "name": "isDisabled",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isQuiet": {
                "defaultValue": null,
                "description": "Whether the button should be displayed with a [quiet style](https://spectrum.adobe.com/page/action-button/#Quiet).",
                "name": "isQuiet",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "name": {
                "defaultValue": null,
                "description": "Submitted as a pair with the button's value as part of the form data.",
                "name": "name",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "preventFocusOnPress": {
                "defaultValue": null,
                "description": "Whether to prevent focus from moving to the button when pressing it.\n\nCaution, this can make the button inaccessible and should only be used when alternative keyboard interaction is provided,\nsuch as ComboBox's MenuTrigger or a NumberField's increment/decrement control.",
                "name": "preventFocusOnPress",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "size": {
                "defaultValue": {
                    value: "'M'"
                },
                "description": "The size of the ActionButton.",
                "name": "size",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"S\""
                        },
                        {
                            "value": "\"M\""
                        },
                        {
                            "value": "\"L\""
                        },
                        {
                            "value": "\"XL\""
                        },
                        {
                            "value": "\"XS\""
                        }
                    ]
                }
            },
            "staticColor": {
                "defaultValue": null,
                "description": "The static color style to apply. Useful when the ActionButton appears over a color background.",
                "name": "staticColor",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"white\""
                        },
                        {
                            "value": "\"black\""
                        }
                    ]
                }
            },
            "styles": {
                "defaultValue": null,
                "description": "Spectrum-defined styles, returned by the `style()` macro.",
                "name": "styles",
                "required": false,
                "type": {
                    "name": "StylesProp"
                }
            },
            "type": {
                "defaultValue": {
                    value: "'button'"
                },
                "description": "The behavior of the button when used in an HTML form.",
                "name": "type",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"button\""
                        },
                        {
                            "value": "\"submit\""
                        },
                        {
                            "value": "\"reset\""
                        }
                    ]
                }
            },
            "UNSAFE_className": {
                "defaultValue": null,
                "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_className",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_style": {
                "defaultValue": null,
                "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_style",
                "required": false,
                "type": {
                    "name": "CSSProperties"
                }
            },
            "value": {
                "defaultValue": null,
                "description": "The value associated with the button's name when it's submitted with the form data.",
                "name": "value",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "onPress": {
                "defaultValue": null,
                "description": "Handler that is called when the press is released over the target.",
                "name": "onPress",
                "required": false,
                "type": {
                    "name": "(e: PressEvent) => void"
                }
            },
            "onPressChange": {
                "defaultValue": null,
                "description": "Handler that is called when the press state changes.",
                "name": "onPressChange",
                "required": false,
                "type": {
                    "name": "(isPressed: boolean) => void"
                }
            },
            "onPressEnd": {
                "defaultValue": null,
                "description": "Handler that is called when a press interaction ends, either\nover the target or when the pointer leaves the target.",
                "name": "onPressEnd",
                "required": false,
                "type": {
                    "name": "(e: PressEvent) => void"
                }
            },
            "onPressStart": {
                "defaultValue": null,
                "description": "Handler that is called when a press interaction starts.",
                "name": "onPressStart",
                "required": false,
                "type": {
                    "name": "(e: PressEvent) => void"
                }
            },
            "onPressUp": {
                "defaultValue": null,
                "description": "Handler that is called when a press is released over the target, regardless of\nwhether it started on the target or not.",
                "name": "onPressUp",
                "required": false,
                "type": {
                    "name": "(e: PressEvent) => void"
                }
            },
            "key": {
                "defaultValue": null,
                "description": "",
                "name": "key",
                "required": false,
                "type": {
                    "name": "Key"
                }
            },
            "ref": {
                "defaultValue": null,
                "description": "Allows getting a ref to the component instance.\nOnce the component unmounts, React will set `ref.current` to `null`\n(or call the ref with `null` if you passed a callback ref).\n@see {@link https://react.dev/learn/referencing-values-with-refs#refs-and-the-dom React Docs}",
                "name": "ref",
                "required": false,
                "type": {
                    "name": "Ref<FocusableRefValue<HTMLButtonElement, HTMLButtonElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/ActionButton.tsx#_ActionButton"] = {
        docgenInfo: _ActionButton.__docgenInfo,
        name: "_ActionButton",
        path: "packages/@react-spectrum/s2/src/ActionButton.tsx#_ActionButton"
    };
} catch (__react_docgen_typescript_loader_error) {}

},{"0":"0GyZn","1":"dg3ji","2":"k1jyB","3":"4Vq2w","react/jsx-runtime":"2JzhG","react-aria-components":"8nuKL","./CenterBaseline":"hXatv","react":"jEiK2","./Icon":"1OC2a","./pressScale":"6BiUY","./Skeleton":"2hWWB","./Content":"aBWEm","@react-spectrum/utils":"bebxO","./Form":"gJckc","./useSpectrumContextProps":"ileU6","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"0GyZn":[function() {},{}],"dg3ji":[function() {},{}],"k1jyB":[function() {},{}],"4Vq2w":[function() {},{}],"hXatv":[function(require,module,exports) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CenterBaseline", ()=>CenterBaseline);
parcelHelpers.export(exports, "centerBaselineBefore", ()=>centerBaselineBefore);
parcelHelpers.export(exports, "centerBaseline", ()=>centerBaseline);
var _jsxRuntime = require("react/jsx-runtime");
var _runtime = require("../style/runtime");
const styles = " . _Zd _1c";
function CenterBaseline(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        slot: props.slot,
        style: props.style,
        className: (0, _runtime.mergeStyles)(styles, props.styles) + ' ' + centerBaselineBefore,
        children: props.children
    });
}
const centerBaselineBefore = "-_1b6ows1";
function centerBaseline(props = {}) {
    return (icon)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(CenterBaseline, {
            ...props,
            children: icon
        });
}
try {
    // @ts-ignore
    CenterBaseline.displayName = "CenterBaseline";
    // @ts-ignore
    CenterBaseline.__docgenInfo = {
        "description": "",
        "displayName": "CenterBaseline",
        "props": {
            "style": {
                "defaultValue": null,
                "description": "",
                "name": "style",
                "required": false,
                "type": {
                    "name": "CSSProperties"
                }
            },
            "styles": {
                "defaultValue": null,
                "description": "",
                "name": "styles",
                "required": false,
                "type": {
                    "name": "StyleString"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/CenterBaseline.tsx#CenterBaseline"] = {
        docgenInfo: CenterBaseline.__docgenInfo,
        name: "CenterBaseline",
        path: "packages/@react-spectrum/s2/src/CenterBaseline.tsx#CenterBaseline"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    centerBaseline.displayName = "centerBaseline";
    // @ts-ignore
    centerBaseline.__docgenInfo = {
        "description": "",
        "displayName": "centerBaseline",
        "props": {
            "style": {
                "defaultValue": null,
                "description": "",
                "name": "style",
                "required": false,
                "type": {
                    "name": "CSSProperties"
                }
            },
            "styles": {
                "defaultValue": null,
                "description": "",
                "name": "styles",
                "required": false,
                "type": {
                    "name": "StyleString"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/CenterBaseline.tsx#centerBaseline"] = {
        docgenInfo: centerBaseline.__docgenInfo,
        name: "centerBaseline",
        path: "packages/@react-spectrum/s2/src/CenterBaseline.tsx#centerBaseline"
    };
} catch (__react_docgen_typescript_loader_error) {}

},{"0":"4vHOO","1":"40S9S","react/jsx-runtime":"2JzhG","../style/runtime":"dzhKB","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"4vHOO":[function() {},{}],"40S9S":[function() {},{}],"6BiUY":[function(require,module,exports) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "pressScale", ()=>pressScale);
var _reactAriaComponents = require("react-aria-components");
function pressScale(ref, style) {
    return (0, _reactAriaComponents.composeRenderProps)(style, (style, renderProps)=>{
        if (renderProps.isPressed && ref.current) {
            let { width = 0, height = 0 } = ref.current.getBoundingClientRect() ?? {};
            return {
                ...style,
                willChange: `${style?.willChange ?? ''} transform`,
                transform: `${style?.transform ?? ''} perspective(${Math.max(height, width / 3, 24)}px) translate3d(0, 0, -2px)`
            };
        } else return {
            ...style,
            willChange: `${style?.willChange ?? ''} transform`
        };
    });
}

},{"react-aria-components":"8nuKL","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"aBWEm":[function(require,module,exports) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HeadingContext", ()=>HeadingContext);
parcelHelpers.export(exports, "Heading", ()=>_Heading);
parcelHelpers.export(exports, "HeaderContext", ()=>HeaderContext);
parcelHelpers.export(exports, "Header", ()=>_Header);
parcelHelpers.export(exports, "ContentContext", ()=>ContentContext);
parcelHelpers.export(exports, "Content", ()=>_Content);
parcelHelpers.export(exports, "TextContext", ()=>TextContext);
parcelHelpers.export(exports, "Text", ()=>_Text);
parcelHelpers.export(exports, "KeyboardContext", ()=>KeyboardContext);
parcelHelpers.export(exports, "Keyboard", ()=>_Keyboard);
parcelHelpers.export(exports, "FooterContext", ()=>FooterContext);
parcelHelpers.export(exports, "Footer", ()=>_Footer);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _react = require("react");
var _utils = require("@react-spectrum/utils");
var _skeleton = require("./Skeleton");
var _useSpectrumContextProps = require("./useSpectrumContextProps");
const HeadingContext = /*#__PURE__*/ (0, _react.createContext)(null);
// Wrapper around RAC Heading to unmount when hidden.
function Heading(props, ref) {
    [props, ref] = (0, _useSpectrumContextProps.useSpectrumContextProps)(props, ref, HeadingContext);
    let domRef = (0, _utils.useDOMRef)(ref);
    let { UNSAFE_className = '', UNSAFE_style, styles, isHidden, slot, ...otherProps } = props;
    if (isHidden) return null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Heading), {
        ...otherProps,
        ref: domRef,
        className: UNSAFE_className + styles,
        style: UNSAFE_style,
        slot: slot || undefined
    });
}
const _Heading = /*#__PURE__*/ (0, _react.forwardRef)(Heading);
const HeaderContext = /*#__PURE__*/ (0, _react.createContext)(null);
function Header(props, ref) {
    [props, ref] = (0, _useSpectrumContextProps.useSpectrumContextProps)(props, ref, HeaderContext);
    let domRef = (0, _utils.useDOMRef)(ref);
    let { UNSAFE_className = '', UNSAFE_style, styles, isHidden, slot, ...otherProps } = props;
    if (isHidden) return null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Header), {
        ...otherProps,
        ref: domRef,
        className: UNSAFE_className + styles,
        style: UNSAFE_style,
        slot: slot || undefined
    });
}
const _Header = /*#__PURE__*/ (0, _react.forwardRef)(Header);
const ContentContext = /*#__PURE__*/ (0, _react.createContext)(null);
function Content(props, ref) {
    [props, ref] = (0, _useSpectrumContextProps.useSpectrumContextProps)(props, ref, ContentContext);
    let domRef = (0, _utils.useDOMRef)(ref);
    let { UNSAFE_className = '', UNSAFE_style, styles, isHidden, slot, ...otherProps } = props;
    if (isHidden) return null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        ...otherProps,
        ref: domRef,
        className: UNSAFE_className + styles,
        style: UNSAFE_style,
        slot: slot || undefined
    });
}
const _Content = /*#__PURE__*/ (0, _react.forwardRef)(Content);
const TextContext = /*#__PURE__*/ (0, _react.createContext)(null);
function Text(props, ref) {
    [props, ref] = (0, _useSpectrumContextProps.useSpectrumContextProps)(props, ref, TextContext);
    let domRef = (0, _utils.useDOMRef)(ref);
    let { UNSAFE_className = '', UNSAFE_style, styles, isHidden, slot, children, ...otherProps } = props;
    let racContext = (0, _react.useContext)((0, _reactAriaComponents.TextContext));
    let isSkeleton = (0, _skeleton.useIsSkeleton)();
    [children, UNSAFE_style] = (0, _skeleton.useSkeletonText)(children, UNSAFE_style);
    if (isHidden) return null;
    slot = slot && racContext && 'slots' in racContext && !racContext.slots?.[slot] ? undefined : slot;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Text), {
        ...otherProps,
        ref: domRef,
        // @ts-ignore - compatibility with React < 19
        inert: isSkeleton ? 'true' : undefined,
        className: UNSAFE_className + styles,
        style: UNSAFE_style,
        slot: slot || undefined,
        children: children
    });
}
const _Text = /*#__PURE__*/ (0, _react.forwardRef)(Text);
const KeyboardContext = /*#__PURE__*/ (0, _react.createContext)({});
function Keyboard(props, ref) {
    [props, ref] = (0, _useSpectrumContextProps.useSpectrumContextProps)(props, ref, KeyboardContext);
    let domRef = (0, _utils.useDOMRef)(ref);
    let { UNSAFE_className = '', UNSAFE_style, styles, isHidden, slot, ...otherProps } = props;
    if (isHidden) return null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Keyboard), {
        ...otherProps,
        ref: domRef,
        className: UNSAFE_className + styles,
        style: UNSAFE_style,
        slot: slot || undefined
    });
}
const _Keyboard = /*#__PURE__*/ (0, _react.forwardRef)(Keyboard);
const FooterContext = /*#__PURE__*/ (0, _react.createContext)({});
function Footer(props, ref) {
    [props, ref] = (0, _useSpectrumContextProps.useSpectrumContextProps)(props, ref, FooterContext);
    let domRef = (0, _utils.useDOMRef)(ref);
    let { UNSAFE_className = '', UNSAFE_style, styles, isHidden, slot, ...otherProps } = props;
    if (isHidden) return null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("footer", {
        ...otherProps,
        ref: domRef,
        className: UNSAFE_className + styles,
        style: UNSAFE_style,
        slot: slot || undefined
    });
}
const _Footer = /*#__PURE__*/ (0, _react.forwardRef)(Footer);
try {
    // @ts-ignore
    HeadingContext.displayName = "HeadingContext";
    // @ts-ignore
    HeadingContext.__docgenInfo = {
        "description": "",
        "displayName": "HeadingContext",
        "props": {
            "value": {
                "defaultValue": null,
                "description": "",
                "name": "value",
                "required": true,
                "type": {
                    "name": "ContextValue<HeadingProps, DOMRefValue<HTMLHeadingElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/Content.tsx#HeadingContext"] = {
        docgenInfo: HeadingContext.__docgenInfo,
        name: "HeadingContext",
        path: "packages/@react-spectrum/s2/src/Content.tsx#HeadingContext"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    _Heading.displayName = "_Heading";
    // @ts-ignore
    _Heading.__docgenInfo = {
        "description": "",
        "displayName": "_Heading",
        "props": {
            "isHidden": {
                "defaultValue": null,
                "description": "",
                "name": "isHidden",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "level": {
                "defaultValue": null,
                "description": "",
                "name": "level",
                "required": false,
                "type": {
                    "name": "number"
                }
            },
            "styles": {
                "defaultValue": null,
                "description": "",
                "name": "styles",
                "required": false,
                "type": {
                    "name": "StyleString"
                }
            },
            "UNSAFE_className": {
                "defaultValue": null,
                "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_className",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_style": {
                "defaultValue": null,
                "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_style",
                "required": false,
                "type": {
                    "name": "CSSProperties"
                }
            },
            "key": {
                "defaultValue": null,
                "description": "",
                "name": "key",
                "required": false,
                "type": {
                    "name": "Key"
                }
            },
            "ref": {
                "defaultValue": null,
                "description": "Allows getting a ref to the component instance.\nOnce the component unmounts, React will set `ref.current` to `null`\n(or call the ref with `null` if you passed a callback ref).\n@see {@link https://react.dev/learn/referencing-values-with-refs#refs-and-the-dom React Docs}",
                "name": "ref",
                "required": false,
                "type": {
                    "name": "Ref<DOMRefValue<HTMLHeadingElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/Content.tsx#_Heading"] = {
        docgenInfo: _Heading.__docgenInfo,
        name: "_Heading",
        path: "packages/@react-spectrum/s2/src/Content.tsx#_Heading"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    HeaderContext.displayName = "HeaderContext";
    // @ts-ignore
    HeaderContext.__docgenInfo = {
        "description": "",
        "displayName": "HeaderContext",
        "props": {
            "value": {
                "defaultValue": null,
                "description": "",
                "name": "value",
                "required": true,
                "type": {
                    "name": "ContextValue<ContentProps, DOMRefValue<HTMLElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/Content.tsx#HeaderContext"] = {
        docgenInfo: HeaderContext.__docgenInfo,
        name: "HeaderContext",
        path: "packages/@react-spectrum/s2/src/Content.tsx#HeaderContext"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    _Header.displayName = "_Header";
    // @ts-ignore
    _Header.__docgenInfo = {
        "description": "",
        "displayName": "_Header",
        "props": {
            "isHidden": {
                "defaultValue": null,
                "description": "",
                "name": "isHidden",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "styles": {
                "defaultValue": null,
                "description": "",
                "name": "styles",
                "required": false,
                "type": {
                    "name": "StyleString"
                }
            },
            "UNSAFE_className": {
                "defaultValue": null,
                "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_className",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_style": {
                "defaultValue": null,
                "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_style",
                "required": false,
                "type": {
                    "name": "CSSProperties"
                }
            },
            "key": {
                "defaultValue": null,
                "description": "",
                "name": "key",
                "required": false,
                "type": {
                    "name": "Key"
                }
            },
            "ref": {
                "defaultValue": null,
                "description": "Allows getting a ref to the component instance.\nOnce the component unmounts, React will set `ref.current` to `null`\n(or call the ref with `null` if you passed a callback ref).\n@see {@link https://react.dev/learn/referencing-values-with-refs#refs-and-the-dom React Docs}",
                "name": "ref",
                "required": false,
                "type": {
                    "name": "Ref<DOMRefValue<HTMLElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/Content.tsx#_Header"] = {
        docgenInfo: _Header.__docgenInfo,
        name: "_Header",
        path: "packages/@react-spectrum/s2/src/Content.tsx#_Header"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    ContentContext.displayName = "ContentContext";
    // @ts-ignore
    ContentContext.__docgenInfo = {
        "description": "",
        "displayName": "ContentContext",
        "props": {
            "value": {
                "defaultValue": null,
                "description": "",
                "name": "value",
                "required": true,
                "type": {
                    "name": "ContextValue<ContentProps, DOMRefValue<HTMLDivElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/Content.tsx#ContentContext"] = {
        docgenInfo: ContentContext.__docgenInfo,
        name: "ContentContext",
        path: "packages/@react-spectrum/s2/src/Content.tsx#ContentContext"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    _Content.displayName = "_Content";
    // @ts-ignore
    _Content.__docgenInfo = {
        "description": "",
        "displayName": "_Content",
        "props": {
            "isHidden": {
                "defaultValue": null,
                "description": "",
                "name": "isHidden",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "styles": {
                "defaultValue": null,
                "description": "",
                "name": "styles",
                "required": false,
                "type": {
                    "name": "StyleString"
                }
            },
            "UNSAFE_className": {
                "defaultValue": null,
                "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_className",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_style": {
                "defaultValue": null,
                "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_style",
                "required": false,
                "type": {
                    "name": "CSSProperties"
                }
            },
            "key": {
                "defaultValue": null,
                "description": "",
                "name": "key",
                "required": false,
                "type": {
                    "name": "Key"
                }
            },
            "ref": {
                "defaultValue": null,
                "description": "Allows getting a ref to the component instance.\nOnce the component unmounts, React will set `ref.current` to `null`\n(or call the ref with `null` if you passed a callback ref).\n@see {@link https://react.dev/learn/referencing-values-with-refs#refs-and-the-dom React Docs}",
                "name": "ref",
                "required": false,
                "type": {
                    "name": "Ref<DOMRefValue<HTMLDivElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/Content.tsx#_Content"] = {
        docgenInfo: _Content.__docgenInfo,
        name: "_Content",
        path: "packages/@react-spectrum/s2/src/Content.tsx#_Content"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    TextContext.displayName = "TextContext";
    // @ts-ignore
    TextContext.__docgenInfo = {
        "description": "",
        "displayName": "TextContext",
        "props": {
            "value": {
                "defaultValue": null,
                "description": "",
                "name": "value",
                "required": true,
                "type": {
                    "name": "ContextValue<ContentProps, DOMRefValue<HTMLElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/Content.tsx#TextContext"] = {
        docgenInfo: TextContext.__docgenInfo,
        name: "TextContext",
        path: "packages/@react-spectrum/s2/src/Content.tsx#TextContext"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    _Text.displayName = "_Text";
    // @ts-ignore
    _Text.__docgenInfo = {
        "description": "",
        "displayName": "_Text",
        "props": {
            "isHidden": {
                "defaultValue": null,
                "description": "",
                "name": "isHidden",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "styles": {
                "defaultValue": null,
                "description": "",
                "name": "styles",
                "required": false,
                "type": {
                    "name": "StyleString"
                }
            },
            "UNSAFE_className": {
                "defaultValue": null,
                "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_className",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_style": {
                "defaultValue": null,
                "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_style",
                "required": false,
                "type": {
                    "name": "CSSProperties"
                }
            },
            "key": {
                "defaultValue": null,
                "description": "",
                "name": "key",
                "required": false,
                "type": {
                    "name": "Key"
                }
            },
            "ref": {
                "defaultValue": null,
                "description": "Allows getting a ref to the component instance.\nOnce the component unmounts, React will set `ref.current` to `null`\n(or call the ref with `null` if you passed a callback ref).\n@see {@link https://react.dev/learn/referencing-values-with-refs#refs-and-the-dom React Docs}",
                "name": "ref",
                "required": false,
                "type": {
                    "name": "Ref<DOMRefValue<HTMLElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/Content.tsx#_Text"] = {
        docgenInfo: _Text.__docgenInfo,
        name: "_Text",
        path: "packages/@react-spectrum/s2/src/Content.tsx#_Text"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    KeyboardContext.displayName = "KeyboardContext";
    // @ts-ignore
    KeyboardContext.__docgenInfo = {
        "description": "",
        "displayName": "KeyboardContext",
        "props": {
            "value": {
                "defaultValue": null,
                "description": "",
                "name": "value",
                "required": true,
                "type": {
                    "name": "ContextValue<ContentProps, DOMRefValue<HTMLElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/Content.tsx#KeyboardContext"] = {
        docgenInfo: KeyboardContext.__docgenInfo,
        name: "KeyboardContext",
        path: "packages/@react-spectrum/s2/src/Content.tsx#KeyboardContext"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    _Keyboard.displayName = "_Keyboard";
    // @ts-ignore
    _Keyboard.__docgenInfo = {
        "description": "",
        "displayName": "_Keyboard",
        "props": {
            "isHidden": {
                "defaultValue": null,
                "description": "",
                "name": "isHidden",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "styles": {
                "defaultValue": null,
                "description": "",
                "name": "styles",
                "required": false,
                "type": {
                    "name": "StyleString"
                }
            },
            "UNSAFE_className": {
                "defaultValue": null,
                "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_className",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_style": {
                "defaultValue": null,
                "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_style",
                "required": false,
                "type": {
                    "name": "CSSProperties"
                }
            },
            "key": {
                "defaultValue": null,
                "description": "",
                "name": "key",
                "required": false,
                "type": {
                    "name": "Key"
                }
            },
            "ref": {
                "defaultValue": null,
                "description": "Allows getting a ref to the component instance.\nOnce the component unmounts, React will set `ref.current` to `null`\n(or call the ref with `null` if you passed a callback ref).\n@see {@link https://react.dev/learn/referencing-values-with-refs#refs-and-the-dom React Docs}",
                "name": "ref",
                "required": false,
                "type": {
                    "name": "Ref<DOMRefValue<HTMLElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/Content.tsx#_Keyboard"] = {
        docgenInfo: _Keyboard.__docgenInfo,
        name: "_Keyboard",
        path: "packages/@react-spectrum/s2/src/Content.tsx#_Keyboard"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    FooterContext.displayName = "FooterContext";
    // @ts-ignore
    FooterContext.__docgenInfo = {
        "description": "",
        "displayName": "FooterContext",
        "props": {
            "value": {
                "defaultValue": null,
                "description": "",
                "name": "value",
                "required": true,
                "type": {
                    "name": "ContextValue<ContentProps, DOMRefValue<HTMLElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/Content.tsx#FooterContext"] = {
        docgenInfo: FooterContext.__docgenInfo,
        name: "FooterContext",
        path: "packages/@react-spectrum/s2/src/Content.tsx#FooterContext"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    _Footer.displayName = "_Footer";
    // @ts-ignore
    _Footer.__docgenInfo = {
        "description": "",
        "displayName": "_Footer",
        "props": {
            "isHidden": {
                "defaultValue": null,
                "description": "",
                "name": "isHidden",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "styles": {
                "defaultValue": null,
                "description": "",
                "name": "styles",
                "required": false,
                "type": {
                    "name": "StyleString"
                }
            },
            "UNSAFE_className": {
                "defaultValue": null,
                "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_className",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_style": {
                "defaultValue": null,
                "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_style",
                "required": false,
                "type": {
                    "name": "CSSProperties"
                }
            },
            "key": {
                "defaultValue": null,
                "description": "",
                "name": "key",
                "required": false,
                "type": {
                    "name": "Key"
                }
            },
            "ref": {
                "defaultValue": null,
                "description": "Allows getting a ref to the component instance.\nOnce the component unmounts, React will set `ref.current` to `null`\n(or call the ref with `null` if you passed a callback ref).\n@see {@link https://react.dev/learn/referencing-values-with-refs#refs-and-the-dom React Docs}",
                "name": "ref",
                "required": false,
                "type": {
                    "name": "Ref<DOMRefValue<HTMLElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/Content.tsx#_Footer"] = {
        docgenInfo: _Footer.__docgenInfo,
        name: "_Footer",
        path: "packages/@react-spectrum/s2/src/Content.tsx#_Footer"
    };
} catch (__react_docgen_typescript_loader_error) {}

},{"react/jsx-runtime":"2JzhG","react-aria-components":"8nuKL","react":"jEiK2","@react-spectrum/utils":"bebxO","./Skeleton":"2hWWB","./useSpectrumContextProps":"ileU6","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"gJckc":[function(require,module,exports) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FormContext", ()=>FormContext);
parcelHelpers.export(exports, "useFormProps", ()=>useFormProps);
parcelHelpers.export(exports, "Form", ()=>_Form);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactAriaComponents = require("react-aria-components");
var _utils = require("@react-spectrum/utils");
var _skeleton = require("./Skeleton");
const FormContext = /*#__PURE__*/ (0, _react.createContext)(null);
function useFormProps(props) {
    let ctx = (0, _react.useContext)(FormContext);
    let isSkeleton = (0, _skeleton.useIsSkeleton)();
    return (0, _react.useMemo)(()=>{
        let result = props;
        if (ctx || isSkeleton) result = {
            ...props
        };
        if (ctx) {
            // This is a subset of mergeProps. We just need to merge non-undefined values.
            for(let key in ctx)if (result[key] === undefined) result[key] = ctx[key];
        }
        // Skeleton always wins over local props.
        if (isSkeleton) result.isDisabled = true;
        return result;
    }, [
        ctx,
        props,
        isSkeleton
    ]);
}
function Form(props, ref) {
    let { labelPosition = 'top', labelAlign, necessityIndicator, isRequired, isDisabled, isEmphasized, size = 'M', ...formProps } = props;
    let domRef = (0, _utils.useDOMRef)(ref);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Form), {
        ...formProps,
        ref: domRef,
        style: props.UNSAFE_style,
        className: (props.UNSAFE_className || '') + function anonymous(props, overrides) {
            let rules = " .";
            let matches = (overrides || '').match(/(?:^|\s)(?:y|z|A|B|_9|_8|h|_5|_4|__A|__c|__d|__a|__b|U|__Q|X|Z|V|W|l|q|r)[^\s]+/g) || [];
            rules += matches.join('');
            rules += ' _Zf';
            if (props.labelPosition === "side") rules += ' __h-hgmn7f';
            else if (props.labelPosition === "top") rules += ' __h-nvqmqy';
            if (props.size === "XL") rules += ' il';
            else if (props.size === "L") rules += ' ij';
            else if (props.size === "M") rules += ' ih';
            else if (props.size === "S") rules += ' ig';
            else if (props.size === "XS") rules += ' if';
            rules += ' jF';
            return rules;
        }({
            labelPosition,
            size
        }, props.styles),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(FormContext.Provider, {
            value: {
                labelPosition,
                labelAlign,
                necessityIndicator,
                isRequired,
                isDisabled,
                isEmphasized,
                size
            },
            children: props.children
        })
    });
}
/**
 * Forms allow users to enter data that can be submitted while providing alignment and styling for form fields.
 */ let _Form = /*#__PURE__*/ (0, _react.forwardRef)(Form);
try {
    // @ts-ignore
    useFormProps.displayName = "useFormProps";
    // @ts-ignore
    useFormProps.__docgenInfo = {
        "description": "",
        "displayName": "useFormProps",
        "props": {
            "isDisabled": {
                "defaultValue": null,
                "description": "Whether the Form elements are disabled.",
                "name": "isDisabled",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isEmphasized": {
                "defaultValue": null,
                "description": "Whether the Form elements are rendered with their emphasized style.",
                "name": "isEmphasized",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isRequired": {
                "defaultValue": null,
                "description": "Whether the label is labeling a required field or group.",
                "name": "isRequired",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "labelAlign": {
                "defaultValue": {
                    value: "'start'"
                },
                "description": "The label's horizontal alignment relative to the element it is labeling.",
                "name": "labelAlign",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"end\""
                        },
                        {
                            "value": "\"start\""
                        }
                    ]
                }
            },
            "labelPosition": {
                "defaultValue": {
                    value: "'top'"
                },
                "description": "The label's overall position relative to the element it is labeling.",
                "name": "labelPosition",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"top\""
                        },
                        {
                            "value": "\"side\""
                        }
                    ]
                }
            },
            "necessityIndicator": {
                "defaultValue": {
                    value: "'icon'"
                },
                "description": "Whether the required state should be shown as an icon or text.",
                "name": "necessityIndicator",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"label\""
                        },
                        {
                            "value": "\"icon\""
                        }
                    ]
                }
            },
            "size": {
                "defaultValue": {
                    value: "'M'"
                },
                "description": "Size of the Form elements.",
                "name": "size",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"S\""
                        },
                        {
                            "value": "\"M\""
                        },
                        {
                            "value": "\"L\""
                        },
                        {
                            "value": "\"XL\""
                        }
                    ]
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/Form.tsx#useFormProps"] = {
        docgenInfo: useFormProps.__docgenInfo,
        name: "useFormProps",
        path: "packages/@react-spectrum/s2/src/Form.tsx#useFormProps"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    FormContext.displayName = "FormContext";
    // @ts-ignore
    FormContext.__docgenInfo = {
        "description": "",
        "displayName": "FormContext",
        "props": {
            "value": {
                "defaultValue": null,
                "description": "",
                "name": "value",
                "required": true,
                "type": {
                    "name": "FormStyleProps"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/Form.tsx#FormContext"] = {
        docgenInfo: FormContext.__docgenInfo,
        name: "FormContext",
        path: "packages/@react-spectrum/s2/src/Form.tsx#FormContext"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    _Form.displayName = "_Form";
    // @ts-ignore
    _Form.__docgenInfo = {
        "description": "Forms allow users to enter data that can be submitted while providing alignment and styling for form fields.",
        "displayName": "_Form",
        "props": {
            "action": {
                "defaultValue": null,
                "description": "Where to send the form-data when the form is submitted.\nSee [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/form#action).",
                "name": "action",
                "required": false,
                "type": {
                    "name": "string | ((formData: FormData) => void)"
                }
            },
            "autoCapitalize": {
                "defaultValue": null,
                "description": "Controls whether inputted text is automatically capitalized and, if so, in what manner. \nSee [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/autocapitalize).",
                "name": "autoCapitalize",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"none\""
                        },
                        {
                            "value": "\"off\""
                        },
                        {
                            "value": "\"on\""
                        },
                        {
                            "value": "\"sentences\""
                        },
                        {
                            "value": "\"words\""
                        },
                        {
                            "value": "\"characters\""
                        }
                    ]
                }
            },
            "autoComplete": {
                "defaultValue": null,
                "description": "Indicates whether input elements can by default have their values automatically completed by the browser.\nSee [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/form#autocomplete).",
                "name": "autoComplete",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"off\""
                        },
                        {
                            "value": "\"on\""
                        }
                    ]
                }
            },
            "encType": {
                "defaultValue": null,
                "description": "The enctype attribute specifies how the form-data should be encoded when submitting it to the server.\nSee [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/form#enctype).",
                "name": "encType",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"application/x-www-form-urlencoded\""
                        },
                        {
                            "value": "\"multipart/form-data\""
                        },
                        {
                            "value": "\"text/plain\""
                        }
                    ]
                }
            },
            "isDisabled": {
                "defaultValue": null,
                "description": "Whether the Form elements are disabled.",
                "name": "isDisabled",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isEmphasized": {
                "defaultValue": null,
                "description": "Whether the Form elements are rendered with their emphasized style.",
                "name": "isEmphasized",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isRequired": {
                "defaultValue": null,
                "description": "Whether the label is labeling a required field or group.",
                "name": "isRequired",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "labelAlign": {
                "defaultValue": {
                    value: "'start'"
                },
                "description": "The label's horizontal alignment relative to the element it is labeling.",
                "name": "labelAlign",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"end\""
                        },
                        {
                            "value": "\"start\""
                        }
                    ]
                }
            },
            "labelPosition": {
                "defaultValue": {
                    value: "'top'"
                },
                "description": "The label's overall position relative to the element it is labeling.",
                "name": "labelPosition",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"top\""
                        },
                        {
                            "value": "\"side\""
                        }
                    ]
                }
            },
            "method": {
                "defaultValue": null,
                "description": "The HTTP method to submit the form with.\nSee [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/form#method).",
                "name": "method",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"dialog\""
                        },
                        {
                            "value": "\"get\""
                        },
                        {
                            "value": "\"post\""
                        }
                    ]
                }
            },
            "necessityIndicator": {
                "defaultValue": {
                    value: "'icon'"
                },
                "description": "Whether the required state should be shown as an icon or text.",
                "name": "necessityIndicator",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"label\""
                        },
                        {
                            "value": "\"icon\""
                        }
                    ]
                }
            },
            "role": {
                "defaultValue": null,
                "description": "An ARIA role override to apply to the form element.",
                "name": "role",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"presentation\""
                        },
                        {
                            "value": "\"search\""
                        }
                    ]
                }
            },
            "size": {
                "defaultValue": {
                    value: "'M'"
                },
                "description": "Size of the Form elements.",
                "name": "size",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"S\""
                        },
                        {
                            "value": "\"M\""
                        },
                        {
                            "value": "\"L\""
                        },
                        {
                            "value": "\"XL\""
                        }
                    ]
                }
            },
            "styles": {
                "defaultValue": null,
                "description": "Spectrum-defined styles, returned by the `style()` macro.",
                "name": "styles",
                "required": false,
                "type": {
                    "name": "StylesProp"
                }
            },
            "target": {
                "defaultValue": null,
                "description": "The target attribute specifies a name or a keyword that indicates where to display the response that is received after submitting the form.\nSee [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/form#target).",
                "name": "target",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"_self\""
                        },
                        {
                            "value": "\"_blank\""
                        },
                        {
                            "value": "\"_parent\""
                        },
                        {
                            "value": "\"_top\""
                        }
                    ]
                }
            },
            "UNSAFE_className": {
                "defaultValue": null,
                "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_className",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_style": {
                "defaultValue": null,
                "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_style",
                "required": false,
                "type": {
                    "name": "CSSProperties"
                }
            },
            "validationBehavior": {
                "defaultValue": {
                    value: "'native'"
                },
                "description": "Whether to use native HTML form validation to prevent form submission\nwhen a field value is missing or invalid, or mark fields as required\nor invalid via ARIA.",
                "name": "validationBehavior",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"native\""
                        },
                        {
                            "value": "\"aria\""
                        }
                    ]
                }
            },
            "validationErrors": {
                "defaultValue": null,
                "description": "Validation errors for the form, typically returned by a server.\nThis should be set to an object mapping from input names to errors.",
                "name": "validationErrors",
                "required": false,
                "type": {
                    "name": "ValidationErrors"
                }
            },
            "onInvalid": {
                "defaultValue": null,
                "description": "Triggered for each invalid field when a user submits the form.",
                "name": "onInvalid",
                "required": false,
                "type": {
                    "name": "(event: FormEvent<HTMLFormElement>) => void"
                }
            },
            "onReset": {
                "defaultValue": null,
                "description": "Triggered when a user resets the form.",
                "name": "onReset",
                "required": false,
                "type": {
                    "name": "(event: FormEvent<HTMLFormElement>) => void"
                }
            },
            "onSubmit": {
                "defaultValue": null,
                "description": "Triggered when a user submits the form.",
                "name": "onSubmit",
                "required": false,
                "type": {
                    "name": "(event: FormEvent<HTMLFormElement>) => void"
                }
            },
            "key": {
                "defaultValue": null,
                "description": "",
                "name": "key",
                "required": false,
                "type": {
                    "name": "Key"
                }
            },
            "ref": {
                "defaultValue": null,
                "description": "Allows getting a ref to the component instance.\nOnce the component unmounts, React will set `ref.current` to `null`\n(or call the ref with `null` if you passed a callback ref).\n@see {@link https://react.dev/learn/referencing-values-with-refs#refs-and-the-dom React Docs}",
                "name": "ref",
                "required": false,
                "type": {
                    "name": "Ref<DOMRefValue<HTMLFormElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/Form.tsx#_Form"] = {
        docgenInfo: _Form.__docgenInfo,
        name: "_Form",
        path: "packages/@react-spectrum/s2/src/Form.tsx#_Form"
    };
} catch (__react_docgen_typescript_loader_error) {}

},{"0":"llOt3","react/jsx-runtime":"2JzhG","react":"jEiK2","react-aria-components":"8nuKL","@react-spectrum/utils":"bebxO","./Skeleton":"2hWWB","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"llOt3":[function() {},{}],"iU6xz":[function(require,module,exports) {
const _temp0 = require("58bfc50b39003baf");
const _temp1 = require("4259320a0928e7ce");
const _temp2 = require("5156c0052f206613");
const _temp3 = require("1baaaf4759bff7a8");
const _temp4 = require("f9c01177a70c77b4");
const _temp5 = require("2f3018c584449f67");
const _temp6 = require("8bef325a9fa1e51d");
const _temp7 = require("e20e3821216afb3a");
const _temp8 = require("46be7a57e480d4a8");
const _temp9 = require("daf60680d7e81230");
const _temp10 = require("ec9647e64b360b50");
const _temp11 = require("d190c83c90c6c10a");
const _temp12 = require("a926bfcc29332994");
const _temp13 = require("e68260382a457735");
const _temp14 = require("4e6868ad523badd");
const _temp15 = require("e3731779c504405d");
const _temp16 = require("fd0a5af7e0a33f6f");
const _temp17 = require("289ef70fdf024c59");
const _temp18 = require("af7e19ed8050b6b4");
const _temp19 = require("7aff5e58534b0b23");
const _temp20 = require("9ef2869a4645d579");
const _temp21 = require("5ebd9be8bf3e8c7");
const _temp22 = require("4f372669c5f88764");
const _temp23 = require("3747d5d46eb1bd96");
const _temp24 = require("ac0c1443caf5629a");
const _temp25 = require("65734a6426d5c449");
const _temp26 = require("588c44a59446f286");
const _temp27 = require("37d21c4e67d40a7b");
const _temp28 = require("9edad6470848b70a");
const _temp29 = require("4e739478518b975c");
const _temp30 = require("1835ee9dae76b43c");
const _temp31 = require("36b0c2388b98c639");
const _temp32 = require("35da9474c5046d59");
const _temp33 = require("443bfc188a4a2bd8");
module.exports = {
    "ar-AE": _temp0,
    "bg-BG": _temp1,
    "cs-CZ": _temp2,
    "da-DK": _temp3,
    "de-DE": _temp4,
    "el-GR": _temp5,
    "en-US": _temp6,
    "es-ES": _temp7,
    "et-EE": _temp8,
    "fi-FI": _temp9,
    "fr-FR": _temp10,
    "he-IL": _temp11,
    "hr-HR": _temp12,
    "hu-HU": _temp13,
    "it-IT": _temp14,
    "ja-JP": _temp15,
    "ko-KR": _temp16,
    "lt-LT": _temp17,
    "lv-LV": _temp18,
    "nb-NO": _temp19,
    "nl-NL": _temp20,
    "pl-PL": _temp21,
    "pt-BR": _temp22,
    "pt-PT": _temp23,
    "ro-RO": _temp24,
    "ru-RU": _temp25,
    "sk-SK": _temp26,
    "sl-SI": _temp27,
    "sr-SP": _temp28,
    "sv-SE": _temp29,
    "tr-TR": _temp30,
    "uk-UA": _temp31,
    "zh-CN": _temp32,
    "zh-TW": _temp33
};

},{"58bfc50b39003baf":"i31AB","4259320a0928e7ce":"1psNz","5156c0052f206613":"bJ65a","1baaaf4759bff7a8":"2J1va","f9c01177a70c77b4":"5myi8","2f3018c584449f67":"cOskX","8bef325a9fa1e51d":"iFMO4","e20e3821216afb3a":"hiUJr","46be7a57e480d4a8":"jMILP","daf60680d7e81230":"941io","ec9647e64b360b50":"dmM7y","d190c83c90c6c10a":"gszUu","a926bfcc29332994":"5FkEM","e68260382a457735":"20rhU","4e6868ad523badd":"11VKM","e3731779c504405d":"iVme0","fd0a5af7e0a33f6f":"9K98b","289ef70fdf024c59":"9iv9K","af7e19ed8050b6b4":"desZF","7aff5e58534b0b23":"8XyRa","9ef2869a4645d579":"iFKlM","5ebd9be8bf3e8c7":"hxrR0","4f372669c5f88764":"hkDOg","3747d5d46eb1bd96":"d6EvE","ac0c1443caf5629a":"cqXSj","65734a6426d5c449":"dQeCS","588c44a59446f286":"8gWNE","37d21c4e67d40a7b":"1aj9G","9edad6470848b70a":"8iOHN","4e739478518b975c":"eg2bi","1835ee9dae76b43c":"66jZO","36b0c2388b98c639":"1d6PE","35da9474c5046d59":"fgRoW","443bfc188a4a2bd8":"dcZTv"}],"i31AB":[function(require,module,exports) {
module.exports = {
    "breadcrumbs.more": `More items`,
    "button.pending": `\u{642}\u{64A}\u{62F} \u{627}\u{644}\u{627}\u{646}\u{62A}\u{638}\u{627}\u{631}`,
    "contextualhelp.help": `\u{645}\u{633}\u{627}\u{639}\u{62F}\u{629}`,
    "contextualhelp.info": `\u{645}\u{639}\u{644}\u{648}\u{645}\u{627}\u{62A}`,
    "dialog.alert": `\u{62A}\u{646}\u{628}\u{64A}\u{647}`,
    "dialog.dismiss": `\u{62A}\u{62C}\u{627}\u{647}\u{644}`,
    "dropzone.replaceMessage": `\u{644}\u{644}\u{627}\u{633}\u{62A}\u{628}\u{62F}\u{627}\u{644}\u{60C} \u{642}\u{645} \u{628}\u{625}\u{641}\u{644}\u{627}\u{62A} \u{627}\u{644}\u{645}\u{644}\u{641}`,
    "inlinealert.informative": `\u{645}\u{639}\u{644}\u{648}\u{645}\u{627}\u{62A}`,
    "inlinealert.negative": `\u{62E}\u{637}\u{623}`,
    "inlinealert.notice": `\u{62A}\u{62D}\u{630}\u{64A}\u{631}`,
    "inlinealert.positive": `\u{62A}\u{645} \u{628}\u{646}\u{62C}\u{627}\u{62D}`,
    "label.(optional)": `(\u{627}\u{62E}\u{62A}\u{64A}\u{627}\u{631}\u{64A})`,
    "label.(required)": `(\u{645}\u{637}\u{644}\u{648}\u{628})`,
    "menu.moreActions": `\u{627}\u{644}\u{645}\u{632}\u{64A}\u{62F} \u{645}\u{646} \u{627}\u{644}\u{625}\u{62C}\u{631}\u{627}\u{621}\u{627}\u{62A}`,
    "picker.placeholder": `\u{62A}\u{62D}\u{62F}\u{64A}\u{62F}\u{2026}`,
    "slider.maximum": `\u{623}\u{642}\u{635}\u{649}`,
    "slider.minimum": `\u{623}\u{62F}\u{646}\u{649}`,
    "table.loading": `\u{62C}\u{627}\u{631}\u{64D} \u{627}\u{644}\u{62A}\u{62D}\u{645}\u{64A}\u{644}...`,
    "table.loadingMore": `\u{62C}\u{627}\u{631}\u{64D} \u{62A}\u{62D}\u{645}\u{64A}\u{644} \u{627}\u{644}\u{645}\u{632}\u{64A}\u{62F}...`,
    "table.resizeColumn": `\u{62A}\u{63A}\u{64A}\u{64A}\u{631} \u{62D}\u{62C}\u{645} \u{627}\u{644}\u{639}\u{645}\u{648}\u{62F}`,
    "table.sortAscending": `\u{641}\u{631}\u{632} \u{628}\u{62A}\u{631}\u{62A}\u{64A}\u{628} \u{62A}\u{635}\u{627}\u{639}\u{62F}\u{64A}`,
    "table.sortDescending": `\u{641}\u{631}\u{632} \u{628}\u{62A}\u{631}\u{62A}\u{64A}\u{628} \u{62A}\u{646}\u{627}\u{632}\u{644}\u{64A}`,
    "tag.actions": `\u{627}\u{644}\u{625}\u{62C}\u{631}\u{627}\u{621}\u{627}\u{62A}`,
    "tag.hideButtonLabel": `\u{625}\u{638}\u{647}\u{627}\u{631} \u{623}\u{642}\u{644}`,
    "tag.noTags": `\u{628}\u{62F}\u{648}\u{646}`,
    "tag.showAllButtonLabel": (args, formatter)=>`\u{639}\u{631}\u{636} \u{627}\u{644}\u{643}\u{644} (${formatter.number(args.tagCount)})`
};

},{}],"1psNz":[function(require,module,exports) {
module.exports = {
    "breadcrumbs.more": `More items`,
    "button.pending": `\u{43D}\u{435}\u{434}\u{43E}\u{432}\u{44A}\u{440}\u{448}\u{435}\u{43D}\u{43E}`,
    "contextualhelp.help": `\u{41F}\u{43E}\u{43C}\u{43E}\u{449}`,
    "contextualhelp.info": `\u{418}\u{43D}\u{444}\u{43E}\u{440}\u{43C}\u{430}\u{446}\u{438}\u{44F}`,
    "dialog.alert": `\u{421}\u{438}\u{433}\u{43D}\u{430}\u{43B}`,
    "dialog.dismiss": `\u{41E}\u{442}\u{445}\u{432}\u{44A}\u{440}\u{43B}\u{44F}\u{43D}\u{435}`,
    "dropzone.replaceMessage": `\u{41F}\u{443}\u{441}\u{43D}\u{435}\u{442}\u{435} \u{444}\u{430}\u{439}\u{43B} \u{437}\u{430} \u{437}\u{430}\u{43C}\u{44F}\u{43D}\u{430}`,
    "inlinealert.informative": `\u{418}\u{43D}\u{444}\u{43E}\u{440}\u{43C}\u{430}\u{446}\u{438}\u{44F}`,
    "inlinealert.negative": `\u{413}\u{440}\u{435}\u{448}\u{43A}\u{430}`,
    "inlinealert.notice": `\u{41F}\u{440}\u{435}\u{434}\u{443}\u{43F}\u{440}\u{435}\u{436}\u{434}\u{435}\u{43D}\u{438}\u{435}`,
    "inlinealert.positive": `\u{423}\u{441}\u{43F}\u{435}\u{448}\u{43D}\u{43E}`,
    "label.(optional)": `(\u{43D}\u{435}\u{437}\u{430}\u{434}\u{44A}\u{43B}\u{436}\u{438}\u{442}\u{435}\u{43B}\u{43D}\u{43E})`,
    "label.(required)": `(\u{437}\u{430}\u{434}\u{44A}\u{43B}\u{436}\u{438}\u{442}\u{435}\u{43B}\u{43D}\u{43E})`,
    "menu.moreActions": `\u{41F}\u{43E}\u{432}\u{435}\u{447}\u{435} \u{434}\u{435}\u{439}\u{441}\u{442}\u{432}\u{438}\u{44F}`,
    "picker.placeholder": `\u{418}\u{437}\u{431}\u{435}\u{440}\u{435}\u{442}\u{435}\u{2026}`,
    "slider.maximum": `\u{41C}\u{430}\u{43A}\u{441}\u{438}\u{43C}\u{443}\u{43C}`,
    "slider.minimum": `\u{41C}\u{438}\u{43D}\u{438}\u{43C}\u{443}\u{43C}`,
    "table.loading": `\u{417}\u{430}\u{440}\u{435}\u{436}\u{434}\u{430}\u{43D}\u{435}...`,
    "table.loadingMore": `\u{417}\u{430}\u{440}\u{435}\u{436}\u{434}\u{430}\u{43D}\u{435} \u{43D}\u{430} \u{43E}\u{449}\u{435}...`,
    "table.resizeColumn": `\u{41F}\u{440}\u{435}\u{43E}\u{440}\u{430}\u{437}\u{43C}\u{435}\u{440}\u{44F}\u{432}\u{430}\u{43D}\u{435} \u{43D}\u{430} \u{43A}\u{43E}\u{43B}\u{43E}\u{43D}\u{430}`,
    "table.sortAscending": `\u{412}\u{44A}\u{437}\u{445}\u{43E}\u{434}\u{44F}\u{449}\u{43E} \u{441}\u{43E}\u{440}\u{442}\u{438}\u{440}\u{430}\u{43D}\u{435}`,
    "table.sortDescending": `\u{41D}\u{438}\u{437}\u{445}\u{43E}\u{434}\u{44F}\u{449}\u{43E} \u{441}\u{43E}\u{440}\u{442}\u{438}\u{440}\u{430}\u{43D}\u{435} `,
    "tag.actions": `\u{414}\u{435}\u{439}\u{441}\u{442}\u{432}\u{438}\u{44F}`,
    "tag.hideButtonLabel": `\u{41F}\u{43E}\u{43A}\u{430}\u{437}\u{432}\u{430}\u{43D}\u{435} \u{43D}\u{430} \u{43F}\u{43E}-\u{43C}\u{430}\u{43B}\u{43A}\u{43E}`,
    "tag.noTags": `\u{41D}\u{438}\u{442}\u{43E} \u{435}\u{434}\u{438}\u{43D}`,
    "tag.showAllButtonLabel": (args, formatter)=>`\u{41F}\u{43E}\u{43A}\u{430}\u{437}\u{432}\u{430}\u{43D}\u{435} \u{43D}\u{430} \u{432}\u{441}\u{438}\u{447}\u{43A}\u{438} (${formatter.number(args.tagCount)})`
};

},{}],"bJ65a":[function(require,module,exports) {
module.exports = {
    "breadcrumbs.more": `V\xedce polo\u{17E}ek`,
    "button.pending": `\u{10D}ek\xe1 na vy\u{159}\xedzen\xed`,
    "contextualhelp.help": `N\xe1pov\u{11B}da`,
    "contextualhelp.info": `Informace`,
    "dialog.alert": `V\xfdstraha`,
    "dialog.dismiss": `Odstranit`,
    "dropzone.replaceMessage": `P\u{159}et\xe1hn\u{11B}te soubor k nahrazen\xed`,
    "inlinealert.informative": `Informace`,
    "inlinealert.negative": `Chyba`,
    "inlinealert.notice": `Varov\xe1n\xed`,
    "inlinealert.positive": `\xdasp\u{11B}ch`,
    "label.(optional)": `(voliteln\u{11B})`,
    "label.(required)": `(po\u{17E}adov\xe1no)`,
    "menu.moreActions": `Dal\u{161}\xed akce`,
    "picker.placeholder": `Vybrat\u{2026}`,
    "slider.maximum": `Maximum`,
    "slider.minimum": `Minimum`,
    "table.loading": `Na\u{10D}\xedt\xe1n\xed...`,
    "table.loadingMore": `Na\u{10D}\xedt\xe1n\xed dal\u{161}\xedch...`,
    "table.resizeColumn": `Zm\u{11B}nit velikost sloupce`,
    "table.sortAscending": `Se\u{159}adit vzestupn\u{11B}`,
    "table.sortDescending": `Se\u{159}adit sestupn\u{11B}`,
    "tag.actions": `Akce`,
    "tag.hideButtonLabel": `Zobrazit m\xe9n\u{11B}`,
    "tag.noTags": `\u{17D}\xe1dn\xfd`,
    "tag.showAllButtonLabel": (args, formatter)=>`Zobrazit v\u{161}e (${formatter.number(args.tagCount)})`
};

},{}],"2J1va":[function(require,module,exports) {
module.exports = {
    "breadcrumbs.more": `Flere elementer`,
    "button.pending": `afventende`,
    "contextualhelp.help": `Hj\xe6lp`,
    "contextualhelp.info": `Oplysninger`,
    "dialog.alert": `Advarsel`,
    "dialog.dismiss": `Luk`,
    "dropzone.replaceMessage": `Drop fil for at erstatte`,
    "inlinealert.informative": `Oplysninger`,
    "inlinealert.negative": `Fejl`,
    "inlinealert.notice": `Advarsel`,
    "inlinealert.positive": `Fuldf\xf8rt`,
    "label.(optional)": `(valgfrit)`,
    "label.(required)": `(obligatorisk)`,
    "menu.moreActions": `Flere handlinger`,
    "picker.placeholder": `V\xe6lg\u{2026}`,
    "slider.maximum": `Maksimum`,
    "slider.minimum": `Minimum`,
    "table.loading": `Indl\xe6ser...`,
    "table.loadingMore": `Indl\xe6ser flere...`,
    "table.resizeColumn": `Tilpas st\xf8rrelse p\xe5 kolonne`,
    "table.sortAscending": `Sorter stigende`,
    "table.sortDescending": `Sorter faldende`,
    "tag.actions": `Handlinger`,
    "tag.hideButtonLabel": `Vis mindre`,
    "tag.noTags": `Ingen`,
    "tag.showAllButtonLabel": (args, formatter)=>`Vis alle (${formatter.number(args.tagCount)})`
};

},{}],"5myi8":[function(require,module,exports) {
module.exports = {
    "breadcrumbs.more": `Weitere Elemente`,
    "button.pending": `Ausstehend`,
    "contextualhelp.help": `Hilfe`,
    "contextualhelp.info": `Informationen`,
    "dialog.alert": `Warnhinweis`,
    "dialog.dismiss": `Schlie\xdfen`,
    "dropzone.replaceMessage": `Datei zum Ersetzen ablegen`,
    "inlinealert.informative": `Informationen`,
    "inlinealert.negative": `Fehler`,
    "inlinealert.notice": `Warnung`,
    "inlinealert.positive": `Erfolg`,
    "label.(optional)": `(optional)`,
    "label.(required)": `(erforderlich)`,
    "menu.moreActions": `Mehr Aktionen`,
    "picker.placeholder": `Ausw\xe4hlen\u{2026}`,
    "slider.maximum": `Maximum`,
    "slider.minimum": `Minimum`,
    "table.loading": `Laden...`,
    "table.loadingMore": `Mehr laden ...`,
    "table.resizeColumn": `Spaltengr\xf6\xdfe \xe4ndern`,
    "table.sortAscending": `Aufsteigend sortieren`,
    "table.sortDescending": `Absteigend sortieren`,
    "tag.actions": `Aktionen`,
    "tag.hideButtonLabel": `Weniger zeigen`,
    "tag.noTags": `Keine`,
    "tag.showAllButtonLabel": (args, formatter)=>`Alle anzeigen (${formatter.number(args.tagCount)})`
};

},{}],"cOskX":[function(require,module,exports) {
module.exports = {
    "breadcrumbs.more": `More items`,
    "button.pending": `\u{3C3}\u{3B5} \u{3B5}\u{3BA}\u{3BA}\u{3C1}\u{3B5}\u{3BC}\u{3CC}\u{3C4}\u{3B7}\u{3C4}\u{3B1}`,
    "contextualhelp.help": `\u{392}\u{3BF}\u{3AE}\u{3B8}\u{3B5}\u{3B9}\u{3B1}`,
    "contextualhelp.info": `\u{3A0}\u{3BB}\u{3B7}\u{3C1}\u{3BF}\u{3C6}\u{3BF}\u{3C1}\u{3AF}\u{3B5}\u{3C2}`,
    "dialog.alert": `\u{395}\u{3B9}\u{3B4}\u{3BF}\u{3C0}\u{3BF}\u{3AF}\u{3B7}\u{3C3}\u{3B7}`,
    "dialog.dismiss": `\u{391}\u{3C0}\u{3CC}\u{3C1}\u{3C1}\u{3B9}\u{3C8}\u{3B7}`,
    "dropzone.replaceMessage": `\u{391}\u{3C0}\u{3CC}\u{3B8}\u{3B5}\u{3C3}\u{3B7} \u{3B1}\u{3C1}\u{3C7}\u{3B5}\u{3AF}\u{3BF}\u{3C5} \u{3B3}\u{3B9}\u{3B1} \u{3B1}\u{3BD}\u{3C4}\u{3B9}\u{3BA}\u{3B1}\u{3C4}\u{3AC}\u{3C3}\u{3C4}\u{3B1}\u{3C3}\u{3B7}`,
    "inlinealert.informative": `\u{3A0}\u{3BB}\u{3B7}\u{3C1}\u{3BF}\u{3C6}\u{3BF}\u{3C1}\u{3AF}\u{3B5}\u{3C2}`,
    "inlinealert.negative": `\u{3A3}\u{3C6}\u{3AC}\u{3BB}\u{3BC}\u{3B1}`,
    "inlinealert.notice": `\u{3A0}\u{3C1}\u{3BF}\u{3B5}\u{3B9}\u{3B4}\u{3BF}\u{3C0}\u{3BF}\u{3AF}\u{3B7}\u{3C3}\u{3B7}`,
    "inlinealert.positive": `\u{395}\u{3C0}\u{3B9}\u{3C4}\u{3C5}\u{3C7}\u{3AF}\u{3B1}`,
    "label.(optional)": `(\u{3C0}\u{3C1}\u{3BF}\u{3B1}\u{3B9}\u{3C1}\u{3B5}\u{3C4}\u{3B9}\u{3BA}\u{3CC})`,
    "label.(required)": `(\u{3B1}\u{3C0}\u{3B1}\u{3B9}\u{3C4}\u{3B5}\u{3AF}\u{3C4}\u{3B1}\u{3B9})`,
    "menu.moreActions": `\u{3A0}\u{3B5}\u{3C1}\u{3B9}\u{3C3}\u{3C3}\u{3CC}\u{3C4}\u{3B5}\u{3C1}\u{3B5}\u{3C2} \u{3B5}\u{3BD}\u{3AD}\u{3C1}\u{3B3}\u{3B5}\u{3B9}\u{3B5}\u{3C2}`,
    "picker.placeholder": `\u{395}\u{3C0}\u{3B9}\u{3BB}\u{3BF}\u{3B3}\u{3AE}\u{2026}`,
    "slider.maximum": `\u{39C}\u{3AD}\u{3B3}\u{3B9}\u{3C3}\u{3C4}\u{3BF}`,
    "slider.minimum": `\u{395}\u{3BB}\u{3AC}\u{3C7}\u{3B9}\u{3C3}\u{3C4}\u{3BF}`,
    "table.loading": `\u{3A6}\u{3CC}\u{3C1}\u{3C4}\u{3C9}\u{3C3}\u{3B7}...`,
    "table.loadingMore": `\u{3A6}\u{3CC}\u{3C1}\u{3C4}\u{3C9}\u{3C3}\u{3B7} \u{3C0}\u{3B5}\u{3C1}\u{3B9}\u{3C3}\u{3C3}\u{3CC}\u{3C4}\u{3B5}\u{3C1}\u{3C9}\u{3BD}...`,
    "table.resizeColumn": `\u{391}\u{3BB}\u{3BB}\u{3B1}\u{3B3}\u{3AE} \u{3BC}\u{3B5}\u{3B3}\u{3AD}\u{3B8}\u{3BF}\u{3C5}\u{3C2} \u{3C3}\u{3C4}\u{3AE}\u{3BB}\u{3B7}\u{3C2}`,
    "table.sortAscending": `\u{3A4}\u{3B1}\u{3BE}\u{3B9}\u{3BD}\u{3CC}\u{3BC}\u{3B7}\u{3C3}\u{3B7} \u{3BA}\u{3B1}\u{3C4}\u{3AC} \u{3B1}\u{3CD}\u{3BE}\u{3BF}\u{3C5}\u{3C3}\u{3B1} \u{3C3}\u{3B5}\u{3B9}\u{3C1}\u{3AC}`,
    "table.sortDescending": `\u{3A4}\u{3B1}\u{3BE}\u{3B9}\u{3BD}\u{3CC}\u{3BC}\u{3B7}\u{3C3}\u{3B7} \u{3BA}\u{3B1}\u{3C4}\u{3AC} \u{3C6}\u{3B8}\u{3AF}\u{3BD}\u{3BF}\u{3C5}\u{3C3}\u{3B1} \u{3C3}\u{3B5}\u{3B9}\u{3C1}\u{3AC}`,
    "tag.actions": `\u{395}\u{3BD}\u{3AD}\u{3C1}\u{3B3}\u{3B5}\u{3B9}\u{3B5}\u{3C2}`,
    "tag.hideButtonLabel": `\u{395}\u{3BC}\u{3C6}\u{3AC}\u{3BD}\u{3B9}\u{3C3}\u{3B7} \u{3BB}\u{3B9}\u{3B3}\u{3CC}\u{3C4}\u{3B5}\u{3C1}\u{3C9}\u{3BD}`,
    "tag.noTags": `\u{39A}\u{3B1}\u{3BD}\u{3AD}\u{3BD}\u{3B1}`,
    "tag.showAllButtonLabel": (args, formatter)=>`\u{395}\u{3BC}\u{3C6}\u{3AC}\u{3BD}\u{3B9}\u{3C3}\u{3B7} \u{3CC}\u{3BB}\u{3C9}\u{3BD} (${formatter.number(args.tagCount)})`
};

},{}],"iFMO4":[function(require,module,exports) {
module.exports = {
    "button.pending": `pending`,
    "contextualhelp.info": `Information`,
    "contextualhelp.help": `Help`,
    "dialog.dismiss": `Dismiss`,
    "dialog.alert": `Alert`,
    "dropzone.replaceMessage": `Drop file to replace`,
    "inlinealert.negative": `Error`,
    "inlinealert.notice": `Warning`,
    "inlinealert.informative": `Information`,
    "inlinealert.positive": `Success`,
    "label.(required)": `(required)`,
    "label.(optional)": `(optional)`,
    "menu.moreActions": `More actions`,
    "picker.placeholder": `Select\u{2026}`,
    "slider.minimum": `Minimum`,
    "slider.maximum": `Maximum`,
    "table.loading": `Loading\u{2026}`,
    "table.loadingMore": `Loading more\u{2026}`,
    "table.sortAscending": `Sort Ascending`,
    "table.sortDescending": `Sort Descending`,
    "table.resizeColumn": `Resize column`,
    "tag.showAllButtonLabel": (args, formatter)=>`Show all (${formatter.number(args.tagCount)})`,
    "tag.hideButtonLabel": `Show less`,
    "tag.actions": `Actions`,
    "tag.noTags": `None`,
    "breadcrumbs.more": `More items`
};

},{}],"hiUJr":[function(require,module,exports) {
module.exports = {
    "breadcrumbs.more": `M\xe1s elementos`,
    "button.pending": `pendiente`,
    "contextualhelp.help": `Ayuda`,
    "contextualhelp.info": `Informaci\xf3n`,
    "dialog.alert": `Alerta`,
    "dialog.dismiss": `Descartar`,
    "dropzone.replaceMessage": `Suelte el archivo para reemplazar`,
    "inlinealert.informative": `Informaci\xf3n`,
    "inlinealert.negative": `Error`,
    "inlinealert.notice": `Advertencia`,
    "inlinealert.positive": `\xc9xito`,
    "label.(optional)": `(opcional)`,
    "label.(required)": `(obligatorio)`,
    "menu.moreActions": `M\xe1s acciones`,
    "picker.placeholder": `Seleccione\u{2026}`,
    "slider.maximum": `M\xe1ximo`,
    "slider.minimum": `M\xednimo`,
    "table.loading": `Cargando\u{2026}`,
    "table.loadingMore": `Cargando m\xe1s\u{2026}`,
    "table.resizeColumn": `Cambiar el tama\xf1o de la columna`,
    "table.sortAscending": `Orden de subida`,
    "table.sortDescending": `Orden de bajada`,
    "tag.actions": `Acciones`,
    "tag.hideButtonLabel": `Mostrar menos`,
    "tag.noTags": `Ninguno`,
    "tag.showAllButtonLabel": (args, formatter)=>`Mostrar todo (${formatter.number(args.tagCount)})`
};

},{}],"jMILP":[function(require,module,exports) {
module.exports = {
    "breadcrumbs.more": `More items`,
    "button.pending": `ootel`,
    "contextualhelp.help": `Spikker`,
    "contextualhelp.info": `Teave`,
    "dialog.alert": `Teade`,
    "dialog.dismiss": `L\xf5peta`,
    "dropzone.replaceMessage": `Kukuta fail asendamiseks`,
    "inlinealert.informative": `Teave`,
    "inlinealert.negative": `Viga`,
    "inlinealert.notice": `Hoiatus`,
    "inlinealert.positive": `Valmis`,
    "label.(optional)": `(valikuline)`,
    "label.(required)": `(n\xf5utav)`,
    "menu.moreActions": `Veel toiminguid`,
    "picker.placeholder": `Valige\u{2026}`,
    "slider.maximum": `Maksimaalne`,
    "slider.minimum": `Minimaalne`,
    "table.loading": `Laadimine...`,
    "table.loadingMore": `Laadi rohkem...`,
    "table.resizeColumn": `Muuda veeru suurust`,
    "table.sortAscending": `Sordi kasvavalt`,
    "table.sortDescending": `Sordi kahanevalt`,
    "tag.actions": `Toimingud`,
    "tag.hideButtonLabel": `Kuva v\xe4hem`,
    "tag.noTags": `Puudub`,
    "tag.showAllButtonLabel": (args, formatter)=>`Kuva k\xf5ik (${formatter.number(args.tagCount)})`
};

},{}],"941io":[function(require,module,exports) {
module.exports = {
    "breadcrumbs.more": `Lis\xe4\xe4 kohteita`,
    "button.pending": `odottaa`,
    "contextualhelp.help": `Ohje`,
    "contextualhelp.info": `Tiedot`,
    "dialog.alert": `H\xe4lytys`,
    "dialog.dismiss": `Hylk\xe4\xe4`,
    "dropzone.replaceMessage": `Pudota korvaava tiedosto`,
    "inlinealert.informative": `Tiedot`,
    "inlinealert.negative": `Virhe`,
    "inlinealert.notice": `Varoitus`,
    "inlinealert.positive": `Onnistui`,
    "label.(optional)": `(valinnainen)`,
    "label.(required)": `(pakollinen)`,
    "menu.moreActions": `Lis\xe4\xe4 toimintoja`,
    "picker.placeholder": `Valitse\u{2026}`,
    "slider.maximum": `Maksimi`,
    "slider.minimum": `Minimi`,
    "table.loading": `Ladataan\u{2026}`,
    "table.loadingMore": `Ladataan lis\xe4\xe4\u{2026}`,
    "table.resizeColumn": `Muuta sarakkeen kokoa`,
    "table.sortAscending": `Lajitteluj\xe4rjestys: nouseva`,
    "table.sortDescending": `Lajitteluj\xe4rjestys: laskeva`,
    "tag.actions": `Toiminnot`,
    "tag.hideButtonLabel": `N\xe4yt\xe4 v\xe4hemm\xe4n`,
    "tag.noTags": `Ei mit\xe4\xe4n`,
    "tag.showAllButtonLabel": (args, formatter)=>`N\xe4yt\xe4 kaikki (${formatter.number(args.tagCount)})`
};

},{}],"dmM7y":[function(require,module,exports) {
module.exports = {
    "breadcrumbs.more": `Plus d'\xe9l\xe9ments`,
    "button.pending": `En attente`,
    "contextualhelp.help": `Aide`,
    "contextualhelp.info": `Informations`,
    "dialog.alert": `Alerte`,
    "dialog.dismiss": `Rejeter`,
    "dropzone.replaceMessage": `D\xe9poser le fichier \xe0 remplacer`,
    "inlinealert.informative": `Informations`,
    "inlinealert.negative": `Erreur`,
    "inlinealert.notice": `Avertissement`,
    "inlinealert.positive": `Succ\xe8s`,
    "label.(optional)": `(facultatif)`,
    "label.(required)": `(requis)`,
    "menu.moreActions": `Autres actions`,
    "picker.placeholder": `S\xe9lectionner\u{2026}`,
    "slider.maximum": `Maximum`,
    "slider.minimum": `Minimum`,
    "table.loading": `Chargement...`,
    "table.loadingMore": `Chargement suppl\xe9mentaire...`,
    "table.resizeColumn": `Redimensionner la colonne`,
    "table.sortAscending": `Trier par ordre croissant`,
    "table.sortDescending": `Trier par ordre d\xe9croissant`,
    "tag.actions": `Actions`,
    "tag.hideButtonLabel": `Afficher moins`,
    "tag.noTags": `Aucun`,
    "tag.showAllButtonLabel": (args, formatter)=>`Tout afficher (${formatter.number(args.tagCount)})`
};

},{}],"gszUu":[function(require,module,exports) {
module.exports = {
    "breadcrumbs.more": `More items`,
    "button.pending": `\u{5DE}\u{5DE}\u{5EA}\u{5D9}\u{5DF} \u{5DC}`,
    "contextualhelp.help": `\u{5E2}\u{5D6}\u{5E8}\u{5D4}`,
    "contextualhelp.info": `\u{5DE}\u{5D9}\u{5D3}\u{5E2}`,
    "dialog.alert": `\u{5D4}\u{5EA}\u{5E8}\u{5D0}\u{5D4}`,
    "dialog.dismiss": `\u{5D4}\u{5EA}\u{5E2}\u{5DC}\u{5DD}`,
    "dropzone.replaceMessage": `\u{5E9}\u{5D7}\u{5E8}\u{5E8} \u{5D0}\u{5EA} \u{5D4}\u{5E7}\u{5D5}\u{5D1}\u{5E5} \u{5DC}\u{5D4}\u{5D7}\u{5DC}\u{5E4}\u{5D4}`,
    "inlinealert.informative": `\u{5DE}\u{5D9}\u{5D3}\u{5E2}`,
    "inlinealert.negative": `\u{5E9}\u{5D2}\u{5D9}\u{5D0}\u{5D4}`,
    "inlinealert.notice": `\u{5D0}\u{5D6}\u{5D4}\u{5E8}\u{5D4}`,
    "inlinealert.positive": `\u{5D4}\u{5E6}\u{5DC}\u{5D7}\u{5D4}`,
    "label.(optional)": `(\u{5D0}\u{5D5}\u{5E4}\u{5E6}\u{5D9}\u{5D5}\u{5E0}\u{5DC}\u{5D9})`,
    "label.(required)": `(\u{5E0}\u{5D3}\u{5E8}\u{5E9})`,
    "menu.moreActions": `\u{5E4}\u{5E2}\u{5D5}\u{5DC}\u{5D5}\u{5EA} \u{5E0}\u{5D5}\u{5E1}\u{5E4}\u{5D5}\u{5EA}`,
    "picker.placeholder": `\u{5D1}\u{5D7}\u{5E8}\u{2026}`,
    "slider.maximum": `\u{5DE}\u{5E7}\u{5E1}\u{5D9}\u{5DE}\u{5D5}\u{5DD}`,
    "slider.minimum": `\u{5DE}\u{5D9}\u{5E0}\u{5D9}\u{5DE}\u{5D5}\u{5DD}`,
    "table.loading": `\u{5D8}\u{5D5}\u{5E2}\u{5DF}...`,
    "table.loadingMore": `\u{5D8}\u{5D5}\u{5E2}\u{5DF} \u{5E2}\u{5D5}\u{5D3}...`,
    "table.resizeColumn": `\u{5E9}\u{5E0}\u{5D4} \u{5D0}\u{5EA} \u{5D2}\u{5D5}\u{5D3}\u{5DC} \u{5D4}\u{5E2}\u{5DE}\u{5D5}\u{5D3}\u{5D4}`,
    "table.sortAscending": `\u{5DE}\u{5D9}\u{5D9}\u{5DF} \u{5D1}\u{5E1}\u{5D3}\u{5E8} \u{5E2}\u{5D5}\u{5DC}\u{5D4}`,
    "table.sortDescending": `\u{5DE}\u{5D9}\u{5D9}\u{5DF} \u{5D1}\u{5E1}\u{5D3}\u{5E8} \u{5D9}\u{5D5}\u{5E8}\u{5D3}`,
    "tag.actions": `\u{5E4}\u{5E2}\u{5D5}\u{5DC}\u{5D5}\u{5EA}`,
    "tag.hideButtonLabel": `\u{5D4}\u{5E6}\u{5D2} \u{5E4}\u{5D7}\u{5D5}\u{5EA}`,
    "tag.noTags": `\u{5DC}\u{5DC}\u{5D0}`,
    "tag.showAllButtonLabel": (args, formatter)=>`\u{5D4}\u{5E6}\u{5D2} \u{5D4}\u{5DB}\u{5DC} (${formatter.number(args.tagCount)})`
};

},{}],"5FkEM":[function(require,module,exports) {
module.exports = {
    "breadcrumbs.more": `More items`,
    "button.pending": `u tijeku`,
    "contextualhelp.help": `Pomo\u{107}`,
    "contextualhelp.info": `Informacije`,
    "dialog.alert": `Upozorenje`,
    "dialog.dismiss": `Odbaci`,
    "dropzone.replaceMessage": `Ispustite datoteku za zamjenu`,
    "inlinealert.informative": `Informacije`,
    "inlinealert.negative": `Pogre\u{161}ka`,
    "inlinealert.notice": `Upozorenje`,
    "inlinealert.positive": `Uspje\u{161}no`,
    "label.(optional)": `(opcionalno)`,
    "label.(required)": `(obvezno)`,
    "menu.moreActions": `Dodatne radnje`,
    "picker.placeholder": `Odaberite\u{2026}`,
    "slider.maximum": `Najvi\u{161}e`,
    "slider.minimum": `Najmanje`,
    "table.loading": `U\u{10D}itavam...`,
    "table.loadingMore": `U\u{10D}itavam jo\u{161}...`,
    "table.resizeColumn": `Promijeni veli\u{10D}inu stupca`,
    "table.sortAscending": `Sortiraj uzlazno`,
    "table.sortDescending": `Sortiraj silazno`,
    "tag.actions": `Radnje`,
    "tag.hideButtonLabel": `Prika\u{17E}i manje`,
    "tag.noTags": `Nema`,
    "tag.showAllButtonLabel": (args, formatter)=>`Prika\u{17E}i sve (${formatter.number(args.tagCount)})`
};

},{}],"20rhU":[function(require,module,exports) {
module.exports = {
    "breadcrumbs.more": `More items`,
    "button.pending": `f\xfcgg\u{151}ben lev\u{151}`,
    "contextualhelp.help": `S\xfag\xf3`,
    "contextualhelp.info": `Inform\xe1ci\xf3`,
    "dialog.alert": `Figyelmeztet\xe9s`,
    "dialog.dismiss": `Elutas\xedt\xe1s`,
    "dropzone.replaceMessage": `Ejtse le a f\xe1jlt a cser\xe9hez`,
    "inlinealert.informative": `Inform\xe1ci\xf3`,
    "inlinealert.negative": `Hiba`,
    "inlinealert.notice": `Figyelmeztet\xe9s`,
    "inlinealert.positive": `Siker`,
    "label.(optional)": `(opcion\xe1lis)`,
    "label.(required)": `(k\xf6telez\u{151})`,
    "menu.moreActions": `Tov\xe1bbi lehet\u{151}s\xe9gek`,
    "picker.placeholder": `Kiv\xe1laszt\xe1s\u{2026}`,
    "slider.maximum": `Maximum`,
    "slider.minimum": `Minimum`,
    "table.loading": `Bet\xf6lt\xe9s folyamatban\u{2026}`,
    "table.loadingMore": `Tov\xe1bbiak bet\xf6lt\xe9se folyamatban\u{2026}`,
    "table.resizeColumn": `Oszlop \xe1tm\xe9retez\xe9se`,
    "table.sortAscending": `N\xf6vekv\u{151} rendez\xe9s`,
    "table.sortDescending": `Cs\xf6kken\u{151} rendez\xe9s`,
    "tag.actions": `M\u{171}veletek`,
    "tag.hideButtonLabel": `Mutass kevesebbet`,
    "tag.noTags": `Egyik sem`,
    "tag.showAllButtonLabel": (args, formatter)=>`Az \xf6sszes megjelen\xedt\xe9se (${formatter.number(args.tagCount)})`
};

},{}],"11VKM":[function(require,module,exports) {
module.exports = {
    "breadcrumbs.more": `Altri elementi`,
    "button.pending": `in sospeso`,
    "contextualhelp.help": `Aiuto`,
    "contextualhelp.info": `Informazioni`,
    "dialog.alert": `Avviso`,
    "dialog.dismiss": `Ignora`,
    "dropzone.replaceMessage": `Rilascia il file da sostituire`,
    "inlinealert.informative": `Informazioni`,
    "inlinealert.negative": `Errore`,
    "inlinealert.notice": `Avvertenza`,
    "inlinealert.positive": `Operazione riuscita`,
    "label.(optional)": `(facoltativo)`,
    "label.(required)": `(obbligatorio)`,
    "menu.moreActions": `Altre azioni`,
    "picker.placeholder": `Seleziona\u{2026}`,
    "slider.maximum": `Massimo`,
    "slider.minimum": `Minimo`,
    "table.loading": `Caricamento...`,
    "table.loadingMore": `Caricamento altri...`,
    "table.resizeColumn": `Ridimensiona colonna`,
    "table.sortAscending": `Ordinamento crescente`,
    "table.sortDescending": `Ordinamento decrescente`,
    "tag.actions": `Azioni`,
    "tag.hideButtonLabel": `Mostra meno`,
    "tag.noTags": `Nessuno`,
    "tag.showAllButtonLabel": (args, formatter)=>`Mostra tutto (${formatter.number(args.tagCount)})`
};

},{}],"iVme0":[function(require,module,exports) {
module.exports = {
    "breadcrumbs.more": `\u{9805}\u{76EE}\u{3092}\u{8FFD}\u{52A0}`,
    "button.pending": `\u{4FDD}\u{7559}`,
    "contextualhelp.help": `\u{30D8}\u{30EB}\u{30D7}`,
    "contextualhelp.info": `\u{60C5}\u{5831}`,
    "dialog.alert": `\u{30A2}\u{30E9}\u{30FC}\u{30C8}`,
    "dialog.dismiss": `\u{9589}\u{3058}\u{308B}`,
    "dropzone.replaceMessage": `\u{30D5}\u{30A1}\u{30A4}\u{30EB}\u{3092}\u{30C9}\u{30ED}\u{30C3}\u{30D7}\u{3057}\u{3066}\u{7F6E}\u{63DB}`,
    "inlinealert.informative": `\u{60C5}\u{5831}`,
    "inlinealert.negative": `\u{30A8}\u{30E9}\u{30FC}`,
    "inlinealert.notice": `\u{8B66}\u{544A}`,
    "inlinealert.positive": `\u{6210}\u{529F}`,
    "label.(optional)": `\u{FF08}\u{30AA}\u{30D7}\u{30B7}\u{30E7}\u{30F3}\u{FF09}`,
    "label.(required)": `\u{FF08}\u{5FC5}\u{9808}\u{FF09}`,
    "menu.moreActions": `\u{305D}\u{306E}\u{4ED6}\u{306E}\u{30A2}\u{30AF}\u{30B7}\u{30E7}\u{30F3}`,
    "picker.placeholder": `\u{9078}\u{629E}\u{2026}`,
    "slider.maximum": `\u{6700}\u{5927}`,
    "slider.minimum": `\u{6700}\u{5C0F}`,
    "table.loading": `\u{8AAD}\u{307F}\u{8FBC}\u{307F}\u{4E2D}...`,
    "table.loadingMore": `\u{3055}\u{3089}\u{306B}\u{8AAD}\u{307F}\u{8FBC}\u{307F}\u{4E2D}...`,
    "table.resizeColumn": `\u{5217}\u{5E45}\u{3092}\u{5909}\u{66F4}`,
    "table.sortAscending": `\u{6607}\u{9806}\u{306B}\u{4E26}\u{3079}\u{66FF}\u{3048}`,
    "table.sortDescending": `\u{964D}\u{9806}\u{306B}\u{4E26}\u{3079}\u{66FF}\u{3048}`,
    "tag.actions": `\u{30A2}\u{30AF}\u{30B7}\u{30E7}\u{30F3}`,
    "tag.hideButtonLabel": `\u{8868}\u{793A}\u{3092}\u{6E1B}\u{3089}\u{3059}`,
    "tag.noTags": `\u{306A}\u{3057}`,
    "tag.showAllButtonLabel": (args, formatter)=>`\u{3059}\u{3079}\u{3066}\u{306E} (${formatter.number(args.tagCount)}) \u{3092}\u{8868}\u{793A}`
};

},{}],"9K98b":[function(require,module,exports) {
module.exports = {
    "breadcrumbs.more": `\u{D56D}\u{BAA9} \u{B354} \u{BCF4}\u{AE30}`,
    "button.pending": `\u{BCF4}\u{B958} \u{C911}`,
    "contextualhelp.help": `\u{B3C4}\u{C6C0}\u{B9D0}`,
    "contextualhelp.info": `\u{C815}\u{BCF4}`,
    "dialog.alert": `\u{ACBD}\u{ACE0}`,
    "dialog.dismiss": `\u{BB34}\u{C2DC}`,
    "dropzone.replaceMessage": `\u{D30C}\u{C77C}\u{C744} \u{B4DC}\u{B86D}\u{D558}\u{C5EC} \u{BC14}\u{AFB8}\u{AE30}`,
    "inlinealert.informative": `\u{C815}\u{BCF4}`,
    "inlinealert.negative": `\u{C624}\u{B958}`,
    "inlinealert.notice": `\u{ACBD}\u{ACE0}`,
    "inlinealert.positive": `\u{C131}\u{ACF5}`,
    "label.(optional)": `(\u{C120}\u{D0DD} \u{C0AC}\u{D56D})`,
    "label.(required)": `(\u{D544}\u{C218} \u{C0AC}\u{D56D})`,
    "menu.moreActions": `\u{AE30}\u{D0C0} \u{C561}\u{C158}`,
    "picker.placeholder": `\u{C120}\u{D0DD}\u{2026}`,
    "slider.maximum": `\u{CD5C}\u{B300}`,
    "slider.minimum": `\u{CD5C}\u{C18C}`,
    "table.loading": `\u{B85C}\u{B4DC} \u{C911}\u{2026}`,
    "table.loadingMore": `\u{CD94}\u{AC00} \u{B85C}\u{B4DC} \u{C911}\u{2026}`,
    "table.resizeColumn": `\u{C5F4} \u{D06C}\u{AE30} \u{C870}\u{C815}`,
    "table.sortAscending": `\u{C624}\u{B984}\u{CC28}\u{C21C} \u{C815}\u{B82C}`,
    "table.sortDescending": `\u{B0B4}\u{B9BC}\u{CC28}\u{C21C} \u{C815}\u{B82C}`,
    "tag.actions": `\u{C561}\u{C158}`,
    "tag.hideButtonLabel": `\u{AC04}\u{B2E8}\u{D788} \u{D45C}\u{C2DC}`,
    "tag.noTags": `\u{C5C6}\u{C74C}`,
    "tag.showAllButtonLabel": (args, formatter)=>`\u{BAA8}\u{B450} \u{D45C}\u{C2DC} (${formatter.number(args.tagCount)})`
};

},{}],"9iv9K":[function(require,module,exports) {
module.exports = {
    "breadcrumbs.more": `More items`,
    "button.pending": `laukiama`,
    "contextualhelp.help": `\u{17D}inynas`,
    "contextualhelp.info": `Informacija`,
    "dialog.alert": `\u{12E}sp\u{117}jimas`,
    "dialog.dismiss": `Atmesti`,
    "dropzone.replaceMessage": `Pa\u{161}alinkite fail\u{105}, kad pakeistum\u{117}te`,
    "inlinealert.informative": `Informacija`,
    "inlinealert.negative": `Klaida`,
    "inlinealert.notice": `\u{12E}sp\u{117}jimas`,
    "inlinealert.positive": `S\u{117}kmingai`,
    "label.(optional)": `(pasirenkama)`,
    "label.(required)": `(privaloma)`,
    "menu.moreActions": `Daugiau veiksm\u{173}`,
    "picker.placeholder": `Pasirinkite\u{2026}`,
    "slider.maximum": `Daugiausia`,
    "slider.minimum": `Ma\u{17E}iausia`,
    "table.loading": `\u{12E}keliama\u{2026}`,
    "table.loadingMore": `\u{12E}keliama daugiau\u{2026}`,
    "table.resizeColumn": `Keisti stulpelio dyd\u{12F}`,
    "table.sortAscending": `Rikiuoti did\u{117}jimo tvarka`,
    "table.sortDescending": `Rikiuoti ma\u{17E}\u{117}jimo tvarka`,
    "tag.actions": `Veiksmai`,
    "tag.hideButtonLabel": `Rodyti ma\u{17E}iau`,
    "tag.noTags": `N\u{117}ra`,
    "tag.showAllButtonLabel": (args, formatter)=>`Rodyti visk\u{105} (${formatter.number(args.tagCount)})`
};

},{}],"desZF":[function(require,module,exports) {
module.exports = {
    "breadcrumbs.more": `More items`,
    "button.pending": `gaida`,
    "contextualhelp.help": `Pal\u{12B}dz\u{12B}ba`,
    "contextualhelp.info": `Inform\u{101}cija`,
    "dialog.alert": `Br\u{12B}din\u{101}jums`,
    "dialog.dismiss": `Ner\u{101}d\u{12B}t`,
    "dropzone.replaceMessage": `Lai aizst\u{101}tu, nometiet failu`,
    "inlinealert.informative": `Inform\u{101}cija`,
    "inlinealert.negative": `K\u{13C}\u{16B}da`,
    "inlinealert.notice": `Br\u{12B}din\u{101}jums`,
    "inlinealert.positive": `Izdev\u{101}s`,
    "label.(optional)": `(neoblig\u{101}ti)`,
    "label.(required)": `(oblig\u{101}ti)`,
    "menu.moreActions": `Citas darb\u{12B}bas`,
    "picker.placeholder": `Izv\u{113}l\u{113}ties\u{2026}`,
    "slider.maximum": `Maksim\u{101}l\u{101} v\u{113}rt\u{12B}ba`,
    "slider.minimum": `Minim\u{101}l\u{101} v\u{113}rt\u{12B}ba`,
    "table.loading": `Notiek iel\u{101}de\u{2026}`,
    "table.loadingMore": `Tiek iel\u{101}d\u{113}ts v\u{113}l...`,
    "table.resizeColumn": `Main\u{12B}t kolonnas lielumu`,
    "table.sortAscending": `K\u{101}rtot augo\u{161}\u{101} sec\u{12B}b\u{101}`,
    "table.sortDescending": `K\u{101}rtot dilsto\u{161}\u{101} sec\u{12B}b\u{101}`,
    "tag.actions": `Darb\u{12B}bas`,
    "tag.hideButtonLabel": `R\u{101}d\u{12B}t maz\u{101}k`,
    "tag.noTags": `Nav`,
    "tag.showAllButtonLabel": (args, formatter)=>`R\u{101}d\u{12B}t visu (${formatter.number(args.tagCount)})`
};

},{}],"8XyRa":[function(require,module,exports) {
module.exports = {
    "breadcrumbs.more": `Flere elementer`,
    "button.pending": `avventer`,
    "contextualhelp.help": `Hjelp`,
    "contextualhelp.info": `Informasjon`,
    "dialog.alert": `Varsel`,
    "dialog.dismiss": `Lukk`,
    "dropzone.replaceMessage": `Slipp filen for \xe5 erstatte`,
    "inlinealert.informative": `Informasjon`,
    "inlinealert.negative": `Feil`,
    "inlinealert.notice": `Advarsel`,
    "inlinealert.positive": `Vellykket`,
    "label.(optional)": `(valgfritt)`,
    "label.(required)": `(obligatorisk)`,
    "menu.moreActions": `Flere handlinger`,
    "picker.placeholder": `Velg \u{2026}`,
    "slider.maximum": `Maksimum`,
    "slider.minimum": `Minimum`,
    "table.loading": `Laster inn...`,
    "table.loadingMore": `Laster inn flere...`,
    "table.resizeColumn": `Endre st\xf8rrelse p\xe5 kolonne`,
    "table.sortAscending": `Sorter stigende`,
    "table.sortDescending": `Sorter synkende`,
    "tag.actions": `Handlinger`,
    "tag.hideButtonLabel": `Vis mindre`,
    "tag.noTags": `Ingen`,
    "tag.showAllButtonLabel": (args, formatter)=>`Vis alle (${formatter.number(args.tagCount)})`
};

},{}],"iFKlM":[function(require,module,exports) {
module.exports = {
    "breadcrumbs.more": `Meer items`,
    "button.pending": `in behandeling`,
    "contextualhelp.help": `Help`,
    "contextualhelp.info": `Informatie`,
    "dialog.alert": `Melding`,
    "dialog.dismiss": `Negeren`,
    "dropzone.replaceMessage": `Bestand neerzetten om te vervangen`,
    "inlinealert.informative": `Informatie`,
    "inlinealert.negative": `Fout`,
    "inlinealert.notice": `Waarschuwing`,
    "inlinealert.positive": `Geslaagd`,
    "label.(optional)": `(optioneel)`,
    "label.(required)": `(vereist)`,
    "menu.moreActions": `Meer handelingen`,
    "picker.placeholder": `Selecteren\u{2026}`,
    "slider.maximum": `Maximum`,
    "slider.minimum": `Minimum`,
    "table.loading": `Laden...`,
    "table.loadingMore": `Meer laden...`,
    "table.resizeColumn": `Kolomgrootte wijzigen`,
    "table.sortAscending": `Oplopend sorteren`,
    "table.sortDescending": `Aflopend sorteren`,
    "tag.actions": `Acties`,
    "tag.hideButtonLabel": `Minder weergeven`,
    "tag.noTags": `Geen`,
    "tag.showAllButtonLabel": (args, formatter)=>`Alles tonen (${formatter.number(args.tagCount)})`
};

},{}],"hxrR0":[function(require,module,exports) {
module.exports = {
    "breadcrumbs.more": `Wi\u{119}cej element\xf3w`,
    "button.pending": `oczekuj\u{105}ce`,
    "contextualhelp.help": `Pomoc`,
    "contextualhelp.info": `Informacja`,
    "dialog.alert": `Ostrze\u{17C}enie`,
    "dialog.dismiss": `Zignoruj`,
    "dropzone.replaceMessage": `Upu\u{15B}\u{107} plik, aby zast\u{105}pi\u{107}`,
    "inlinealert.informative": `Informacja`,
    "inlinealert.negative": `B\u{142}\u{105}d`,
    "inlinealert.notice": `Ostrze\u{17C}enie`,
    "inlinealert.positive": `Powodzenie`,
    "label.(optional)": `(opcjonalne)`,
    "label.(required)": `(wymagane)`,
    "menu.moreActions": `Wi\u{119}cej akcji`,
    "picker.placeholder": `Zaznacz\u{2026}`,
    "slider.maximum": `Maksimum`,
    "slider.minimum": `Minimum`,
    "table.loading": `Wczytywanie...`,
    "table.loadingMore": `Wczytywanie wi\u{119}kszej liczby...`,
    "table.resizeColumn": `Zmie\u{144} rozmiar kolumny`,
    "table.sortAscending": `Sortuj rosn\u{105}co`,
    "table.sortDescending": `Sortuj malej\u{105}co`,
    "tag.actions": `Dzia\u{142}ania`,
    "tag.hideButtonLabel": `Wy\u{15B}wietl mniej`,
    "tag.noTags": `Brak`,
    "tag.showAllButtonLabel": (args, formatter)=>`Poka\u{17C} wszystko (${formatter.number(args.tagCount)})`
};

},{}],"hkDOg":[function(require,module,exports) {
module.exports = {
    "breadcrumbs.more": `Mais itens`,
    "button.pending": `pendente`,
    "contextualhelp.help": `Ajuda`,
    "contextualhelp.info": `Informa\xe7\xf5es`,
    "dialog.alert": `Alerta`,
    "dialog.dismiss": `Descartar`,
    "dropzone.replaceMessage": `Solte o arquivo para substituir`,
    "inlinealert.informative": `Informa\xe7\xf5es`,
    "inlinealert.negative": `Erro`,
    "inlinealert.notice": `Aviso`,
    "inlinealert.positive": `Sucesso`,
    "label.(optional)": `(opcional)`,
    "label.(required)": `(obrigat\xf3rio)`,
    "menu.moreActions": `Mais a\xe7\xf5es`,
    "picker.placeholder": `Selecionar\u{2026}`,
    "slider.maximum": `M\xe1ximo`,
    "slider.minimum": `M\xednimo`,
    "table.loading": `Carregando...`,
    "table.loadingMore": `Carregando mais...`,
    "table.resizeColumn": `Redimensionar coluna`,
    "table.sortAscending": `Ordenar por ordem crescente`,
    "table.sortDescending": `Ordenar por ordem decrescente`,
    "tag.actions": `A\xe7\xf5es`,
    "tag.hideButtonLabel": `Mostrar menos`,
    "tag.noTags": `Nenhum`,
    "tag.showAllButtonLabel": (args, formatter)=>`Mostrar tudo (${formatter.number(args.tagCount)})`
};

},{}],"d6EvE":[function(require,module,exports) {
module.exports = {
    "breadcrumbs.more": `More items`,
    "button.pending": `pendente`,
    "contextualhelp.help": `Ajuda`,
    "contextualhelp.info": `Informa\xe7\xe3o`,
    "dialog.alert": `Alerta`,
    "dialog.dismiss": `Dispensar`,
    "dropzone.replaceMessage": `Largar ficheiro para substituir`,
    "inlinealert.informative": `Informa\xe7\xe3o`,
    "inlinealert.negative": `Erro`,
    "inlinealert.notice": `Aviso`,
    "inlinealert.positive": `Sucesso`,
    "label.(optional)": `(opcional)`,
    "label.(required)": `(obrigat\xf3rio)`,
    "menu.moreActions": `Mais a\xe7\xf5es`,
    "picker.placeholder": `Selecionar\u{2026}`,
    "slider.maximum": `M\xe1ximo`,
    "slider.minimum": `M\xednimo`,
    "table.loading": `A carregar...`,
    "table.loadingMore": `A carregar mais...`,
    "table.resizeColumn": `Redimensionar coluna`,
    "table.sortAscending": `Ordenar por ordem ascendente`,
    "table.sortDescending": `Ordenar por ordem decrescente`,
    "tag.actions": `A\xe7\xf5es`,
    "tag.hideButtonLabel": `Mostrar menos`,
    "tag.noTags": `Nenhum`,
    "tag.showAllButtonLabel": (args, formatter)=>`Mostrar tudo (${formatter.number(args.tagCount)})`
};

},{}],"cqXSj":[function(require,module,exports) {
module.exports = {
    "breadcrumbs.more": `More items`,
    "button.pending": `\xeen a\u{219}teptare`,
    "contextualhelp.help": `Ajutor`,
    "contextualhelp.info": `Informa\u{21B}ii`,
    "dialog.alert": `Alert\u{103}`,
    "dialog.dismiss": `Revocare`,
    "dropzone.replaceMessage": `Plasa\u{21B}i fi\u{219}ierul pentru a \xeenlocui`,
    "inlinealert.informative": `Informa\u{21B}ii`,
    "inlinealert.negative": `Eroare`,
    "inlinealert.notice": `Avertisment`,
    "inlinealert.positive": `Succes`,
    "label.(optional)": `(op\u{163}ional)`,
    "label.(required)": `(obligatoriu)`,
    "menu.moreActions": `Mai multe ac\u{21B}iuni`,
    "picker.placeholder": `Selecta\u{21B}i\u{2026}`,
    "slider.maximum": `Maximum`,
    "slider.minimum": `Minimum`,
    "table.loading": `Se \xeencarc\u{103}...`,
    "table.loadingMore": `Se \xeencarc\u{103} mai multe...`,
    "table.resizeColumn": `Redimensiona\u{21B}i coloana`,
    "table.sortAscending": `Sorta\u{21B}i cresc\u{103}tor`,
    "table.sortDescending": `Sorta\u{21B}i descresc\u{103}tor`,
    "tag.actions": `Ac\u{21B}iuni`,
    "tag.hideButtonLabel": `Se afi\u{219}eaz\u{103} mai pu\u{21B}in`,
    "tag.noTags": `Niciuna`,
    "tag.showAllButtonLabel": (args, formatter)=>`Se afi\u{219}eaz\u{103} tot (${formatter.number(args.tagCount)})`
};

},{}],"dQeCS":[function(require,module,exports) {
module.exports = {
    "breadcrumbs.more": `\u{414}\u{43E}\u{43F}\u{43E}\u{43B}\u{43D}\u{438}\u{442}\u{435}\u{43B}\u{44C}\u{43D}\u{44B}\u{435} \u{44D}\u{43B}\u{435}\u{43C}\u{435}\u{43D}\u{442}\u{44B}`,
    "button.pending": `\u{432} \u{43E}\u{436}\u{438}\u{434}\u{430}\u{43D}\u{438}\u{438}`,
    "contextualhelp.help": `\u{421}\u{43F}\u{440}\u{430}\u{432}\u{43A}\u{430}`,
    "contextualhelp.info": `\u{418}\u{43D}\u{444}\u{43E}\u{440}\u{43C}\u{430}\u{446}\u{438}\u{44F}`,
    "dialog.alert": `\u{41F}\u{440}\u{435}\u{434}\u{443}\u{43F}\u{440}\u{435}\u{436}\u{434}\u{435}\u{43D}\u{438}\u{435}`,
    "dialog.dismiss": `\u{41F}\u{440}\u{43E}\u{43F}\u{443}\u{441}\u{442}\u{438}\u{442}\u{44C}`,
    "dropzone.replaceMessage": `\u{41F}\u{435}\u{440}\u{435}\u{442}\u{430}\u{449}\u{438}\u{442}\u{435} \u{444}\u{430}\u{439}\u{43B} \u{434}\u{43B}\u{44F} \u{437}\u{430}\u{43C}\u{435}\u{43D}\u{44B}`,
    "inlinealert.informative": `\u{418}\u{43D}\u{444}\u{43E}\u{440}\u{43C}\u{430}\u{446}\u{438}\u{44F}`,
    "inlinealert.negative": `\u{41E}\u{448}\u{438}\u{431}\u{43A}\u{430}`,
    "inlinealert.notice": `\u{41F}\u{440}\u{435}\u{434}\u{443}\u{43F}\u{440}\u{435}\u{436}\u{434}\u{435}\u{43D}\u{438}\u{435}`,
    "inlinealert.positive": `\u{423}\u{441}\u{43F}\u{435}\u{448}\u{43D}\u{43E}`,
    "label.(optional)": `(\u{434}\u{43E}\u{43F}\u{43E}\u{43B}\u{43D}\u{438}\u{442}\u{435}\u{43B}\u{44C}\u{43D}\u{43E})`,
    "label.(required)": `(\u{43E}\u{431}\u{44F}\u{437}\u{430}\u{442}\u{435}\u{43B}\u{44C}\u{43D}\u{43E})`,
    "menu.moreActions": `\u{414}\u{43E}\u{43F}\u{43E}\u{43B}\u{43D}\u{438}\u{442}\u{435}\u{43B}\u{44C}\u{43D}\u{44B}\u{435} \u{434}\u{435}\u{439}\u{441}\u{442}\u{432}\u{438}\u{44F}`,
    "picker.placeholder": `\u{412}\u{44B}\u{431}\u{440}\u{430}\u{442}\u{44C}\u{2026}`,
    "slider.maximum": `\u{41C}\u{430}\u{43A}\u{441}\u{438}\u{43C}\u{443}\u{43C}`,
    "slider.minimum": `\u{41C}\u{438}\u{43D}\u{438}\u{43C}\u{443}\u{43C}`,
    "table.loading": `\u{417}\u{430}\u{433}\u{440}\u{443}\u{437}\u{43A}\u{430}...`,
    "table.loadingMore": `\u{414}\u{43E}\u{43F}\u{43E}\u{43B}\u{43D}\u{438}\u{442}\u{435}\u{43B}\u{44C}\u{43D}\u{430}\u{44F} \u{437}\u{430}\u{433}\u{440}\u{443}\u{437}\u{43A}\u{430}...`,
    "table.resizeColumn": `\u{418}\u{437}\u{43C}\u{435}\u{43D}\u{438}\u{442}\u{44C} \u{440}\u{430}\u{437}\u{43C}\u{435}\u{440} \u{441}\u{442}\u{43E}\u{43B}\u{431}\u{446}\u{430}`,
    "table.sortAscending": `\u{421}\u{43E}\u{440}\u{442}\u{438}\u{440}\u{43E}\u{432}\u{430}\u{442}\u{44C} \u{43F}\u{43E} \u{432}\u{43E}\u{437}\u{440}\u{430}\u{441}\u{442}\u{430}\u{43D}\u{438}\u{44E}`,
    "table.sortDescending": `\u{421}\u{43E}\u{440}\u{442}\u{438}\u{440}\u{43E}\u{432}\u{430}\u{442}\u{44C} \u{43F}\u{43E} \u{443}\u{431}\u{44B}\u{432}\u{430}\u{43D}\u{438}\u{44E}`,
    "tag.actions": `\u{414}\u{435}\u{439}\u{441}\u{442}\u{432}\u{438}\u{44F}`,
    "tag.hideButtonLabel": `\u{41F}\u{43E}\u{43A}\u{430}\u{437}\u{430}\u{442}\u{44C} \u{43C}\u{435}\u{43D}\u{44C}\u{448}\u{435}`,
    "tag.noTags": `\u{41D}\u{435}\u{442}`,
    "tag.showAllButtonLabel": (args, formatter)=>`\u{41F}\u{43E}\u{43A}\u{430}\u{437}\u{430}\u{442}\u{44C} \u{432}\u{441}\u{435} (${formatter.number(args.tagCount)})`
};

},{}],"8gWNE":[function(require,module,exports) {
module.exports = {
    "breadcrumbs.more": `More items`,
    "button.pending": `\u{10D}akaj\xface`,
    "contextualhelp.help": `Pomoc`,
    "contextualhelp.info": `Inform\xe1cie`,
    "dialog.alert": `Upozornenie`,
    "dialog.dismiss": `Zru\u{161}i\u{165}`,
    "dropzone.replaceMessage": `Presu\u{148}te s\xfabor, ktor\xfd chcete nahradi\u{165}`,
    "inlinealert.informative": `Inform\xe1cie`,
    "inlinealert.negative": `Chyba`,
    "inlinealert.notice": `Upozornenie`,
    "inlinealert.positive": `\xdaspech`,
    "label.(optional)": `(nepovinn\xe9)`,
    "label.(required)": `(povinn\xe9)`,
    "menu.moreActions": `\u{10E}al\u{161}ie akcie`,
    "picker.placeholder": `Vybra\u{165}\u{2026}`,
    "slider.maximum": `Maximum`,
    "slider.minimum": `Minimum`,
    "table.loading": `Na\u{10D}\xedtava sa...`,
    "table.loadingMore": `Na\u{10D}\xedtava sa viac...`,
    "table.resizeColumn": `Zmeni\u{165} ve\u{13E}kos\u{165} st\u{13A}pca`,
    "table.sortAscending": `Zoradi\u{165} vzostupne`,
    "table.sortDescending": `Zoradi\u{165} zostupne`,
    "tag.actions": `Akcie`,
    "tag.hideButtonLabel": `Zobrazi\u{165} menej`,
    "tag.noTags": `\u{17D}iadne`,
    "tag.showAllButtonLabel": (args, formatter)=>`Zobrazi\u{165} v\u{161}etko (${formatter.number(args.tagCount)})`
};

},{}],"1aj9G":[function(require,module,exports) {
module.exports = {
    "breadcrumbs.more": `More items`,
    "button.pending": `v teku`,
    "contextualhelp.help": `Pomo\u{10D}`,
    "contextualhelp.info": `Informacije`,
    "dialog.alert": `Opozorilo`,
    "dialog.dismiss": `Opusti`,
    "dropzone.replaceMessage": `Spustite datoteko za zamenjavo`,
    "inlinealert.informative": `Informacije`,
    "inlinealert.negative": `Napaka`,
    "inlinealert.notice": `Opozorilo`,
    "inlinealert.positive": `Uspe\u{161}no`,
    "label.(optional)": `(opcijsko)`,
    "label.(required)": `(obvezno)`,
    "menu.moreActions": `Ve\u{10D} mo\u{17E}nosti`,
    "picker.placeholder": `Izberite\u{2026}`,
    "slider.maximum": `Najve\u{10D}ji`,
    "slider.minimum": `Najmanj`,
    "table.loading": `Nalaganje...`,
    "table.loadingMore": `Nalaganje ve\u{10D} vsebine...`,
    "table.resizeColumn": `Spremeni velikost stolpca`,
    "table.sortAscending": `Razvrsti nara\u{161}\u{10D}ajo\u{10D}e`,
    "table.sortDescending": `Razvrsti padajo\u{10D}e`,
    "tag.actions": `Dejanja`,
    "tag.hideButtonLabel": `Prika\u{17E}i manj`,
    "tag.noTags": `Ni\u{10D}`,
    "tag.showAllButtonLabel": (args, formatter)=>`Prika\u{17E} vse (${formatter.number(args.tagCount)})`
};

},{}],"8iOHN":[function(require,module,exports) {
module.exports = {
    "breadcrumbs.more": `More items`,
    "button.pending": `nere\u{161}eno`,
    "contextualhelp.help": `Pomo\u{107}`,
    "contextualhelp.info": `Informacije`,
    "dialog.alert": `Upozorenje`,
    "dialog.dismiss": `Odbaci`,
    "dropzone.replaceMessage": `Otpustite datoteku radi zamene`,
    "inlinealert.informative": `Informacije`,
    "inlinealert.negative": `Gre\u{161}ka`,
    "inlinealert.notice": `Upozorenje`,
    "inlinealert.positive": `Uspe\u{161}no`,
    "label.(optional)": `(opciono)`,
    "label.(required)": `(obavezno)`,
    "menu.moreActions": `Dodatne radnje`,
    "picker.placeholder": `Izaberite...`,
    "slider.maximum": `Najvi\u{161}e`,
    "slider.minimum": `Najmanje`,
    "table.loading": `U\u{10D}itavam...`,
    "table.loadingMore": `U\u{10D}itavam jo\u{161}...`,
    "table.resizeColumn": `Promeni veli\u{10D}inu kolone`,
    "table.sortAscending": `Sortiraj po rastu\u{107}em redosledu`,
    "table.sortDescending": `Sortiraj po opadaju\u{107}em redosledu`,
    "tag.actions": `Radnje`,
    "tag.hideButtonLabel": `Prika\u{17E}i manje`,
    "tag.noTags": `Ne postoji`,
    "tag.showAllButtonLabel": (args, formatter)=>`Prika\u{17E}i sve (${formatter.number(args.tagCount)})`
};

},{}],"eg2bi":[function(require,module,exports) {
module.exports = {
    "breadcrumbs.more": `Fler alternativ`,
    "button.pending": `v\xe4ntande`,
    "contextualhelp.help": `Hj\xe4lp`,
    "contextualhelp.info": `Information`,
    "dialog.alert": `Varning`,
    "dialog.dismiss": `Avvisa`,
    "dropzone.replaceMessage": `Sl\xe4pp filen f\xf6r att ers\xe4tta`,
    "inlinealert.informative": `Information`,
    "inlinealert.negative": `Fel`,
    "inlinealert.notice": `Varning`,
    "inlinealert.positive": `Lyckades`,
    "label.(optional)": `(valfritt)`,
    "label.(required)": `(kr\xe4vs)`,
    "menu.moreActions": `Fler \xe5tg\xe4rder`,
    "picker.placeholder": `V\xe4lj\u{2026}`,
    "slider.maximum": `Maximum`,
    "slider.minimum": `Minimum`,
    "table.loading": `L\xe4ser in...`,
    "table.loadingMore": `L\xe4ser in mer...`,
    "table.resizeColumn": `\xc4ndra storlek p\xe5 kolumn`,
    "table.sortAscending": `Sortera i stigande ordning`,
    "table.sortDescending": `Sortera i fallande ordning`,
    "tag.actions": `\xc5tg\xe4rder`,
    "tag.hideButtonLabel": `Visa mindre`,
    "tag.noTags": `Ingen`,
    "tag.showAllButtonLabel": (args, formatter)=>`Visa alla (${formatter.number(args.tagCount)})`
};

},{}],"66jZO":[function(require,module,exports) {
module.exports = {
    "breadcrumbs.more": `Daha Fazla \xd6\u{11F}e`,
    "button.pending": `beklemede`,
    "contextualhelp.help": `Yard\u{131}m`,
    "contextualhelp.info": `Bilgiler`,
    "dialog.alert": `Uyar\u{131}`,
    "dialog.dismiss": `Kapat`,
    "dropzone.replaceMessage": `De\u{11F}i\u{15F}tirmek i\xe7in dosyay\u{131} b\u{131}rak\u{131}n`,
    "inlinealert.informative": `Bilgiler`,
    "inlinealert.negative": `Hata`,
    "inlinealert.notice": `Uyar\u{131}`,
    "inlinealert.positive": `Ba\u{15F}ar\u{131}l\u{131}`,
    "label.(optional)": `(iste\u{11F}e ba\u{11F}l\u{131})`,
    "label.(required)": `(gerekli)`,
    "menu.moreActions": `Daha fazla eylem`,
    "picker.placeholder": `Se\xe7in\u{2026}`,
    "slider.maximum": `Maksimum`,
    "slider.minimum": `Minimum`,
    "table.loading": `Y\xfckleniyor...`,
    "table.loadingMore": `Daha fazla y\xfckleniyor...`,
    "table.resizeColumn": `S\xfctunu yeniden boyutland\u{131}r`,
    "table.sortAscending": `Artan S\u{131}ralama`,
    "table.sortDescending": `Azalan S\u{131}ralama`,
    "tag.actions": `Eylemler`,
    "tag.hideButtonLabel": `Daha az g\xf6ster`,
    "tag.noTags": `Hi\xe7biri`,
    "tag.showAllButtonLabel": (args, formatter)=>`T\xfcm\xfcn\xfc g\xf6ster (${formatter.number(args.tagCount)})`
};

},{}],"1d6PE":[function(require,module,exports) {
module.exports = {
    "breadcrumbs.more": `More items`,
    "button.pending": `\u{432} \u{43E}\u{447}\u{456}\u{43A}\u{443}\u{432}\u{430}\u{43D}\u{43D}\u{456}`,
    "contextualhelp.help": `\u{414}\u{43E}\u{432}\u{456}\u{434}\u{43A}\u{430}`,
    "contextualhelp.info": `\u{406}\u{43D}\u{444}\u{43E}\u{440}\u{43C}\u{430}\u{446}\u{456}\u{44F}`,
    "dialog.alert": `\u{421}\u{438}\u{433}\u{43D}\u{430}\u{43B} \u{442}\u{440}\u{438}\u{432}\u{43E}\u{433}\u{438}`,
    "dialog.dismiss": `\u{421}\u{43A}\u{430}\u{441}\u{443}\u{432}\u{430}\u{442}\u{438}`,
    "dropzone.replaceMessage": `\u{41F}\u{435}\u{440}\u{435}\u{442}\u{44F}\u{433}\u{43D}\u{456}\u{442}\u{44C} \u{444}\u{430}\u{439}\u{43B} \u{434}\u{43B}\u{44F} \u{437}\u{430}\u{43C}\u{456}\u{43D}\u{438}`,
    "inlinealert.informative": `\u{406}\u{43D}\u{444}\u{43E}\u{440}\u{43C}\u{430}\u{446}\u{456}\u{44F}`,
    "inlinealert.negative": `\u{41F}\u{43E}\u{43C}\u{438}\u{43B}\u{43A}\u{430}`,
    "inlinealert.notice": `\u{41F}\u{43E}\u{43F}\u{435}\u{440}\u{435}\u{434}\u{436}\u{435}\u{43D}\u{43D}\u{44F}`,
    "inlinealert.positive": `\u{423}\u{441}\u{43F}\u{456}\u{448}\u{43D}\u{43E}`,
    "label.(optional)": `(\u{43D}\u{435}\u{43E}\u{431}\u{43E}\u{432}\u{2019}\u{44F}\u{437}\u{43A}\u{43E}\u{432}\u{43E})`,
    "label.(required)": `(\u{43E}\u{431}\u{43E}\u{432}\u{2019}\u{44F}\u{437}\u{43A}\u{43E}\u{432}\u{43E})`,
    "menu.moreActions": `\u{411}\u{456}\u{43B}\u{44C}\u{448}\u{435} \u{434}\u{456}\u{439}`,
    "picker.placeholder": `\u{412}\u{438}\u{431}\u{440}\u{430}\u{442}\u{438}\u{2026}`,
    "slider.maximum": `\u{41C}\u{430}\u{43A}\u{441}\u{438}\u{43C}\u{443}\u{43C}`,
    "slider.minimum": `\u{41C}\u{456}\u{43D}\u{456}\u{43C}\u{443}\u{43C}`,
    "table.loading": `\u{417}\u{430}\u{432}\u{430}\u{43D}\u{442}\u{430}\u{436}\u{435}\u{43D}\u{43D}\u{44F}\u{2026}`,
    "table.loadingMore": `\u{417}\u{430}\u{432}\u{430}\u{43D}\u{442}\u{430}\u{436}\u{435}\u{43D}\u{43D}\u{44F} \u{456}\u{43D}\u{448}\u{438}\u{445} \u{43E}\u{431}\u{2019}\u{454}\u{43A}\u{442}\u{456}\u{432}...`,
    "table.resizeColumn": `\u{417}\u{43C}\u{456}\u{43D}\u{438}\u{442}\u{438} \u{440}\u{43E}\u{437}\u{43C}\u{456}\u{440} \u{441}\u{442}\u{43E}\u{432}\u{43F}\u{446}\u{44F}`,
    "table.sortAscending": `\u{421}\u{43E}\u{440}\u{442}\u{443}\u{432}\u{430}\u{442}\u{438} \u{437}\u{430} \u{437}\u{440}\u{43E}\u{441}\u{442}\u{430}\u{43D}\u{43D}\u{44F}\u{43C}`,
    "table.sortDescending": `\u{421}\u{43E}\u{440}\u{442}\u{443}\u{432}\u{430}\u{442}\u{438} \u{437}\u{430} \u{441}\u{43F}\u{430}\u{434}\u{430}\u{43D}\u{43D}\u{44F}\u{43C}`,
    "tag.actions": `\u{414}\u{456}\u{457}`,
    "tag.hideButtonLabel": `\u{41F}\u{43E}\u{43A}\u{430}\u{437}\u{443}\u{432}\u{430}\u{442}\u{438} \u{43C}\u{435}\u{43D}\u{448}\u{435}`,
    "tag.noTags": `\u{41D}\u{435}\u{43C}\u{430}\u{454}`,
    "tag.showAllButtonLabel": (args, formatter)=>`\u{41F}\u{43E}\u{43A}\u{430}\u{437}\u{430}\u{442}\u{438} \u{432}\u{441}\u{456} (${formatter.number(args.tagCount)})`
};

},{}],"fgRoW":[function(require,module,exports) {
module.exports = {
    "breadcrumbs.more": `\u{66F4}\u{591A}\u{9879}\u{76EE}`,
    "button.pending": `\u{5F85}\u{5904}\u{7406}`,
    "contextualhelp.help": `\u{5E2E}\u{52A9}`,
    "contextualhelp.info": `\u{4FE1}\u{606F}`,
    "dialog.alert": `\u{8B66}\u{62A5}`,
    "dialog.dismiss": `\u{53D6}\u{6D88}`,
    "dropzone.replaceMessage": `\u{5220}\u{9664}\u{8981}\u{66FF}\u{6362}\u{7684}\u{6587}\u{4EF6}`,
    "inlinealert.informative": `\u{4FE1}\u{606F}`,
    "inlinealert.negative": `\u{9519}\u{8BEF}`,
    "inlinealert.notice": `\u{8B66}\u{544A}`,
    "inlinealert.positive": `\u{6210}\u{529F}`,
    "label.(optional)": `\u{FF08}\u{53EF}\u{9009}\u{FF09}`,
    "label.(required)": `\u{FF08}\u{5FC5}\u{586B}\u{FF09}`,
    "menu.moreActions": `\u{66F4}\u{591A}\u{64CD}\u{4F5C}`,
    "picker.placeholder": `\u{9009}\u{62E9}...`,
    "slider.maximum": `\u{6700}\u{5927}`,
    "slider.minimum": `\u{6700}\u{5C0F}`,
    "table.loading": `\u{6B63}\u{5728}\u{52A0}\u{8F7D}...`,
    "table.loadingMore": `\u{6B63}\u{5728}\u{52A0}\u{8F7D}\u{66F4}\u{591A}...`,
    "table.resizeColumn": `\u{8C03}\u{6574}\u{5217}\u{5927}\u{5C0F}`,
    "table.sortAscending": `\u{5347}\u{5E8F}\u{6392}\u{5E8F}`,
    "table.sortDescending": `\u{964D}\u{5E8F}\u{6392}\u{5E8F}`,
    "tag.actions": `\u{64CD}\u{4F5C}`,
    "tag.hideButtonLabel": `\u{663E}\u{793A}\u{66F4}\u{5C11}`,
    "tag.noTags": `\u{65E0}`,
    "tag.showAllButtonLabel": (args, formatter)=>`\u{5168}\u{90E8}\u{663E}\u{793A} (${formatter.number(args.tagCount)})`
};

},{}],"dcZTv":[function(require,module,exports) {
module.exports = {
    "breadcrumbs.more": `\u{66F4}\u{591A}\u{9805}\u{76EE}`,
    "button.pending": `\u{5F85}\u{8655}\u{7406}`,
    "contextualhelp.help": `\u{8AAA}\u{660E}`,
    "contextualhelp.info": `\u{8CC7}\u{8A0A}`,
    "dialog.alert": `\u{8B66}\u{793A}`,
    "dialog.dismiss": `\u{95DC}\u{9589}`,
    "dropzone.replaceMessage": `\u{653E}\u{7F6E}\u{8981}\u{53D6}\u{4EE3}\u{7684}\u{6A94}\u{6848}`,
    "inlinealert.informative": `\u{8CC7}\u{8A0A}`,
    "inlinealert.negative": `\u{932F}\u{8AA4}`,
    "inlinealert.notice": `\u{8B66}\u{544A}`,
    "inlinealert.positive": `\u{6210}\u{529F}`,
    "label.(optional)": `(\u{9078}\u{586B})`,
    "label.(required)": `(\u{5FC5}\u{586B})`,
    "menu.moreActions": `\u{66F4}\u{591A}\u{52D5}\u{4F5C}`,
    "picker.placeholder": `\u{9078}\u{53D6}\u{2026}`,
    "slider.maximum": `\u{6700}\u{5927}\u{503C}`,
    "slider.minimum": `\u{6700}\u{5C0F}\u{503C}`,
    "table.loading": `\u{8F09}\u{5165}\u{4E2D}\u{2026}`,
    "table.loadingMore": `\u{6B63}\u{5728}\u{8F09}\u{5165}\u{66F4}\u{591A}\u{2026}`,
    "table.resizeColumn": `\u{8ABF}\u{6574}\u{6B04}\u{5927}\u{5C0F}`,
    "table.sortAscending": `\u{5347}\u{5E8F}\u{6392}\u{5E8F}`,
    "table.sortDescending": `\u{964D}\u{5E8F}\u{6392}\u{5E8F}`,
    "tag.actions": `\u{52D5}\u{4F5C}`,
    "tag.hideButtonLabel": `\u{986F}\u{793A}\u{8F03}\u{5C11}`,
    "tag.noTags": `\u{7121}`,
    "tag.showAllButtonLabel": (args, formatter)=>`\u{986F}\u{793A}\u{5168}\u{90E8} (${formatter.number(args.tagCount)})`
};

},{}],"l3wRP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ImageContext", ()=>ImageContext);
parcelHelpers.export(exports, "Image", ()=>_Image);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _imageCoordinator = require("./ImageCoordinator");
var _skeleton = require("./Skeleton");
var _runtime = require("../style/runtime");
var _utils = require("@react-aria/utils");
var _useSpectrumContextProps = require("./useSpectrumContextProps");
const ImageContext = /*#__PURE__*/ (0, _react.createContext)(null);
function createState(src) {
    return {
        state: 'loading',
        src,
        startTime: Date.now(),
        loadTime: 0
    };
}
function reducer(state, action) {
    switch(action.type){
        case 'update':
            return {
                state: 'loading',
                src: action.src,
                startTime: Date.now(),
                loadTime: 0
            };
        case 'loaded':
        case 'error':
            return {
                ...state,
                state: action.type
            };
        case 'revealed':
            return {
                ...state,
                state: 'revealed',
                loadTime: Date.now() - state.startTime
            };
        default:
            return state;
    }
}
const wrapperStyles = " . bg __vb __wb";
const imgStyles = function anonymous(props) {
    let rules = " .";
    rules += ' _Za';
    rules += ' lG';
    rules += ' kG';
    rules += ' __N-17zqamw';
    rules += ' __O-17zqamw';
    if (props.isRevealed) rules += ' _K-3t1y';
    else rules += ' _K-3t1x';
    if (props.isTransitioning) rules += ' _Oc';
    else rules += ' _Og';
    rules += ' _Q-3760fu';
    if (props.isTransitioning) rules += ' _Ra';
    else rules += ' _Ra';
    return rules;
};
function Image(props, domRef) {
    [props, domRef] = (0, _useSpectrumContextProps.useSpectrumContextProps)(props, domRef, ImageContext);
    let { src = '', styles, UNSAFE_className = '', UNSAFE_style, renderError, group = (0, _imageCoordinator.DefaultImageGroup), // TODO
    // srcSet,
    // sizes,
    alt, crossOrigin, decoding, loading, referrerPolicy } = props;
    let hidden = props.hidden;
    let { revealAll, register, unregister, load } = (0, _react.useContext)(group);
    let [{ state, src: lastSrc, loadTime }, dispatch] = (0, _react.useReducer)(reducer, src, createState);
    if (src !== lastSrc && !hidden) dispatch({
        type: 'update',
        src
    });
    if (state === 'loaded' && revealAll && !hidden) dispatch({
        type: 'revealed'
    });
    let imgRef = (0, _react.useRef)(null);
    (0, _utils.useLayoutEffect)(()=>{
        if (hidden) return;
        register(src);
        return ()=>{
            unregister(src);
        };
    }, [
        hidden,
        register,
        unregister,
        src
    ]);
    let onLoad = (0, _react.useCallback)(()=>{
        load(src);
        dispatch({
            type: 'loaded'
        });
    }, [
        load,
        src
    ]);
    let onError = (0, _react.useCallback)(()=>{
        dispatch({
            type: 'error'
        });
        unregister(src);
    }, [
        unregister,
        src
    ]);
    let isSkeleton = (0, _skeleton.useIsSkeleton)();
    let isAnimating = isSkeleton || state === 'loading' || state === 'loaded';
    let animation = (0, _skeleton.useLoadingAnimation)(isAnimating);
    (0, _utils.useLayoutEffect)(()=>{
        if (hidden) return;
        // If the image is already loaded, update state immediately instead of waiting for onLoad.
        if (state === 'loading' && imgRef.current?.complete) // Queue a microtask so we don't hit React's update limit.
        // TODO: is this necessary?
        queueMicrotask(onLoad);
        animation(domRef.current);
    });
    if (props.alt == null) console.warn('The `alt` prop was not provided to an image. Add `alt` text for screen readers, or set `alt=""` prop to indicate that the image is decorative or redundant with displayed text and should not be announced by screen readers.');
    let errorState = !isSkeleton && state === 'error' && renderError?.();
    let isRevealed = state === 'revealed' && !isSkeleton;
    let isTransitioning = isRevealed && loadTime > 200;
    return (0, _react.useMemo)(()=>hidden ? null : /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            ref: domRef,
            style: UNSAFE_style,
            className: UNSAFE_className + (0, _runtime.mergeStyles)(wrapperStyles, styles) + ' ' + (isAnimating ? (0, _skeleton.loadingStyle) : ''),
            children: [
                errorState,
                !errorState && /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                    src: src,
                    alt: alt,
                    crossOrigin: crossOrigin,
                    decoding: decoding,
                    loading: loading,
                    referrerPolicy: referrerPolicy,
                    ref: imgRef,
                    onLoad: onLoad,
                    onError: onError,
                    className: imgStyles({
                        isRevealed,
                        isTransitioning
                    })
                })
            ]
        }), [
        hidden,
        domRef,
        UNSAFE_style,
        UNSAFE_className,
        styles,
        isAnimating,
        errorState,
        src,
        alt,
        crossOrigin,
        decoding,
        loading,
        referrerPolicy,
        onLoad,
        onError,
        isRevealed,
        isTransitioning
    ]);
}
const _Image = /*#__PURE__*/ (0, _react.forwardRef)(Image);
try {
    // @ts-ignore
    ImageContext.displayName = "ImageContext";
    // @ts-ignore
    ImageContext.__docgenInfo = {
        "description": "",
        "displayName": "ImageContext",
        "props": {
            "value": {
                "defaultValue": null,
                "description": "",
                "name": "value",
                "required": true,
                "type": {
                    "name": "ContextValue<ImageContextValue, HTMLDivElement>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/Image.tsx#ImageContext"] = {
        docgenInfo: ImageContext.__docgenInfo,
        name: "ImageContext",
        path: "packages/@react-spectrum/s2/src/Image.tsx#ImageContext"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    _Image.displayName = "_Image";
    // @ts-ignore
    _Image.__docgenInfo = {
        "description": "",
        "displayName": "_Image",
        "props": {
            "alt": {
                "defaultValue": null,
                "description": "Accessible alt text for the image.",
                "name": "alt",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "crossOrigin": {
                "defaultValue": null,
                "description": "Indicates if the fetching of the image must be done using a CORS request.\n[See MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/crossorigin).",
                "name": "crossOrigin",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"anonymous\""
                        },
                        {
                            "value": "\"use-credentials\""
                        }
                    ]
                }
            },
            "decoding": {
                "defaultValue": null,
                "description": "Whether the browser should decode images synchronously or asynchronously.\n[See MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/img#decoding).",
                "name": "decoding",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"auto\""
                        },
                        {
                            "value": "\"async\""
                        },
                        {
                            "value": "\"sync\""
                        }
                    ]
                }
            },
            "group": {
                "defaultValue": null,
                "description": "A group of images to coordinate between, matching the group passed to the `<ImageCoordinator>` component.\nIf not provided, the default image group is used.",
                "name": "group",
                "required": false,
                "type": {
                    "name": "ImageGroup"
                }
            },
            "loading": {
                "defaultValue": null,
                "description": "Whether the image should be loaded immediately or lazily when scrolled into view.\n[See MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/img#loading).",
                "name": "loading",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"eager\""
                        },
                        {
                            "value": "\"lazy\""
                        }
                    ]
                }
            },
            "referrerPolicy": {
                "defaultValue": null,
                "description": "A string indicating which referrer to use when fetching the resource.\n[See MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/img#referrerpolicy).",
                "name": "referrerPolicy",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"\""
                        },
                        {
                            "value": "\"no-referrer\""
                        },
                        {
                            "value": "\"no-referrer-when-downgrade\""
                        },
                        {
                            "value": "\"origin\""
                        },
                        {
                            "value": "\"origin-when-cross-origin\""
                        },
                        {
                            "value": "\"same-origin\""
                        },
                        {
                            "value": "\"strict-origin\""
                        },
                        {
                            "value": "\"strict-origin-when-cross-origin\""
                        },
                        {
                            "value": "\"unsafe-url\""
                        }
                    ]
                }
            },
            "renderError": {
                "defaultValue": null,
                "description": "A function that is called to render a fallback when the image fails to load.",
                "name": "renderError",
                "required": false,
                "type": {
                    "name": "() => ReactNode"
                }
            },
            "src": {
                "defaultValue": null,
                "description": "The URL of the image.",
                "name": "src",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "styles": {
                "defaultValue": null,
                "description": "Spectrum-defined styles, returned by the `style()` macro.",
                "name": "styles",
                "required": false,
                "type": {
                    "name": "StyleString"
                }
            },
            "UNSAFE_className": {
                "defaultValue": null,
                "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_className",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_style": {
                "defaultValue": null,
                "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_style",
                "required": false,
                "type": {
                    "name": "CSSProperties"
                }
            },
            "key": {
                "defaultValue": null,
                "description": "",
                "name": "key",
                "required": false,
                "type": {
                    "name": "Key"
                }
            },
            "ref": {
                "defaultValue": null,
                "description": "Allows getting a ref to the component instance.\nOnce the component unmounts, React will set `ref.current` to `null`\n(or call the ref with `null` if you passed a callback ref).\n@see {@link https://react.dev/learn/referencing-values-with-refs#refs-and-the-dom React Docs}",
                "name": "ref",
                "required": false,
                "type": {
                    "name": "Ref<HTMLDivElement>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/Image.tsx#_Image"] = {
        docgenInfo: _Image.__docgenInfo,
        name: "_Image",
        path: "packages/@react-spectrum/s2/src/Image.tsx#_Image"
    };
} catch (__react_docgen_typescript_loader_error) {}

},{"0":"3F3UA","1":"gSzLI","react/jsx-runtime":"2JzhG","react":"jEiK2","./ImageCoordinator":"2Xi55","./Skeleton":"2hWWB","../style/runtime":"dzhKB","@react-aria/utils":"e9Yvo","./useSpectrumContextProps":"ileU6","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"3F3UA":[function() {},{}],"gSzLI":[function() {},{}],"2Xi55":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DefaultImageGroup", ()=>DefaultImageGroup);
parcelHelpers.export(exports, "createImageGroup", ()=>createImageGroup);
/**
 * An ImageCoordinator coordinates loading behavior for a group of images.
 * Images within an ImageCoordinator are revealed together once all of them have loaded.
 */ parcelHelpers.export(exports, "ImageCoordinator", ()=>ImageCoordinator);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const defaultContext = {
    revealAll: true,
    register () {},
    unregister () {},
    load () {}
};
const DefaultImageGroup = createImageGroup();
function createImageGroup() {
    return /*#__PURE__*/ (0, _react.createContext)(defaultContext);
}
function reducer(state, action) {
    switch(action.type){
        case 'register':
            if (state.loaded.get(action.url) !== false) {
                let loaded = new Map(state.loaded);
                loaded.set(action.url, false);
                return {
                    loadedAll: false,
                    // If we had previously loaded all items, then reset the timed out state
                    // since this is the first item of a new batch.
                    timedOut: state.loadedAll ? false : state.timedOut,
                    loadStartTime: state.loadedAll ? Date.now() : state.loadStartTime,
                    loaded
                };
            }
            return state;
        case 'unregister':
            if (state.loaded.has(action.url)) {
                let loaded = new Map(state.loaded);
                loaded.delete(action.url);
                return {
                    loadedAll: isAllLoaded(loaded),
                    timedOut: state.timedOut,
                    loadStartTime: state.loadStartTime,
                    loaded
                };
            }
            return state;
        case 'load':
            if (state.loaded.get(action.url) === false) {
                let loaded = new Map(state.loaded);
                loaded.set(action.url, true);
                return {
                    loadedAll: isAllLoaded(loaded),
                    timedOut: state.timedOut,
                    loadStartTime: state.loadStartTime,
                    loaded
                };
            }
            return state;
        case 'timeout':
            if (!state.loadedAll && !state.timedOut) return {
                ...state,
                timedOut: true
            };
            return state;
        default:
            return state;
    }
}
function isAllLoaded(loaded) {
    for (let isLoaded of loaded.values()){
        if (!isLoaded) return false;
    }
    return true;
}
function ImageCoordinator(props) {
    // If we are already inside another ImageCoordinator, just pass
    // through children and coordinate loading at the root.
    let ctx = (0, _react.useContext)(props.group || DefaultImageGroup);
    if (ctx !== defaultContext) return props.children;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(ImageCoordinatorRoot, {
        ...props
    });
}
function ImageCoordinatorRoot(props) {
    let { children, timeout = 5000, group = DefaultImageGroup } = props;
    let [{ loadedAll, timedOut, loadStartTime }, dispatch] = (0, _react.useReducer)(reducer, {
        loadedAll: true,
        timedOut: false,
        loadStartTime: 0,
        loaded: new Map()
    });
    let register = (0, _react.useCallback)((url)=>dispatch({
            type: 'register',
            url
        }), []);
    let unregister = (0, _react.useCallback)((url)=>dispatch({
            type: 'unregister',
            url
        }), []);
    let load = (0, _react.useCallback)((url)=>dispatch({
            type: 'load',
            url
        }), []);
    (0, _react.useEffect)(()=>{
        if (!loadedAll) {
            let timeoutId = setTimeout(()=>{
                dispatch({
                    type: 'timeout'
                });
            }, loadStartTime + timeout - Date.now());
            return ()=>clearTimeout(timeoutId);
        }
    }, [
        loadStartTime,
        loadedAll,
        timeout
    ]);
    let revealAll = loadedAll || timedOut;
    return (0, _react.useMemo)(()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(group.Provider, {
            value: {
                revealAll,
                register,
                unregister,
                load
            },
            children: children
        }), [
        group,
        children,
        revealAll,
        register,
        unregister,
        load
    ]);
}
try {
    // @ts-ignore
    ImageCoordinator.displayName = "ImageCoordinator";
    // @ts-ignore
    ImageCoordinator.__docgenInfo = {
        "description": "An ImageCoordinator coordinates loading behavior for a group of images.\nImages within an ImageCoordinator are revealed together once all of them have loaded.",
        "displayName": "ImageCoordinator",
        "props": {
            "children": {
                "defaultValue": null,
                "description": "Children within the ImageCoordinator.",
                "name": "children",
                "required": true,
                "type": {
                    "name": "ReactNode"
                }
            },
            "group": {
                "defaultValue": null,
                "description": "A group of images to coordinate between, matching the group passed to the `<Image>` component.\nIf not provided, the default image group is used.",
                "name": "group",
                "required": false,
                "type": {
                    "name": "ImageGroup"
                }
            },
            "timeout": {
                "defaultValue": {
                    value: "5000"
                },
                "description": "Time in milliseconds after which images are always displayed, even if all images are not yet loaded.",
                "name": "timeout",
                "required": false,
                "type": {
                    "name": "number"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/ImageCoordinator.tsx#ImageCoordinator"] = {
        docgenInfo: ImageCoordinator.__docgenInfo,
        name: "ImageCoordinator",
        path: "packages/@react-spectrum/s2/src/ImageCoordinator.tsx#ImageCoordinator"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    DefaultImageGroup.displayName = "DefaultImageGroup";
    // @ts-ignore
    DefaultImageGroup.__docgenInfo = {
        "description": "",
        "displayName": "DefaultImageGroup",
        "props": {
            "value": {
                "defaultValue": null,
                "description": "",
                "name": "value",
                "required": true,
                "type": {
                    "name": "ImageGroupValue"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/ImageCoordinator.tsx#DefaultImageGroup"] = {
        docgenInfo: DefaultImageGroup.__docgenInfo,
        name: "DefaultImageGroup",
        path: "packages/@react-spectrum/s2/src/ImageCoordinator.tsx#DefaultImageGroup"
    };
} catch (__react_docgen_typescript_loader_error) {}

},{"react/jsx-runtime":"2JzhG","react":"jEiK2","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"3Y0dA":[function(require,module,exports) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Popover", ()=>_Popover);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _provider = require("./Provider");
var _react = require("react");
var _runtime = require("../style/runtime");
var _utils = require("@react-spectrum/utils");
const fadeKeyframes = "-_1llqja1";
const slideUpKeyframes = "-xohm13";
const slideDownKeyframes = "-_2hjlm";
const slideRightKeyframes = "-_1s1guk8";
const slideLeftKeyframes = "-_1dp80kl";
let popover = function anonymous(props, overrides) {
    let rules = " .";
    let matches = (overrides || '').match(/(?:^|\s)(?:y|z|A|B|_9|_8|h|_5|_4|__A|__c|__d|__a|__b|U|__Q|X|Z|V|W|l|q|r)[^\s]+/g) || [];
    rules += matches.join('');
    let $l = false;
    for (let p of matches)if (/^\s*l/.test(p)) $l = true;
    if (props.colorScheme === "dark") rules += ' _Ab';
    else if (props.colorScheme === "light") rules += ' _Aa';
    else if (props.colorScheme === "light dark") rules += ' _Ac';
    else rules += ' _A-10jn6wd';
    rules += ' -_1de2x0q_b-______k';
    rules += ' b-1de2x0q';
    rules += ' _vd';
    rules += ' _wd';
    rules += ' _xd';
    rules += ' _yd';
    if (props.isArrowShown) rules += ' _ub';
    if (props.isArrowShown) rules += ' _td';
    else rules += ' _tb';
    rules += ' wa';
    rules += ' ub';
    rules += ' vb';
    rules += ' sb';
    rules += ' tb';
    rules += ' ca_____v';
    rules += ' ch';
    if (!$l) {
        if (props.size === "L") rules += ' l-3940j6';
        else if (props.size === "M") rules += ' l-38elgx';
        else if (props.size === "S") rules += ' l-38aqto';
    }
    if (props.placement === "top") {
        if (props.isArrowShown) rules += ' QG';
    } else if (props.placement === "bottom") {
        if (props.isArrowShown) rules += ' Qd';
    }
    if (props.placement === "right") {
        if (props.isArrowShown) rules += ' Pd';
    } else if (props.placement === "left") {
        if (props.isArrowShown) rules += ' PG';
    }
    if (props.placement === "right") {
        if (props.isExiting) rules += ' _S-tlelkz';
        else if (props.isEntering) rules += ' _S-tlelkz';
    } else if (props.placement === "left") {
        if (props.isExiting) rules += ' _S-1hbwyb';
        else if (props.isEntering) rules += ' _S-1hbwyb';
    } else if (props.placement === "bottom") {
        if (props.isExiting) rules += ' _S-crq4zk';
        else if (props.isEntering) rules += ' _S-crq4zk';
    } else if (props.placement === "top") {
        if (props.isExiting) rules += ' _S-17xx2vw';
        else if (props.isEntering) rules += ' _S-17xx2vw';
    }
    if (props.isExiting) rules += ' _T-375xx3';
    else if (props.isEntering) rules += ' _T-375xx3';
    if (props.isExiting) rules += ' _Yc';
    if (props.isExiting) rules += ' _Vb';
    else if (props.isEntering) rules += ' _Va';
    rules += ' _O-19n1ox2';
    rules += ' _Q-375x7f';
    rules += ' _Ra';
    rules += ' __P-19n1ox2';
    rules += ' __Fa';
    if (props.isExiting) rules += ' __Ba';
    return rules;
};
// TODO: animations and real Popover Arrow
let arrow = function anonymous(props) {
    let rules = " .";
    rules += ' _Za';
    rules += ' e-1de2x0q';
    if (props.placement === "right") rules += ' R-3hn0u';
    else if (props.placement === "left") rules += ' R-375ty3';
    else if (props.placement === "bottom") rules += ' R-375xa6';
    else if (props.placement === "top") rules += ' R-3t1x';
    else rules += ' R-375xa6';
    if (props.placement === "right") rules += ' Pc';
    else if (props.placement === "left") rules += ' PF';
    rules += ' xb';
    rules += ' fa_____x';
    rules += ' fj';
    return rules;
};
function Popover(props, ref) {
    let { hideArrow = false, UNSAFE_className = '', UNSAFE_style, styles, size } = props;
    let domRef = (0, _utils.useDOMRef)(ref);
    let colorScheme = (0, _react.useContext)((0, _provider.ColorSchemeContext));
    let { locale, direction } = (0, _reactAriaComponents.useLocale)();
    // TODO: should we pass through lang and dir props in RAC?
    let popoverRef = (0, _react.useCallback)((el)=>{
        domRef.current = el;
        if (el) {
            el.lang = locale;
            el.dir = direction;
        }
    }, [
        locale,
        direction,
        domRef
    ]);
    // TODO: this still isn't the final popover 'tip', copying various ones out of the designs files yields different results
    // containerPadding not working as expected
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Popover), {
        ...props,
        ref: popoverRef,
        style: {
            ...UNSAFE_style,
            // Override default z-index from useOverlayPosition. We use isolation: isolate instead.
            zIndex: undefined
        },
        className: (renderProps)=>UNSAFE_className + (0, _runtime.mergeStyles)(popover({
                ...renderProps,
                size,
                isArrowShown: !hideArrow,
                colorScheme
            }), styles),
        children: (0, _reactAriaComponents.composeRenderProps)(props.children, (children, renderProps)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    !hideArrow && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.OverlayArrow), {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                            width: 18,
                            height: 9,
                            viewBox: "0 0 18 10",
                            className: arrow(renderProps),
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                transform: "translate(0 -1)",
                                d: "M1 1L7.93799 8.52588C8.07224 8.67448 8.23607 8.79362 8.41895 8.87524C8.60182 8.95687 8.79973 8.9993 9 9C9.19984 8.99882 9.39724 8.95606 9.57959 8.87427C9.76193 8.79248 9.9253 8.67336 10.0591 8.5249L17 1"
                            })
                        })
                    }),
                    children
                ]
            }))
    });
}
/**
 * A popover is an overlay element positioned relative to a trigger.
 */ let _Popover = /*#__PURE__*/ (0, _react.forwardRef)(Popover);
try {
    // @ts-ignore
    _Popover.displayName = "_Popover";
    // @ts-ignore
    _Popover.__docgenInfo = {
        "description": "A popover is an overlay element positioned relative to a trigger.",
        "displayName": "_Popover",
        "props": {
            "boundaryElement": {
                "defaultValue": {
                    value: "document.body"
                },
                "description": "Element that that serves as the positioning boundary.",
                "name": "boundaryElement",
                "required": false,
                "type": {
                    "name": "Element"
                }
            },
            "children": {
                "defaultValue": null,
                "description": "The children of the component. A function may be provided to alter the children based on component state.",
                "name": "children",
                "required": false,
                "type": {
                    "name": "ReactNode | ((values: PopoverRenderProps & { defaultChildren: ReactNode; }) => ReactNode)"
                }
            },
            "className": {
                "defaultValue": null,
                "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
                "name": "className",
                "required": false,
                "type": {
                    "name": "string | ((values: PopoverRenderProps & { defaultClassName: string; }) => string)"
                }
            },
            "containerPadding": {
                "defaultValue": {
                    value: "12"
                },
                "description": "The placement padding that should be applied between the element and its\nsurrounding container.",
                "name": "containerPadding",
                "required": false,
                "type": {
                    "name": "number"
                }
            },
            "crossOffset": {
                "defaultValue": {
                    value: "0"
                },
                "description": "The additional offset applied along the cross axis between the element and its\nanchor element.",
                "name": "crossOffset",
                "required": false,
                "type": {
                    "name": "number"
                }
            },
            "defaultOpen": {
                "defaultValue": null,
                "description": "Whether the overlay is open by default (uncontrolled).",
                "name": "defaultOpen",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "hideArrow": {
                "defaultValue": {
                    value: "false"
                },
                "description": "Whether a popover's arrow should be hidden.",
                "name": "hideArrow",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isEntering": {
                "defaultValue": null,
                "description": "Whether the popover is currently performing an entry animation.",
                "name": "isEntering",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isExiting": {
                "defaultValue": null,
                "description": "Whether the popover is currently performing an exit animation.",
                "name": "isExiting",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isOpen": {
                "defaultValue": null,
                "description": "Whether the overlay is open by default (controlled).",
                "name": "isOpen",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "maxHeight": {
                "defaultValue": null,
                "description": "The maxHeight specified for the overlay element.\nBy default, it will take all space up to the current viewport height.",
                "name": "maxHeight",
                "required": false,
                "type": {
                    "name": "number"
                }
            },
            "offset": {
                "defaultValue": {
                    value: "8"
                },
                "description": "The additional offset applied along the main axis between the element and its\nanchor element.",
                "name": "offset",
                "required": false,
                "type": {
                    "name": "number"
                }
            },
            "placement": {
                "defaultValue": {
                    value: "'bottom'"
                },
                "description": "The placement of the element with respect to its anchor element.",
                "name": "placement",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"top\""
                        },
                        {
                            "value": "\"bottom\""
                        },
                        {
                            "value": "\"start\""
                        },
                        {
                            "value": "\"end\""
                        },
                        {
                            "value": "\"left\""
                        },
                        {
                            "value": "\"right\""
                        },
                        {
                            "value": "\"left bottom\""
                        },
                        {
                            "value": "\"left top\""
                        },
                        {
                            "value": "\"right bottom\""
                        },
                        {
                            "value": "\"right top\""
                        },
                        {
                            "value": "\"top right\""
                        },
                        {
                            "value": "\"bottom right\""
                        },
                        {
                            "value": "\"bottom left\""
                        },
                        {
                            "value": "\"bottom start\""
                        },
                        {
                            "value": "\"bottom end\""
                        },
                        {
                            "value": "\"top left\""
                        },
                        {
                            "value": "\"top start\""
                        },
                        {
                            "value": "\"top end\""
                        },
                        {
                            "value": "\"start top\""
                        },
                        {
                            "value": "\"start bottom\""
                        },
                        {
                            "value": "\"end top\""
                        },
                        {
                            "value": "\"end bottom\""
                        }
                    ]
                }
            },
            "scrollRef": {
                "defaultValue": {
                    value: "overlayRef"
                },
                "description": "A ref for the scrollable region within the overlay.",
                "name": "scrollRef",
                "required": false,
                "type": {
                    "name": "RefObject<Element>"
                }
            },
            "shouldFlip": {
                "defaultValue": {
                    value: "true"
                },
                "description": "Whether the element should flip its orientation (e.g. top to bottom or left to right) when\nthere is insufficient room for it to render completely.",
                "name": "shouldFlip",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "size": {
                "defaultValue": null,
                "description": "",
                "name": "size",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"S\""
                        },
                        {
                            "value": "\"M\""
                        },
                        {
                            "value": "\"L\""
                        }
                    ]
                }
            },
            "style": {
                "defaultValue": null,
                "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
                "name": "style",
                "required": false,
                "type": {
                    "name": "CSSProperties | ((values: PopoverRenderProps & { defaultStyle: CSSProperties; }) => CSSProperties)"
                }
            },
            "styles": {
                "defaultValue": null,
                "description": "",
                "name": "styles",
                "required": false,
                "type": {
                    "name": "StyleString"
                }
            },
            "trigger": {
                "defaultValue": null,
                "description": "The name of the component that triggered the popover. This is reflected on the element\nas the `data-trigger` attribute, and can be used to provide specific\nstyles for the popover depending on which element triggered it.",
                "name": "trigger",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "triggerRef": {
                "defaultValue": null,
                "description": "The ref for the element which the popover positions itself with respect to.\n\nWhen used within a trigger component such as DialogTrigger, MenuTrigger, Select, etc.,\nthis is set automatically. It is only required when used standalone.",
                "name": "triggerRef",
                "required": false,
                "type": {
                    "name": "RefObject<Element>"
                }
            },
            "UNSAFE_className": {
                "defaultValue": null,
                "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_className",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_style": {
                "defaultValue": null,
                "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_style",
                "required": false,
                "type": {
                    "name": "CSSProperties"
                }
            },
            "UNSTABLE_portalContainer": {
                "defaultValue": {
                    value: "document.body"
                },
                "description": "The container element in which the overlay portal will be placed. This may have unknown behavior depending on where it is portalled to.",
                "name": "UNSTABLE_portalContainer",
                "required": false,
                "type": {
                    "name": "Element"
                }
            },
            "onOpenChange": {
                "defaultValue": null,
                "description": "Handler that is called when the overlay's open state changes.",
                "name": "onOpenChange",
                "required": false,
                "type": {
                    "name": "(isOpen: boolean) => void"
                }
            },
            "key": {
                "defaultValue": null,
                "description": "",
                "name": "key",
                "required": false,
                "type": {
                    "name": "Key"
                }
            },
            "ref": {
                "defaultValue": null,
                "description": "Allows getting a ref to the component instance.\nOnce the component unmounts, React will set `ref.current` to `null`\n(or call the ref with `null` if you passed a callback ref).\n@see {@link https://react.dev/learn/referencing-values-with-refs#refs-and-the-dom React Docs}",
                "name": "ref",
                "required": false,
                "type": {
                    "name": "Ref<DOMRefValue<HTMLDivElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/Popover.tsx#_Popover"] = {
        docgenInfo: _Popover.__docgenInfo,
        name: "_Popover",
        path: "packages/@react-spectrum/s2/src/Popover.tsx#_Popover"
    };
} catch (__react_docgen_typescript_loader_error) {}

},{"0":"cjfIk","1":"gGShr","2":"2nLst","3":"4Cm7w","4":"fHRpa","5":"aod34","6":"7uDsY","react/jsx-runtime":"2JzhG","react-aria-components":"8nuKL","./Provider":"hIsCH","react":"jEiK2","../style/runtime":"dzhKB","@react-spectrum/utils":"bebxO","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"cjfIk":[function() {},{}],"gGShr":[function() {},{}],"2nLst":[function() {},{}],"4Cm7w":[function() {},{}],"fHRpa":[function() {},{}],"aod34":[function() {},{}],"7uDsY":[function() {},{}],"hIsCH":[function(require,module,exports) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ColorSchemeContext", ()=>ColorSchemeContext);
parcelHelpers.export(exports, "Provider", ()=>Provider);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactAriaComponents = require("react-aria-components");
var _runtime = require("../style/runtime");
const ColorSchemeContext = /*#__PURE__*/ (0, _react.createContext)(null);
function Provider(props) {
    let result = /*#__PURE__*/ (0, _jsxRuntime.jsx)(ProviderInner, {
        ...props
    });
    let parentColorScheme = (0, _react.useContext)(ColorSchemeContext);
    let colorScheme = props.colorScheme || parentColorScheme;
    if (colorScheme !== parentColorScheme) result = /*#__PURE__*/ (0, _jsxRuntime.jsx)(ColorSchemeContext.Provider, {
        value: colorScheme,
        children: result
    });
    if (props.locale) result = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.I18nProvider), {
        locale: props.locale,
        children: result
    });
    if (props.router) result = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.RouterProvider), {
        ...props.router,
        children: result
    });
    return result;
}
undefined;
let providerStyles = function anonymous(props) {
    let rules = " .";
    if (props.colorScheme === "dark") rules += ' _Ab';
    else if (props.colorScheme === "light") rules += ' _Aa';
    else if (props.colorScheme === "light dark") rules += ' _Ac';
    else rules += ' _A-10jn6wd';
    if (props.background === "layer-2") rules += ' -_1de2x0q_b-______k';
    else if (props.background === "layer-1") rules += ' -_1de2x0q_b-e';
    else if (props.background === "base") rules += ' -_1de2x0q_b-d';
    if (props.background === "layer-2") rules += ' b-1de2x0q';
    else if (props.background === "layer-1") rules += ' b-1de2x0q';
    else if (props.background === "base") rules += ' b-1de2x0q';
    return rules;
};
function ProviderInner(props) {
    let { elementType: Element = 'div', UNSAFE_style, UNSAFE_className = '', styles, children, background, colorScheme } = props;
    let { locale, direction } = (0, _reactAriaComponents.useLocale)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Element, {
        lang: locale,
        dir: direction,
        style: UNSAFE_style,
        className: UNSAFE_className + (0, _runtime.mergeStyles)(styles, providerStyles({
            background,
            colorScheme
        })),
        children: children
    });
}
try {
    // @ts-ignore
    Provider.displayName = "Provider";
    // @ts-ignore
    Provider.__docgenInfo = {
        "description": "",
        "displayName": "Provider",
        "props": {
            "children": {
                "defaultValue": null,
                "description": "The content of the Provider.",
                "name": "children",
                "required": true,
                "type": {
                    "name": "ReactNode"
                }
            },
            "background": {
                "defaultValue": null,
                "description": "The background for this provider. If not provided, the background is transparent.",
                "name": "background",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"base\""
                        },
                        {
                            "value": "\"layer-1\""
                        },
                        {
                            "value": "\"layer-2\""
                        }
                    ]
                }
            },
            "colorScheme": {
                "defaultValue": null,
                "description": "The color scheme for your application.\nDefaults to operating system preferences.",
                "name": "colorScheme",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"light\""
                        },
                        {
                            "value": "\"dark\""
                        }
                    ]
                }
            },
            "elementType": {
                "defaultValue": {
                    value: "div"
                },
                "description": "The DOM element to render.",
                "name": "elementType",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"symbol\""
                        },
                        {
                            "value": "\"object\""
                        },
                        {
                            "value": "\"style\""
                        },
                        {
                            "value": "\"slot\""
                        },
                        {
                            "value": "\"button\""
                        },
                        {
                            "value": "\"form\""
                        },
                        {
                            "value": "\"map\""
                        },
                        {
                            "value": "\"filter\""
                        },
                        {
                            "value": "\"a\""
                        },
                        {
                            "value": "\"abbr\""
                        },
                        {
                            "value": "\"address\""
                        },
                        {
                            "value": "\"area\""
                        },
                        {
                            "value": "\"article\""
                        },
                        {
                            "value": "\"aside\""
                        },
                        {
                            "value": "\"audio\""
                        },
                        {
                            "value": "\"b\""
                        },
                        {
                            "value": "\"base\""
                        },
                        {
                            "value": "\"bdi\""
                        },
                        {
                            "value": "\"bdo\""
                        },
                        {
                            "value": "\"big\""
                        },
                        {
                            "value": "\"blockquote\""
                        },
                        {
                            "value": "\"body\""
                        },
                        {
                            "value": "\"br\""
                        },
                        {
                            "value": "\"canvas\""
                        },
                        {
                            "value": "\"caption\""
                        },
                        {
                            "value": "\"center\""
                        },
                        {
                            "value": "\"cite\""
                        },
                        {
                            "value": "\"code\""
                        },
                        {
                            "value": "\"col\""
                        },
                        {
                            "value": "\"colgroup\""
                        },
                        {
                            "value": "\"data\""
                        },
                        {
                            "value": "\"datalist\""
                        },
                        {
                            "value": "\"dd\""
                        },
                        {
                            "value": "\"del\""
                        },
                        {
                            "value": "\"details\""
                        },
                        {
                            "value": "\"dfn\""
                        },
                        {
                            "value": "\"dialog\""
                        },
                        {
                            "value": "\"div\""
                        },
                        {
                            "value": "\"dl\""
                        },
                        {
                            "value": "\"dt\""
                        },
                        {
                            "value": "\"em\""
                        },
                        {
                            "value": "\"embed\""
                        },
                        {
                            "value": "\"fieldset\""
                        },
                        {
                            "value": "\"figcaption\""
                        },
                        {
                            "value": "\"figure\""
                        },
                        {
                            "value": "\"footer\""
                        },
                        {
                            "value": "\"h1\""
                        },
                        {
                            "value": "\"h2\""
                        },
                        {
                            "value": "\"h3\""
                        },
                        {
                            "value": "\"h4\""
                        },
                        {
                            "value": "\"h5\""
                        },
                        {
                            "value": "\"h6\""
                        },
                        {
                            "value": "\"head\""
                        },
                        {
                            "value": "\"header\""
                        },
                        {
                            "value": "\"hgroup\""
                        },
                        {
                            "value": "\"hr\""
                        },
                        {
                            "value": "\"html\""
                        },
                        {
                            "value": "\"i\""
                        },
                        {
                            "value": "\"iframe\""
                        },
                        {
                            "value": "\"img\""
                        },
                        {
                            "value": "\"input\""
                        },
                        {
                            "value": "\"ins\""
                        },
                        {
                            "value": "\"kbd\""
                        },
                        {
                            "value": "\"keygen\""
                        },
                        {
                            "value": "\"label\""
                        },
                        {
                            "value": "\"legend\""
                        },
                        {
                            "value": "\"li\""
                        },
                        {
                            "value": "\"link\""
                        },
                        {
                            "value": "\"main\""
                        },
                        {
                            "value": "\"mark\""
                        },
                        {
                            "value": "\"menu\""
                        },
                        {
                            "value": "\"menuitem\""
                        },
                        {
                            "value": "\"meta\""
                        },
                        {
                            "value": "\"meter\""
                        },
                        {
                            "value": "\"nav\""
                        },
                        {
                            "value": "\"noindex\""
                        },
                        {
                            "value": "\"noscript\""
                        },
                        {
                            "value": "\"ol\""
                        },
                        {
                            "value": "\"optgroup\""
                        },
                        {
                            "value": "\"option\""
                        },
                        {
                            "value": "\"output\""
                        },
                        {
                            "value": "\"p\""
                        },
                        {
                            "value": "\"param\""
                        },
                        {
                            "value": "\"picture\""
                        },
                        {
                            "value": "\"pre\""
                        },
                        {
                            "value": "\"progress\""
                        },
                        {
                            "value": "\"q\""
                        },
                        {
                            "value": "\"rp\""
                        },
                        {
                            "value": "\"rt\""
                        },
                        {
                            "value": "\"ruby\""
                        },
                        {
                            "value": "\"s\""
                        },
                        {
                            "value": "\"samp\""
                        },
                        {
                            "value": "\"search\""
                        },
                        {
                            "value": "\"script\""
                        },
                        {
                            "value": "\"section\""
                        },
                        {
                            "value": "\"select\""
                        },
                        {
                            "value": "\"small\""
                        },
                        {
                            "value": "\"source\""
                        },
                        {
                            "value": "\"span\""
                        },
                        {
                            "value": "\"strong\""
                        },
                        {
                            "value": "\"sub\""
                        },
                        {
                            "value": "\"summary\""
                        },
                        {
                            "value": "\"sup\""
                        },
                        {
                            "value": "\"table\""
                        },
                        {
                            "value": "\"template\""
                        },
                        {
                            "value": "\"tbody\""
                        },
                        {
                            "value": "\"td\""
                        },
                        {
                            "value": "\"textarea\""
                        },
                        {
                            "value": "\"tfoot\""
                        },
                        {
                            "value": "\"th\""
                        },
                        {
                            "value": "\"thead\""
                        },
                        {
                            "value": "\"time\""
                        },
                        {
                            "value": "\"title\""
                        },
                        {
                            "value": "\"tr\""
                        },
                        {
                            "value": "\"track\""
                        },
                        {
                            "value": "\"u\""
                        },
                        {
                            "value": "\"ul\""
                        },
                        {
                            "value": "\"var\""
                        },
                        {
                            "value": "\"video\""
                        },
                        {
                            "value": "\"wbr\""
                        },
                        {
                            "value": "\"webview\""
                        },
                        {
                            "value": "\"svg\""
                        },
                        {
                            "value": "\"animate\""
                        },
                        {
                            "value": "\"animateMotion\""
                        },
                        {
                            "value": "\"animateTransform\""
                        },
                        {
                            "value": "\"circle\""
                        },
                        {
                            "value": "\"clipPath\""
                        },
                        {
                            "value": "\"defs\""
                        },
                        {
                            "value": "\"desc\""
                        },
                        {
                            "value": "\"ellipse\""
                        },
                        {
                            "value": "\"feBlend\""
                        },
                        {
                            "value": "\"feColorMatrix\""
                        },
                        {
                            "value": "\"feComponentTransfer\""
                        },
                        {
                            "value": "\"feComposite\""
                        },
                        {
                            "value": "\"feConvolveMatrix\""
                        },
                        {
                            "value": "\"feDiffuseLighting\""
                        },
                        {
                            "value": "\"feDisplacementMap\""
                        },
                        {
                            "value": "\"feDistantLight\""
                        },
                        {
                            "value": "\"feDropShadow\""
                        },
                        {
                            "value": "\"feFlood\""
                        },
                        {
                            "value": "\"feFuncA\""
                        },
                        {
                            "value": "\"feFuncB\""
                        },
                        {
                            "value": "\"feFuncG\""
                        },
                        {
                            "value": "\"feFuncR\""
                        },
                        {
                            "value": "\"feGaussianBlur\""
                        },
                        {
                            "value": "\"feImage\""
                        },
                        {
                            "value": "\"feMerge\""
                        },
                        {
                            "value": "\"feMergeNode\""
                        },
                        {
                            "value": "\"feMorphology\""
                        },
                        {
                            "value": "\"feOffset\""
                        },
                        {
                            "value": "\"fePointLight\""
                        },
                        {
                            "value": "\"feSpecularLighting\""
                        },
                        {
                            "value": "\"feSpotLight\""
                        },
                        {
                            "value": "\"feTile\""
                        },
                        {
                            "value": "\"feTurbulence\""
                        },
                        {
                            "value": "\"foreignObject\""
                        },
                        {
                            "value": "\"g\""
                        },
                        {
                            "value": "\"image\""
                        },
                        {
                            "value": "\"line\""
                        },
                        {
                            "value": "\"linearGradient\""
                        },
                        {
                            "value": "\"marker\""
                        },
                        {
                            "value": "\"mask\""
                        },
                        {
                            "value": "\"metadata\""
                        },
                        {
                            "value": "\"mpath\""
                        },
                        {
                            "value": "\"path\""
                        },
                        {
                            "value": "\"pattern\""
                        },
                        {
                            "value": "\"polygon\""
                        },
                        {
                            "value": "\"polyline\""
                        },
                        {
                            "value": "\"radialGradient\""
                        },
                        {
                            "value": "\"rect\""
                        },
                        {
                            "value": "\"set\""
                        },
                        {
                            "value": "\"stop\""
                        },
                        {
                            "value": "\"switch\""
                        },
                        {
                            "value": "\"text\""
                        },
                        {
                            "value": "\"textPath\""
                        },
                        {
                            "value": "\"tspan\""
                        },
                        {
                            "value": "\"use\""
                        },
                        {
                            "value": "\"view\""
                        }
                    ]
                }
            },
            "locale": {
                "defaultValue": {
                    value: "'en-US'"
                },
                "description": "The locale for your application as a [BCP 47](https://www.ietf.org/rfc/bcp/bcp47.txt) language code.\nDefaults to the browser/OS language setting.",
                "name": "locale",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "router": {
                "defaultValue": null,
                "description": "Provides a client side router to all nested React Spectrum links to enable client side navigation.",
                "name": "router",
                "required": false,
                "type": {
                    "name": "Router"
                }
            },
            "styles": {
                "defaultValue": null,
                "description": "Spectrum-defined styles, returned by the `style()` macro.",
                "name": "styles",
                "required": false,
                "type": {
                    "name": "StyleString"
                }
            },
            "UNSAFE_className": {
                "defaultValue": null,
                "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_className",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_style": {
                "defaultValue": null,
                "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_style",
                "required": false,
                "type": {
                    "name": "CSSProperties"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/Provider.tsx#Provider"] = {
        docgenInfo: Provider.__docgenInfo,
        name: "Provider",
        path: "packages/@react-spectrum/s2/src/Provider.tsx#Provider"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    ColorSchemeContext.displayName = "ColorSchemeContext";
    // @ts-ignore
    ColorSchemeContext.__docgenInfo = {
        "description": "",
        "displayName": "ColorSchemeContext",
        "props": {
            "value": {
                "defaultValue": null,
                "description": "",
                "name": "value",
                "required": true,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"light\""
                        },
                        {
                            "value": "\"dark\""
                        },
                        {
                            "value": "\"light dark\""
                        }
                    ]
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/Provider.tsx#ColorSchemeContext"] = {
        docgenInfo: ColorSchemeContext.__docgenInfo,
        name: "ColorSchemeContext",
        path: "packages/@react-spectrum/s2/src/Provider.tsx#ColorSchemeContext"
    };
} catch (__react_docgen_typescript_loader_error) {}

},{"0":"2YCuu","1":"k7PpT","react/jsx-runtime":"2JzhG","react":"jEiK2","react-aria-components":"8nuKL","../style/runtime":"dzhKB","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"2YCuu":[function() {},{}],"k7PpT":[function() {},{}],"gH5vG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M10 15.123c-.231.008-.456-.073-.627-.228-.33-.365-.33-.92 0-1.285.17-.158.395-.242.626-.234.237-.01.466.08.633.247.162.168.25.394.242.627.012.235-.07.465-.228.639-.174.164-.408.25-.647.234ZM10 11.75c-.414 0-.75-.336-.75-.75V7c0-.414.336-.75.75-.75s.75.336.75.75v4c0 .414-.336.75-.75.75Z",
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M16.733 18H3.267c-.8 0-1.523-.41-1.933-1.098s-.427-1.518-.046-2.222L8.02 2.232c.394-.727 1.152-1.18 1.979-1.18s1.585.453 1.979 1.18l6.733 12.448c.381.704.364 1.535-.046 2.222S17.534 18 16.733 18ZM10 2.553c-.134 0-.468.038-.66.392L2.607 15.393c-.183.338-.05.631.016.74.065.111.259.367.644.367h13.466c.385 0 .579-.256.644-.366.066-.11.2-.403.016-.741L10.66 2.945c-.192-.354-.526-.392-.66-.392Z",
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef, (0, _icon.IconContext));

},{"react/jsx-runtime":"2JzhG","~/src/Icon":"1OC2a","react":"jEiK2","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"lgKOs":[function(require,module,exports) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ButtonContext", ()=>ButtonContext);
parcelHelpers.export(exports, "LinkButtonContext", ()=>LinkButtonContext);
parcelHelpers.export(exports, "Button", ()=>_Button);
parcelHelpers.export(exports, "LinkButton", ()=>_LinkButton);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _centerBaseline = require("./CenterBaseline");
var _react = require("react");
var _icon = require("./Icon");
// @ts-ignore
var _json = require("../intl/*.json");
var _jsonDefault = parcelHelpers.interopDefault(_json);
var _pressScale = require("./pressScale");
var _progressCircle = require("./ProgressCircle");
var _skeleton = require("./Skeleton");
var _content = require("./Content");
var _utils = require("@react-spectrum/utils");
var _form = require("./Form");
var _i18N = require("@react-aria/i18n");
var _useSpectrumContextProps = require("./useSpectrumContextProps");
const ButtonContext = /*#__PURE__*/ (0, _react.createContext)(null);
const LinkButtonContext = /*#__PURE__*/ (0, _react.createContext)(null);
const iconOnly = ':has([slot=icon]):not(:has([data-rsp-slot=text]))';
const button = function anonymous(props, overrides) {
    let rules = " .";
    let matches = (overrides || '').match(/(?:^|\s)(?:y|z|A|B|_9|_8|h|_5|_4|__A|__c|__d|__a|__b|U|__Q|X|Z|V|W|l|q|r)[^\s]+/g) || [];
    rules += matches.join('');
    let $U = false;
    let $q = false;
    let $l = false;
    for (let p of matches){
        if (/^\s*U/.test(p)) $U = true;
        if (/^\s*q/.test(p)) $q = true;
        if (/^\s*l/.test(p)) $l = true;
    }
    if (props.isFocusVisible) rules += ' _Lb';
    else rules += ' _La';
    rules += ' da_____z';
    if (props.staticColor === "black") rules += ' db';
    else if (props.staticColor === "white") rules += ' dc';
    else rules += ' dx';
    rules += ' _Nc';
    rules += ' _M-3t1z';
    if (!$U) rules += ' Uc';
    rules += ' _Zd';
    rules += ' _1-soocicc';
    rules += ' _1d';
    rules += ' _2d';
    rules += ' _ja';
    rules += ' jbH';
    rules += ' jG';
    rules += ' _c-bc1l9oh';
    rules += ' _c-1uotwbwg';
    rules += ' _c-eo0c6sf';
    rules += ' _c-enzzrge';
    rules += ' _c-enzykdd';
    rules += ' _c-enzwzjc';
    rules += ' _c-enzrfpb';
    rules += ' _ca';
    if (props.size === "XL") {
        rules += ' _dbj';
        rules += ' _di';
    } else if (props.size === "L") {
        rules += ' _dbh';
        rules += ' _dg';
    } else if (props.size === "S") {
        rules += ' _dbd';
        rules += ' _dc';
    } else if (props.size === "XS") {
        rules += ' _dbb';
        rules += ' _da';
    } else {
        rules += ' _dbf';
        rules += ' _de';
    }
    rules += ' _ed';
    rules += ' _f-1x99dlob';
    rules += ' _fa';
    if (props.fillStyle === "outline") {
        if (props.isDisabled) rules += ' aa_____B';
        else rules += ' aa_____x';
    } else if (props.fillStyle === "fill") {
        if (props.isDisabled) rules += ' aa_____A';
        else rules += ' aa_____w';
    }
    if (props.staticColor === "black") {
        if (props.isDisabled) rules += ' a_____n';
        else if (props.fillStyle === "outline") {
            if (props.isPressed) rules += ' a_____s';
            else if (props.isFocusVisible) rules += ' a_____s';
            else if (props.isHovered) rules += ' a_____s';
            else rules += ' a_____r';
        } else if (props.fillStyle === "fill") {
            if (props.variant === "secondary") {
                if (props.isPressed) rules += ' a_____s';
                else if (props.isFocusVisible) rules += ' a_____s';
                else if (props.isHovered) rules += ' a_____s';
                else rules += ' a_____r';
            } else if (props.variant === "primary") rules += ' ac';
        }
    } else if (props.staticColor === "white") {
        if (props.isDisabled) rules += ' a_____a';
        else if (props.fillStyle === "outline") {
            if (props.isPressed) rules += ' a_____f';
            else if (props.isFocusVisible) rules += ' a_____f';
            else if (props.isHovered) rules += ' a_____f';
            else rules += ' a_____e';
        } else if (props.fillStyle === "fill") {
            if (props.variant === "secondary") {
                if (props.isPressed) rules += ' a_____f';
                else if (props.isFocusVisible) rules += ' a_____f';
                else if (props.isHovered) rules += ' a_____f';
                else rules += ' a_____e';
            } else if (props.variant === "primary") rules += ' ab';
        }
    } else if (props.fillStyle === "outline") {
        if (props.isDisabled) rules += ' aj';
        else {
            if (props.isPressed) rules += ' ao';
            else if (props.isFocusVisible) rules += ' ao';
            else if (props.isHovered) rules += ' ao';
            else rules += ' an';
        }
    } else if (props.fillStyle === "fill") {
        if (props.isDisabled) rules += ' aj';
        else if (props.variant === "negative") rules += ' ac';
        else if (props.variant === "accent") rules += ' ac';
        else if (props.variant === "secondary") {
            if (props.isPressed) rules += ' ao';
            else if (props.isFocusVisible) rules += ' ao';
            else if (props.isHovered) rules += ' ao';
            else rules += ' an';
        } else if (props.variant === "primary") rules += ' ad';
    }
    rules += ' __Da';
    rules += ' o-375tou';
    if (!$q) {
        if (props.size === "XL") rules += ' q-soocicn';
        else if (props.size === "L") rules += ' q-soocicl';
        else if (props.size === "S") rules += ' q-soocich';
        else if (props.size === "XS") rules += ' q-soocicg';
        else rules += ' q-soocicj';
    }
    rules += ' _vg';
    rules += ' _wg';
    rules += ' _xg';
    rules += ' _yg';
    rules += ' __na';
    if (!$l) rules += ' lJ';
    rules += ' _ld';
    rules += ' C-soocica';
    rules += ' CJ';
    rules += ' D-soocica';
    rules += ' DJ';
    rules += ' Ea';
    rules += ' Fa';
    rules += ' _b-soocicb';
    rules += ' _Oa';
    rules += ' _Q-375x7f';
    rules += ' _Ra';
    rules += ' wa';
    rules += ' u-375tp0';
    rules += ' v-375tp1';
    if (props.fillStyle === "outline") rules += ' sc';
    else if (props.fillStyle === "fill") rules += ' sa';
    if (props.fillStyle === "outline") rules += ' tc';
    else if (props.fillStyle === "fill") rules += ' ta';
    rules += ' -_1gogtue_E--1dbqcch';
    rules += ' -oelgqu_A--soocica';
    rules += ' -oelgqu_A--177861o';
    if (props.isDisabled) rules += ' ca_____B';
    else if (props.isHovered) rules += ' ca_____z';
    else rules += ' ca_____v';
    if (props.staticColor === "black") {
        if (props.isDisabled) rules += ' c_____m';
        else if (props.variant === "secondary") {
            if (props.isPressed) rules += ' c_____n';
            else if (props.isFocusVisible) rules += ' c_____n';
            else if (props.isHovered) rules += ' c_____n';
            else rules += ' c_____m';
        } else if (props.variant === "primary") {
            if (props.isPressed) rules += ' c_____s';
            else if (props.isFocusVisible) rules += ' c_____s';
            else if (props.isHovered) rules += ' c_____s';
            else rules += ' c_____r';
        }
    } else if (props.staticColor === "white") {
        if (props.isDisabled) rules += ' c____9';
        else if (props.variant === "secondary") {
            if (props.isPressed) rules += ' c_____a';
            else if (props.isFocusVisible) rules += ' c_____a';
            else if (props.isHovered) rules += ' c_____a';
            else rules += ' c____9';
        } else if (props.variant === "primary") {
            if (props.isPressed) rules += ' c_____f';
            else if (props.isFocusVisible) rules += ' c_____f';
            else if (props.isHovered) rules += ' c_____f';
            else rules += ' c_____e';
        }
    } else if (props.isDisabled) rules += ' ci';
    else if (props.variant === "secondary") {
        if (props.isPressed) rules += ' cj';
        else if (props.isFocusVisible) rules += ' cj';
        else if (props.isHovered) rules += ' cj';
        else rules += ' ci';
    } else if (props.variant === "primary") {
        if (props.isPressed) rules += ' co';
        else if (props.isFocusVisible) rules += ' co';
        else if (props.isHovered) rules += ' co';
        else rules += ' cn';
    }
    if (props.fillStyle === "outline") rules += ' ba_____w';
    else if (props.fillStyle === "fill") {
        if (props.isDisabled) rules += ' ba_____B';
        else if (props.isHovered) rules += ' ba_____z';
        else rules += ' ba_____x';
    }
    if (props.staticColor === "black") {
        if (props.fillStyle === "outline") {
            if (props.isDisabled) rules += ' ba';
            else if (props.isFocusVisible) rules += ' b_____k';
            else if (props.isPressed) rules += ' b_____k';
            else if (props.isHovered) rules += ' b_____k';
            else rules += ' ba';
        } else if (props.fillStyle === "fill") {
            if (props.isDisabled) rules += ' b_____k';
            else if (props.variant === "secondary") {
                if (props.isPressed) rules += ' b_____l';
                else if (props.isFocusVisible) rules += ' b_____l';
                else if (props.isHovered) rules += ' b_____l';
                else rules += ' b_____k';
            } else if (props.variant === "primary") {
                if (props.isPressed) rules += ' b_____s';
                else if (props.isFocusVisible) rules += ' b_____s';
                else if (props.isHovered) rules += ' b_____s';
                else rules += ' b_____r';
            }
        }
    } else if (props.staticColor === "white") {
        if (props.fillStyle === "outline") {
            if (props.isDisabled) rules += ' ba';
            else if (props.isFocusVisible) rules += ' b____7';
            else if (props.isPressed) rules += ' b____7';
            else if (props.isHovered) rules += ' b____7';
            else rules += ' ba';
        } else if (props.fillStyle === "fill") {
            if (props.isDisabled) rules += ' b____7';
            else if (props.variant === "secondary") {
                if (props.isPressed) rules += ' b____8';
                else if (props.isFocusVisible) rules += ' b____8';
                else if (props.isHovered) rules += ' b____8';
                else rules += ' b____7';
            } else if (props.variant === "primary") {
                if (props.isPressed) rules += ' b_____f';
                else if (props.isFocusVisible) rules += ' b_____f';
                else if (props.isHovered) rules += ' b_____f';
                else rules += ' b_____e';
            }
        }
    } else if (props.fillStyle === "outline") {
        if (props.isDisabled) rules += ' ba';
        else if (props.isFocusVisible) rules += ' bg';
        else if (props.isPressed) rules += ' bg';
        else if (props.isHovered) rules += ' bg';
        else rules += ' ba';
    } else if (props.fillStyle === "fill") {
        if (props.isDisabled) rules += ' bg';
        else if (props.variant === "negative") {
            if (props.isPressed) rules += ' b_____L';
            else if (props.isFocusVisible) rules += ' b_____L';
            else if (props.isHovered) rules += ' b_____L';
            else rules += ' b_____K';
        } else if (props.variant === "accent") {
            if (props.isPressed) rules += ' b_____F';
            else if (props.isFocusVisible) rules += ' b_____F';
            else if (props.isHovered) rules += ' b_____F';
            else rules += ' b_____E';
        } else if (props.variant === "secondary") {
            if (props.isPressed) rules += ' bh';
            else if (props.isFocusVisible) rules += ' bh';
            else if (props.isHovered) rules += ' bh';
            else rules += ' bg';
        } else if (props.variant === "primary") {
            if (props.isPressed) rules += ' bo';
            else if (props.isFocusVisible) rules += ' bo';
            else if (props.isHovered) rules += ' bo';
            else rules += ' bn';
        }
    }
    rules += ' -rwx0fg_e-b';
    rules += ' _zb';
    rules += ' __R-yksgrp';
    if (props.size === "XL") rules += ' -_375tou_o-n';
    else if (props.size === "L") rules += ' -_375tou_o-l';
    else if (props.size === "S") rules += ' -_375tou_o-h';
    else if (props.size === "XS") rules += ' -_375tou_o-g';
    else rules += ' -_375tou_o-j';
    if (props.fillStyle === "outline") rules += ' -_375tp0_u-c';
    else if (props.fillStyle === "fill") rules += ' -_375tp0_u-a';
    if (props.fillStyle === "outline") rules += ' -_375tp1_v-c';
    else if (props.fillStyle === "fill") rules += ' -_375tp1_v-a';
    return rules;
};
function Button(props1, ref) {
    [props1, ref] = (0, _useSpectrumContextProps.useSpectrumContextProps)(props1, ref, ButtonContext);
    props1 = (0, _form.useFormProps)(props1);
    let stringFormatter = (0, _i18N.useLocalizedStringFormatter)((0, _jsonDefault.default), '@react-spectrum/s2');
    let { isPending, variant = 'primary', fillStyle = 'fill', size = 'M', staticColor } = props1;
    let domRef = (0, _utils.useFocusableRef)(ref);
    let overlayTriggerState = (0, _react.useContext)((0, _reactAriaComponents.OverlayTriggerStateContext));
    let [isProgressVisible, setIsProgressVisible] = (0, _react.useState)(false);
    (0, _react.useEffect)(()=>{
        let timeout;
        if (isPending) // Start timer when isPending is set to true.
        timeout = setTimeout(()=>{
            setIsProgressVisible(true);
        }, 1000);
        else // Exit loading state when isPending is set to false. */
        setIsProgressVisible(false);
        return ()=>{
            // Clean up on unmount or when user removes isPending prop before entering loading state.
            clearTimeout(timeout);
        };
    }, [
        isPending
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Button), {
        ...props1,
        ref: domRef,
        style: (0, _pressScale.pressScale)(domRef, props1.UNSAFE_style),
        className: (renderProps)=>(props1.UNSAFE_className || '') + button({
                ...renderProps,
                // Retain hover styles when an overlay is open.
                isHovered: renderProps.isHovered || overlayTriggerState?.isOpen || false,
                isDisabled: renderProps.isDisabled || isProgressVisible,
                variant,
                fillStyle,
                size,
                staticColor
            }, props1.styles),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactAriaComponents.Provider), {
            values: [
                [
                    (0, _skeleton.SkeletonContext),
                    null
                ],
                [
                    (0, _content.TextContext),
                    {
                        styles: function anonymous(props) {
                            let rules = " .";
                            rules += ' E-1gogtue';
                            rules += ' F-1gogtue';
                            rules += ' __A-3t1y';
                            if (props.isProgressVisible) rules += ' _K-3t1x';
                            else rules += ' _K-3t1y';
                            return rules;
                        }({
                            isProgressVisible
                        }),
                        // @ts-ignore data-attributes allowed on all JSX elements, but adding to DOMProps has been problematic in the past
                        'data-rsp-slot': 'text'
                    }
                ],
                [
                    (0, _icon.IconContext),
                    {
                        render: (0, _centerBaseline.centerBaseline)({
                            slot: 'icon',
                            styles: " . __A-3t1x"
                        }),
                        styles: function anonymous(props) {
                            let rules = " .";
                            rules += ' l-1sthc3k';
                            rules += ' k-1sthc3k';
                            rules += ' y-oelgqu';
                            rules += ' _8-3t1x';
                            if (props.isProgressVisible) rules += ' _K-3t1x';
                            else rules += ' _K-3t1y';
                            return rules;
                        }({
                            isProgressVisible
                        })
                    }
                ]
            ],
            children: [
                typeof props1.children === 'string' ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _content.Text), {
                    children: props1.children
                }) : props1.children,
                isPending && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: function anonymous(props) {
                        let rules = " .";
                        rules += ' Ua';
                        rules += ' X-3760fj';
                        rules += ' Y-3760fj';
                        rules += ' T-1tktoou';
                        if (props.isProgressVisible) rules += ' _K-3t1y';
                        else rules += ' _K-3t1x';
                        return rules;
                    }({
                        isProgressVisible,
                        isPending
                    }),
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _progressCircle.ProgressCircle), {
                        isIndeterminate: true,
                        "aria-label": stringFormatter.format('button.pending'),
                        size: "S",
                        staticColor: staticColor,
                        styles: function anonymous(props) {
                            let rules = " .";
                            if (props.size === "XL") rules += ' lh';
                            else if (props.size === "L") rules += ' lg';
                            else if (props.size === "M") rules += ' l-9ed7ss';
                            else if (props.size === "S") rules += ' l-1l1y6lj';
                            if (props.size === "XL") rules += ' kh';
                            else if (props.size === "L") rules += ' kg';
                            else if (props.size === "M") rules += ' k-9ed7ss';
                            else if (props.size === "S") rules += ' k-1l1y6lj';
                            return rules;
                        }({
                            size
                        })
                    })
                })
            ]
        })
    });
}
/**
 * Buttons allow users to perform an action.
 * They have multiple styles for various needs, and are ideal for calling attention to
 * where a user needs to do something in order to move forward in a flow.
 */ let _Button = /*#__PURE__*/ (0, _react.forwardRef)(Button);
function LinkButton(props, ref) {
    [props, ref] = (0, _useSpectrumContextProps.useSpectrumContextProps)(props, ref, LinkButtonContext);
    props = (0, _form.useFormProps)(props);
    let domRef = (0, _utils.useFocusableRef)(ref);
    let overlayTriggerState = (0, _react.useContext)((0, _reactAriaComponents.OverlayTriggerStateContext));
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Link), {
        ...props,
        ref: domRef,
        style: (0, _pressScale.pressScale)(domRef, props.UNSAFE_style),
        className: (renderProps)=>(props.UNSAFE_className || '') + button({
                ...renderProps,
                // Retain hover styles when an overlay is open.
                isHovered: renderProps.isHovered || overlayTriggerState?.isOpen || false,
                variant: props.variant || 'primary',
                fillStyle: props.fillStyle || 'fill',
                size: props.size || 'M',
                staticColor: props.staticColor,
                isPending: false
            }, props.styles),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Provider), {
            values: [
                [
                    (0, _skeleton.SkeletonContext),
                    null
                ],
                [
                    (0, _content.TextContext),
                    {
                        styles: " . E-1gogtue F-1gogtue __A-3t1y",
                        // @ts-ignore data-attributes allowed on all JSX elements, but adding to DOMProps has been problematic in the past
                        'data-rsp-slot': 'text'
                    }
                ],
                [
                    (0, _icon.IconContext),
                    {
                        render: (0, _centerBaseline.centerBaseline)({
                            slot: 'icon',
                            styles: " . __A-3t1x"
                        }),
                        styles: " . l-1sthc3k k-1sthc3k y-oelgqu _8-3t1x"
                    }
                ]
            ],
            children: typeof props.children === 'string' ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _content.Text), {
                children: props.children
            }) : props.children
        })
    });
}
/**
 * A LinkButton combines the functionality of a link with the appearance of a button. Useful for allowing users to navigate to another page.
 */ let _LinkButton = /*#__PURE__*/ (0, _react.forwardRef)(LinkButton);
try {
    // @ts-ignore
    ButtonContext.displayName = "ButtonContext";
    // @ts-ignore
    ButtonContext.__docgenInfo = {
        "description": "",
        "displayName": "ButtonContext",
        "props": {
            "value": {
                "defaultValue": null,
                "description": "",
                "name": "value",
                "required": true,
                "type": {
                    "name": "ContextValue<ButtonProps, FocusableRefValue<HTMLButtonElement, HTMLButtonElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/Button.tsx#ButtonContext"] = {
        docgenInfo: ButtonContext.__docgenInfo,
        name: "ButtonContext",
        path: "packages/@react-spectrum/s2/src/Button.tsx#ButtonContext"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    LinkButtonContext.displayName = "LinkButtonContext";
    // @ts-ignore
    LinkButtonContext.__docgenInfo = {
        "description": "",
        "displayName": "LinkButtonContext",
        "props": {
            "value": {
                "defaultValue": null,
                "description": "",
                "name": "value",
                "required": true,
                "type": {
                    "name": "ContextValue<ButtonProps, FocusableRefValue<HTMLAnchorElement, HTMLAnchorElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/Button.tsx#LinkButtonContext"] = {
        docgenInfo: LinkButtonContext.__docgenInfo,
        name: "LinkButtonContext",
        path: "packages/@react-spectrum/s2/src/Button.tsx#LinkButtonContext"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    _Button.displayName = "_Button";
    // @ts-ignore
    _Button.__docgenInfo = {
        "description": "Buttons allow users to perform an action.\nThey have multiple styles for various needs, and are ideal for calling attention to\nwhere a user needs to do something in order to move forward in a flow.",
        "displayName": "_Button",
        "props": {
            "autoFocus": {
                "defaultValue": null,
                "description": "Whether the element should receive focus on render.",
                "name": "autoFocus",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "children": {
                "defaultValue": null,
                "description": "The content to display in the Button.",
                "name": "children",
                "required": false,
                "type": {
                    "name": "ReactNode"
                }
            },
            "excludeFromTabOrder": {
                "defaultValue": null,
                "description": "Whether to exclude the element from the sequential tab order. If true,\nthe element will not be focusable via the keyboard by tabbing. This should\nbe avoided except in rare scenarios where an alternative means of accessing\nthe element or its functionality via the keyboard is available.",
                "name": "excludeFromTabOrder",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "fillStyle": {
                "defaultValue": {
                    value: "'fill'"
                },
                "description": "The background style of the Button.",
                "name": "fillStyle",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"fill\""
                        },
                        {
                            "value": "\"outline\""
                        }
                    ]
                }
            },
            "form": {
                "defaultValue": null,
                "description": "The `<form>` element to associate the button with.\nThe value of this attribute must be the id of a `<form>` in the same document.",
                "name": "form",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "formAction": {
                "defaultValue": null,
                "description": "The URL that processes the information submitted by the button.\nOverrides the action attribute of the button's form owner.",
                "name": "formAction",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "formEncType": {
                "defaultValue": null,
                "description": "Indicates how to encode the form data that is submitted.",
                "name": "formEncType",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "formMethod": {
                "defaultValue": null,
                "description": "Indicates the HTTP method used to submit the form.",
                "name": "formMethod",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "formNoValidate": {
                "defaultValue": null,
                "description": "Indicates that the form is not to be validated when it is submitted.",
                "name": "formNoValidate",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "formTarget": {
                "defaultValue": null,
                "description": "Overrides the target attribute of the button's form owner.",
                "name": "formTarget",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "isDisabled": {
                "defaultValue": null,
                "description": "Whether the button is disabled.",
                "name": "isDisabled",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isPending": {
                "defaultValue": null,
                "description": "Whether the button is in a pending state. This disables press and hover events\nwhile retaining focusability, and announces the pending state to screen readers.",
                "name": "isPending",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "name": {
                "defaultValue": null,
                "description": "Submitted as a pair with the button's value as part of the form data.",
                "name": "name",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "preventFocusOnPress": {
                "defaultValue": null,
                "description": "Whether to prevent focus from moving to the button when pressing it.\n\nCaution, this can make the button inaccessible and should only be used when alternative keyboard interaction is provided,\nsuch as ComboBox's MenuTrigger or a NumberField's increment/decrement control.",
                "name": "preventFocusOnPress",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "size": {
                "defaultValue": {
                    value: "'M'"
                },
                "description": "The size of the Button.",
                "name": "size",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"S\""
                        },
                        {
                            "value": "\"M\""
                        },
                        {
                            "value": "\"L\""
                        },
                        {
                            "value": "\"XL\""
                        }
                    ]
                }
            },
            "staticColor": {
                "defaultValue": null,
                "description": "The static color style to apply. Useful when the Button appears over a color background.",
                "name": "staticColor",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"white\""
                        },
                        {
                            "value": "\"black\""
                        }
                    ]
                }
            },
            "styles": {
                "defaultValue": null,
                "description": "Spectrum-defined styles, returned by the `style()` macro.",
                "name": "styles",
                "required": false,
                "type": {
                    "name": "StylesProp"
                }
            },
            "type": {
                "defaultValue": {
                    value: "'button'"
                },
                "description": "The behavior of the button when used in an HTML form.",
                "name": "type",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"button\""
                        },
                        {
                            "value": "\"submit\""
                        },
                        {
                            "value": "\"reset\""
                        }
                    ]
                }
            },
            "UNSAFE_className": {
                "defaultValue": null,
                "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_className",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_style": {
                "defaultValue": null,
                "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_style",
                "required": false,
                "type": {
                    "name": "CSSProperties"
                }
            },
            "value": {
                "defaultValue": null,
                "description": "The value associated with the button's name when it's submitted with the form data.",
                "name": "value",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "variant": {
                "defaultValue": {
                    value: "'primary'"
                },
                "description": "The [visual style](https://spectrum.adobe.com/page/button/#Options) of the button.",
                "name": "variant",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"primary\""
                        },
                        {
                            "value": "\"secondary\""
                        },
                        {
                            "value": "\"accent\""
                        },
                        {
                            "value": "\"negative\""
                        }
                    ]
                }
            },
            "onPress": {
                "defaultValue": null,
                "description": "Handler that is called when the press is released over the target.",
                "name": "onPress",
                "required": false,
                "type": {
                    "name": "(e: PressEvent) => void"
                }
            },
            "onPressChange": {
                "defaultValue": null,
                "description": "Handler that is called when the press state changes.",
                "name": "onPressChange",
                "required": false,
                "type": {
                    "name": "(isPressed: boolean) => void"
                }
            },
            "onPressEnd": {
                "defaultValue": null,
                "description": "Handler that is called when a press interaction ends, either\nover the target or when the pointer leaves the target.",
                "name": "onPressEnd",
                "required": false,
                "type": {
                    "name": "(e: PressEvent) => void"
                }
            },
            "onPressStart": {
                "defaultValue": null,
                "description": "Handler that is called when a press interaction starts.",
                "name": "onPressStart",
                "required": false,
                "type": {
                    "name": "(e: PressEvent) => void"
                }
            },
            "onPressUp": {
                "defaultValue": null,
                "description": "Handler that is called when a press is released over the target, regardless of\nwhether it started on the target or not.",
                "name": "onPressUp",
                "required": false,
                "type": {
                    "name": "(e: PressEvent) => void"
                }
            },
            "key": {
                "defaultValue": null,
                "description": "",
                "name": "key",
                "required": false,
                "type": {
                    "name": "Key"
                }
            },
            "ref": {
                "defaultValue": null,
                "description": "Allows getting a ref to the component instance.\nOnce the component unmounts, React will set `ref.current` to `null`\n(or call the ref with `null` if you passed a callback ref).\n@see {@link https://react.dev/learn/referencing-values-with-refs#refs-and-the-dom React Docs}",
                "name": "ref",
                "required": false,
                "type": {
                    "name": "Ref<FocusableRefValue<HTMLButtonElement, HTMLButtonElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/Button.tsx#_Button"] = {
        docgenInfo: _Button.__docgenInfo,
        name: "_Button",
        path: "packages/@react-spectrum/s2/src/Button.tsx#_Button"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    _LinkButton.displayName = "_LinkButton";
    // @ts-ignore
    _LinkButton.__docgenInfo = {
        "description": "A LinkButton combines the functionality of a link with the appearance of a button. Useful for allowing users to navigate to another page.",
        "displayName": "_LinkButton",
        "props": {
            "autoFocus": {
                "defaultValue": null,
                "description": "Whether the element should receive focus on render.",
                "name": "autoFocus",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "children": {
                "defaultValue": null,
                "description": "The content to display in the Button.",
                "name": "children",
                "required": false,
                "type": {
                    "name": "ReactNode"
                }
            },
            "download": {
                "defaultValue": null,
                "description": "Causes the browser to download the linked URL. A string may be provided to suggest a file name. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#download).",
                "name": "download",
                "required": false,
                "type": {
                    "name": "string | boolean"
                }
            },
            "fillStyle": {
                "defaultValue": {
                    value: "'fill'"
                },
                "description": "The background style of the Button.",
                "name": "fillStyle",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"fill\""
                        },
                        {
                            "value": "\"outline\""
                        }
                    ]
                }
            },
            "href": {
                "defaultValue": null,
                "description": "A URL to link to. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#href).",
                "name": "href",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "hrefLang": {
                "defaultValue": null,
                "description": "Hints at the human language of the linked URL. See[MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#hreflang).",
                "name": "hrefLang",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "isDisabled": {
                "defaultValue": null,
                "description": "Whether the link is disabled.",
                "name": "isDisabled",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "ping": {
                "defaultValue": null,
                "description": "A space-separated list of URLs to ping when the link is followed. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#ping).",
                "name": "ping",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "referrerPolicy": {
                "defaultValue": null,
                "description": "How much of the referrer to send when following the link. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#referrerpolicy).",
                "name": "referrerPolicy",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"\""
                        },
                        {
                            "value": "\"origin\""
                        },
                        {
                            "value": "\"no-referrer\""
                        },
                        {
                            "value": "\"no-referrer-when-downgrade\""
                        },
                        {
                            "value": "\"origin-when-cross-origin\""
                        },
                        {
                            "value": "\"same-origin\""
                        },
                        {
                            "value": "\"strict-origin\""
                        },
                        {
                            "value": "\"strict-origin-when-cross-origin\""
                        },
                        {
                            "value": "\"unsafe-url\""
                        }
                    ]
                }
            },
            "rel": {
                "defaultValue": null,
                "description": "The relationship between the linked resource and the current page. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/rel).",
                "name": "rel",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "routerOptions": {
                "defaultValue": null,
                "description": "Options for the configured client side router.",
                "name": "routerOptions",
                "required": false,
                "type": {
                    "name": "never"
                }
            },
            "size": {
                "defaultValue": {
                    value: "'M'"
                },
                "description": "The size of the Button.",
                "name": "size",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"S\""
                        },
                        {
                            "value": "\"M\""
                        },
                        {
                            "value": "\"L\""
                        },
                        {
                            "value": "\"XL\""
                        }
                    ]
                }
            },
            "staticColor": {
                "defaultValue": null,
                "description": "The static color style to apply. Useful when the Button appears over a color background.",
                "name": "staticColor",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"white\""
                        },
                        {
                            "value": "\"black\""
                        }
                    ]
                }
            },
            "styles": {
                "defaultValue": null,
                "description": "Spectrum-defined styles, returned by the `style()` macro.",
                "name": "styles",
                "required": false,
                "type": {
                    "name": "StylesProp"
                }
            },
            "target": {
                "defaultValue": null,
                "description": "The target window for the link. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#target).",
                "name": "target",
                "required": false,
                "type": {
                    "name": "HTMLAttributeAnchorTarget"
                }
            },
            "UNSAFE_className": {
                "defaultValue": null,
                "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_className",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_style": {
                "defaultValue": null,
                "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_style",
                "required": false,
                "type": {
                    "name": "CSSProperties"
                }
            },
            "variant": {
                "defaultValue": {
                    value: "'primary'"
                },
                "description": "The [visual style](https://spectrum.adobe.com/page/button/#Options) of the button.",
                "name": "variant",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"primary\""
                        },
                        {
                            "value": "\"secondary\""
                        },
                        {
                            "value": "\"accent\""
                        },
                        {
                            "value": "\"negative\""
                        }
                    ]
                }
            },
            "onPress": {
                "defaultValue": null,
                "description": "Handler that is called when the press is released over the target.",
                "name": "onPress",
                "required": false,
                "type": {
                    "name": "(e: PressEvent) => void"
                }
            },
            "onPressChange": {
                "defaultValue": null,
                "description": "Handler that is called when the press state changes.",
                "name": "onPressChange",
                "required": false,
                "type": {
                    "name": "(isPressed: boolean) => void"
                }
            },
            "onPressEnd": {
                "defaultValue": null,
                "description": "Handler that is called when a press interaction ends, either\nover the target or when the pointer leaves the target.",
                "name": "onPressEnd",
                "required": false,
                "type": {
                    "name": "(e: PressEvent) => void"
                }
            },
            "onPressStart": {
                "defaultValue": null,
                "description": "Handler that is called when a press interaction starts.",
                "name": "onPressStart",
                "required": false,
                "type": {
                    "name": "(e: PressEvent) => void"
                }
            },
            "onPressUp": {
                "defaultValue": null,
                "description": "Handler that is called when a press is released over the target, regardless of\nwhether it started on the target or not.",
                "name": "onPressUp",
                "required": false,
                "type": {
                    "name": "(e: PressEvent) => void"
                }
            },
            "key": {
                "defaultValue": null,
                "description": "",
                "name": "key",
                "required": false,
                "type": {
                    "name": "Key"
                }
            },
            "ref": {
                "defaultValue": null,
                "description": "Allows getting a ref to the component instance.\nOnce the component unmounts, React will set `ref.current` to `null`\n(or call the ref with `null` if you passed a callback ref).\n@see {@link https://react.dev/learn/referencing-values-with-refs#refs-and-the-dom React Docs}",
                "name": "ref",
                "required": false,
                "type": {
                    "name": "Ref<FocusableRefValue<HTMLAnchorElement, HTMLAnchorElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/Button.tsx#_LinkButton"] = {
        docgenInfo: _LinkButton.__docgenInfo,
        name: "_LinkButton",
        path: "packages/@react-spectrum/s2/src/Button.tsx#_LinkButton"
    };
} catch (__react_docgen_typescript_loader_error) {}

},{"0":"9XRwF","1":"hqLVd","2":"5FdGQ","3":"iEQfX","4":"5THdb","5":"f0hrM","6":"goaIF","7":"ftJYR","8":"d4oLQ","react/jsx-runtime":"2JzhG","react-aria-components":"8nuKL","./CenterBaseline":"hXatv","react":"jEiK2","./Icon":"1OC2a","../intl/*.json":"iU6xz","./pressScale":"6BiUY","./ProgressCircle":"c4KdT","./Skeleton":"2hWWB","./Content":"aBWEm","@react-spectrum/utils":"bebxO","./Form":"gJckc","@react-aria/i18n":"hFrKJ","./useSpectrumContextProps":"ileU6","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"9XRwF":[function() {},{}],"hqLVd":[function() {},{}],"5FdGQ":[function() {},{}],"iEQfX":[function() {},{}],"5THdb":[function() {},{}],"f0hrM":[function() {},{}],"goaIF":[function() {},{}],"ftJYR":[function() {},{}],"d4oLQ":[function() {},{}],"c4KdT":[function(require,module,exports) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ProgressCircleContext", ()=>ProgressCircleContext);
parcelHelpers.export(exports, "ProgressCircle", ()=>_ProgressCircle);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _react = require("react");
var _utils = require("@react-spectrum/utils");
var _useSpectrumContextProps = require("./useSpectrumContextProps");
const ProgressCircleContext = /*#__PURE__*/ (0, _react.createContext)(null);
// Double check the types passed to each style, may not need all for each
const wrapper = function anonymous(props, overrides) {
    let rules = " .";
    let matches = (overrides || '').match(/(?:^|\s)(?:y|z|A|B|_9|_8|h|_5|_4|__A|__c|__d|__a|__b|U|__Q|X|Z|V|W|l|q|r|k|o|p)[^\s]+/g) || [];
    rules += matches.join('');
    let $l = false;
    let $k = false;
    for (let p of matches){
        if (/^\s*l/.test(p)) $l = true;
        if (/^\s*k/.test(p)) $k = true;
    }
    if (!$l) {
        if (props.size === "L") rules += ' lp';
        else if (props.size === "S") rules += ' lf';
        else rules += ' lj';
    }
    if (!$k) {
        if (props.size === "L") rules += ' kp';
        else if (props.size === "S") rules += ' kf';
        else rules += ' kj';
    }
    rules += ' _bb';
    return rules;
};
const track = function anonymous(props) {
    let rules = " .";
    rules += ' fa_____w';
    if (props.staticColor === "black") rules += ' f_____o';
    else if (props.staticColor === "white") rules += ' f_____b';
    else rules += ' fk';
    return rules;
};
const fill = function anonymous(props) {
    let rules = " .";
    rules += ' fa_____B';
    if (props.staticColor === "black") rules += ' f_____u';
    else if (props.staticColor === "white") rules += ' f_____h';
    else rules += ' fA';
    rules += ' R-375ty3';
    rules += ' __Ga';
    return rules;
};
const rotationAnimation = "-u41dq3";
// stroke-dashoffset represents `100 - percentage`. See below for how this works.
const dashoffsetAnimation = "-_1i5ccgk";
function ProgressCircle(props, ref) {
    [props, ref] = (0, _useSpectrumContextProps.useSpectrumContextProps)(props, ref, ProgressCircleContext);
    let { size = 'M', staticColor, UNSAFE_style, UNSAFE_className = '' } = props;
    let domRef = (0, _utils.useDOMRef)(ref);
    let strokeWidth = 3;
    if (size === 'S') strokeWidth = 2;
    else if (size === 'L') strokeWidth = 4;
    // SVG strokes are centered, so subtract half the stroke width from the radius to create an inner stroke.
    let radius = `calc(50% - ${strokeWidth / 2}px)`;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.ProgressBar), {
        ...props,
        ref: domRef,
        style: UNSAFE_style,
        className: (renderProps)=>UNSAFE_className + wrapper({
                ...renderProps,
                size
            }, props.styles),
        children: ({ percentage, isIndeterminate })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                fill: "none",
                width: "100%",
                height: "100%",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                        cx: "50%",
                        cy: "50%",
                        r: radius,
                        strokeWidth: strokeWidth,
                        className: track({
                            staticColor
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                        cx: "50%",
                        cy: "50%",
                        r: radius,
                        strokeWidth: strokeWidth,
                        className: fill({
                            staticColor
                        }),
                        style: {
                            // These cubic-bezier timing functions were derived from the previous animation keyframes
                            // using a best fit algorithm, and then manually adjusted to approximate the original animation.
                            animation: isIndeterminate ? `${rotationAnimation} 1s cubic-bezier(.6, .1, .3, .9) infinite, ${dashoffsetAnimation} 1s cubic-bezier(.25, .1, .25, 1.3) infinite` : undefined
                        },
                        // Normalize the path length to 100 so we can easily set stroke-dashoffset to a percentage.
                        pathLength: "100",
                        // Add extra gap between dashes so 0% works in Chrome.
                        strokeDasharray: "100 200",
                        strokeDashoffset: isIndeterminate || percentage == null ? undefined : 100 - percentage,
                        strokeLinecap: "round"
                    })
                ]
            })
    });
}
/**
 * ProgressCircles show the progression of a system operation such as downloading, uploading, or processing, in a visual way.
 * They can represent determinate or indeterminate progress.
 */ let _ProgressCircle = /*#__PURE__*/ (0, _react.forwardRef)(ProgressCircle);
try {
    // @ts-ignore
    ProgressCircleContext.displayName = "ProgressCircleContext";
    // @ts-ignore
    ProgressCircleContext.__docgenInfo = {
        "description": "",
        "displayName": "ProgressCircleContext",
        "props": {
            "value": {
                "defaultValue": null,
                "description": "",
                "name": "value",
                "required": true,
                "type": {
                    "name": "ContextValue<ProgressCircleProps, DOMRefValue<HTMLDivElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/ProgressCircle.tsx#ProgressCircleContext"] = {
        docgenInfo: ProgressCircleContext.__docgenInfo,
        name: "ProgressCircleContext",
        path: "packages/@react-spectrum/s2/src/ProgressCircle.tsx#ProgressCircleContext"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    _ProgressCircle.displayName = "_ProgressCircle";
    // @ts-ignore
    _ProgressCircle.__docgenInfo = {
        "description": "ProgressCircles show the progression of a system operation such as downloading, uploading, or processing, in a visual way.\nThey can represent determinate or indeterminate progress.",
        "displayName": "_ProgressCircle",
        "props": {
            "isIndeterminate": {
                "defaultValue": null,
                "description": "Whether presentation is indeterminate when progress isn't known.",
                "name": "isIndeterminate",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "maxValue": {
                "defaultValue": {
                    value: "100"
                },
                "description": "The largest value allowed for the input.",
                "name": "maxValue",
                "required": false,
                "type": {
                    "name": "number"
                }
            },
            "minValue": {
                "defaultValue": {
                    value: "0"
                },
                "description": "The smallest value allowed for the input.",
                "name": "minValue",
                "required": false,
                "type": {
                    "name": "number"
                }
            },
            "size": {
                "defaultValue": {
                    value: "'M'"
                },
                "description": "The size of the ProgressCircle.",
                "name": "size",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"S\""
                        },
                        {
                            "value": "\"M\""
                        },
                        {
                            "value": "\"L\""
                        }
                    ]
                }
            },
            "staticColor": {
                "defaultValue": null,
                "description": "The static color style to apply. Useful when the button appears over a color background.",
                "name": "staticColor",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"white\""
                        },
                        {
                            "value": "\"black\""
                        }
                    ]
                }
            },
            "styles": {
                "defaultValue": null,
                "description": "Spectrum-defined styles, returned by the `style()` macro.",
                "name": "styles",
                "required": false,
                "type": {
                    "name": "StylesPropWithHeight"
                }
            },
            "UNSAFE_className": {
                "defaultValue": null,
                "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_className",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_style": {
                "defaultValue": null,
                "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_style",
                "required": false,
                "type": {
                    "name": "CSSProperties"
                }
            },
            "value": {
                "defaultValue": {
                    value: "0"
                },
                "description": "The current value (controlled).",
                "name": "value",
                "required": false,
                "type": {
                    "name": "number"
                }
            },
            "key": {
                "defaultValue": null,
                "description": "",
                "name": "key",
                "required": false,
                "type": {
                    "name": "Key"
                }
            },
            "ref": {
                "defaultValue": null,
                "description": "Allows getting a ref to the component instance.\nOnce the component unmounts, React will set `ref.current` to `null`\n(or call the ref with `null` if you passed a callback ref).\n@see {@link https://react.dev/learn/referencing-values-with-refs#refs-and-the-dom React Docs}",
                "name": "ref",
                "required": false,
                "type": {
                    "name": "Ref<DOMRefValue<HTMLDivElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/ProgressCircle.tsx#_ProgressCircle"] = {
        docgenInfo: _ProgressCircle.__docgenInfo,
        name: "_ProgressCircle",
        path: "packages/@react-spectrum/s2/src/ProgressCircle.tsx#_ProgressCircle"
    };
} catch (__react_docgen_typescript_loader_error) {}

},{"0":"32rrx","1":"2CXAj","2":"lRO1S","3":"4Ve4u","4":"iwUay","react/jsx-runtime":"2JzhG","react-aria-components":"8nuKL","react":"jEiK2","@react-spectrum/utils":"bebxO","./useSpectrumContextProps":"ileU6","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"32rrx":[function() {},{}],"2CXAj":[function() {},{}],"lRO1S":[function() {},{}],"4Ve4u":[function() {},{}],"iwUay":[function() {},{}],"bQ9CV":[function(require,module,exports) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ButtonGroupContext", ()=>ButtonGroupContext);
parcelHelpers.export(exports, "ButtonGroup", ()=>_ButtonGroup);
var _jsxRuntime = require("react/jsx-runtime");
var _button = require("./Button");
var _reactAriaComponents = require("react-aria-components");
var _react = require("react");
var _utils = require("@react-spectrum/utils");
var _utils1 = require("@react-aria/utils");
var _useSpectrumContextProps = require("./useSpectrumContextProps");
const ButtonGroupContext = /*#__PURE__*/ (0, _react.createContext)({});
const buttongroup = function anonymous(props, overrides) {
    let rules = " .";
    let matches = (overrides || '').match(/(?:^|\s)(?:y|z|A|B|_9|_8|h|_5|_4|__A|__c|__d|__a|__b|U|__Q|X|Z|V|W|l|q|r)[^\s]+/g) || [];
    rules += matches.join('');
    let $U = false;
    for (let p of matches)if (/^\s*U/.test(p)) $U = true;
    rules += ' _Ze';
    if (!$U) rules += ' Uc';
    if (props.size === "XL") rules += ' ie';
    else if (props.size === "L") rules += ' ie';
    else if (props.size === "M") rules += ' ie';
    else if (props.size === "S") rules += ' id';
    if (props.size === "XL") rules += ' je';
    else if (props.size === "L") rules += ' je';
    else if (props.size === "M") rules += ' je';
    else if (props.size === "S") rules += ' jd';
    if (props.orientation === "vertical") rules += ' _6b';
    else rules += ' _6a';
    if (props.orientation === "vertical") {
        if (props.align === "center") rules += ' _1c';
        else if (props.align === "end") rules += ' _1b';
        else rules += ' _1a';
    } else rules += ' _1c';
    if (props.orientation === "vertical") {
        if (props.align === "center") rules += ' _2d';
        else if (props.align === "end") rules += ' _2c';
        else rules += ' _2b';
    }
    return rules;
};
function ButtonGroup(props, ref) {
    [props, ref] = (0, _useSpectrumContextProps.useSpectrumContextProps)(props, ref, ButtonGroupContext);
    let domRef = (0, _utils.useDOMRef)(ref);
    let { size = 'M', orientation = 'horizontal', align = 'start', children, isDisabled } = props;
    let [hasOverflow, setHasOverflow] = (0, _utils1.useValueEffect)(false);
    let checkForOverflow = (0, _react.useCallback)(()=>{
        let computeHasOverflow = ()=>{
            if (domRef.current && orientation === 'horizontal') {
                let buttonGroupChildren = Array.from(domRef.current.children);
                let maxX = domRef.current.offsetWidth + 1; // + 1 to account for rounding errors
                // If any buttons have negative X positions (align="end") or extend beyond
                // the width of the button group (align="start"), then switch to vertical.
                if (buttonGroupChildren.some((child)=>child.offsetLeft < 0 || child.offsetLeft + child.offsetWidth > maxX)) return true;
                return false;
            }
        };
        if (orientation === 'horizontal') setHasOverflow(function*() {
            // Force to horizontal for measurement.
            yield false;
            // Measure, and update if there is overflow.
            yield computeHasOverflow();
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        domRef,
        orientation,
        setHasOverflow,
        children
    ]);
    // There are two main reasons we need to remeasure:
    // 1. Internal changes: Check for initial overflow or when orientation/scale/children change (from checkForOverflow dep array)
    (0, _utils1.useLayoutEffect)(()=>{
        checkForOverflow();
    }, [
        checkForOverflow
    ]);
    // 2. External changes: buttongroup won't change size due to any parents changing size, so listen to its container for size changes to figure out if we should remeasure
    let parent = (0, _react.useRef)(null);
    (0, _utils1.useLayoutEffect)(()=>{
        if (domRef.current) parent.current = domRef.current.parentElement;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        domRef.current
    ]);
    (0, _utils.useResizeObserver)({
        ref: parent,
        onResize: checkForOverflow
    });
    if (props.isHidden) return null;
    let context = {
        styles: " . _8-3t1x",
        size,
        isDisabled
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        ref: domRef,
        style: props.UNSAFE_style,
        className: (props.UNSAFE_className || '') + buttongroup({
            align,
            orientation: orientation === 'vertical' || hasOverflow ? 'vertical' : 'horizontal',
            size
        }, props.styles),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Provider), {
            values: [
                [
                    (0, _button.ButtonContext),
                    context
                ],
                [
                    (0, _button.LinkButtonContext),
                    context
                ]
            ],
            children: children
        })
    });
}
/**
 * ButtonGroup handles overflow for a grouping of buttons whose actions are related to each other.
 */ const _ButtonGroup = /*#__PURE__*/ (0, _react.forwardRef)(ButtonGroup);
try {
    // @ts-ignore
    ButtonGroupContext.displayName = "ButtonGroupContext";
    // @ts-ignore
    ButtonGroupContext.__docgenInfo = {
        "description": "",
        "displayName": "ButtonGroupContext",
        "props": {
            "value": {
                "defaultValue": null,
                "description": "",
                "name": "value",
                "required": true,
                "type": {
                    "name": "ContextValue<ButtonGroupContextValue, DOMRefValue<HTMLDivElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/ButtonGroup.tsx#ButtonGroupContext"] = {
        docgenInfo: ButtonGroupContext.__docgenInfo,
        name: "ButtonGroupContext",
        path: "packages/@react-spectrum/s2/src/ButtonGroup.tsx#ButtonGroupContext"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    _ButtonGroup.displayName = "_ButtonGroup";
    // @ts-ignore
    _ButtonGroup.__docgenInfo = {
        "description": "ButtonGroup handles overflow for a grouping of buttons whose actions are related to each other.",
        "displayName": "_ButtonGroup",
        "props": {
            "children": {
                "defaultValue": null,
                "description": "The Buttons contained within the ButtonGroup.",
                "name": "children",
                "required": true,
                "type": {
                    "name": "ReactNode"
                }
            },
            "align": {
                "defaultValue": {
                    value: "'start'"
                },
                "description": "The alignment of the Buttons within the ButtonGroup.",
                "name": "align",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"start\""
                        },
                        {
                            "value": "\"end\""
                        },
                        {
                            "value": "\"center\""
                        }
                    ]
                }
            },
            "isDisabled": {
                "defaultValue": null,
                "description": "Whether the Buttons in the ButtonGroup are all disabled.",
                "name": "isDisabled",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "orientation": {
                "defaultValue": {
                    value: "'horizontal'"
                },
                "description": "The axis the ButtonGroup should align with. Setting this to 'vertical' will prevent\nany switching behaviors between 'vertical' and 'horizontal'.",
                "name": "orientation",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"horizontal\""
                        },
                        {
                            "value": "\"vertical\""
                        }
                    ]
                }
            },
            "size": {
                "defaultValue": {
                    value: "'M'"
                },
                "description": "The size of the Buttons within the ButtonGroup.",
                "name": "size",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"S\""
                        },
                        {
                            "value": "\"M\""
                        },
                        {
                            "value": "\"L\""
                        },
                        {
                            "value": "\"XL\""
                        }
                    ]
                }
            },
            "styles": {
                "defaultValue": null,
                "description": "Spectrum-defined styles, returned by the `style()` macro.",
                "name": "styles",
                "required": false,
                "type": {
                    "name": "StylesProp"
                }
            },
            "UNSAFE_className": {
                "defaultValue": null,
                "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_className",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_style": {
                "defaultValue": null,
                "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_style",
                "required": false,
                "type": {
                    "name": "CSSProperties"
                }
            },
            "key": {
                "defaultValue": null,
                "description": "",
                "name": "key",
                "required": false,
                "type": {
                    "name": "Key"
                }
            },
            "ref": {
                "defaultValue": null,
                "description": "Allows getting a ref to the component instance.\nOnce the component unmounts, React will set `ref.current` to `null`\n(or call the ref with `null` if you passed a callback ref).\n@see {@link https://react.dev/learn/referencing-values-with-refs#refs-and-the-dom React Docs}",
                "name": "ref",
                "required": false,
                "type": {
                    "name": "Ref<DOMRefValue<HTMLDivElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/ButtonGroup.tsx#_ButtonGroup"] = {
        docgenInfo: _ButtonGroup.__docgenInfo,
        name: "_ButtonGroup",
        path: "packages/@react-spectrum/s2/src/ButtonGroup.tsx#_ButtonGroup"
    };
} catch (__react_docgen_typescript_loader_error) {}

},{"0":"j0yjK","1":"dxxV4","react/jsx-runtime":"2JzhG","./Button":"lgKOs","react-aria-components":"8nuKL","react":"jEiK2","@react-spectrum/utils":"bebxO","@react-aria/utils":"e9Yvo","./useSpectrumContextProps":"ileU6","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"j0yjK":[function() {},{}],"dxxV4":[function() {},{}],"1TY9V":[function(require,module,exports) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DialogContext", ()=>DialogContext);
parcelHelpers.export(exports, "Dialog", ()=>_Dialog);
parcelHelpers.export(exports, "dialogInner", ()=>dialogInner);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _buttonGroup = require("./ButtonGroup");
var _closeButton = require("./CloseButton");
var _content = require("./Content");
var _react = require("react");
var _image = require("./Image");
// @ts-ignore
var _json = require("../intl/*.json");
var _jsonDefault = parcelHelpers.interopDefault(_json);
var _modal = require("./Modal");
var _popover = require("./Popover");
var _utils = require("@react-spectrum/utils");
var _i18N = require("@react-aria/i18n");
const image = " . lG k-37m3s2 __Nb";
const heading = " . _9-3t1y Aa Ba _ca _c-enzrfpb _c-enzwzjc _c-enzykdd _c-enzzrge _c-eo0c6sf _c-1uotwbwg _c-bc1l9oh _dj _dbm _ee _e-1x99dloe _fa _f-1x99dlob ao";
const header = " . _ca _c-enzrfpb _c-enzwzjc _c-enzykdd _c-enzzrge _c-eo0c6sf _c-1uotwbwg _c-bc1l9oh _di _dbj _eb _fb _f-1x99dloc an";
const content = function anonymous(props) {
    let rules = " .";
    rules += ' _9-3t1y';
    if (props.type === "popover") rules += ' __wd';
    else {
        rules += ' __w-l92dlrd';
        rules += ' __wa';
    }
    rules += ' _c-bc1l9oh';
    rules += ' _c-1uotwbwg';
    rules += ' _c-eo0c6sf';
    rules += ' _c-enzzrge';
    rules += ' _c-enzykdd';
    rules += ' _c-enzwzjc';
    rules += ' _c-enzrfpb';
    rules += ' _ca';
    rules += ' _dbh';
    rules += ' _dg';
    rules += ' _eb';
    rules += ' _f-1x99dloc';
    rules += ' _fb';
    rules += ' an';
    rules += ' yj';
    rules += ' zj';
    return rules;
};
const footer = " . _9-3t1y _ca _c-enzrfpb _c-enzwzjc _c-enzykdd _c-enzzrge _c-eo0c6sf _c-1uotwbwg _c-bc1l9oh _dg _dbh _eb _fb _f-1x99dloc an";
const buttonGroup = " . y_d rG";
const DialogContext = /*#__PURE__*/ (0, _react.createContext)({
    type: 'modal',
    isDismissable: false,
    hideArrow: false,
    shouldFlip: true,
    isKeyboardDismissDisabled: false
});
function Dialog(props, ref) {
    let ctx = (0, _react.useContext)(DialogContext);
    let isDismissable = ctx.isDismissable || props.isDismissable;
    let isKeyboardDismissDisabled = ctx.isKeyboardDismissDisabled;
    let domRef = (0, _utils.useDOMRef)(ref);
    switch(ctx.type){
        case 'modal':
        case 'fullscreen':
        case 'fullscreenTakeover':
            {
                let size = ctx.type === 'modal' ? props.size : ctx.type;
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _modal.Modal), {
                    size: size,
                    isDismissable: isDismissable,
                    isKeyboardDismissDisabled: isKeyboardDismissDisabled,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(DialogInner, {
                        ...props,
                        ...ctx,
                        dialogRef: domRef,
                        isDismissable: isDismissable
                    })
                });
            }
        case 'popover':
            // get hideArrow from dialog instead?
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _popover.Popover), {
                size: props.size || 'M',
                hideArrow: ctx.hideArrow,
                placement: ctx.placement,
                shouldFlip: ctx.shouldFlip,
                containerPadding: ctx.containerPadding,
                offset: ctx.offset,
                crossOffset: ctx.crossOffset,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(DialogInner, {
                    ...props,
                    ...ctx,
                    dialogRef: domRef,
                    isDismissable: isDismissable
                })
            });
    }
}
/**
 * Dialogs are windows containing contextual information, tasks, or workflows that appear over the user interface.
 * Depending on the kind of Dialog, further interactions may be blocked until the Dialog is acknowledged.
 */ let _Dialog = /*#__PURE__*/ (0, _react.forwardRef)(Dialog);
const dialogInner = " . _Zd _6b _9-3t1y p-17zqamw __na _La _ca _c-enzrfpb _c-enzwzjc _c-enzykdd _c-enzzrge _c-eo0c6sf _c-1uotwbwg _c-bc1l9oh _v-17zqamw _w-17zqamw _x-17zqamw _y-17zqamw __va __wa";
function DialogInner(props1) {
    let stringFormatter = (0, _i18N.useLocalizedStringFormatter)((0, _jsonDefault.default), '@react-spectrum/s2');
    // The button group in fullscreen dialogs usually goes at the top, but
    // when the window is small, it moves to the bottom. We could do this in
    // pure CSS with display: none, but then the ref would go to two places.
    // With JS we can actually unmount on of them to ensure there is only one at a time.
    // Hopefully apps don't SSR render a dialog that's already open, because this means
    // we don't evaluate the media query until JS loads.
    let isSmall = (0, _utils.useMediaQuery)('(max-width: 640px)');
    let buttonGroupPlacement = 'bottom';
    if (props1.type === 'fullscreen' || props1.type === 'fullscreenTakeover') buttonGroupPlacement = isSmall ? 'bottom' : 'top';
    if (props1.isDismissable) buttonGroupPlacement = 'none';
    // TODO: manage focus when the button group placement changes and focus was on one of the buttons?
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Dialog), {
        ...props1,
        ref: props1.dialogRef,
        style: props1.UNSAFE_style,
        className: (props1.UNSAFE_className || '') + dialogInner,
        children: (0, _reactAriaComponents.composeRenderProps)(props1.children, (children, { close })=>// Render the children multiple times inside the wrappers we need to implement the layout.
            // Each instance hides certain children so that they are all rendered in the correct locations.
            // Reset OverlayTriggerStateContext so the buttons inside the dialog don't retain their hover state.
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactAriaComponents.OverlayTriggerStateContext).Provider, {
                value: null,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Provider), {
                        values: [
                            [
                                (0, _image.ImageContext),
                                {
                                    styles: image
                                }
                            ],
                            [
                                (0, _content.HeadingContext),
                                {
                                    isHidden: true
                                }
                            ],
                            [
                                (0, _content.HeaderContext),
                                {
                                    isHidden: true
                                }
                            ],
                            [
                                (0, _content.ContentContext),
                                {
                                    isHidden: true
                                }
                            ],
                            [
                                (0, _content.FooterContext),
                                {
                                    isHidden: true
                                }
                            ],
                            [
                                (0, _buttonGroup.ButtonGroupContext),
                                {
                                    isHidden: true
                                }
                            ]
                        ],
                        children: children
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: function anonymous(props) {
                            let rules = " .";
                            rules += ' _Zd';
                            rules += ' _1a';
                            rules += ' je';
                            rules += ' yj';
                            if (props.isDismissable) rules += ' ze';
                            else rules += ' zj';
                            rules += ' Ae';
                            return rules;
                        }({
                            isDismissable: props1.isDismissable,
                            type: props1.type
                        }),
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: " . _Zd _9-3t1y Ag A-15rr5u6a Bf B-15rr5u6a jh id _6b _6ca _1a _1cc",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Provider), {
                                    values: [
                                        [
                                            (0, _image.ImageContext),
                                            {
                                                hidden: true
                                            }
                                        ],
                                        [
                                            (0, _content.HeadingContext),
                                            {
                                                styles: heading
                                            }
                                        ],
                                        [
                                            (0, _content.HeaderContext),
                                            {
                                                styles: header
                                            }
                                        ],
                                        [
                                            (0, _content.ContentContext),
                                            {
                                                isHidden: true
                                            }
                                        ],
                                        [
                                            (0, _content.FooterContext),
                                            {
                                                isHidden: true
                                            }
                                        ],
                                        [
                                            (0, _buttonGroup.ButtonGroupContext),
                                            {
                                                isHidden: buttonGroupPlacement !== 'top'
                                            }
                                        ]
                                    ],
                                    children: children
                                })
                            }),
                            props1.isDismissable && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _closeButton.CloseButton), {
                                "aria-label": stringFormatter.format('dialog.dismiss'),
                                onPress: close,
                                styles: " . Be"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Provider), {
                        values: [
                            [
                                (0, _image.ImageContext),
                                {
                                    hidden: true
                                }
                            ],
                            [
                                (0, _content.HeadingContext),
                                {
                                    isHidden: true
                                }
                            ],
                            [
                                (0, _content.HeaderContext),
                                {
                                    isHidden: true
                                }
                            ],
                            [
                                (0, _content.ContentContext),
                                {
                                    styles: content({
                                        type: props1.type
                                    })
                                }
                            ],
                            [
                                (0, _content.FooterContext),
                                {
                                    isHidden: true
                                }
                            ],
                            [
                                (0, _buttonGroup.ButtonGroupContext),
                                {
                                    isHidden: true
                                }
                            ]
                        ],
                        children: children
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: " . _Zd Cj Dj Fj Ej E-15rr5u6a ih jh _1c _7a",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Provider), {
                            values: [
                                [
                                    (0, _image.ImageContext),
                                    {
                                        hidden: true
                                    }
                                ],
                                [
                                    (0, _content.HeadingContext),
                                    {
                                        isHidden: true
                                    }
                                ],
                                [
                                    (0, _content.HeaderContext),
                                    {
                                        isHidden: true
                                    }
                                ],
                                [
                                    (0, _content.ContentContext),
                                    {
                                        isHidden: true
                                    }
                                ],
                                [
                                    (0, _content.FooterContext),
                                    {
                                        styles: footer
                                    }
                                ],
                                [
                                    (0, _buttonGroup.ButtonGroupContext),
                                    {
                                        isHidden: buttonGroupPlacement !== 'bottom',
                                        styles: buttonGroup,
                                        align: 'end'
                                    }
                                ]
                            ],
                            children: children
                        })
                    })
                ]
            }))
    });
}
try {
    // @ts-ignore
    DialogContext.displayName = "DialogContext";
    // @ts-ignore
    DialogContext.__docgenInfo = {
        "description": "",
        "displayName": "DialogContext",
        "props": {
            "value": {
                "defaultValue": null,
                "description": "",
                "name": "value",
                "required": true,
                "type": {
                    "name": "DialogContextValue"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/Dialog.tsx#DialogContext"] = {
        docgenInfo: DialogContext.__docgenInfo,
        name: "DialogContext",
        path: "packages/@react-spectrum/s2/src/Dialog.tsx#DialogContext"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    _Dialog.displayName = "_Dialog";
    // @ts-ignore
    _Dialog.__docgenInfo = {
        "description": "Dialogs are windows containing contextual information, tasks, or workflows that appear over the user interface.\nDepending on the kind of Dialog, further interactions may be blocked until the Dialog is acknowledged.",
        "displayName": "_Dialog",
        "props": {
            "children": {
                "defaultValue": null,
                "description": "Children of the dialog. A function may be provided to access a function to close the dialog.",
                "name": "children",
                "required": false,
                "type": {
                    "name": "ReactNode | ((opts: DialogRenderProps) => ReactNode)"
                }
            },
            "isDismissable": {
                "defaultValue": null,
                "description": "Whether the Dialog is dismissable.",
                "name": "isDismissable",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "role": {
                "defaultValue": {
                    value: "'dialog'"
                },
                "description": "The accessibility role for the dialog.",
                "name": "role",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"alertdialog\""
                        },
                        {
                            "value": "\"dialog\""
                        }
                    ]
                }
            },
            "size": {
                "defaultValue": {
                    value: "'M'"
                },
                "description": "The size of the Dialog.",
                "name": "size",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"S\""
                        },
                        {
                            "value": "\"M\""
                        },
                        {
                            "value": "\"L\""
                        }
                    ]
                }
            },
            "styles": {
                "defaultValue": null,
                "description": "Spectrum-defined styles, returned by the `style()` macro.",
                "name": "styles",
                "required": false,
                "type": {
                    "name": "StylesProp"
                }
            },
            "UNSAFE_className": {
                "defaultValue": null,
                "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_className",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_style": {
                "defaultValue": null,
                "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_style",
                "required": false,
                "type": {
                    "name": "CSSProperties"
                }
            },
            "key": {
                "defaultValue": null,
                "description": "",
                "name": "key",
                "required": false,
                "type": {
                    "name": "Key"
                }
            },
            "ref": {
                "defaultValue": null,
                "description": "Allows getting a ref to the component instance.\nOnce the component unmounts, React will set `ref.current` to `null`\n(or call the ref with `null` if you passed a callback ref).\n@see {@link https://react.dev/learn/referencing-values-with-refs#refs-and-the-dom React Docs}",
                "name": "ref",
                "required": false,
                "type": {
                    "name": "Ref<DOMRefValue<HTMLElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/Dialog.tsx#_Dialog"] = {
        docgenInfo: _Dialog.__docgenInfo,
        name: "_Dialog",
        path: "packages/@react-spectrum/s2/src/Dialog.tsx#_Dialog"
    };
} catch (__react_docgen_typescript_loader_error) {}

},{"0":"aFV2x","1":"jYvqW","2":"frZTM","3":"bGgC3","4":"drIii","5":"kmtrt","6":"aCQ2U","7":"chKfG","8":"3jHKR","9":"kJUFV","10":"64gB1","react/jsx-runtime":"2JzhG","react-aria-components":"8nuKL","./ButtonGroup":"bQ9CV","./CloseButton":"6s57W","./Content":"aBWEm","react":"jEiK2","./Image":"l3wRP","../intl/*.json":"iU6xz","./Modal":"3rhAy","./Popover":"3Y0dA","@react-spectrum/utils":"bebxO","@react-aria/i18n":"hFrKJ","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"aFV2x":[function() {},{}],"jYvqW":[function() {},{}],"frZTM":[function() {},{}],"bGgC3":[function() {},{}],"drIii":[function() {},{}],"kmtrt":[function() {},{}],"aCQ2U":[function() {},{}],"chKfG":[function() {},{}],"3jHKR":[function() {},{}],"kJUFV":[function() {},{}],"64gB1":[function() {},{}],"6s57W":[function(require,module,exports) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CloseButton", ()=>_CloseButton);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _cross = require("../ui-icons/Cross");
var _crossDefault = parcelHelpers.interopDefault(_cross);
var _react = require("react");
var _pressScale = require("./pressScale");
var _utils = require("@react-spectrum/utils");
const hoverBackground = {
    default: 'gray-100',
    staticColor: {
        white: 'transparent-white-100',
        black: 'transparent-black-100'
    }
};
const styles = function anonymous(props, overrides) {
    let rules = " .";
    let matches = (overrides || '').match(/(?:^|\s)(?:y|z|A|B|_9|_8|h|_5|_4|__A|__c|__d|__a|__b|U|__Q|X|Z|V|W|l|q|r)[^\s]+/g) || [];
    rules += matches.join('');
    let $l = false;
    for (let p of matches)if (/^\s*l/.test(p)) $l = true;
    if (props.isFocusVisible) rules += ' _Lb';
    else rules += ' _La';
    rules += ' da_____z';
    if (props.staticColor === "black") rules += ' db';
    else if (props.staticColor === "white") rules += ' dc';
    else rules += ' dx';
    rules += ' _Nc';
    rules += ' _M-3t1z';
    rules += ' _Zd';
    rules += ' _1c';
    rules += ' _2d';
    if (!$l) {
        if (props.size === "XL") rules += ' ln';
        else if (props.size === "L") rules += ' ll';
        else if (props.size === "S") rules += ' lh';
        else if (props.size === "XS") rules += ' lg';
        else rules += ' lj';
    }
    if (props.size === "XL") rules += ' kn';
    else if (props.size === "L") rules += ' kl';
    else if (props.size === "S") rules += ' kh';
    else if (props.size === "XS") rules += ' kg';
    else rules += ' kj';
    rules += ' _vf';
    rules += ' _wf';
    rules += ' _xf';
    rules += ' _yf';
    rules += ' Ea';
    rules += ' Fa';
    rules += ' Ca';
    rules += ' Da';
    rules += ' wf';
    rules += ' _Oa';
    rules += ' _Q-375x7f';
    rules += ' _Ra';
    if (props.isPressed) {
        if (props.staticColor === "black") rules += ' b_____k';
        else if (props.staticColor === "white") rules += ' b____7';
        else rules += ' bg';
    } else if (props.isFocusVisible) {
        if (props.staticColor === "black") rules += ' b_____k';
        else if (props.staticColor === "white") rules += ' b____7';
        else rules += ' bg';
    } else if (props.isHovered) {
        if (props.staticColor === "black") rules += ' b_____k';
        else if (props.staticColor === "white") rules += ' b____7';
        else rules += ' bg';
    } else rules += ' ba';
    if (props.staticColor === "black") {
        if (props.isDisabled) rules += ' -rwx0fg_a-_____n';
        else {
            if (props.isPressed) rules += ' -rwx0fg_a-_____s';
            else if (props.isFocusVisible) rules += ' -rwx0fg_a-_____s';
            else if (props.isHovered) rules += ' -rwx0fg_a-_____s';
            else rules += ' -rwx0fg_a-_____r';
        }
    } else if (props.staticColor === "white") {
        if (props.isDisabled) rules += ' -rwx0fg_a-_____a';
        else {
            if (props.isPressed) rules += ' -rwx0fg_a-_____f';
            else if (props.isFocusVisible) rules += ' -rwx0fg_a-_____f';
            else if (props.isHovered) rules += ' -rwx0fg_a-_____f';
            else rules += ' -rwx0fg_a-_____e';
        }
    } else if (props.isDisabled) rules += ' -rwx0fg_a-j';
    else {
        if (props.isPressed) rules += ' -rwx0fg_a-o';
        else if (props.isFocusVisible) rules += ' -rwx0fg_a-o';
        else if (props.isHovered) rules += ' -rwx0fg_a-o';
        else rules += ' -rwx0fg_a-n';
    }
    return rules;
};
function CloseButton(props, ref) {
    let { UNSAFE_style, UNSAFE_className = '' } = props;
    let domRef = (0, _utils.useFocusableRef)(ref);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Button), {
        ...props,
        ref: domRef,
        style: (0, _pressScale.pressScale)(domRef, UNSAFE_style),
        className: (renderProps)=>UNSAFE_className + styles(renderProps, props.styles),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _crossDefault.default), {
            size: {
                S: 'L',
                M: 'XL',
                L: 'XXL',
                XL: 'XXXL'
            }[props.size || 'M']
        })
    });
}
let _CloseButton = /*#__PURE__*/ (0, _react.forwardRef)(CloseButton);
try {
    // @ts-ignore
    _CloseButton.displayName = "_CloseButton";
    // @ts-ignore
    _CloseButton.__docgenInfo = {
        "description": "",
        "displayName": "_CloseButton",
        "props": {
            "autoFocus": {
                "defaultValue": null,
                "description": "Whether the element should receive focus on render.",
                "name": "autoFocus",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "excludeFromTabOrder": {
                "defaultValue": null,
                "description": "Whether to exclude the element from the sequential tab order. If true,\nthe element will not be focusable via the keyboard by tabbing. This should\nbe avoided except in rare scenarios where an alternative means of accessing\nthe element or its functionality via the keyboard is available.",
                "name": "excludeFromTabOrder",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "form": {
                "defaultValue": null,
                "description": "The `<form>` element to associate the button with.\nThe value of this attribute must be the id of a `<form>` in the same document.",
                "name": "form",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "formAction": {
                "defaultValue": null,
                "description": "The URL that processes the information submitted by the button.\nOverrides the action attribute of the button's form owner.",
                "name": "formAction",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "formEncType": {
                "defaultValue": null,
                "description": "Indicates how to encode the form data that is submitted.",
                "name": "formEncType",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "formMethod": {
                "defaultValue": null,
                "description": "Indicates the HTTP method used to submit the form.",
                "name": "formMethod",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "formNoValidate": {
                "defaultValue": null,
                "description": "Indicates that the form is not to be validated when it is submitted.",
                "name": "formNoValidate",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "formTarget": {
                "defaultValue": null,
                "description": "Overrides the target attribute of the button's form owner.",
                "name": "formTarget",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "isDisabled": {
                "defaultValue": null,
                "description": "Whether the button is disabled.",
                "name": "isDisabled",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isPending": {
                "defaultValue": null,
                "description": "Whether the button is in a pending state. This disables press and hover events\nwhile retaining focusability, and announces the pending state to screen readers.",
                "name": "isPending",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "name": {
                "defaultValue": null,
                "description": "Submitted as a pair with the button's value as part of the form data.",
                "name": "name",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "preventFocusOnPress": {
                "defaultValue": null,
                "description": "Whether to prevent focus from moving to the button when pressing it.\n\nCaution, this can make the button inaccessible and should only be used when alternative keyboard interaction is provided,\nsuch as ComboBox's MenuTrigger or a NumberField's increment/decrement control.",
                "name": "preventFocusOnPress",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "size": {
                "defaultValue": {
                    value: "'M'"
                },
                "description": "The size of the CloseButton.",
                "name": "size",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"S\""
                        },
                        {
                            "value": "\"M\""
                        },
                        {
                            "value": "\"L\""
                        },
                        {
                            "value": "\"XL\""
                        }
                    ]
                }
            },
            "staticColor": {
                "defaultValue": null,
                "description": "The static color style to apply. Useful when the Button appears over a color background.",
                "name": "staticColor",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"white\""
                        },
                        {
                            "value": "\"black\""
                        }
                    ]
                }
            },
            "styles": {
                "defaultValue": null,
                "description": "Spectrum-defined styles, returned by the `style()` macro.",
                "name": "styles",
                "required": false,
                "type": {
                    "name": "StylesProp"
                }
            },
            "type": {
                "defaultValue": {
                    value: "'button'"
                },
                "description": "The behavior of the button when used in an HTML form.",
                "name": "type",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"button\""
                        },
                        {
                            "value": "\"submit\""
                        },
                        {
                            "value": "\"reset\""
                        }
                    ]
                }
            },
            "UNSAFE_className": {
                "defaultValue": null,
                "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_className",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_style": {
                "defaultValue": null,
                "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_style",
                "required": false,
                "type": {
                    "name": "CSSProperties"
                }
            },
            "value": {
                "defaultValue": null,
                "description": "The value associated with the button's name when it's submitted with the form data.",
                "name": "value",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "onPress": {
                "defaultValue": null,
                "description": "Handler that is called when the press is released over the target.",
                "name": "onPress",
                "required": false,
                "type": {
                    "name": "(e: PressEvent) => void"
                }
            },
            "onPressChange": {
                "defaultValue": null,
                "description": "Handler that is called when the press state changes.",
                "name": "onPressChange",
                "required": false,
                "type": {
                    "name": "(isPressed: boolean) => void"
                }
            },
            "onPressEnd": {
                "defaultValue": null,
                "description": "Handler that is called when a press interaction ends, either\nover the target or when the pointer leaves the target.",
                "name": "onPressEnd",
                "required": false,
                "type": {
                    "name": "(e: PressEvent) => void"
                }
            },
            "onPressStart": {
                "defaultValue": null,
                "description": "Handler that is called when a press interaction starts.",
                "name": "onPressStart",
                "required": false,
                "type": {
                    "name": "(e: PressEvent) => void"
                }
            },
            "onPressUp": {
                "defaultValue": null,
                "description": "Handler that is called when a press is released over the target, regardless of\nwhether it started on the target or not.",
                "name": "onPressUp",
                "required": false,
                "type": {
                    "name": "(e: PressEvent) => void"
                }
            },
            "key": {
                "defaultValue": null,
                "description": "",
                "name": "key",
                "required": false,
                "type": {
                    "name": "Key"
                }
            },
            "ref": {
                "defaultValue": null,
                "description": "Allows getting a ref to the component instance.\nOnce the component unmounts, React will set `ref.current` to `null`\n(or call the ref with `null` if you passed a callback ref).\n@see {@link https://react.dev/learn/referencing-values-with-refs#refs-and-the-dom React Docs}",
                "name": "ref",
                "required": false,
                "type": {
                    "name": "Ref<FocusableRefValue<HTMLButtonElement, HTMLButtonElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/CloseButton.tsx#_CloseButton"] = {
        docgenInfo: _CloseButton.__docgenInfo,
        name: "_CloseButton",
        path: "packages/@react-spectrum/s2/src/CloseButton.tsx#_CloseButton"
    };
} catch (__react_docgen_typescript_loader_error) {}

},{"0":"jmZJU","react/jsx-runtime":"2JzhG","react-aria-components":"8nuKL","../ui-icons/Cross":"dcfAa","react":"jEiK2","./pressScale":"6BiUY","@react-spectrum/utils":"bebxO","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"jmZJU":[function() {},{}],"dcfAa":[function(require,module,exports) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Cross);
var _jsxRuntime = require("react/jsx-runtime");
var _s2CrossSize200Svg = require("./S2_CrossSize200.svg");
var _s2CrossSize200SvgDefault = parcelHelpers.interopDefault(_s2CrossSize200Svg);
var _s2CrossSize100Svg = require("./S2_CrossSize100.svg");
var _s2CrossSize100SvgDefault = parcelHelpers.interopDefault(_s2CrossSize100Svg);
var _s2CrossSize75Svg = require("./S2_CrossSize75.svg");
var _s2CrossSize75SvgDefault = parcelHelpers.interopDefault(_s2CrossSize75Svg);
var _s2CrossSize300Svg = require("./S2_CrossSize300.svg");
var _s2CrossSize300SvgDefault = parcelHelpers.interopDefault(_s2CrossSize300Svg);
var _s2CrossSize400Svg = require("./S2_CrossSize400.svg");
var _s2CrossSize400SvgDefault = parcelHelpers.interopDefault(_s2CrossSize400Svg);
var _s2CrossSize500Svg = require("./S2_CrossSize500.svg");
var _s2CrossSize500SvgDefault = parcelHelpers.interopDefault(_s2CrossSize500Svg);
var _s2CrossSize600Svg = require("./S2_CrossSize600.svg");
var _s2CrossSize600SvgDefault = parcelHelpers.interopDefault(_s2CrossSize600Svg);
function Cross(props) {
    let { size = 'M', ...otherProps } = props;
    switch(size){
        case 'M':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2CrossSize100SvgDefault.default), {
                ...otherProps
            });
        case 'L':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2CrossSize200SvgDefault.default), {
                ...otherProps
            });
        case 'XL':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2CrossSize300SvgDefault.default), {
                ...otherProps
            });
        case 'XXL':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2CrossSize400SvgDefault.default), {
                ...otherProps
            });
        case 'XXXL':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2CrossSize500SvgDefault.default), {
                ...otherProps
            });
        case 'XXXXL':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2CrossSize600SvgDefault.default), {
                ...otherProps
            });
        case 'S':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2CrossSize75SvgDefault.default), {
                ...otherProps
            });
    }
}

},{"react/jsx-runtime":"2JzhG","./S2_CrossSize200.svg":"8c1fC","./S2_CrossSize100.svg":"6Cz5W","./S2_CrossSize75.svg":"1NKbR","./S2_CrossSize300.svg":"kzowV","./S2_CrossSize400.svg":"dbyJg","./S2_CrossSize500.svg":"e3VlC","./S2_CrossSize600.svg":"aXKe0","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"8c1fC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgS2CrossSize200 = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 10,
        height: 10,
        viewBox: "0 0 10 10",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "m6.289 5 2.922-2.923A.912.912 0 0 0 7.922.788L5 3.711 2.078.788a.912.912 0 0 0-1.29 1.29L3.712 5 .789 7.923a.912.912 0 0 0 1.289 1.289L5 6.289l2.922 2.923a.909.909 0 0 0 1.29 0 .912.912 0 0 0 0-1.29L6.288 5Z",
            fill: "var(--iconPrimary, #222)"
        })
    });
exports.default = SvgS2CrossSize200;

},{"react/jsx-runtime":"2JzhG","react":"jEiK2","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"6Cz5W":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgS2CrossSize100 = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 8,
        height: 8,
        viewBox: "0 0 8 8",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "m5.238 4 2.456-2.456A.876.876 0 0 0 6.457.306L4 2.762 1.543.306A.875.875 0 1 0 .306 1.544L2.762 4 .306 6.456a.876.876 0 0 0 1.237 1.238L4 5.238l2.457 2.456a.871.871 0 0 0 1.237 0 .876.876 0 0 0 0-1.238L5.238 4Z",
            fill: "var(--iconPrimary, #222)"
        })
    });
exports.default = SvgS2CrossSize100;

},{"react/jsx-runtime":"2JzhG","react":"jEiK2","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"1NKbR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgS2CrossSize75 = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 8,
        height: 8,
        viewBox: "0 0 8 8",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "m5.188 4 2.14-2.14A.84.84 0 0 0 6.14.671L4 2.812 1.86.672A.84.84 0 0 0 .672 1.859L2.812 4 .672 6.14A.84.84 0 0 0 1.86 7.329L4 5.188l2.14 2.14a.838.838 0 0 0 1.188 0 .84.84 0 0 0 0-1.187L5.188 4Z",
            fill: "var(--iconPrimary, #222)"
        })
    });
exports.default = SvgS2CrossSize75;

},{"react/jsx-runtime":"2JzhG","react":"jEiK2","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"kzowV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgS2CrossSize300 = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 12,
        height: 12,
        viewBox: "0 0 12 12",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "m7.342 6 3.396-3.396a.95.95 0 1 0-1.342-1.342L6 4.658 2.604 1.262a.95.95 0 1 0-1.343 1.342L4.659 6 1.262 9.396a.95.95 0 1 0 1.343 1.342L6 7.342l3.396 3.396a.946.946 0 0 0 1.342.001.95.95 0 0 0 0-1.343L7.342 6Z",
            fill: "var(--iconPrimary, #222)"
        })
    });
exports.default = SvgS2CrossSize300;

},{"react/jsx-runtime":"2JzhG","react":"jEiK2","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"dbyJg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgS2CrossSize400 = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 12,
        height: 12,
        viewBox: "0 0 12 12",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "m7.398 6 3.932-3.932A.989.989 0 1 0 9.932.67L6 4.602 2.068.67A.988.988 0 1 0 .67 2.068L4.602 6 .67 9.932a.989.989 0 1 0 1.398 1.398L6 7.398l3.932 3.932a.985.985 0 0 0 1.398 0 .989.989 0 0 0 0-1.398L7.398 6Z",
            fill: "var(--iconPrimary, #222)"
        })
    });
exports.default = SvgS2CrossSize400;

},{"react/jsx-runtime":"2JzhG","react":"jEiK2","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"e3VlC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgS2CrossSize500 = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 14,
        height: 14,
        viewBox: "0 0 14 14",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "m8.457 7 4.54-4.54a1.031 1.031 0 0 0-1.457-1.456L7 5.543l-4.54-4.54a1.03 1.03 0 0 0-1.457 1.458L5.543 7l-4.54 4.54a1.031 1.031 0 0 0 1.457 1.456L7 8.457l4.54 4.54a1.027 1.027 0 0 0 1.457 0 1.031 1.031 0 0 0 0-1.458L8.457 7Z",
            fill: "var(--iconPrimary, #222)"
        })
    });
exports.default = SvgS2CrossSize500;

},{"react/jsx-runtime":"2JzhG","react":"jEiK2","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"aXKe0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgS2CrossSize600 = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        viewBox: "0 0 16 16",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "m9.518 8 5.23-5.229a1.073 1.073 0 0 0-1.519-1.517L8 6.483l-5.229-5.23a1.073 1.073 0 0 0-1.518 1.518l5.23 5.23-5.23 5.228a1.073 1.073 0 0 0 1.518 1.518l5.23-5.229 5.228 5.23a1.073 1.073 0 1 0 1.518-1.519L9.518 8Z",
            fill: "var(--iconPrimary, #222)"
        })
    });
exports.default = SvgS2CrossSize600;

},{"react/jsx-runtime":"2JzhG","react":"jEiK2","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"3rhAy":[function(require,module,exports) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Modal", ()=>_Modal);
var _jsxRuntime = require("react/jsx-runtime");
var _provider = require("./Provider");
var _react = require("react");
var _reactAriaComponents = require("react-aria-components");
var _utils = require("@react-spectrum/utils");
const fade = "-_1llqja1";
const fadeAndSlide = "-_1mhijd";
const modalOverlayStyles = function anonymous(props) {
    let rules = " .";
    if (props.colorScheme === "dark") rules += ' _Ab';
    else if (props.colorScheme === "light") rules += ' _Aa';
    else if (props.colorScheme === "light dark") rules += ' _Ac';
    else rules += ' _A-10jn6wd';
    rules += ' Ub';
    rules += ' Xa';
    rules += ' Za';
    rules += ' Va';
    rules += ' Wa';
    rules += ' __Fa';
    rules += ' b_____o';
    rules += ' _Zd';
    rules += ' _1c';
    rules += ' _2d';
    if (props.isExiting) rules += ' _S-1nys8p3';
    else if (props.isEntering) rules += ' _S-1nys8p3';
    if (props.isExiting) rules += ' _T-375x5l';
    else if (props.isEntering) rules += ' _T-375y1o';
    if (props.isExiting) rules += ' _Ya';
    else if (props.isEntering) rules += ' _Ya';
    if (props.isExiting) rules += ' _Vb';
    else if (props.isEntering) rules += ' _Va';
    return rules;
};
function Modal(props1, ref) {
    let domRef = (0, _utils.useDOMRef)(ref);
    let colorScheme = (0, _react.useContext)((0, _provider.ColorSchemeContext));
    let { locale, direction } = (0, _reactAriaComponents.useLocale)();
    // TODO: should we pass through lang and dir props in RAC?
    let modalRef = (0, _react.useCallback)((el)=>{
        domRef.current = el;
        if (el) {
            el.lang = locale;
            el.dir = direction;
        }
    }, [
        locale,
        direction,
        domRef
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.ModalOverlay), {
        ...props1,
        className: (renderProps)=>modalOverlayStyles({
                ...renderProps,
                colorScheme
            }),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Modal), {
            ...props1,
            ref: modalRef,
            className: (renderProps)=>(function anonymous(props) {
                    let rules = " .";
                    rules += ' _Zd';
                    rules += ' _6b';
                    if (props.size === "fullscreenTakeover") rules += ' _va';
                    else rules += ' _ve';
                    if (props.size === "fullscreenTakeover") rules += ' _wa';
                    else rules += ' _we';
                    if (props.size === "fullscreenTakeover") rules += ' _xa';
                    else rules += ' _xe';
                    if (props.size === "fullscreenTakeover") rules += ' _ya';
                    else rules += ' _ye';
                    if (props.size === "fullscreenTakeover") rules += ' lG';
                    else if (props.size === "fullscreen") rules += ' l-tp2nko';
                    else if (props.size === "L") rules += ' l-3940j6';
                    else if (props.size === "M") rules += ' l-38elgx';
                    else if (props.size === "S") rules += ' l-38aqto';
                    if (props.size === "fullscreenTakeover") rules += ' kG';
                    else if (props.size === "fullscreen") rules += ' k-tp2nko';
                    if (props.size === "L") rules += ' r-yjhhbv';
                    else if (props.size === "M") rules += ' r-yjhhbv';
                    else if (props.size === "S") rules += ' r-yjhhbv';
                    if (props.size === "L") rules += ' p-yjhhbg';
                    else if (props.size === "M") rules += ' p-yjhhbg';
                    else if (props.size === "S") rules += ' p-yjhhbg';
                    rules += ' -_1de2x0q_b-______k';
                    rules += ' b-1de2x0q';
                    if (props.isExiting) rules += ' _S-1nys8p3';
                    else if (props.isEntering) rules += ' _S-3zirke';
                    if (props.isExiting) rules += ' _T-375x5l';
                    else if (props.isEntering) rules += ' _T-375y1o';
                    if (props.isExiting) rules += ' _Ya';
                    else if (props.isEntering) rules += ' _Ya';
                    if (props.isExiting) rules += ' _U-3t1x';
                    else if (props.isEntering) rules += ' _U-375x8c';
                    if (props.isExiting) rules += ' _Vb';
                    else if (props.isEntering) rules += ' _Va';
                    rules += ' _Wd';
                    rules += ' _Lb';
                    rules += ' _Nb';
                    rules += ' da';
                    return rules;
                })({
                    ...renderProps,
                    size: props1.size || 'M'
                })
        })
    });
}
/**
 * A modal is an overlay element which blocks interaction with elements outside it.
 */ let _Modal = /*#__PURE__*/ (0, _react.forwardRef)(Modal);
try {
    // @ts-ignore
    _Modal.displayName = "_Modal";
    // @ts-ignore
    _Modal.__docgenInfo = {
        "description": "A modal is an overlay element which blocks interaction with elements outside it.",
        "displayName": "_Modal",
        "props": {
            "children": {
                "defaultValue": null,
                "description": "The children of the component. A function may be provided to alter the children based on component state.",
                "name": "children",
                "required": false,
                "type": {
                    "name": "ReactNode | ((values: ModalRenderProps & { defaultChildren: ReactNode; }) => ReactNode)"
                }
            },
            "className": {
                "defaultValue": null,
                "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
                "name": "className",
                "required": false,
                "type": {
                    "name": "string | ((values: ModalRenderProps & { defaultClassName: string; }) => string)"
                }
            },
            "defaultOpen": {
                "defaultValue": null,
                "description": "Whether the overlay is open by default (uncontrolled).",
                "name": "defaultOpen",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isDismissable": {
                "defaultValue": {
                    value: "false"
                },
                "description": "Whether to close the modal when the user interacts outside it.",
                "name": "isDismissable",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isEntering": {
                "defaultValue": null,
                "description": "Whether the modal is currently performing an entry animation.",
                "name": "isEntering",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isExiting": {
                "defaultValue": null,
                "description": "Whether the modal is currently performing an exit animation.",
                "name": "isExiting",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isKeyboardDismissDisabled": {
                "defaultValue": {
                    value: "false"
                },
                "description": "Whether pressing the escape key to close the modal should be disabled.",
                "name": "isKeyboardDismissDisabled",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isOpen": {
                "defaultValue": null,
                "description": "Whether the overlay is open by default (controlled).",
                "name": "isOpen",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "shouldCloseOnInteractOutside": {
                "defaultValue": null,
                "description": "When user interacts with the argument element outside of the overlay ref,\nreturn true if onClose should be called.  This gives you a chance to filter\nout interaction with elements that should not dismiss the overlay.\nBy default, onClose will always be called on interaction outside the overlay ref.",
                "name": "shouldCloseOnInteractOutside",
                "required": false,
                "type": {
                    "name": "(element: Element) => boolean"
                }
            },
            "size": {
                "defaultValue": {
                    value: "'M'"
                },
                "description": "The size of the Modal.",
                "name": "size",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"S\""
                        },
                        {
                            "value": "\"M\""
                        },
                        {
                            "value": "\"L\""
                        },
                        {
                            "value": "\"fullscreen\""
                        },
                        {
                            "value": "\"fullscreenTakeover\""
                        }
                    ]
                }
            },
            "style": {
                "defaultValue": null,
                "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
                "name": "style",
                "required": false,
                "type": {
                    "name": "CSSProperties | ((values: ModalRenderProps & { defaultStyle: CSSProperties; }) => CSSProperties)"
                }
            },
            "UNSTABLE_portalContainer": {
                "defaultValue": {
                    value: "document.body"
                },
                "description": "The container element in which the overlay portal will be placed. This may have unknown behavior depending on where it is portalled to.",
                "name": "UNSTABLE_portalContainer",
                "required": false,
                "type": {
                    "name": "Element"
                }
            },
            "onOpenChange": {
                "defaultValue": null,
                "description": "Handler that is called when the overlay's open state changes.",
                "name": "onOpenChange",
                "required": false,
                "type": {
                    "name": "(isOpen: boolean) => void"
                }
            },
            "key": {
                "defaultValue": null,
                "description": "",
                "name": "key",
                "required": false,
                "type": {
                    "name": "Key"
                }
            },
            "ref": {
                "defaultValue": null,
                "description": "Allows getting a ref to the component instance.\nOnce the component unmounts, React will set `ref.current` to `null`\n(or call the ref with `null` if you passed a callback ref).\n@see {@link https://react.dev/learn/referencing-values-with-refs#refs-and-the-dom React Docs}",
                "name": "ref",
                "required": false,
                "type": {
                    "name": "Ref<DOMRefValue<HTMLDivElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/Modal.tsx#_Modal"] = {
        docgenInfo: _Modal.__docgenInfo,
        name: "_Modal",
        path: "packages/@react-spectrum/s2/src/Modal.tsx#_Modal"
    };
} catch (__react_docgen_typescript_loader_error) {}

},{"0":"hC5c0","1":"lsPu8","2":"3Rtia","3":"llUps","react/jsx-runtime":"2JzhG","./Provider":"hIsCH","react":"jEiK2","react-aria-components":"8nuKL","@react-spectrum/utils":"bebxO","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"hC5c0":[function() {},{}],"lsPu8":[function() {},{}],"3Rtia":[function() {},{}],"llUps":[function() {},{}],"9c1qW":[function(require,module,exports) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FieldLabel", ()=>_FieldLabel);
parcelHelpers.export(exports, "FieldGroup", ()=>_FieldGroup);
parcelHelpers.export(exports, "Input", ()=>_Input);
parcelHelpers.export(exports, "HelpText", ()=>HelpText);
parcelHelpers.export(exports, "FieldErrorIcon", ()=>FieldErrorIcon);
var _jsxRuntime = require("react/jsx-runtime");
var _s2IconAlertTriangle20NSvg = require("../s2wf-icons/S2_Icon_AlertTriangle_20_N.svg");
var _s2IconAlertTriangle20NSvgDefault = parcelHelpers.interopDefault(_s2IconAlertTriangle20NSvg);
var _asterisk = require("../ui-icons/Asterisk");
var _asteriskDefault = parcelHelpers.interopDefault(_asterisk);
var _centerBaseline = require("./CenterBaseline");
var _reactAriaComponents = require("react-aria-components");
var _contextualHelp = require("./ContextualHelp");
var _react = require("react");
var _icon = require("./Icon");
// @ts-ignore
var _json = require("../intl/*.json");
var _jsonDefault = parcelHelpers.interopDefault(_json);
var _runtime = require("../style/runtime");
var _utils = require("@react-spectrum/utils");
var _utils1 = require("@react-aria/utils");
var _i18N = require("@react-aria/i18n");
function FieldLabel(props, ref) {
    let stringFormatter = (0, _i18N.useLocalizedStringFormatter)((0, _jsonDefault.default), '@react-spectrum/s2');
    let { isDisabled, isRequired, size = 'M', necessityIndicator = 'icon', includeNecessityIndicatorInAccessibilityName = false, labelAlign, labelPosition, staticColor, contextualHelp, isQuiet, UNSAFE_style, UNSAFE_className = '', ...labelProps } = props;
    let domRef = (0, _utils.useDOMRef)(ref);
    let contextualHelpId = (0, _utils1.useId)();
    let fallbackLabelPropsId = (0, _utils1.useId)();
    if (contextualHelp && !labelProps.id) labelProps.id = fallbackLabelPropsId;
    if (!props.children) return null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: function anonymous(props) {
            let rules = " .";
            rules += ' __a-4e9m05';
            rules += ' __b-4e9m05';
            rules += ' __c-4e9m05';
            rules += ' __d-4e9m05';
            rules += ' _Zc';
            if (props.labelAlign === "end") rules += ' _jc';
            else if (props.labelAlign === "start") rules += ' _ja';
            if (props.labelPosition === "top") rules += ' F-1inj1bc';
            if (props.isQuiet) rules += ' __ma';
            else if (props.labelPosition === "top") rules += ' __me';
            return rules;
        }({
            labelAlign,
            labelPosition,
            isQuiet
        }),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactAriaComponents.Label), {
                ...labelProps,
                ref: domRef,
                style: UNSAFE_style,
                className: UNSAFE_className + (0, _runtime.mergeStyles)(function anonymous(props) {
                    let rules = " .";
                    rules += ' _c-bc1l9oh';
                    rules += ' _c-1uotwbwg';
                    rules += ' _c-eo0c6sf';
                    rules += ' _c-enzzrge';
                    rules += ' _c-enzykdd';
                    rules += ' _c-enzwzjc';
                    rules += ' _c-enzrfpb';
                    rules += ' _ca';
                    if (props.size === "XL") {
                        rules += ' _dbj';
                        rules += ' _di';
                    } else if (props.size === "L") {
                        rules += ' _dbh';
                        rules += ' _dg';
                    } else if (props.size === "S") {
                        rules += ' _dbd';
                        rules += ' _dc';
                    } else if (props.size === "XS") {
                        rules += ' _dbb';
                        rules += ' _da';
                    } else {
                        rules += ' _dbf';
                        rules += ' _de';
                    }
                    rules += ' _eb';
                    rules += ' _f-1x99dlob';
                    rules += ' _fa';
                    rules += ' aa_____x';
                    if (props.staticColor === "black") rules += ' a_____s';
                    else if (props.staticColor === "white") rules += ' a_____d';
                    else if (props.isDisabled) rules += ' aj';
                    else {
                        if (props.isPressed) rules += ' an';
                        else if (props.isFocusVisible) rules += ' an';
                        else if (props.isHovered) rules += ' an';
                        else rules += ' am';
                    }
                    rules += ' __Hb';
                    return rules;
                }({
                    labelPosition,
                    isDisabled,
                    size,
                    staticColor
                }), props.styles),
                children: [
                    props.children,
                    (isRequired || necessityIndicator === 'label') && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                        className: " . _pb",
                        children: [
                            "\xa0",
                            necessityIndicator === 'icon' && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _asteriskDefault.default), {
                                size: size === 'S' ? 'M' : size,
                                className: " . -rwx0fg_e-b",
                                "aria-label": includeNecessityIndicatorInAccessibilityName ? stringFormatter.format('label.(required)') : undefined
                            }),
                            necessityIndicator === 'label' && /* The necessity label is hidden to screen readers if the field is required because
              * aria-required is set on the field in that case. That will already be announced,
              * so no need to duplicate it here. If optional, we do want it to be announced here.
              */ /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                "aria-hidden": !includeNecessityIndicatorInAccessibilityName ? isRequired : undefined,
                                children: isRequired ? stringFormatter.format('label.(required)') : stringFormatter.format('label.(optional)')
                            })
                        ]
                    })
                ]
            }),
            contextualHelp && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _centerBaseline.CenterBaseline), {
                styles: " . _Ze ka yc",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _contextualHelp.ContextualHelpContext).Provider, {
                    value: {
                        id: contextualHelpId,
                        'aria-labelledby': labelProps?.id ? `${labelProps.id} ${contextualHelpId}` : undefined,
                        size: size === 'L' || size === 'XL' ? 'S' : 'XS'
                    },
                    children: contextualHelp
                })
            })
        ]
    });
}
let _FieldLabel = /*#__PURE__*/ (0, _react.forwardRef)(FieldLabel);
const fieldGroupStyles = function anonymous(props) {
    let rules = " .";
    if (props.isFocusVisible) rules += ' _Lb';
    else rules += ' _La';
    rules += ' da_____z';
    rules += ' dx';
    rules += ' _Nc';
    rules += ' _M-3t1z';
    rules += ' __a-4cfph1';
    rules += ' __b-4cfph1';
    rules += ' __c-4cfph1';
    rules += ' __d-4cfph1';
    if (props.size === "XL") rules += ' qn';
    else if (props.size === "L") rules += ' ql';
    else if (props.size === "S") rules += ' qh';
    else if (props.size === "XS") rules += ' qg';
    else rules += ' qj';
    if (props.isQuiet) rules += ' __ma';
    else rules += ' __m-1s8glxue';
    if (props.size === "XL") rules += ' -usygro_l-A';
    else if (props.size === "L") rules += ' -usygro_l-z';
    else if (props.size === "S") rules += ' -usygro_l-x';
    else rules += ' -usygro_l-y';
    rules += ' m-rwozxi';
    rules += ' _Zd';
    rules += ' _1c';
    rules += ' k-375toq';
    rules += ' __na';
    rules += ' C-375tnm';
    rules += ' D-375tnn';
    rules += ' _c-bc1l9oh';
    rules += ' _c-1uotwbwg';
    rules += ' _c-eo0c6sf';
    rules += ' _c-enzzrge';
    rules += ' _c-enzykdd';
    rules += ' _c-enzwzjc';
    rules += ' _c-enzrfpb';
    rules += ' _ca';
    if (props.size === "XL") {
        rules += ' _dbj';
        rules += ' _di';
    } else if (props.size === "L") {
        rules += ' _dbh';
        rules += ' _dg';
    } else if (props.size === "S") {
        rules += ' _dbd';
        rules += ' _dc';
    } else if (props.size === "XS") {
        rules += ' _dbb';
        rules += ' _da';
    } else {
        rules += ' _dbf';
        rules += ' _de';
    }
    rules += ' _eb';
    rules += ' _f-1x99dlob';
    rules += ' _fa';
    if (props.isDisabled) rules += ' aj';
    else {
        if (props.isPressed) rules += ' ao';
        else if (props.isFocusVisible) rules += ' ao';
        else if (props.isHovered) rules += ' ao';
        else rules += ' an';
    }
    rules += ' _vh';
    rules += ' _wh';
    rules += ' _xh';
    rules += ' _yh';
    rules += ' uc';
    rules += ' vc';
    rules += ' s-375toy';
    rules += ' t-375toz';
    rules += ' wa';
    rules += ' _Oa';
    rules += ' _Q-375x7f';
    rules += ' _Ra';
    if (props.isDisabled) {
        rules += ' ca_____B';
        rules += ' ci';
    } else if (props.isFocusWithin) {
        rules += ' ca_____z';
        if (props.isInvalid) rules += ' cP';
        else rules += ' co';
    } else if (props.isInvalid) {
        if (props.isPressed) rules += ' cQ';
        else if (props.isFocusVisible) rules += ' cP';
        else if (props.isHovered) rules += ' cP';
        else rules += ' cO';
    } else {
        if (props.isPressed) rules += ' cj';
        else if (props.isFocusVisible) rules += ' cj';
        else if (props.isHovered) rules += ' cj';
        else rules += ' ci';
    }
    rules += ' bd';
    if (props.isDisabled) rules += ' __Hb';
    else rules += ' __He';
    rules += ' -_375tnm_C-I';
    rules += ' -_375tnn_D-I';
    rules += ' -_375toy_s-c';
    rules += ' -_375toz_t-c';
    if (props.size === "XL") rules += ' -_375toq_k-n';
    else if (props.size === "L") rules += ' -_375toq_k-l';
    else if (props.size === "S") rules += ' -_375toq_k-h';
    else if (props.size === "XS") rules += ' -_375toq_k-g';
    else rules += ' -_375toq_k-j';
    return rules;
};
function FieldGroup(props, ref) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Group), {
        ref: ref,
        ...props,
        onPointerDown: (e)=>{
            // Forward focus to input element when clicking on a non-interactive child (e.g. icon or padding)
            if (e.pointerType === 'mouse' && !e.target.closest('button,input,textarea')) {
                e.preventDefault();
                e.currentTarget.querySelector('input')?.focus();
            }
        },
        onPointerUp: (e)=>{
            if (e.pointerType !== 'mouse' && !e.target.closest('button,input,textarea')) {
                e.preventDefault();
                e.currentTarget.querySelector('input')?.focus();
            }
        },
        style: props.UNSAFE_style,
        className: (renderProps)=>(props.UNSAFE_className || '') + ' ' + (0, _centerBaseline.centerBaselineBefore) + (0, _runtime.mergeStyles)(fieldGroupStyles({
                ...renderProps,
                size: props.size || 'M'
            }), props.styles)
    });
}
let _FieldGroup = /*#__PURE__*/ (0, _react.forwardRef)(FieldGroup);
function Input(props, ref) {
    let { UNSAFE_className = '', UNSAFE_style, styles, ...otherProps } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Input), {
        ...otherProps,
        ref: ref,
        style: UNSAFE_style,
        className: UNSAFE_className + (0, _runtime.mergeStyles)(" . Ea Fa Ca Da ba a-17zqamw _c-17zqamw _d-17zqamw _e-17zqamw _9-3t1y _8-3t1y qa lG _La wf __vb __wb _ma _pb", styles)
    });
}
let _Input = /*#__PURE__*/ (0, _react.forwardRef)(Input);
const helpTextStyles = function anonymous(props) {
    let rules = " .";
    rules += ' __a-1oa8qr7';
    rules += ' __b-1oa8qr7';
    rules += ' __c-1oa8qr7';
    rules += ' __d-1oa8qr7';
    rules += ' _Zd';
    rules += ' _1d';
    rules += ' ibH';
    rules += ' iG';
    rules += ' jbH';
    rules += ' jG';
    rules += ' _c-bc1l9oh';
    rules += ' _c-1uotwbwg';
    rules += ' _c-eo0c6sf';
    rules += ' _c-enzzrge';
    rules += ' _c-enzykdd';
    rules += ' _c-enzwzjc';
    rules += ' _c-enzrfpb';
    rules += ' _ca';
    if (props.size === "XL") {
        rules += ' _dbj';
        rules += ' _di';
    } else if (props.size === "L") {
        rules += ' _dbh';
        rules += ' _dg';
    } else if (props.size === "S") {
        rules += ' _dbd';
        rules += ' _dc';
    } else if (props.size === "XS") {
        rules += ' _dbb';
        rules += ' _da';
    } else {
        rules += ' _dbf';
        rules += ' _de';
    }
    rules += ' _eb';
    rules += ' _f-1x99dlob';
    rules += ' _fa';
    if (props.isDisabled) rules += ' aj';
    else if (props.isInvalid) {
        if (props.isPressed) rules += ' aP';
        else if (props.isFocusVisible) rules += ' aP';
        else if (props.isHovered) rules += ' aP';
        else rules += ' aO';
    } else {
        if (props.isPressed) rules += ' an';
        else if (props.isFocusVisible) rules += ' an';
        else if (props.isHovered) rules += ' an';
        else rules += ' am';
    }
    rules += ' -rwx0fg_e-b';
    rules += ' __me';
    rules += ' E-1inj1bc';
    if (props.isDisabled) rules += ' __Hb';
    else rules += ' __He';
    return rules;
};
function HelpText(props) {
    let domDescriptionRef = (0, _utils.useDOMRef)(props.descriptionRef || null);
    let domErrorRef = (0, _utils.useDOMRef)(props.errorRef || null);
    if (!props.isInvalid && props.description) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Text), {
        slot: "description",
        ref: domDescriptionRef,
        className: helpTextStyles({
            size: props.size || 'M',
            isDisabled: props.isDisabled
        }),
        children: props.description
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.FieldError), {
        ...props,
        ref: domErrorRef,
        className: (renderProps)=>helpTextStyles({
                ...renderProps,
                size: props.size || 'M',
                isDisabled: props.isDisabled
            }),
        children: (0, _reactAriaComponents.composeRenderProps)(props.children, (children, { validationErrors })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    props.showErrorIcon && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _centerBaseline.CenterBaseline), {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2IconAlertTriangle20NSvgDefault.default), {})
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        children: children || validationErrors.join(' ')
                    })
                ]
            }))
    });
}
function FieldErrorIcon(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Provider), {
        values: [
            [
                (0, _icon.IconContext),
                {
                    render: (0, _centerBaseline.centerBaseline)({
                        slot: 'icon',
                        styles: " . __A-3t1x _8-3t1x -rwx0fg_e-e -rwx0fg_e-a_____V"
                    }),
                    styles: " . l-1sthc3k k-1sthc3k yG ybH z-177861o _8-3t1x"
                }
            ]
        ],
        children: !props.isDisabled && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2IconAlertTriangle20NSvgDefault.default), {})
    });
}
try {
    // @ts-ignore
    HelpText.displayName = "HelpText";
    // @ts-ignore
    HelpText.__docgenInfo = {
        "description": "",
        "displayName": "HelpText",
        "props": {
            "descriptionRef": {
                "defaultValue": null,
                "description": "",
                "name": "descriptionRef",
                "required": false,
                "type": {
                    "name": "DOMRef<HTMLDivElement>"
                }
            },
            "errorRef": {
                "defaultValue": null,
                "description": "",
                "name": "errorRef",
                "required": false,
                "type": {
                    "name": "DOMRef<HTMLDivElement>"
                }
            },
            "children": {
                "defaultValue": null,
                "description": "The children of the component. A function may be provided to alter the children based on component state.",
                "name": "children",
                "required": false,
                "type": {
                    "name": "ReactNode | ((values: FieldErrorRenderProps & { defaultChildren: ReactNode; }) => ReactNode)"
                }
            },
            "className": {
                "defaultValue": null,
                "description": "The CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. A function may be provided to compute the class based on component state.",
                "name": "className",
                "required": false,
                "type": {
                    "name": "string | ((values: FieldErrorRenderProps & { defaultClassName: string; }) => string)"
                }
            },
            "description": {
                "defaultValue": null,
                "description": "",
                "name": "description",
                "required": false,
                "type": {
                    "name": "ReactNode"
                }
            },
            "isDisabled": {
                "defaultValue": null,
                "description": "",
                "name": "isDisabled",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isInvalid": {
                "defaultValue": null,
                "description": "",
                "name": "isInvalid",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "showErrorIcon": {
                "defaultValue": null,
                "description": "",
                "name": "showErrorIcon",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "size": {
                "defaultValue": null,
                "description": "",
                "name": "size",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"S\""
                        },
                        {
                            "value": "\"M\""
                        },
                        {
                            "value": "\"L\""
                        },
                        {
                            "value": "\"XL\""
                        }
                    ]
                }
            },
            "style": {
                "defaultValue": null,
                "description": "The inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. A function may be provided to compute the style based on component state.",
                "name": "style",
                "required": false,
                "type": {
                    "name": "CSSProperties | ((values: FieldErrorRenderProps & { defaultStyle: CSSProperties; }) => CSSProperties)"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/Field.tsx#HelpText"] = {
        docgenInfo: HelpText.__docgenInfo,
        name: "HelpText",
        path: "packages/@react-spectrum/s2/src/Field.tsx#HelpText"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    FieldErrorIcon.displayName = "FieldErrorIcon";
    // @ts-ignore
    FieldErrorIcon.__docgenInfo = {
        "description": "",
        "displayName": "FieldErrorIcon",
        "props": {
            "isDisabled": {
                "defaultValue": null,
                "description": "",
                "name": "isDisabled",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/Field.tsx#FieldErrorIcon"] = {
        docgenInfo: FieldErrorIcon.__docgenInfo,
        name: "FieldErrorIcon",
        path: "packages/@react-spectrum/s2/src/Field.tsx#FieldErrorIcon"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    _FieldLabel.displayName = "_FieldLabel";
    // @ts-ignore
    _FieldLabel.__docgenInfo = {
        "description": "",
        "displayName": "_FieldLabel",
        "props": {
            "contextualHelp": {
                "defaultValue": null,
                "description": "",
                "name": "contextualHelp",
                "required": false,
                "type": {
                    "name": "ReactNode"
                }
            },
            "elementType": {
                "defaultValue": null,
                "description": "",
                "name": "elementType",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "includeNecessityIndicatorInAccessibilityName": {
                "defaultValue": null,
                "description": "",
                "name": "includeNecessityIndicatorInAccessibilityName",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isDisabled": {
                "defaultValue": null,
                "description": "",
                "name": "isDisabled",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isQuiet": {
                "defaultValue": null,
                "description": "",
                "name": "isQuiet",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isRequired": {
                "defaultValue": null,
                "description": "",
                "name": "isRequired",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "labelAlign": {
                "defaultValue": null,
                "description": "",
                "name": "labelAlign",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"start\""
                        },
                        {
                            "value": "\"end\""
                        }
                    ]
                }
            },
            "labelPosition": {
                "defaultValue": null,
                "description": "",
                "name": "labelPosition",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"top\""
                        },
                        {
                            "value": "\"side\""
                        }
                    ]
                }
            },
            "necessityIndicator": {
                "defaultValue": null,
                "description": "",
                "name": "necessityIndicator",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"label\""
                        },
                        {
                            "value": "\"icon\""
                        }
                    ]
                }
            },
            "size": {
                "defaultValue": null,
                "description": "",
                "name": "size",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"S\""
                        },
                        {
                            "value": "\"M\""
                        },
                        {
                            "value": "\"L\""
                        },
                        {
                            "value": "\"XL\""
                        }
                    ]
                }
            },
            "staticColor": {
                "defaultValue": null,
                "description": "",
                "name": "staticColor",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"white\""
                        },
                        {
                            "value": "\"black\""
                        }
                    ]
                }
            },
            "styles": {
                "defaultValue": null,
                "description": "Spectrum-defined styles, returned by the `style()` macro.",
                "name": "styles",
                "required": false,
                "type": {
                    "name": "StylesProp"
                }
            },
            "UNSAFE_className": {
                "defaultValue": null,
                "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_className",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_style": {
                "defaultValue": null,
                "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_style",
                "required": false,
                "type": {
                    "name": "CSSProperties"
                }
            },
            "about": {
                "defaultValue": null,
                "description": "",
                "name": "about",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "accessKey": {
                "defaultValue": null,
                "description": "",
                "name": "accessKey",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "autoCapitalize": {
                "defaultValue": null,
                "description": "",
                "name": "autoCapitalize",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "autoCorrect": {
                "defaultValue": null,
                "description": "",
                "name": "autoCorrect",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "autoFocus": {
                "defaultValue": null,
                "description": "",
                "name": "autoFocus",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "autoSave": {
                "defaultValue": null,
                "description": "",
                "name": "autoSave",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "color": {
                "defaultValue": null,
                "description": "",
                "name": "color",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "content": {
                "defaultValue": null,
                "description": "",
                "name": "content",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "contentEditable": {
                "defaultValue": null,
                "description": "",
                "name": "contentEditable",
                "required": false,
                "type": {
                    "name": "\"inherit\" | Booleanish | \"plaintext-only\""
                }
            },
            "contextMenu": {
                "defaultValue": null,
                "description": "",
                "name": "contextMenu",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "dangerouslySetInnerHTML": {
                "defaultValue": null,
                "description": "",
                "name": "dangerouslySetInnerHTML",
                "required": false,
                "type": {
                    "name": "{ __html: string | TrustedHTML; }"
                }
            },
            "datatype": {
                "defaultValue": null,
                "description": "",
                "name": "datatype",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "defaultChecked": {
                "defaultValue": null,
                "description": "",
                "name": "defaultChecked",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "defaultValue": {
                "defaultValue": null,
                "description": "",
                "name": "defaultValue",
                "required": false,
                "type": {
                    "name": "string | number | readonly string[]"
                }
            },
            "dir": {
                "defaultValue": null,
                "description": "",
                "name": "dir",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "draggable": {
                "defaultValue": null,
                "description": "",
                "name": "draggable",
                "required": false,
                "type": {
                    "name": "Booleanish"
                }
            },
            "form": {
                "defaultValue": null,
                "description": "",
                "name": "form",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "hidden": {
                "defaultValue": null,
                "description": "",
                "name": "hidden",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "htmlFor": {
                "defaultValue": null,
                "description": "",
                "name": "htmlFor",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "inert": {
                "defaultValue": null,
                "description": "@see https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/inert",
                "name": "inert",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "inlist": {
                "defaultValue": null,
                "description": "",
                "name": "inlist",
                "required": false,
                "type": {
                    "name": "any"
                }
            },
            "inputMode": {
                "defaultValue": null,
                "description": "Hints at the type of data that might be entered by the user while editing the element or its contents\n@see {@link https://html.spec.whatwg.org/multipage/interaction.html#input-modalities:-the-inputmode-attribute}",
                "name": "inputMode",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"text\""
                        },
                        {
                            "value": "\"none\""
                        },
                        {
                            "value": "\"search\""
                        },
                        {
                            "value": "\"decimal\""
                        },
                        {
                            "value": "\"url\""
                        },
                        {
                            "value": "\"tel\""
                        },
                        {
                            "value": "\"email\""
                        },
                        {
                            "value": "\"numeric\""
                        }
                    ]
                }
            },
            "is": {
                "defaultValue": null,
                "description": "Specify that a standard HTML element should behave like a defined custom built-in element\n@see {@link https://html.spec.whatwg.org/multipage/custom-elements.html#attr-is}",
                "name": "is",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "itemID": {
                "defaultValue": null,
                "description": "",
                "name": "itemID",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "itemProp": {
                "defaultValue": null,
                "description": "",
                "name": "itemProp",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "itemRef": {
                "defaultValue": null,
                "description": "",
                "name": "itemRef",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "itemScope": {
                "defaultValue": null,
                "description": "",
                "name": "itemScope",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "itemType": {
                "defaultValue": null,
                "description": "",
                "name": "itemType",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "key": {
                "defaultValue": null,
                "description": "",
                "name": "key",
                "required": false,
                "type": {
                    "name": "Key"
                }
            },
            "lang": {
                "defaultValue": null,
                "description": "",
                "name": "lang",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "nonce": {
                "defaultValue": null,
                "description": "",
                "name": "nonce",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "popover": {
                "defaultValue": null,
                "description": "",
                "name": "popover",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"\""
                        },
                        {
                            "value": "\"manual\""
                        },
                        {
                            "value": "\"auto\""
                        }
                    ]
                }
            },
            "popoverTarget": {
                "defaultValue": null,
                "description": "",
                "name": "popoverTarget",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "popoverTargetAction": {
                "defaultValue": null,
                "description": "",
                "name": "popoverTargetAction",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"toggle\""
                        },
                        {
                            "value": "\"show\""
                        },
                        {
                            "value": "\"hide\""
                        }
                    ]
                }
            },
            "prefix": {
                "defaultValue": null,
                "description": "",
                "name": "prefix",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "property": {
                "defaultValue": null,
                "description": "",
                "name": "property",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "radioGroup": {
                "defaultValue": null,
                "description": "",
                "name": "radioGroup",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "ref": {
                "defaultValue": null,
                "description": "Allows getting a ref to the component instance.\nOnce the component unmounts, React will set `ref.current` to `null`\n(or call the ref with `null` if you passed a callback ref).\n@see {@link https://react.dev/learn/referencing-values-with-refs#refs-and-the-dom React Docs}",
                "name": "ref",
                "required": false,
                "type": {
                    "name": "Ref<DOMRefValue<HTMLLabelElement>>"
                }
            },
            "rel": {
                "defaultValue": null,
                "description": "",
                "name": "rel",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "resource": {
                "defaultValue": null,
                "description": "",
                "name": "resource",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "results": {
                "defaultValue": null,
                "description": "",
                "name": "results",
                "required": false,
                "type": {
                    "name": "number"
                }
            },
            "rev": {
                "defaultValue": null,
                "description": "",
                "name": "rev",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "role": {
                "defaultValue": null,
                "description": "",
                "name": "role",
                "required": false,
                "type": {
                    "name": "AriaRole"
                }
            },
            "security": {
                "defaultValue": null,
                "description": "",
                "name": "security",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "spellCheck": {
                "defaultValue": null,
                "description": "",
                "name": "spellCheck",
                "required": false,
                "type": {
                    "name": "Booleanish"
                }
            },
            "suppressContentEditableWarning": {
                "defaultValue": null,
                "description": "",
                "name": "suppressContentEditableWarning",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "suppressHydrationWarning": {
                "defaultValue": null,
                "description": "",
                "name": "suppressHydrationWarning",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "tabIndex": {
                "defaultValue": null,
                "description": "",
                "name": "tabIndex",
                "required": false,
                "type": {
                    "name": "number"
                }
            },
            "title": {
                "defaultValue": null,
                "description": "",
                "name": "title",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "translate": {
                "defaultValue": null,
                "description": "",
                "name": "translate",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"yes\""
                        },
                        {
                            "value": "\"no\""
                        }
                    ]
                }
            },
            "typeof": {
                "defaultValue": null,
                "description": "",
                "name": "typeof",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "unselectable": {
                "defaultValue": null,
                "description": "",
                "name": "unselectable",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"on\""
                        },
                        {
                            "value": "\"off\""
                        }
                    ]
                }
            },
            "vocab": {
                "defaultValue": null,
                "description": "",
                "name": "vocab",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "onAbort": {
                "defaultValue": null,
                "description": "",
                "name": "onAbort",
                "required": false,
                "type": {
                    "name": "ReactEventHandler<HTMLLabelElement>"
                }
            },
            "onAbortCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onAbortCapture",
                "required": false,
                "type": {
                    "name": "ReactEventHandler<HTMLLabelElement>"
                }
            },
            "onAnimationEnd": {
                "defaultValue": null,
                "description": "",
                "name": "onAnimationEnd",
                "required": false,
                "type": {
                    "name": "AnimationEventHandler<HTMLLabelElement>"
                }
            },
            "onAnimationEndCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onAnimationEndCapture",
                "required": false,
                "type": {
                    "name": "AnimationEventHandler<HTMLLabelElement>"
                }
            },
            "onAnimationIteration": {
                "defaultValue": null,
                "description": "",
                "name": "onAnimationIteration",
                "required": false,
                "type": {
                    "name": "AnimationEventHandler<HTMLLabelElement>"
                }
            },
            "onAnimationIterationCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onAnimationIterationCapture",
                "required": false,
                "type": {
                    "name": "AnimationEventHandler<HTMLLabelElement>"
                }
            },
            "onAnimationStart": {
                "defaultValue": null,
                "description": "",
                "name": "onAnimationStart",
                "required": false,
                "type": {
                    "name": "AnimationEventHandler<HTMLLabelElement>"
                }
            },
            "onAnimationStartCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onAnimationStartCapture",
                "required": false,
                "type": {
                    "name": "AnimationEventHandler<HTMLLabelElement>"
                }
            },
            "onAuxClick": {
                "defaultValue": null,
                "description": "",
                "name": "onAuxClick",
                "required": false,
                "type": {
                    "name": "MouseEventHandler<HTMLLabelElement>"
                }
            },
            "onAuxClickCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onAuxClickCapture",
                "required": false,
                "type": {
                    "name": "MouseEventHandler<HTMLLabelElement>"
                }
            },
            "onBeforeInputCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onBeforeInputCapture",
                "required": false,
                "type": {
                    "name": "FormEventHandler<HTMLLabelElement>"
                }
            },
            "onBeforeToggle": {
                "defaultValue": null,
                "description": "",
                "name": "onBeforeToggle",
                "required": false,
                "type": {
                    "name": "ToggleEventHandler<HTMLLabelElement>"
                }
            },
            "onBlurCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onBlurCapture",
                "required": false,
                "type": {
                    "name": "FocusEventHandler<HTMLLabelElement>"
                }
            },
            "onCanPlay": {
                "defaultValue": null,
                "description": "",
                "name": "onCanPlay",
                "required": false,
                "type": {
                    "name": "ReactEventHandler<HTMLLabelElement>"
                }
            },
            "onCanPlayCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onCanPlayCapture",
                "required": false,
                "type": {
                    "name": "ReactEventHandler<HTMLLabelElement>"
                }
            },
            "onCanPlayThrough": {
                "defaultValue": null,
                "description": "",
                "name": "onCanPlayThrough",
                "required": false,
                "type": {
                    "name": "ReactEventHandler<HTMLLabelElement>"
                }
            },
            "onCanPlayThroughCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onCanPlayThroughCapture",
                "required": false,
                "type": {
                    "name": "ReactEventHandler<HTMLLabelElement>"
                }
            },
            "onChange": {
                "defaultValue": null,
                "description": "",
                "name": "onChange",
                "required": false,
                "type": {
                    "name": "FormEventHandler<HTMLLabelElement>"
                }
            },
            "onChangeCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onChangeCapture",
                "required": false,
                "type": {
                    "name": "FormEventHandler<HTMLLabelElement>"
                }
            },
            "onClick": {
                "defaultValue": null,
                "description": "",
                "name": "onClick",
                "required": false,
                "type": {
                    "name": "MouseEventHandler<HTMLLabelElement>"
                }
            },
            "onClickCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onClickCapture",
                "required": false,
                "type": {
                    "name": "MouseEventHandler<HTMLLabelElement>"
                }
            },
            "onCompositionEndCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onCompositionEndCapture",
                "required": false,
                "type": {
                    "name": "CompositionEventHandler<HTMLLabelElement>"
                }
            },
            "onCompositionStartCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onCompositionStartCapture",
                "required": false,
                "type": {
                    "name": "CompositionEventHandler<HTMLLabelElement>"
                }
            },
            "onCompositionUpdateCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onCompositionUpdateCapture",
                "required": false,
                "type": {
                    "name": "CompositionEventHandler<HTMLLabelElement>"
                }
            },
            "onContextMenu": {
                "defaultValue": null,
                "description": "",
                "name": "onContextMenu",
                "required": false,
                "type": {
                    "name": "MouseEventHandler<HTMLLabelElement>"
                }
            },
            "onContextMenuCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onContextMenuCapture",
                "required": false,
                "type": {
                    "name": "MouseEventHandler<HTMLLabelElement>"
                }
            },
            "onCopyCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onCopyCapture",
                "required": false,
                "type": {
                    "name": "ClipboardEventHandler<HTMLLabelElement>"
                }
            },
            "onCutCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onCutCapture",
                "required": false,
                "type": {
                    "name": "ClipboardEventHandler<HTMLLabelElement>"
                }
            },
            "onDoubleClick": {
                "defaultValue": null,
                "description": "",
                "name": "onDoubleClick",
                "required": false,
                "type": {
                    "name": "MouseEventHandler<HTMLLabelElement>"
                }
            },
            "onDoubleClickCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onDoubleClickCapture",
                "required": false,
                "type": {
                    "name": "MouseEventHandler<HTMLLabelElement>"
                }
            },
            "onDrag": {
                "defaultValue": null,
                "description": "",
                "name": "onDrag",
                "required": false,
                "type": {
                    "name": "DragEventHandler<HTMLLabelElement>"
                }
            },
            "onDragCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onDragCapture",
                "required": false,
                "type": {
                    "name": "DragEventHandler<HTMLLabelElement>"
                }
            },
            "onDragEnd": {
                "defaultValue": null,
                "description": "",
                "name": "onDragEnd",
                "required": false,
                "type": {
                    "name": "DragEventHandler<HTMLLabelElement>"
                }
            },
            "onDragEndCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onDragEndCapture",
                "required": false,
                "type": {
                    "name": "DragEventHandler<HTMLLabelElement>"
                }
            },
            "onDragEnter": {
                "defaultValue": null,
                "description": "",
                "name": "onDragEnter",
                "required": false,
                "type": {
                    "name": "DragEventHandler<HTMLLabelElement>"
                }
            },
            "onDragEnterCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onDragEnterCapture",
                "required": false,
                "type": {
                    "name": "DragEventHandler<HTMLLabelElement>"
                }
            },
            "onDragExit": {
                "defaultValue": null,
                "description": "",
                "name": "onDragExit",
                "required": false,
                "type": {
                    "name": "DragEventHandler<HTMLLabelElement>"
                }
            },
            "onDragExitCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onDragExitCapture",
                "required": false,
                "type": {
                    "name": "DragEventHandler<HTMLLabelElement>"
                }
            },
            "onDragLeave": {
                "defaultValue": null,
                "description": "",
                "name": "onDragLeave",
                "required": false,
                "type": {
                    "name": "DragEventHandler<HTMLLabelElement>"
                }
            },
            "onDragLeaveCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onDragLeaveCapture",
                "required": false,
                "type": {
                    "name": "DragEventHandler<HTMLLabelElement>"
                }
            },
            "onDragOver": {
                "defaultValue": null,
                "description": "",
                "name": "onDragOver",
                "required": false,
                "type": {
                    "name": "DragEventHandler<HTMLLabelElement>"
                }
            },
            "onDragOverCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onDragOverCapture",
                "required": false,
                "type": {
                    "name": "DragEventHandler<HTMLLabelElement>"
                }
            },
            "onDragStart": {
                "defaultValue": null,
                "description": "",
                "name": "onDragStart",
                "required": false,
                "type": {
                    "name": "DragEventHandler<HTMLLabelElement>"
                }
            },
            "onDragStartCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onDragStartCapture",
                "required": false,
                "type": {
                    "name": "DragEventHandler<HTMLLabelElement>"
                }
            },
            "onDrop": {
                "defaultValue": null,
                "description": "",
                "name": "onDrop",
                "required": false,
                "type": {
                    "name": "DragEventHandler<HTMLLabelElement>"
                }
            },
            "onDropCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onDropCapture",
                "required": false,
                "type": {
                    "name": "DragEventHandler<HTMLLabelElement>"
                }
            },
            "onDurationChange": {
                "defaultValue": null,
                "description": "",
                "name": "onDurationChange",
                "required": false,
                "type": {
                    "name": "ReactEventHandler<HTMLLabelElement>"
                }
            },
            "onDurationChangeCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onDurationChangeCapture",
                "required": false,
                "type": {
                    "name": "ReactEventHandler<HTMLLabelElement>"
                }
            },
            "onEmptied": {
                "defaultValue": null,
                "description": "",
                "name": "onEmptied",
                "required": false,
                "type": {
                    "name": "ReactEventHandler<HTMLLabelElement>"
                }
            },
            "onEmptiedCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onEmptiedCapture",
                "required": false,
                "type": {
                    "name": "ReactEventHandler<HTMLLabelElement>"
                }
            },
            "onEncrypted": {
                "defaultValue": null,
                "description": "",
                "name": "onEncrypted",
                "required": false,
                "type": {
                    "name": "ReactEventHandler<HTMLLabelElement>"
                }
            },
            "onEncryptedCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onEncryptedCapture",
                "required": false,
                "type": {
                    "name": "ReactEventHandler<HTMLLabelElement>"
                }
            },
            "onEnded": {
                "defaultValue": null,
                "description": "",
                "name": "onEnded",
                "required": false,
                "type": {
                    "name": "ReactEventHandler<HTMLLabelElement>"
                }
            },
            "onEndedCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onEndedCapture",
                "required": false,
                "type": {
                    "name": "ReactEventHandler<HTMLLabelElement>"
                }
            },
            "onError": {
                "defaultValue": null,
                "description": "",
                "name": "onError",
                "required": false,
                "type": {
                    "name": "ReactEventHandler<HTMLLabelElement>"
                }
            },
            "onErrorCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onErrorCapture",
                "required": false,
                "type": {
                    "name": "ReactEventHandler<HTMLLabelElement>"
                }
            },
            "onFocusCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onFocusCapture",
                "required": false,
                "type": {
                    "name": "FocusEventHandler<HTMLLabelElement>"
                }
            },
            "onGotPointerCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onGotPointerCapture",
                "required": false,
                "type": {
                    "name": "PointerEventHandler<HTMLLabelElement>"
                }
            },
            "onGotPointerCaptureCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onGotPointerCaptureCapture",
                "required": false,
                "type": {
                    "name": "PointerEventHandler<HTMLLabelElement>"
                }
            },
            "onInputCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onInputCapture",
                "required": false,
                "type": {
                    "name": "FormEventHandler<HTMLLabelElement>"
                }
            },
            "onInvalid": {
                "defaultValue": null,
                "description": "",
                "name": "onInvalid",
                "required": false,
                "type": {
                    "name": "FormEventHandler<HTMLLabelElement>"
                }
            },
            "onInvalidCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onInvalidCapture",
                "required": false,
                "type": {
                    "name": "FormEventHandler<HTMLLabelElement>"
                }
            },
            "onKeyDownCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onKeyDownCapture",
                "required": false,
                "type": {
                    "name": "KeyboardEventHandler<HTMLLabelElement>"
                }
            },
            "onKeyPress": {
                "defaultValue": null,
                "description": "@deprecated",
                "name": "onKeyPress",
                "required": false,
                "type": {
                    "name": "KeyboardEventHandler<HTMLLabelElement>"
                }
            },
            "onKeyPressCapture": {
                "defaultValue": null,
                "description": "@deprecated",
                "name": "onKeyPressCapture",
                "required": false,
                "type": {
                    "name": "KeyboardEventHandler<HTMLLabelElement>"
                }
            },
            "onKeyUpCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onKeyUpCapture",
                "required": false,
                "type": {
                    "name": "KeyboardEventHandler<HTMLLabelElement>"
                }
            },
            "onLoad": {
                "defaultValue": null,
                "description": "",
                "name": "onLoad",
                "required": false,
                "type": {
                    "name": "ReactEventHandler<HTMLLabelElement>"
                }
            },
            "onLoadCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onLoadCapture",
                "required": false,
                "type": {
                    "name": "ReactEventHandler<HTMLLabelElement>"
                }
            },
            "onLoadedData": {
                "defaultValue": null,
                "description": "",
                "name": "onLoadedData",
                "required": false,
                "type": {
                    "name": "ReactEventHandler<HTMLLabelElement>"
                }
            },
            "onLoadedDataCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onLoadedDataCapture",
                "required": false,
                "type": {
                    "name": "ReactEventHandler<HTMLLabelElement>"
                }
            },
            "onLoadedMetadata": {
                "defaultValue": null,
                "description": "",
                "name": "onLoadedMetadata",
                "required": false,
                "type": {
                    "name": "ReactEventHandler<HTMLLabelElement>"
                }
            },
            "onLoadedMetadataCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onLoadedMetadataCapture",
                "required": false,
                "type": {
                    "name": "ReactEventHandler<HTMLLabelElement>"
                }
            },
            "onLoadStart": {
                "defaultValue": null,
                "description": "",
                "name": "onLoadStart",
                "required": false,
                "type": {
                    "name": "ReactEventHandler<HTMLLabelElement>"
                }
            },
            "onLoadStartCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onLoadStartCapture",
                "required": false,
                "type": {
                    "name": "ReactEventHandler<HTMLLabelElement>"
                }
            },
            "onLostPointerCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onLostPointerCapture",
                "required": false,
                "type": {
                    "name": "PointerEventHandler<HTMLLabelElement>"
                }
            },
            "onLostPointerCaptureCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onLostPointerCaptureCapture",
                "required": false,
                "type": {
                    "name": "PointerEventHandler<HTMLLabelElement>"
                }
            },
            "onMouseDown": {
                "defaultValue": null,
                "description": "",
                "name": "onMouseDown",
                "required": false,
                "type": {
                    "name": "MouseEventHandler<HTMLLabelElement>"
                }
            },
            "onMouseDownCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onMouseDownCapture",
                "required": false,
                "type": {
                    "name": "MouseEventHandler<HTMLLabelElement>"
                }
            },
            "onMouseEnter": {
                "defaultValue": null,
                "description": "",
                "name": "onMouseEnter",
                "required": false,
                "type": {
                    "name": "MouseEventHandler<HTMLLabelElement>"
                }
            },
            "onMouseLeave": {
                "defaultValue": null,
                "description": "",
                "name": "onMouseLeave",
                "required": false,
                "type": {
                    "name": "MouseEventHandler<HTMLLabelElement>"
                }
            },
            "onMouseMove": {
                "defaultValue": null,
                "description": "",
                "name": "onMouseMove",
                "required": false,
                "type": {
                    "name": "MouseEventHandler<HTMLLabelElement>"
                }
            },
            "onMouseMoveCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onMouseMoveCapture",
                "required": false,
                "type": {
                    "name": "MouseEventHandler<HTMLLabelElement>"
                }
            },
            "onMouseOut": {
                "defaultValue": null,
                "description": "",
                "name": "onMouseOut",
                "required": false,
                "type": {
                    "name": "MouseEventHandler<HTMLLabelElement>"
                }
            },
            "onMouseOutCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onMouseOutCapture",
                "required": false,
                "type": {
                    "name": "MouseEventHandler<HTMLLabelElement>"
                }
            },
            "onMouseOver": {
                "defaultValue": null,
                "description": "",
                "name": "onMouseOver",
                "required": false,
                "type": {
                    "name": "MouseEventHandler<HTMLLabelElement>"
                }
            },
            "onMouseOverCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onMouseOverCapture",
                "required": false,
                "type": {
                    "name": "MouseEventHandler<HTMLLabelElement>"
                }
            },
            "onMouseUp": {
                "defaultValue": null,
                "description": "",
                "name": "onMouseUp",
                "required": false,
                "type": {
                    "name": "MouseEventHandler<HTMLLabelElement>"
                }
            },
            "onMouseUpCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onMouseUpCapture",
                "required": false,
                "type": {
                    "name": "MouseEventHandler<HTMLLabelElement>"
                }
            },
            "onPasteCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onPasteCapture",
                "required": false,
                "type": {
                    "name": "ClipboardEventHandler<HTMLLabelElement>"
                }
            },
            "onPause": {
                "defaultValue": null,
                "description": "",
                "name": "onPause",
                "required": false,
                "type": {
                    "name": "ReactEventHandler<HTMLLabelElement>"
                }
            },
            "onPauseCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onPauseCapture",
                "required": false,
                "type": {
                    "name": "ReactEventHandler<HTMLLabelElement>"
                }
            },
            "onPlay": {
                "defaultValue": null,
                "description": "",
                "name": "onPlay",
                "required": false,
                "type": {
                    "name": "ReactEventHandler<HTMLLabelElement>"
                }
            },
            "onPlayCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onPlayCapture",
                "required": false,
                "type": {
                    "name": "ReactEventHandler<HTMLLabelElement>"
                }
            },
            "onPlaying": {
                "defaultValue": null,
                "description": "",
                "name": "onPlaying",
                "required": false,
                "type": {
                    "name": "ReactEventHandler<HTMLLabelElement>"
                }
            },
            "onPlayingCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onPlayingCapture",
                "required": false,
                "type": {
                    "name": "ReactEventHandler<HTMLLabelElement>"
                }
            },
            "onPointerCancel": {
                "defaultValue": null,
                "description": "",
                "name": "onPointerCancel",
                "required": false,
                "type": {
                    "name": "PointerEventHandler<HTMLLabelElement>"
                }
            },
            "onPointerCancelCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onPointerCancelCapture",
                "required": false,
                "type": {
                    "name": "PointerEventHandler<HTMLLabelElement>"
                }
            },
            "onPointerDown": {
                "defaultValue": null,
                "description": "",
                "name": "onPointerDown",
                "required": false,
                "type": {
                    "name": "PointerEventHandler<HTMLLabelElement>"
                }
            },
            "onPointerDownCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onPointerDownCapture",
                "required": false,
                "type": {
                    "name": "PointerEventHandler<HTMLLabelElement>"
                }
            },
            "onPointerEnter": {
                "defaultValue": null,
                "description": "",
                "name": "onPointerEnter",
                "required": false,
                "type": {
                    "name": "PointerEventHandler<HTMLLabelElement>"
                }
            },
            "onPointerLeave": {
                "defaultValue": null,
                "description": "",
                "name": "onPointerLeave",
                "required": false,
                "type": {
                    "name": "PointerEventHandler<HTMLLabelElement>"
                }
            },
            "onPointerMove": {
                "defaultValue": null,
                "description": "",
                "name": "onPointerMove",
                "required": false,
                "type": {
                    "name": "PointerEventHandler<HTMLLabelElement>"
                }
            },
            "onPointerMoveCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onPointerMoveCapture",
                "required": false,
                "type": {
                    "name": "PointerEventHandler<HTMLLabelElement>"
                }
            },
            "onPointerOut": {
                "defaultValue": null,
                "description": "",
                "name": "onPointerOut",
                "required": false,
                "type": {
                    "name": "PointerEventHandler<HTMLLabelElement>"
                }
            },
            "onPointerOutCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onPointerOutCapture",
                "required": false,
                "type": {
                    "name": "PointerEventHandler<HTMLLabelElement>"
                }
            },
            "onPointerOver": {
                "defaultValue": null,
                "description": "",
                "name": "onPointerOver",
                "required": false,
                "type": {
                    "name": "PointerEventHandler<HTMLLabelElement>"
                }
            },
            "onPointerOverCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onPointerOverCapture",
                "required": false,
                "type": {
                    "name": "PointerEventHandler<HTMLLabelElement>"
                }
            },
            "onPointerUp": {
                "defaultValue": null,
                "description": "",
                "name": "onPointerUp",
                "required": false,
                "type": {
                    "name": "PointerEventHandler<HTMLLabelElement>"
                }
            },
            "onPointerUpCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onPointerUpCapture",
                "required": false,
                "type": {
                    "name": "PointerEventHandler<HTMLLabelElement>"
                }
            },
            "onProgress": {
                "defaultValue": null,
                "description": "",
                "name": "onProgress",
                "required": false,
                "type": {
                    "name": "ReactEventHandler<HTMLLabelElement>"
                }
            },
            "onProgressCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onProgressCapture",
                "required": false,
                "type": {
                    "name": "ReactEventHandler<HTMLLabelElement>"
                }
            },
            "onRateChange": {
                "defaultValue": null,
                "description": "",
                "name": "onRateChange",
                "required": false,
                "type": {
                    "name": "ReactEventHandler<HTMLLabelElement>"
                }
            },
            "onRateChangeCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onRateChangeCapture",
                "required": false,
                "type": {
                    "name": "ReactEventHandler<HTMLLabelElement>"
                }
            },
            "onReset": {
                "defaultValue": null,
                "description": "",
                "name": "onReset",
                "required": false,
                "type": {
                    "name": "FormEventHandler<HTMLLabelElement>"
                }
            },
            "onResetCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onResetCapture",
                "required": false,
                "type": {
                    "name": "FormEventHandler<HTMLLabelElement>"
                }
            },
            "onResize": {
                "defaultValue": null,
                "description": "",
                "name": "onResize",
                "required": false,
                "type": {
                    "name": "ReactEventHandler<HTMLLabelElement>"
                }
            },
            "onResizeCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onResizeCapture",
                "required": false,
                "type": {
                    "name": "ReactEventHandler<HTMLLabelElement>"
                }
            },
            "onScrollCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onScrollCapture",
                "required": false,
                "type": {
                    "name": "UIEventHandler<HTMLLabelElement>"
                }
            },
            "onSeeked": {
                "defaultValue": null,
                "description": "",
                "name": "onSeeked",
                "required": false,
                "type": {
                    "name": "ReactEventHandler<HTMLLabelElement>"
                }
            },
            "onSeekedCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onSeekedCapture",
                "required": false,
                "type": {
                    "name": "ReactEventHandler<HTMLLabelElement>"
                }
            },
            "onSeeking": {
                "defaultValue": null,
                "description": "",
                "name": "onSeeking",
                "required": false,
                "type": {
                    "name": "ReactEventHandler<HTMLLabelElement>"
                }
            },
            "onSeekingCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onSeekingCapture",
                "required": false,
                "type": {
                    "name": "ReactEventHandler<HTMLLabelElement>"
                }
            },
            "onSelectCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onSelectCapture",
                "required": false,
                "type": {
                    "name": "ReactEventHandler<HTMLLabelElement>"
                }
            },
            "onStalled": {
                "defaultValue": null,
                "description": "",
                "name": "onStalled",
                "required": false,
                "type": {
                    "name": "ReactEventHandler<HTMLLabelElement>"
                }
            },
            "onStalledCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onStalledCapture",
                "required": false,
                "type": {
                    "name": "ReactEventHandler<HTMLLabelElement>"
                }
            },
            "onSubmit": {
                "defaultValue": null,
                "description": "",
                "name": "onSubmit",
                "required": false,
                "type": {
                    "name": "FormEventHandler<HTMLLabelElement>"
                }
            },
            "onSubmitCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onSubmitCapture",
                "required": false,
                "type": {
                    "name": "FormEventHandler<HTMLLabelElement>"
                }
            },
            "onSuspend": {
                "defaultValue": null,
                "description": "",
                "name": "onSuspend",
                "required": false,
                "type": {
                    "name": "ReactEventHandler<HTMLLabelElement>"
                }
            },
            "onSuspendCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onSuspendCapture",
                "required": false,
                "type": {
                    "name": "ReactEventHandler<HTMLLabelElement>"
                }
            },
            "onTimeUpdate": {
                "defaultValue": null,
                "description": "",
                "name": "onTimeUpdate",
                "required": false,
                "type": {
                    "name": "ReactEventHandler<HTMLLabelElement>"
                }
            },
            "onTimeUpdateCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onTimeUpdateCapture",
                "required": false,
                "type": {
                    "name": "ReactEventHandler<HTMLLabelElement>"
                }
            },
            "onToggle": {
                "defaultValue": null,
                "description": "",
                "name": "onToggle",
                "required": false,
                "type": {
                    "name": "ToggleEventHandler<HTMLLabelElement>"
                }
            },
            "onTouchCancel": {
                "defaultValue": null,
                "description": "",
                "name": "onTouchCancel",
                "required": false,
                "type": {
                    "name": "TouchEventHandler<HTMLLabelElement>"
                }
            },
            "onTouchCancelCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onTouchCancelCapture",
                "required": false,
                "type": {
                    "name": "TouchEventHandler<HTMLLabelElement>"
                }
            },
            "onTouchEnd": {
                "defaultValue": null,
                "description": "",
                "name": "onTouchEnd",
                "required": false,
                "type": {
                    "name": "TouchEventHandler<HTMLLabelElement>"
                }
            },
            "onTouchEndCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onTouchEndCapture",
                "required": false,
                "type": {
                    "name": "TouchEventHandler<HTMLLabelElement>"
                }
            },
            "onTouchMove": {
                "defaultValue": null,
                "description": "",
                "name": "onTouchMove",
                "required": false,
                "type": {
                    "name": "TouchEventHandler<HTMLLabelElement>"
                }
            },
            "onTouchMoveCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onTouchMoveCapture",
                "required": false,
                "type": {
                    "name": "TouchEventHandler<HTMLLabelElement>"
                }
            },
            "onTouchStart": {
                "defaultValue": null,
                "description": "",
                "name": "onTouchStart",
                "required": false,
                "type": {
                    "name": "TouchEventHandler<HTMLLabelElement>"
                }
            },
            "onTouchStartCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onTouchStartCapture",
                "required": false,
                "type": {
                    "name": "TouchEventHandler<HTMLLabelElement>"
                }
            },
            "onTransitionCancel": {
                "defaultValue": null,
                "description": "",
                "name": "onTransitionCancel",
                "required": false,
                "type": {
                    "name": "TransitionEventHandler<HTMLLabelElement>"
                }
            },
            "onTransitionCancelCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onTransitionCancelCapture",
                "required": false,
                "type": {
                    "name": "TransitionEventHandler<HTMLLabelElement>"
                }
            },
            "onTransitionEnd": {
                "defaultValue": null,
                "description": "",
                "name": "onTransitionEnd",
                "required": false,
                "type": {
                    "name": "TransitionEventHandler<HTMLLabelElement>"
                }
            },
            "onTransitionEndCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onTransitionEndCapture",
                "required": false,
                "type": {
                    "name": "TransitionEventHandler<HTMLLabelElement>"
                }
            },
            "onTransitionRun": {
                "defaultValue": null,
                "description": "",
                "name": "onTransitionRun",
                "required": false,
                "type": {
                    "name": "TransitionEventHandler<HTMLLabelElement>"
                }
            },
            "onTransitionRunCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onTransitionRunCapture",
                "required": false,
                "type": {
                    "name": "TransitionEventHandler<HTMLLabelElement>"
                }
            },
            "onTransitionStart": {
                "defaultValue": null,
                "description": "",
                "name": "onTransitionStart",
                "required": false,
                "type": {
                    "name": "TransitionEventHandler<HTMLLabelElement>"
                }
            },
            "onTransitionStartCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onTransitionStartCapture",
                "required": false,
                "type": {
                    "name": "TransitionEventHandler<HTMLLabelElement>"
                }
            },
            "onVolumeChange": {
                "defaultValue": null,
                "description": "",
                "name": "onVolumeChange",
                "required": false,
                "type": {
                    "name": "ReactEventHandler<HTMLLabelElement>"
                }
            },
            "onVolumeChangeCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onVolumeChangeCapture",
                "required": false,
                "type": {
                    "name": "ReactEventHandler<HTMLLabelElement>"
                }
            },
            "onWaiting": {
                "defaultValue": null,
                "description": "",
                "name": "onWaiting",
                "required": false,
                "type": {
                    "name": "ReactEventHandler<HTMLLabelElement>"
                }
            },
            "onWaitingCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onWaitingCapture",
                "required": false,
                "type": {
                    "name": "ReactEventHandler<HTMLLabelElement>"
                }
            },
            "onWheel": {
                "defaultValue": null,
                "description": "",
                "name": "onWheel",
                "required": false,
                "type": {
                    "name": "WheelEventHandler<HTMLLabelElement>"
                }
            },
            "onWheelCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onWheelCapture",
                "required": false,
                "type": {
                    "name": "WheelEventHandler<HTMLLabelElement>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/Field.tsx#_FieldLabel"] = {
        docgenInfo: _FieldLabel.__docgenInfo,
        name: "_FieldLabel",
        path: "packages/@react-spectrum/s2/src/Field.tsx#_FieldLabel"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    _FieldGroup.displayName = "_FieldGroup";
    // @ts-ignore
    _FieldGroup.__docgenInfo = {
        "description": "",
        "displayName": "_FieldGroup",
        "props": {
            "isDisabled": {
                "defaultValue": null,
                "description": "Whether the group is disabled.",
                "name": "isDisabled",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isInvalid": {
                "defaultValue": null,
                "description": "Whether the group is invalid.",
                "name": "isInvalid",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "role": {
                "defaultValue": {
                    value: "'group'"
                },
                "description": "An accessibility role for the group. By default, this is set to `'group'`.\nUse `'region'` when the contents of the group is important enough to be\nincluded in the page table of contents. Use `'presentation'` if the group\nis visual only and does not represent a semantic grouping of controls.",
                "name": "role",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"group\""
                        },
                        {
                            "value": "\"presentation\""
                        },
                        {
                            "value": "\"region\""
                        }
                    ]
                }
            },
            "size": {
                "defaultValue": null,
                "description": "",
                "name": "size",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"S\""
                        },
                        {
                            "value": "\"M\""
                        },
                        {
                            "value": "\"L\""
                        },
                        {
                            "value": "\"XL\""
                        }
                    ]
                }
            },
            "styles": {
                "defaultValue": null,
                "description": "",
                "name": "styles",
                "required": false,
                "type": {
                    "name": "StyleString"
                }
            },
            "UNSAFE_className": {
                "defaultValue": null,
                "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_className",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_style": {
                "defaultValue": null,
                "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_style",
                "required": false,
                "type": {
                    "name": "CSSProperties"
                }
            },
            "about": {
                "defaultValue": null,
                "description": "",
                "name": "about",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "accessKey": {
                "defaultValue": null,
                "description": "",
                "name": "accessKey",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "autoCapitalize": {
                "defaultValue": null,
                "description": "",
                "name": "autoCapitalize",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "autoCorrect": {
                "defaultValue": null,
                "description": "",
                "name": "autoCorrect",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "autoFocus": {
                "defaultValue": null,
                "description": "",
                "name": "autoFocus",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "autoSave": {
                "defaultValue": null,
                "description": "",
                "name": "autoSave",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "color": {
                "defaultValue": null,
                "description": "",
                "name": "color",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "content": {
                "defaultValue": null,
                "description": "",
                "name": "content",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "contentEditable": {
                "defaultValue": null,
                "description": "",
                "name": "contentEditable",
                "required": false,
                "type": {
                    "name": "\"inherit\" | Booleanish | \"plaintext-only\""
                }
            },
            "contextMenu": {
                "defaultValue": null,
                "description": "",
                "name": "contextMenu",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "dangerouslySetInnerHTML": {
                "defaultValue": null,
                "description": "",
                "name": "dangerouslySetInnerHTML",
                "required": false,
                "type": {
                    "name": "{ __html: string | TrustedHTML; }"
                }
            },
            "datatype": {
                "defaultValue": null,
                "description": "",
                "name": "datatype",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "defaultChecked": {
                "defaultValue": null,
                "description": "",
                "name": "defaultChecked",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "defaultValue": {
                "defaultValue": null,
                "description": "",
                "name": "defaultValue",
                "required": false,
                "type": {
                    "name": "string | number | readonly string[]"
                }
            },
            "dir": {
                "defaultValue": null,
                "description": "",
                "name": "dir",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "draggable": {
                "defaultValue": null,
                "description": "",
                "name": "draggable",
                "required": false,
                "type": {
                    "name": "Booleanish"
                }
            },
            "hidden": {
                "defaultValue": null,
                "description": "",
                "name": "hidden",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "inert": {
                "defaultValue": null,
                "description": "@see https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/inert",
                "name": "inert",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "inlist": {
                "defaultValue": null,
                "description": "",
                "name": "inlist",
                "required": false,
                "type": {
                    "name": "any"
                }
            },
            "inputMode": {
                "defaultValue": null,
                "description": "Hints at the type of data that might be entered by the user while editing the element or its contents\n@see {@link https://html.spec.whatwg.org/multipage/interaction.html#input-modalities:-the-inputmode-attribute}",
                "name": "inputMode",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"text\""
                        },
                        {
                            "value": "\"none\""
                        },
                        {
                            "value": "\"search\""
                        },
                        {
                            "value": "\"decimal\""
                        },
                        {
                            "value": "\"url\""
                        },
                        {
                            "value": "\"tel\""
                        },
                        {
                            "value": "\"email\""
                        },
                        {
                            "value": "\"numeric\""
                        }
                    ]
                }
            },
            "is": {
                "defaultValue": null,
                "description": "Specify that a standard HTML element should behave like a defined custom built-in element\n@see {@link https://html.spec.whatwg.org/multipage/custom-elements.html#attr-is}",
                "name": "is",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "itemID": {
                "defaultValue": null,
                "description": "",
                "name": "itemID",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "itemProp": {
                "defaultValue": null,
                "description": "",
                "name": "itemProp",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "itemRef": {
                "defaultValue": null,
                "description": "",
                "name": "itemRef",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "itemScope": {
                "defaultValue": null,
                "description": "",
                "name": "itemScope",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "itemType": {
                "defaultValue": null,
                "description": "",
                "name": "itemType",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "key": {
                "defaultValue": null,
                "description": "",
                "name": "key",
                "required": false,
                "type": {
                    "name": "Key"
                }
            },
            "lang": {
                "defaultValue": null,
                "description": "",
                "name": "lang",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "nonce": {
                "defaultValue": null,
                "description": "",
                "name": "nonce",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "popover": {
                "defaultValue": null,
                "description": "",
                "name": "popover",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"\""
                        },
                        {
                            "value": "\"manual\""
                        },
                        {
                            "value": "\"auto\""
                        }
                    ]
                }
            },
            "popoverTarget": {
                "defaultValue": null,
                "description": "",
                "name": "popoverTarget",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "popoverTargetAction": {
                "defaultValue": null,
                "description": "",
                "name": "popoverTargetAction",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"toggle\""
                        },
                        {
                            "value": "\"show\""
                        },
                        {
                            "value": "\"hide\""
                        }
                    ]
                }
            },
            "prefix": {
                "defaultValue": null,
                "description": "",
                "name": "prefix",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "property": {
                "defaultValue": null,
                "description": "",
                "name": "property",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "radioGroup": {
                "defaultValue": null,
                "description": "",
                "name": "radioGroup",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "ref": {
                "defaultValue": null,
                "description": "Allows getting a ref to the component instance.\nOnce the component unmounts, React will set `ref.current` to `null`\n(or call the ref with `null` if you passed a callback ref).\n@see {@link https://react.dev/learn/referencing-values-with-refs#refs-and-the-dom React Docs}",
                "name": "ref",
                "required": false,
                "type": {
                    "name": "Ref<HTMLDivElement>"
                }
            },
            "rel": {
                "defaultValue": null,
                "description": "",
                "name": "rel",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "resource": {
                "defaultValue": null,
                "description": "",
                "name": "resource",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "results": {
                "defaultValue": null,
                "description": "",
                "name": "results",
                "required": false,
                "type": {
                    "name": "number"
                }
            },
            "rev": {
                "defaultValue": null,
                "description": "",
                "name": "rev",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "security": {
                "defaultValue": null,
                "description": "",
                "name": "security",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "spellCheck": {
                "defaultValue": null,
                "description": "",
                "name": "spellCheck",
                "required": false,
                "type": {
                    "name": "Booleanish"
                }
            },
            "suppressContentEditableWarning": {
                "defaultValue": null,
                "description": "",
                "name": "suppressContentEditableWarning",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "suppressHydrationWarning": {
                "defaultValue": null,
                "description": "",
                "name": "suppressHydrationWarning",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "tabIndex": {
                "defaultValue": null,
                "description": "",
                "name": "tabIndex",
                "required": false,
                "type": {
                    "name": "number"
                }
            },
            "title": {
                "defaultValue": null,
                "description": "",
                "name": "title",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "translate": {
                "defaultValue": null,
                "description": "",
                "name": "translate",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"yes\""
                        },
                        {
                            "value": "\"no\""
                        }
                    ]
                }
            },
            "typeof": {
                "defaultValue": null,
                "description": "",
                "name": "typeof",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "unselectable": {
                "defaultValue": null,
                "description": "",
                "name": "unselectable",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"on\""
                        },
                        {
                            "value": "\"off\""
                        }
                    ]
                }
            },
            "vocab": {
                "defaultValue": null,
                "description": "",
                "name": "vocab",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "onAbort": {
                "defaultValue": null,
                "description": "",
                "name": "onAbort",
                "required": false,
                "type": {
                    "name": "ReactEventHandler<HTMLElement>"
                }
            },
            "onAbortCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onAbortCapture",
                "required": false,
                "type": {
                    "name": "ReactEventHandler<HTMLElement>"
                }
            },
            "onAnimationEnd": {
                "defaultValue": null,
                "description": "",
                "name": "onAnimationEnd",
                "required": false,
                "type": {
                    "name": "AnimationEventHandler<HTMLElement>"
                }
            },
            "onAnimationEndCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onAnimationEndCapture",
                "required": false,
                "type": {
                    "name": "AnimationEventHandler<HTMLElement>"
                }
            },
            "onAnimationIteration": {
                "defaultValue": null,
                "description": "",
                "name": "onAnimationIteration",
                "required": false,
                "type": {
                    "name": "AnimationEventHandler<HTMLElement>"
                }
            },
            "onAnimationIterationCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onAnimationIterationCapture",
                "required": false,
                "type": {
                    "name": "AnimationEventHandler<HTMLElement>"
                }
            },
            "onAnimationStart": {
                "defaultValue": null,
                "description": "",
                "name": "onAnimationStart",
                "required": false,
                "type": {
                    "name": "AnimationEventHandler<HTMLElement>"
                }
            },
            "onAnimationStartCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onAnimationStartCapture",
                "required": false,
                "type": {
                    "name": "AnimationEventHandler<HTMLElement>"
                }
            },
            "onAuxClick": {
                "defaultValue": null,
                "description": "",
                "name": "onAuxClick",
                "required": false,
                "type": {
                    "name": "MouseEventHandler<HTMLElement>"
                }
            },
            "onAuxClickCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onAuxClickCapture",
                "required": false,
                "type": {
                    "name": "MouseEventHandler<HTMLElement>"
                }
            },
            "onBeforeInputCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onBeforeInputCapture",
                "required": false,
                "type": {
                    "name": "FormEventHandler<HTMLElement>"
                }
            },
            "onBeforeToggle": {
                "defaultValue": null,
                "description": "",
                "name": "onBeforeToggle",
                "required": false,
                "type": {
                    "name": "ToggleEventHandler<HTMLElement>"
                }
            },
            "onBlurCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onBlurCapture",
                "required": false,
                "type": {
                    "name": "FocusEventHandler<HTMLElement>"
                }
            },
            "onCanPlay": {
                "defaultValue": null,
                "description": "",
                "name": "onCanPlay",
                "required": false,
                "type": {
                    "name": "ReactEventHandler<HTMLElement>"
                }
            },
            "onCanPlayCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onCanPlayCapture",
                "required": false,
                "type": {
                    "name": "ReactEventHandler<HTMLElement>"
                }
            },
            "onCanPlayThrough": {
                "defaultValue": null,
                "description": "",
                "name": "onCanPlayThrough",
                "required": false,
                "type": {
                    "name": "ReactEventHandler<HTMLElement>"
                }
            },
            "onCanPlayThroughCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onCanPlayThroughCapture",
                "required": false,
                "type": {
                    "name": "ReactEventHandler<HTMLElement>"
                }
            },
            "onChange": {
                "defaultValue": null,
                "description": "",
                "name": "onChange",
                "required": false,
                "type": {
                    "name": "FormEventHandler<HTMLElement>"
                }
            },
            "onChangeCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onChangeCapture",
                "required": false,
                "type": {
                    "name": "FormEventHandler<HTMLElement>"
                }
            },
            "onClick": {
                "defaultValue": null,
                "description": "",
                "name": "onClick",
                "required": false,
                "type": {
                    "name": "MouseEventHandler<HTMLElement>"
                }
            },
            "onClickCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onClickCapture",
                "required": false,
                "type": {
                    "name": "MouseEventHandler<HTMLElement>"
                }
            },
            "onCompositionEndCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onCompositionEndCapture",
                "required": false,
                "type": {
                    "name": "CompositionEventHandler<HTMLElement>"
                }
            },
            "onCompositionStartCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onCompositionStartCapture",
                "required": false,
                "type": {
                    "name": "CompositionEventHandler<HTMLElement>"
                }
            },
            "onCompositionUpdateCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onCompositionUpdateCapture",
                "required": false,
                "type": {
                    "name": "CompositionEventHandler<HTMLElement>"
                }
            },
            "onContextMenu": {
                "defaultValue": null,
                "description": "",
                "name": "onContextMenu",
                "required": false,
                "type": {
                    "name": "MouseEventHandler<HTMLElement>"
                }
            },
            "onContextMenuCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onContextMenuCapture",
                "required": false,
                "type": {
                    "name": "MouseEventHandler<HTMLElement>"
                }
            },
            "onCopyCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onCopyCapture",
                "required": false,
                "type": {
                    "name": "ClipboardEventHandler<HTMLElement>"
                }
            },
            "onCutCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onCutCapture",
                "required": false,
                "type": {
                    "name": "ClipboardEventHandler<HTMLElement>"
                }
            },
            "onDoubleClick": {
                "defaultValue": null,
                "description": "",
                "name": "onDoubleClick",
                "required": false,
                "type": {
                    "name": "MouseEventHandler<HTMLElement>"
                }
            },
            "onDoubleClickCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onDoubleClickCapture",
                "required": false,
                "type": {
                    "name": "MouseEventHandler<HTMLElement>"
                }
            },
            "onDrag": {
                "defaultValue": null,
                "description": "",
                "name": "onDrag",
                "required": false,
                "type": {
                    "name": "DragEventHandler<HTMLElement>"
                }
            },
            "onDragCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onDragCapture",
                "required": false,
                "type": {
                    "name": "DragEventHandler<HTMLElement>"
                }
            },
            "onDragEnd": {
                "defaultValue": null,
                "description": "",
                "name": "onDragEnd",
                "required": false,
                "type": {
                    "name": "DragEventHandler<HTMLElement>"
                }
            },
            "onDragEndCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onDragEndCapture",
                "required": false,
                "type": {
                    "name": "DragEventHandler<HTMLElement>"
                }
            },
            "onDragEnter": {
                "defaultValue": null,
                "description": "",
                "name": "onDragEnter",
                "required": false,
                "type": {
                    "name": "DragEventHandler<HTMLElement>"
                }
            },
            "onDragEnterCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onDragEnterCapture",
                "required": false,
                "type": {
                    "name": "DragEventHandler<HTMLElement>"
                }
            },
            "onDragExit": {
                "defaultValue": null,
                "description": "",
                "name": "onDragExit",
                "required": false,
                "type": {
                    "name": "DragEventHandler<HTMLElement>"
                }
            },
            "onDragExitCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onDragExitCapture",
                "required": false,
                "type": {
                    "name": "DragEventHandler<HTMLElement>"
                }
            },
            "onDragLeave": {
                "defaultValue": null,
                "description": "",
                "name": "onDragLeave",
                "required": false,
                "type": {
                    "name": "DragEventHandler<HTMLElement>"
                }
            },
            "onDragLeaveCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onDragLeaveCapture",
                "required": false,
                "type": {
                    "name": "DragEventHandler<HTMLElement>"
                }
            },
            "onDragOver": {
                "defaultValue": null,
                "description": "",
                "name": "onDragOver",
                "required": false,
                "type": {
                    "name": "DragEventHandler<HTMLElement>"
                }
            },
            "onDragOverCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onDragOverCapture",
                "required": false,
                "type": {
                    "name": "DragEventHandler<HTMLElement>"
                }
            },
            "onDragStart": {
                "defaultValue": null,
                "description": "",
                "name": "onDragStart",
                "required": false,
                "type": {
                    "name": "DragEventHandler<HTMLElement>"
                }
            },
            "onDragStartCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onDragStartCapture",
                "required": false,
                "type": {
                    "name": "DragEventHandler<HTMLElement>"
                }
            },
            "onDrop": {
                "defaultValue": null,
                "description": "",
                "name": "onDrop",
                "required": false,
                "type": {
                    "name": "DragEventHandler<HTMLElement>"
                }
            },
            "onDropCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onDropCapture",
                "required": false,
                "type": {
                    "name": "DragEventHandler<HTMLElement>"
                }
            },
            "onDurationChange": {
                "defaultValue": null,
                "description": "",
                "name": "onDurationChange",
                "required": false,
                "type": {
                    "name": "ReactEventHandler<HTMLElement>"
                }
            },
            "onDurationChangeCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onDurationChangeCapture",
                "required": false,
                "type": {
                    "name": "ReactEventHandler<HTMLElement>"
                }
            },
            "onEmptied": {
                "defaultValue": null,
                "description": "",
                "name": "onEmptied",
                "required": false,
                "type": {
                    "name": "ReactEventHandler<HTMLElement>"
                }
            },
            "onEmptiedCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onEmptiedCapture",
                "required": false,
                "type": {
                    "name": "ReactEventHandler<HTMLElement>"
                }
            },
            "onEncrypted": {
                "defaultValue": null,
                "description": "",
                "name": "onEncrypted",
                "required": false,
                "type": {
                    "name": "ReactEventHandler<HTMLElement>"
                }
            },
            "onEncryptedCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onEncryptedCapture",
                "required": false,
                "type": {
                    "name": "ReactEventHandler<HTMLElement>"
                }
            },
            "onEnded": {
                "defaultValue": null,
                "description": "",
                "name": "onEnded",
                "required": false,
                "type": {
                    "name": "ReactEventHandler<HTMLElement>"
                }
            },
            "onEndedCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onEndedCapture",
                "required": false,
                "type": {
                    "name": "ReactEventHandler<HTMLElement>"
                }
            },
            "onError": {
                "defaultValue": null,
                "description": "",
                "name": "onError",
                "required": false,
                "type": {
                    "name": "ReactEventHandler<HTMLElement>"
                }
            },
            "onErrorCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onErrorCapture",
                "required": false,
                "type": {
                    "name": "ReactEventHandler<HTMLElement>"
                }
            },
            "onFocusCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onFocusCapture",
                "required": false,
                "type": {
                    "name": "FocusEventHandler<HTMLElement>"
                }
            },
            "onGotPointerCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onGotPointerCapture",
                "required": false,
                "type": {
                    "name": "PointerEventHandler<HTMLElement>"
                }
            },
            "onGotPointerCaptureCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onGotPointerCaptureCapture",
                "required": false,
                "type": {
                    "name": "PointerEventHandler<HTMLElement>"
                }
            },
            "onInputCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onInputCapture",
                "required": false,
                "type": {
                    "name": "FormEventHandler<HTMLElement>"
                }
            },
            "onInvalid": {
                "defaultValue": null,
                "description": "",
                "name": "onInvalid",
                "required": false,
                "type": {
                    "name": "FormEventHandler<HTMLElement>"
                }
            },
            "onInvalidCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onInvalidCapture",
                "required": false,
                "type": {
                    "name": "FormEventHandler<HTMLElement>"
                }
            },
            "onKeyDownCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onKeyDownCapture",
                "required": false,
                "type": {
                    "name": "KeyboardEventHandler<HTMLElement>"
                }
            },
            "onKeyPress": {
                "defaultValue": null,
                "description": "@deprecated",
                "name": "onKeyPress",
                "required": false,
                "type": {
                    "name": "KeyboardEventHandler<HTMLElement>"
                }
            },
            "onKeyPressCapture": {
                "defaultValue": null,
                "description": "@deprecated",
                "name": "onKeyPressCapture",
                "required": false,
                "type": {
                    "name": "KeyboardEventHandler<HTMLElement>"
                }
            },
            "onKeyUpCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onKeyUpCapture",
                "required": false,
                "type": {
                    "name": "KeyboardEventHandler<HTMLElement>"
                }
            },
            "onLoad": {
                "defaultValue": null,
                "description": "",
                "name": "onLoad",
                "required": false,
                "type": {
                    "name": "ReactEventHandler<HTMLElement>"
                }
            },
            "onLoadCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onLoadCapture",
                "required": false,
                "type": {
                    "name": "ReactEventHandler<HTMLElement>"
                }
            },
            "onLoadedData": {
                "defaultValue": null,
                "description": "",
                "name": "onLoadedData",
                "required": false,
                "type": {
                    "name": "ReactEventHandler<HTMLElement>"
                }
            },
            "onLoadedDataCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onLoadedDataCapture",
                "required": false,
                "type": {
                    "name": "ReactEventHandler<HTMLElement>"
                }
            },
            "onLoadedMetadata": {
                "defaultValue": null,
                "description": "",
                "name": "onLoadedMetadata",
                "required": false,
                "type": {
                    "name": "ReactEventHandler<HTMLElement>"
                }
            },
            "onLoadedMetadataCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onLoadedMetadataCapture",
                "required": false,
                "type": {
                    "name": "ReactEventHandler<HTMLElement>"
                }
            },
            "onLoadStart": {
                "defaultValue": null,
                "description": "",
                "name": "onLoadStart",
                "required": false,
                "type": {
                    "name": "ReactEventHandler<HTMLElement>"
                }
            },
            "onLoadStartCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onLoadStartCapture",
                "required": false,
                "type": {
                    "name": "ReactEventHandler<HTMLElement>"
                }
            },
            "onLostPointerCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onLostPointerCapture",
                "required": false,
                "type": {
                    "name": "PointerEventHandler<HTMLElement>"
                }
            },
            "onLostPointerCaptureCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onLostPointerCaptureCapture",
                "required": false,
                "type": {
                    "name": "PointerEventHandler<HTMLElement>"
                }
            },
            "onMouseDown": {
                "defaultValue": null,
                "description": "",
                "name": "onMouseDown",
                "required": false,
                "type": {
                    "name": "MouseEventHandler<HTMLElement>"
                }
            },
            "onMouseDownCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onMouseDownCapture",
                "required": false,
                "type": {
                    "name": "MouseEventHandler<HTMLElement>"
                }
            },
            "onMouseEnter": {
                "defaultValue": null,
                "description": "",
                "name": "onMouseEnter",
                "required": false,
                "type": {
                    "name": "MouseEventHandler<HTMLElement>"
                }
            },
            "onMouseLeave": {
                "defaultValue": null,
                "description": "",
                "name": "onMouseLeave",
                "required": false,
                "type": {
                    "name": "MouseEventHandler<HTMLElement>"
                }
            },
            "onMouseMove": {
                "defaultValue": null,
                "description": "",
                "name": "onMouseMove",
                "required": false,
                "type": {
                    "name": "MouseEventHandler<HTMLElement>"
                }
            },
            "onMouseMoveCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onMouseMoveCapture",
                "required": false,
                "type": {
                    "name": "MouseEventHandler<HTMLElement>"
                }
            },
            "onMouseOut": {
                "defaultValue": null,
                "description": "",
                "name": "onMouseOut",
                "required": false,
                "type": {
                    "name": "MouseEventHandler<HTMLElement>"
                }
            },
            "onMouseOutCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onMouseOutCapture",
                "required": false,
                "type": {
                    "name": "MouseEventHandler<HTMLElement>"
                }
            },
            "onMouseOver": {
                "defaultValue": null,
                "description": "",
                "name": "onMouseOver",
                "required": false,
                "type": {
                    "name": "MouseEventHandler<HTMLElement>"
                }
            },
            "onMouseOverCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onMouseOverCapture",
                "required": false,
                "type": {
                    "name": "MouseEventHandler<HTMLElement>"
                }
            },
            "onMouseUp": {
                "defaultValue": null,
                "description": "",
                "name": "onMouseUp",
                "required": false,
                "type": {
                    "name": "MouseEventHandler<HTMLElement>"
                }
            },
            "onMouseUpCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onMouseUpCapture",
                "required": false,
                "type": {
                    "name": "MouseEventHandler<HTMLElement>"
                }
            },
            "onPasteCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onPasteCapture",
                "required": false,
                "type": {
                    "name": "ClipboardEventHandler<HTMLElement>"
                }
            },
            "onPause": {
                "defaultValue": null,
                "description": "",
                "name": "onPause",
                "required": false,
                "type": {
                    "name": "ReactEventHandler<HTMLElement>"
                }
            },
            "onPauseCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onPauseCapture",
                "required": false,
                "type": {
                    "name": "ReactEventHandler<HTMLElement>"
                }
            },
            "onPlay": {
                "defaultValue": null,
                "description": "",
                "name": "onPlay",
                "required": false,
                "type": {
                    "name": "ReactEventHandler<HTMLElement>"
                }
            },
            "onPlayCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onPlayCapture",
                "required": false,
                "type": {
                    "name": "ReactEventHandler<HTMLElement>"
                }
            },
            "onPlaying": {
                "defaultValue": null,
                "description": "",
                "name": "onPlaying",
                "required": false,
                "type": {
                    "name": "ReactEventHandler<HTMLElement>"
                }
            },
            "onPlayingCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onPlayingCapture",
                "required": false,
                "type": {
                    "name": "ReactEventHandler<HTMLElement>"
                }
            },
            "onPointerCancel": {
                "defaultValue": null,
                "description": "",
                "name": "onPointerCancel",
                "required": false,
                "type": {
                    "name": "PointerEventHandler<HTMLElement>"
                }
            },
            "onPointerCancelCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onPointerCancelCapture",
                "required": false,
                "type": {
                    "name": "PointerEventHandler<HTMLElement>"
                }
            },
            "onPointerDown": {
                "defaultValue": null,
                "description": "",
                "name": "onPointerDown",
                "required": false,
                "type": {
                    "name": "PointerEventHandler<HTMLElement>"
                }
            },
            "onPointerDownCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onPointerDownCapture",
                "required": false,
                "type": {
                    "name": "PointerEventHandler<HTMLElement>"
                }
            },
            "onPointerEnter": {
                "defaultValue": null,
                "description": "",
                "name": "onPointerEnter",
                "required": false,
                "type": {
                    "name": "PointerEventHandler<HTMLElement>"
                }
            },
            "onPointerLeave": {
                "defaultValue": null,
                "description": "",
                "name": "onPointerLeave",
                "required": false,
                "type": {
                    "name": "PointerEventHandler<HTMLElement>"
                }
            },
            "onPointerMove": {
                "defaultValue": null,
                "description": "",
                "name": "onPointerMove",
                "required": false,
                "type": {
                    "name": "PointerEventHandler<HTMLElement>"
                }
            },
            "onPointerMoveCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onPointerMoveCapture",
                "required": false,
                "type": {
                    "name": "PointerEventHandler<HTMLElement>"
                }
            },
            "onPointerOut": {
                "defaultValue": null,
                "description": "",
                "name": "onPointerOut",
                "required": false,
                "type": {
                    "name": "PointerEventHandler<HTMLElement>"
                }
            },
            "onPointerOutCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onPointerOutCapture",
                "required": false,
                "type": {
                    "name": "PointerEventHandler<HTMLElement>"
                }
            },
            "onPointerOver": {
                "defaultValue": null,
                "description": "",
                "name": "onPointerOver",
                "required": false,
                "type": {
                    "name": "PointerEventHandler<HTMLElement>"
                }
            },
            "onPointerOverCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onPointerOverCapture",
                "required": false,
                "type": {
                    "name": "PointerEventHandler<HTMLElement>"
                }
            },
            "onPointerUp": {
                "defaultValue": null,
                "description": "",
                "name": "onPointerUp",
                "required": false,
                "type": {
                    "name": "PointerEventHandler<HTMLElement>"
                }
            },
            "onPointerUpCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onPointerUpCapture",
                "required": false,
                "type": {
                    "name": "PointerEventHandler<HTMLElement>"
                }
            },
            "onProgress": {
                "defaultValue": null,
                "description": "",
                "name": "onProgress",
                "required": false,
                "type": {
                    "name": "ReactEventHandler<HTMLElement>"
                }
            },
            "onProgressCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onProgressCapture",
                "required": false,
                "type": {
                    "name": "ReactEventHandler<HTMLElement>"
                }
            },
            "onRateChange": {
                "defaultValue": null,
                "description": "",
                "name": "onRateChange",
                "required": false,
                "type": {
                    "name": "ReactEventHandler<HTMLElement>"
                }
            },
            "onRateChangeCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onRateChangeCapture",
                "required": false,
                "type": {
                    "name": "ReactEventHandler<HTMLElement>"
                }
            },
            "onReset": {
                "defaultValue": null,
                "description": "",
                "name": "onReset",
                "required": false,
                "type": {
                    "name": "FormEventHandler<HTMLElement>"
                }
            },
            "onResetCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onResetCapture",
                "required": false,
                "type": {
                    "name": "FormEventHandler<HTMLElement>"
                }
            },
            "onResize": {
                "defaultValue": null,
                "description": "",
                "name": "onResize",
                "required": false,
                "type": {
                    "name": "ReactEventHandler<HTMLElement>"
                }
            },
            "onResizeCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onResizeCapture",
                "required": false,
                "type": {
                    "name": "ReactEventHandler<HTMLElement>"
                }
            },
            "onScrollCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onScrollCapture",
                "required": false,
                "type": {
                    "name": "UIEventHandler<HTMLElement>"
                }
            },
            "onSeeked": {
                "defaultValue": null,
                "description": "",
                "name": "onSeeked",
                "required": false,
                "type": {
                    "name": "ReactEventHandler<HTMLElement>"
                }
            },
            "onSeekedCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onSeekedCapture",
                "required": false,
                "type": {
                    "name": "ReactEventHandler<HTMLElement>"
                }
            },
            "onSeeking": {
                "defaultValue": null,
                "description": "",
                "name": "onSeeking",
                "required": false,
                "type": {
                    "name": "ReactEventHandler<HTMLElement>"
                }
            },
            "onSeekingCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onSeekingCapture",
                "required": false,
                "type": {
                    "name": "ReactEventHandler<HTMLElement>"
                }
            },
            "onSelectCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onSelectCapture",
                "required": false,
                "type": {
                    "name": "ReactEventHandler<HTMLElement>"
                }
            },
            "onStalled": {
                "defaultValue": null,
                "description": "",
                "name": "onStalled",
                "required": false,
                "type": {
                    "name": "ReactEventHandler<HTMLElement>"
                }
            },
            "onStalledCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onStalledCapture",
                "required": false,
                "type": {
                    "name": "ReactEventHandler<HTMLElement>"
                }
            },
            "onSubmit": {
                "defaultValue": null,
                "description": "",
                "name": "onSubmit",
                "required": false,
                "type": {
                    "name": "FormEventHandler<HTMLElement>"
                }
            },
            "onSubmitCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onSubmitCapture",
                "required": false,
                "type": {
                    "name": "FormEventHandler<HTMLElement>"
                }
            },
            "onSuspend": {
                "defaultValue": null,
                "description": "",
                "name": "onSuspend",
                "required": false,
                "type": {
                    "name": "ReactEventHandler<HTMLElement>"
                }
            },
            "onSuspendCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onSuspendCapture",
                "required": false,
                "type": {
                    "name": "ReactEventHandler<HTMLElement>"
                }
            },
            "onTimeUpdate": {
                "defaultValue": null,
                "description": "",
                "name": "onTimeUpdate",
                "required": false,
                "type": {
                    "name": "ReactEventHandler<HTMLElement>"
                }
            },
            "onTimeUpdateCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onTimeUpdateCapture",
                "required": false,
                "type": {
                    "name": "ReactEventHandler<HTMLElement>"
                }
            },
            "onToggle": {
                "defaultValue": null,
                "description": "",
                "name": "onToggle",
                "required": false,
                "type": {
                    "name": "ToggleEventHandler<HTMLElement>"
                }
            },
            "onTouchCancel": {
                "defaultValue": null,
                "description": "",
                "name": "onTouchCancel",
                "required": false,
                "type": {
                    "name": "TouchEventHandler<HTMLElement>"
                }
            },
            "onTouchCancelCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onTouchCancelCapture",
                "required": false,
                "type": {
                    "name": "TouchEventHandler<HTMLElement>"
                }
            },
            "onTouchEnd": {
                "defaultValue": null,
                "description": "",
                "name": "onTouchEnd",
                "required": false,
                "type": {
                    "name": "TouchEventHandler<HTMLElement>"
                }
            },
            "onTouchEndCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onTouchEndCapture",
                "required": false,
                "type": {
                    "name": "TouchEventHandler<HTMLElement>"
                }
            },
            "onTouchMove": {
                "defaultValue": null,
                "description": "",
                "name": "onTouchMove",
                "required": false,
                "type": {
                    "name": "TouchEventHandler<HTMLElement>"
                }
            },
            "onTouchMoveCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onTouchMoveCapture",
                "required": false,
                "type": {
                    "name": "TouchEventHandler<HTMLElement>"
                }
            },
            "onTouchStart": {
                "defaultValue": null,
                "description": "",
                "name": "onTouchStart",
                "required": false,
                "type": {
                    "name": "TouchEventHandler<HTMLElement>"
                }
            },
            "onTouchStartCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onTouchStartCapture",
                "required": false,
                "type": {
                    "name": "TouchEventHandler<HTMLElement>"
                }
            },
            "onTransitionCancel": {
                "defaultValue": null,
                "description": "",
                "name": "onTransitionCancel",
                "required": false,
                "type": {
                    "name": "TransitionEventHandler<HTMLElement>"
                }
            },
            "onTransitionCancelCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onTransitionCancelCapture",
                "required": false,
                "type": {
                    "name": "TransitionEventHandler<HTMLElement>"
                }
            },
            "onTransitionEnd": {
                "defaultValue": null,
                "description": "",
                "name": "onTransitionEnd",
                "required": false,
                "type": {
                    "name": "TransitionEventHandler<HTMLElement>"
                }
            },
            "onTransitionEndCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onTransitionEndCapture",
                "required": false,
                "type": {
                    "name": "TransitionEventHandler<HTMLElement>"
                }
            },
            "onTransitionRun": {
                "defaultValue": null,
                "description": "",
                "name": "onTransitionRun",
                "required": false,
                "type": {
                    "name": "TransitionEventHandler<HTMLElement>"
                }
            },
            "onTransitionRunCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onTransitionRunCapture",
                "required": false,
                "type": {
                    "name": "TransitionEventHandler<HTMLElement>"
                }
            },
            "onTransitionStart": {
                "defaultValue": null,
                "description": "",
                "name": "onTransitionStart",
                "required": false,
                "type": {
                    "name": "TransitionEventHandler<HTMLElement>"
                }
            },
            "onTransitionStartCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onTransitionStartCapture",
                "required": false,
                "type": {
                    "name": "TransitionEventHandler<HTMLElement>"
                }
            },
            "onVolumeChange": {
                "defaultValue": null,
                "description": "",
                "name": "onVolumeChange",
                "required": false,
                "type": {
                    "name": "ReactEventHandler<HTMLElement>"
                }
            },
            "onVolumeChangeCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onVolumeChangeCapture",
                "required": false,
                "type": {
                    "name": "ReactEventHandler<HTMLElement>"
                }
            },
            "onWaiting": {
                "defaultValue": null,
                "description": "",
                "name": "onWaiting",
                "required": false,
                "type": {
                    "name": "ReactEventHandler<HTMLElement>"
                }
            },
            "onWaitingCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onWaitingCapture",
                "required": false,
                "type": {
                    "name": "ReactEventHandler<HTMLElement>"
                }
            },
            "onWheel": {
                "defaultValue": null,
                "description": "",
                "name": "onWheel",
                "required": false,
                "type": {
                    "name": "WheelEventHandler<HTMLElement>"
                }
            },
            "onWheelCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onWheelCapture",
                "required": false,
                "type": {
                    "name": "WheelEventHandler<HTMLElement>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/Field.tsx#_FieldGroup"] = {
        docgenInfo: _FieldGroup.__docgenInfo,
        name: "_FieldGroup",
        path: "packages/@react-spectrum/s2/src/Field.tsx#_FieldGroup"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    _Input.displayName = "_Input";
    // @ts-ignore
    _Input.__docgenInfo = {
        "description": "",
        "displayName": "_Input",
        "props": {
            "styles": {
                "defaultValue": null,
                "description": "Spectrum-defined styles, returned by the `style()` macro.",
                "name": "styles",
                "required": false,
                "type": {
                    "name": "StylesProp"
                }
            },
            "UNSAFE_className": {
                "defaultValue": null,
                "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_className",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_style": {
                "defaultValue": null,
                "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_style",
                "required": false,
                "type": {
                    "name": "CSSProperties"
                }
            },
            "about": {
                "defaultValue": null,
                "description": "",
                "name": "about",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "accept": {
                "defaultValue": null,
                "description": "",
                "name": "accept",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "accessKey": {
                "defaultValue": null,
                "description": "",
                "name": "accessKey",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "alt": {
                "defaultValue": null,
                "description": "",
                "name": "alt",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "autoCapitalize": {
                "defaultValue": null,
                "description": "",
                "name": "autoCapitalize",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "autoComplete": {
                "defaultValue": null,
                "description": "",
                "name": "autoComplete",
                "required": false,
                "type": {
                    "name": "HTMLInputAutoCompleteAttribute"
                }
            },
            "autoCorrect": {
                "defaultValue": null,
                "description": "",
                "name": "autoCorrect",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "autoFocus": {
                "defaultValue": null,
                "description": "",
                "name": "autoFocus",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "autoSave": {
                "defaultValue": null,
                "description": "",
                "name": "autoSave",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "capture": {
                "defaultValue": null,
                "description": "",
                "name": "capture",
                "required": false,
                "type": {
                    "name": "boolean | \"user\" | \"environment\""
                }
            },
            "checked": {
                "defaultValue": null,
                "description": "",
                "name": "checked",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "color": {
                "defaultValue": null,
                "description": "",
                "name": "color",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "content": {
                "defaultValue": null,
                "description": "",
                "name": "content",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "contentEditable": {
                "defaultValue": null,
                "description": "",
                "name": "contentEditable",
                "required": false,
                "type": {
                    "name": "\"inherit\" | Booleanish | \"plaintext-only\""
                }
            },
            "contextMenu": {
                "defaultValue": null,
                "description": "",
                "name": "contextMenu",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "dangerouslySetInnerHTML": {
                "defaultValue": null,
                "description": "",
                "name": "dangerouslySetInnerHTML",
                "required": false,
                "type": {
                    "name": "{ __html: string | TrustedHTML; }"
                }
            },
            "datatype": {
                "defaultValue": null,
                "description": "",
                "name": "datatype",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "defaultChecked": {
                "defaultValue": null,
                "description": "",
                "name": "defaultChecked",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "defaultValue": {
                "defaultValue": null,
                "description": "",
                "name": "defaultValue",
                "required": false,
                "type": {
                    "name": "string | number | readonly string[]"
                }
            },
            "dir": {
                "defaultValue": null,
                "description": "",
                "name": "dir",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "disabled": {
                "defaultValue": null,
                "description": "",
                "name": "disabled",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "draggable": {
                "defaultValue": null,
                "description": "",
                "name": "draggable",
                "required": false,
                "type": {
                    "name": "Booleanish"
                }
            },
            "enterKeyHint": {
                "defaultValue": null,
                "description": "",
                "name": "enterKeyHint",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"search\""
                        },
                        {
                            "value": "\"enter\""
                        },
                        {
                            "value": "\"done\""
                        },
                        {
                            "value": "\"go\""
                        },
                        {
                            "value": "\"next\""
                        },
                        {
                            "value": "\"previous\""
                        },
                        {
                            "value": "\"send\""
                        }
                    ]
                }
            },
            "form": {
                "defaultValue": null,
                "description": "",
                "name": "form",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "formAction": {
                "defaultValue": null,
                "description": "",
                "name": "formAction",
                "required": false,
                "type": {
                    "name": "string | ((formData: FormData) => void)"
                }
            },
            "formEncType": {
                "defaultValue": null,
                "description": "",
                "name": "formEncType",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "formMethod": {
                "defaultValue": null,
                "description": "",
                "name": "formMethod",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "formNoValidate": {
                "defaultValue": null,
                "description": "",
                "name": "formNoValidate",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "formTarget": {
                "defaultValue": null,
                "description": "",
                "name": "formTarget",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "height": {
                "defaultValue": null,
                "description": "",
                "name": "height",
                "required": false,
                "type": {
                    "name": "string | number"
                }
            },
            "hidden": {
                "defaultValue": null,
                "description": "",
                "name": "hidden",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "inert": {
                "defaultValue": null,
                "description": "@see https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/inert",
                "name": "inert",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "inlist": {
                "defaultValue": null,
                "description": "",
                "name": "inlist",
                "required": false,
                "type": {
                    "name": "any"
                }
            },
            "inputMode": {
                "defaultValue": null,
                "description": "Hints at the type of data that might be entered by the user while editing the element or its contents\n@see {@link https://html.spec.whatwg.org/multipage/interaction.html#input-modalities:-the-inputmode-attribute}",
                "name": "inputMode",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"text\""
                        },
                        {
                            "value": "\"none\""
                        },
                        {
                            "value": "\"search\""
                        },
                        {
                            "value": "\"decimal\""
                        },
                        {
                            "value": "\"url\""
                        },
                        {
                            "value": "\"tel\""
                        },
                        {
                            "value": "\"email\""
                        },
                        {
                            "value": "\"numeric\""
                        }
                    ]
                }
            },
            "is": {
                "defaultValue": null,
                "description": "Specify that a standard HTML element should behave like a defined custom built-in element\n@see {@link https://html.spec.whatwg.org/multipage/custom-elements.html#attr-is}",
                "name": "is",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "itemID": {
                "defaultValue": null,
                "description": "",
                "name": "itemID",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "itemProp": {
                "defaultValue": null,
                "description": "",
                "name": "itemProp",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "itemRef": {
                "defaultValue": null,
                "description": "",
                "name": "itemRef",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "itemScope": {
                "defaultValue": null,
                "description": "",
                "name": "itemScope",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "itemType": {
                "defaultValue": null,
                "description": "",
                "name": "itemType",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "key": {
                "defaultValue": null,
                "description": "",
                "name": "key",
                "required": false,
                "type": {
                    "name": "Key"
                }
            },
            "lang": {
                "defaultValue": null,
                "description": "",
                "name": "lang",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "list": {
                "defaultValue": null,
                "description": "",
                "name": "list",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "max": {
                "defaultValue": null,
                "description": "",
                "name": "max",
                "required": false,
                "type": {
                    "name": "string | number"
                }
            },
            "maxLength": {
                "defaultValue": null,
                "description": "",
                "name": "maxLength",
                "required": false,
                "type": {
                    "name": "number"
                }
            },
            "min": {
                "defaultValue": null,
                "description": "",
                "name": "min",
                "required": false,
                "type": {
                    "name": "string | number"
                }
            },
            "minLength": {
                "defaultValue": null,
                "description": "",
                "name": "minLength",
                "required": false,
                "type": {
                    "name": "number"
                }
            },
            "multiple": {
                "defaultValue": null,
                "description": "",
                "name": "multiple",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "name": {
                "defaultValue": null,
                "description": "",
                "name": "name",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "nonce": {
                "defaultValue": null,
                "description": "",
                "name": "nonce",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "pattern": {
                "defaultValue": null,
                "description": "",
                "name": "pattern",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "placeholder": {
                "defaultValue": null,
                "description": "",
                "name": "placeholder",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "popover": {
                "defaultValue": null,
                "description": "",
                "name": "popover",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"\""
                        },
                        {
                            "value": "\"manual\""
                        },
                        {
                            "value": "\"auto\""
                        }
                    ]
                }
            },
            "popoverTarget": {
                "defaultValue": null,
                "description": "",
                "name": "popoverTarget",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "popoverTargetAction": {
                "defaultValue": null,
                "description": "",
                "name": "popoverTargetAction",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"toggle\""
                        },
                        {
                            "value": "\"show\""
                        },
                        {
                            "value": "\"hide\""
                        }
                    ]
                }
            },
            "prefix": {
                "defaultValue": null,
                "description": "",
                "name": "prefix",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "property": {
                "defaultValue": null,
                "description": "",
                "name": "property",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "radioGroup": {
                "defaultValue": null,
                "description": "",
                "name": "radioGroup",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "readOnly": {
                "defaultValue": null,
                "description": "",
                "name": "readOnly",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "ref": {
                "defaultValue": null,
                "description": "Allows getting a ref to the component instance.\nOnce the component unmounts, React will set `ref.current` to `null`\n(or call the ref with `null` if you passed a callback ref).\n@see {@link https://react.dev/learn/referencing-values-with-refs#refs-and-the-dom React Docs}",
                "name": "ref",
                "required": false,
                "type": {
                    "name": "Ref<HTMLInputElement>"
                }
            },
            "rel": {
                "defaultValue": null,
                "description": "",
                "name": "rel",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "required": {
                "defaultValue": null,
                "description": "",
                "name": "required",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "resource": {
                "defaultValue": null,
                "description": "",
                "name": "resource",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "results": {
                "defaultValue": null,
                "description": "",
                "name": "results",
                "required": false,
                "type": {
                    "name": "number"
                }
            },
            "rev": {
                "defaultValue": null,
                "description": "",
                "name": "rev",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "role": {
                "defaultValue": null,
                "description": "",
                "name": "role",
                "required": false,
                "type": {
                    "name": "AriaRole"
                }
            },
            "security": {
                "defaultValue": null,
                "description": "",
                "name": "security",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "size": {
                "defaultValue": null,
                "description": "",
                "name": "size",
                "required": false,
                "type": {
                    "name": "number"
                }
            },
            "spellCheck": {
                "defaultValue": null,
                "description": "",
                "name": "spellCheck",
                "required": false,
                "type": {
                    "name": "Booleanish"
                }
            },
            "src": {
                "defaultValue": null,
                "description": "",
                "name": "src",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "step": {
                "defaultValue": null,
                "description": "",
                "name": "step",
                "required": false,
                "type": {
                    "name": "string | number"
                }
            },
            "suppressContentEditableWarning": {
                "defaultValue": null,
                "description": "",
                "name": "suppressContentEditableWarning",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "suppressHydrationWarning": {
                "defaultValue": null,
                "description": "",
                "name": "suppressHydrationWarning",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "tabIndex": {
                "defaultValue": null,
                "description": "",
                "name": "tabIndex",
                "required": false,
                "type": {
                    "name": "number"
                }
            },
            "title": {
                "defaultValue": null,
                "description": "",
                "name": "title",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "translate": {
                "defaultValue": null,
                "description": "",
                "name": "translate",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"yes\""
                        },
                        {
                            "value": "\"no\""
                        }
                    ]
                }
            },
            "type": {
                "defaultValue": null,
                "description": "",
                "name": "type",
                "required": false,
                "type": {
                    "name": "HTMLInputTypeAttribute"
                }
            },
            "typeof": {
                "defaultValue": null,
                "description": "",
                "name": "typeof",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "unselectable": {
                "defaultValue": null,
                "description": "",
                "name": "unselectable",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"on\""
                        },
                        {
                            "value": "\"off\""
                        }
                    ]
                }
            },
            "value": {
                "defaultValue": null,
                "description": "",
                "name": "value",
                "required": false,
                "type": {
                    "name": "string | number | readonly string[]"
                }
            },
            "vocab": {
                "defaultValue": null,
                "description": "",
                "name": "vocab",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "width": {
                "defaultValue": null,
                "description": "",
                "name": "width",
                "required": false,
                "type": {
                    "name": "string | number"
                }
            },
            "onAbort": {
                "defaultValue": null,
                "description": "",
                "name": "onAbort",
                "required": false,
                "type": {
                    "name": "ReactEventHandler<HTMLInputElement>"
                }
            },
            "onAbortCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onAbortCapture",
                "required": false,
                "type": {
                    "name": "ReactEventHandler<HTMLInputElement>"
                }
            },
            "onAnimationEnd": {
                "defaultValue": null,
                "description": "",
                "name": "onAnimationEnd",
                "required": false,
                "type": {
                    "name": "AnimationEventHandler<HTMLInputElement>"
                }
            },
            "onAnimationEndCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onAnimationEndCapture",
                "required": false,
                "type": {
                    "name": "AnimationEventHandler<HTMLInputElement>"
                }
            },
            "onAnimationIteration": {
                "defaultValue": null,
                "description": "",
                "name": "onAnimationIteration",
                "required": false,
                "type": {
                    "name": "AnimationEventHandler<HTMLInputElement>"
                }
            },
            "onAnimationIterationCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onAnimationIterationCapture",
                "required": false,
                "type": {
                    "name": "AnimationEventHandler<HTMLInputElement>"
                }
            },
            "onAnimationStart": {
                "defaultValue": null,
                "description": "",
                "name": "onAnimationStart",
                "required": false,
                "type": {
                    "name": "AnimationEventHandler<HTMLInputElement>"
                }
            },
            "onAnimationStartCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onAnimationStartCapture",
                "required": false,
                "type": {
                    "name": "AnimationEventHandler<HTMLInputElement>"
                }
            },
            "onAuxClick": {
                "defaultValue": null,
                "description": "",
                "name": "onAuxClick",
                "required": false,
                "type": {
                    "name": "MouseEventHandler<HTMLInputElement>"
                }
            },
            "onAuxClickCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onAuxClickCapture",
                "required": false,
                "type": {
                    "name": "MouseEventHandler<HTMLInputElement>"
                }
            },
            "onBeforeInputCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onBeforeInputCapture",
                "required": false,
                "type": {
                    "name": "FormEventHandler<HTMLInputElement>"
                }
            },
            "onBeforeToggle": {
                "defaultValue": null,
                "description": "",
                "name": "onBeforeToggle",
                "required": false,
                "type": {
                    "name": "ToggleEventHandler<HTMLInputElement>"
                }
            },
            "onBlurCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onBlurCapture",
                "required": false,
                "type": {
                    "name": "FocusEventHandler<HTMLInputElement>"
                }
            },
            "onCanPlay": {
                "defaultValue": null,
                "description": "",
                "name": "onCanPlay",
                "required": false,
                "type": {
                    "name": "ReactEventHandler<HTMLInputElement>"
                }
            },
            "onCanPlayCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onCanPlayCapture",
                "required": false,
                "type": {
                    "name": "ReactEventHandler<HTMLInputElement>"
                }
            },
            "onCanPlayThrough": {
                "defaultValue": null,
                "description": "",
                "name": "onCanPlayThrough",
                "required": false,
                "type": {
                    "name": "ReactEventHandler<HTMLInputElement>"
                }
            },
            "onCanPlayThroughCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onCanPlayThroughCapture",
                "required": false,
                "type": {
                    "name": "ReactEventHandler<HTMLInputElement>"
                }
            },
            "onChange": {
                "defaultValue": null,
                "description": "",
                "name": "onChange",
                "required": false,
                "type": {
                    "name": "ChangeEventHandler<HTMLInputElement>"
                }
            },
            "onChangeCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onChangeCapture",
                "required": false,
                "type": {
                    "name": "FormEventHandler<HTMLInputElement>"
                }
            },
            "onClick": {
                "defaultValue": null,
                "description": "",
                "name": "onClick",
                "required": false,
                "type": {
                    "name": "MouseEventHandler<HTMLInputElement>"
                }
            },
            "onClickCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onClickCapture",
                "required": false,
                "type": {
                    "name": "MouseEventHandler<HTMLInputElement>"
                }
            },
            "onCompositionEndCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onCompositionEndCapture",
                "required": false,
                "type": {
                    "name": "CompositionEventHandler<HTMLInputElement>"
                }
            },
            "onCompositionStartCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onCompositionStartCapture",
                "required": false,
                "type": {
                    "name": "CompositionEventHandler<HTMLInputElement>"
                }
            },
            "onCompositionUpdateCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onCompositionUpdateCapture",
                "required": false,
                "type": {
                    "name": "CompositionEventHandler<HTMLInputElement>"
                }
            },
            "onContextMenu": {
                "defaultValue": null,
                "description": "",
                "name": "onContextMenu",
                "required": false,
                "type": {
                    "name": "MouseEventHandler<HTMLInputElement>"
                }
            },
            "onContextMenuCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onContextMenuCapture",
                "required": false,
                "type": {
                    "name": "MouseEventHandler<HTMLInputElement>"
                }
            },
            "onCopyCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onCopyCapture",
                "required": false,
                "type": {
                    "name": "ClipboardEventHandler<HTMLInputElement>"
                }
            },
            "onCutCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onCutCapture",
                "required": false,
                "type": {
                    "name": "ClipboardEventHandler<HTMLInputElement>"
                }
            },
            "onDoubleClick": {
                "defaultValue": null,
                "description": "",
                "name": "onDoubleClick",
                "required": false,
                "type": {
                    "name": "MouseEventHandler<HTMLInputElement>"
                }
            },
            "onDoubleClickCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onDoubleClickCapture",
                "required": false,
                "type": {
                    "name": "MouseEventHandler<HTMLInputElement>"
                }
            },
            "onDrag": {
                "defaultValue": null,
                "description": "",
                "name": "onDrag",
                "required": false,
                "type": {
                    "name": "DragEventHandler<HTMLInputElement>"
                }
            },
            "onDragCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onDragCapture",
                "required": false,
                "type": {
                    "name": "DragEventHandler<HTMLInputElement>"
                }
            },
            "onDragEnd": {
                "defaultValue": null,
                "description": "",
                "name": "onDragEnd",
                "required": false,
                "type": {
                    "name": "DragEventHandler<HTMLInputElement>"
                }
            },
            "onDragEndCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onDragEndCapture",
                "required": false,
                "type": {
                    "name": "DragEventHandler<HTMLInputElement>"
                }
            },
            "onDragEnter": {
                "defaultValue": null,
                "description": "",
                "name": "onDragEnter",
                "required": false,
                "type": {
                    "name": "DragEventHandler<HTMLInputElement>"
                }
            },
            "onDragEnterCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onDragEnterCapture",
                "required": false,
                "type": {
                    "name": "DragEventHandler<HTMLInputElement>"
                }
            },
            "onDragExit": {
                "defaultValue": null,
                "description": "",
                "name": "onDragExit",
                "required": false,
                "type": {
                    "name": "DragEventHandler<HTMLInputElement>"
                }
            },
            "onDragExitCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onDragExitCapture",
                "required": false,
                "type": {
                    "name": "DragEventHandler<HTMLInputElement>"
                }
            },
            "onDragLeave": {
                "defaultValue": null,
                "description": "",
                "name": "onDragLeave",
                "required": false,
                "type": {
                    "name": "DragEventHandler<HTMLInputElement>"
                }
            },
            "onDragLeaveCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onDragLeaveCapture",
                "required": false,
                "type": {
                    "name": "DragEventHandler<HTMLInputElement>"
                }
            },
            "onDragOver": {
                "defaultValue": null,
                "description": "",
                "name": "onDragOver",
                "required": false,
                "type": {
                    "name": "DragEventHandler<HTMLInputElement>"
                }
            },
            "onDragOverCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onDragOverCapture",
                "required": false,
                "type": {
                    "name": "DragEventHandler<HTMLInputElement>"
                }
            },
            "onDragStart": {
                "defaultValue": null,
                "description": "",
                "name": "onDragStart",
                "required": false,
                "type": {
                    "name": "DragEventHandler<HTMLInputElement>"
                }
            },
            "onDragStartCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onDragStartCapture",
                "required": false,
                "type": {
                    "name": "DragEventHandler<HTMLInputElement>"
                }
            },
            "onDrop": {
                "defaultValue": null,
                "description": "",
                "name": "onDrop",
                "required": false,
                "type": {
                    "name": "DragEventHandler<HTMLInputElement>"
                }
            },
            "onDropCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onDropCapture",
                "required": false,
                "type": {
                    "name": "DragEventHandler<HTMLInputElement>"
                }
            },
            "onDurationChange": {
                "defaultValue": null,
                "description": "",
                "name": "onDurationChange",
                "required": false,
                "type": {
                    "name": "ReactEventHandler<HTMLInputElement>"
                }
            },
            "onDurationChangeCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onDurationChangeCapture",
                "required": false,
                "type": {
                    "name": "ReactEventHandler<HTMLInputElement>"
                }
            },
            "onEmptied": {
                "defaultValue": null,
                "description": "",
                "name": "onEmptied",
                "required": false,
                "type": {
                    "name": "ReactEventHandler<HTMLInputElement>"
                }
            },
            "onEmptiedCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onEmptiedCapture",
                "required": false,
                "type": {
                    "name": "ReactEventHandler<HTMLInputElement>"
                }
            },
            "onEncrypted": {
                "defaultValue": null,
                "description": "",
                "name": "onEncrypted",
                "required": false,
                "type": {
                    "name": "ReactEventHandler<HTMLInputElement>"
                }
            },
            "onEncryptedCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onEncryptedCapture",
                "required": false,
                "type": {
                    "name": "ReactEventHandler<HTMLInputElement>"
                }
            },
            "onEnded": {
                "defaultValue": null,
                "description": "",
                "name": "onEnded",
                "required": false,
                "type": {
                    "name": "ReactEventHandler<HTMLInputElement>"
                }
            },
            "onEndedCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onEndedCapture",
                "required": false,
                "type": {
                    "name": "ReactEventHandler<HTMLInputElement>"
                }
            },
            "onError": {
                "defaultValue": null,
                "description": "",
                "name": "onError",
                "required": false,
                "type": {
                    "name": "ReactEventHandler<HTMLInputElement>"
                }
            },
            "onErrorCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onErrorCapture",
                "required": false,
                "type": {
                    "name": "ReactEventHandler<HTMLInputElement>"
                }
            },
            "onFocusCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onFocusCapture",
                "required": false,
                "type": {
                    "name": "FocusEventHandler<HTMLInputElement>"
                }
            },
            "onGotPointerCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onGotPointerCapture",
                "required": false,
                "type": {
                    "name": "PointerEventHandler<HTMLInputElement>"
                }
            },
            "onGotPointerCaptureCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onGotPointerCaptureCapture",
                "required": false,
                "type": {
                    "name": "PointerEventHandler<HTMLInputElement>"
                }
            },
            "onInputCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onInputCapture",
                "required": false,
                "type": {
                    "name": "FormEventHandler<HTMLInputElement>"
                }
            },
            "onInvalid": {
                "defaultValue": null,
                "description": "",
                "name": "onInvalid",
                "required": false,
                "type": {
                    "name": "FormEventHandler<HTMLInputElement>"
                }
            },
            "onInvalidCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onInvalidCapture",
                "required": false,
                "type": {
                    "name": "FormEventHandler<HTMLInputElement>"
                }
            },
            "onKeyDownCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onKeyDownCapture",
                "required": false,
                "type": {
                    "name": "KeyboardEventHandler<HTMLInputElement>"
                }
            },
            "onKeyPress": {
                "defaultValue": null,
                "description": "@deprecated",
                "name": "onKeyPress",
                "required": false,
                "type": {
                    "name": "KeyboardEventHandler<HTMLInputElement>"
                }
            },
            "onKeyPressCapture": {
                "defaultValue": null,
                "description": "@deprecated",
                "name": "onKeyPressCapture",
                "required": false,
                "type": {
                    "name": "KeyboardEventHandler<HTMLInputElement>"
                }
            },
            "onKeyUpCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onKeyUpCapture",
                "required": false,
                "type": {
                    "name": "KeyboardEventHandler<HTMLInputElement>"
                }
            },
            "onLoad": {
                "defaultValue": null,
                "description": "",
                "name": "onLoad",
                "required": false,
                "type": {
                    "name": "ReactEventHandler<HTMLInputElement>"
                }
            },
            "onLoadCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onLoadCapture",
                "required": false,
                "type": {
                    "name": "ReactEventHandler<HTMLInputElement>"
                }
            },
            "onLoadedData": {
                "defaultValue": null,
                "description": "",
                "name": "onLoadedData",
                "required": false,
                "type": {
                    "name": "ReactEventHandler<HTMLInputElement>"
                }
            },
            "onLoadedDataCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onLoadedDataCapture",
                "required": false,
                "type": {
                    "name": "ReactEventHandler<HTMLInputElement>"
                }
            },
            "onLoadedMetadata": {
                "defaultValue": null,
                "description": "",
                "name": "onLoadedMetadata",
                "required": false,
                "type": {
                    "name": "ReactEventHandler<HTMLInputElement>"
                }
            },
            "onLoadedMetadataCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onLoadedMetadataCapture",
                "required": false,
                "type": {
                    "name": "ReactEventHandler<HTMLInputElement>"
                }
            },
            "onLoadStart": {
                "defaultValue": null,
                "description": "",
                "name": "onLoadStart",
                "required": false,
                "type": {
                    "name": "ReactEventHandler<HTMLInputElement>"
                }
            },
            "onLoadStartCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onLoadStartCapture",
                "required": false,
                "type": {
                    "name": "ReactEventHandler<HTMLInputElement>"
                }
            },
            "onLostPointerCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onLostPointerCapture",
                "required": false,
                "type": {
                    "name": "PointerEventHandler<HTMLInputElement>"
                }
            },
            "onLostPointerCaptureCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onLostPointerCaptureCapture",
                "required": false,
                "type": {
                    "name": "PointerEventHandler<HTMLInputElement>"
                }
            },
            "onMouseDown": {
                "defaultValue": null,
                "description": "",
                "name": "onMouseDown",
                "required": false,
                "type": {
                    "name": "MouseEventHandler<HTMLInputElement>"
                }
            },
            "onMouseDownCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onMouseDownCapture",
                "required": false,
                "type": {
                    "name": "MouseEventHandler<HTMLInputElement>"
                }
            },
            "onMouseEnter": {
                "defaultValue": null,
                "description": "",
                "name": "onMouseEnter",
                "required": false,
                "type": {
                    "name": "MouseEventHandler<HTMLInputElement>"
                }
            },
            "onMouseLeave": {
                "defaultValue": null,
                "description": "",
                "name": "onMouseLeave",
                "required": false,
                "type": {
                    "name": "MouseEventHandler<HTMLInputElement>"
                }
            },
            "onMouseMove": {
                "defaultValue": null,
                "description": "",
                "name": "onMouseMove",
                "required": false,
                "type": {
                    "name": "MouseEventHandler<HTMLInputElement>"
                }
            },
            "onMouseMoveCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onMouseMoveCapture",
                "required": false,
                "type": {
                    "name": "MouseEventHandler<HTMLInputElement>"
                }
            },
            "onMouseOut": {
                "defaultValue": null,
                "description": "",
                "name": "onMouseOut",
                "required": false,
                "type": {
                    "name": "MouseEventHandler<HTMLInputElement>"
                }
            },
            "onMouseOutCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onMouseOutCapture",
                "required": false,
                "type": {
                    "name": "MouseEventHandler<HTMLInputElement>"
                }
            },
            "onMouseOver": {
                "defaultValue": null,
                "description": "",
                "name": "onMouseOver",
                "required": false,
                "type": {
                    "name": "MouseEventHandler<HTMLInputElement>"
                }
            },
            "onMouseOverCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onMouseOverCapture",
                "required": false,
                "type": {
                    "name": "MouseEventHandler<HTMLInputElement>"
                }
            },
            "onMouseUp": {
                "defaultValue": null,
                "description": "",
                "name": "onMouseUp",
                "required": false,
                "type": {
                    "name": "MouseEventHandler<HTMLInputElement>"
                }
            },
            "onMouseUpCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onMouseUpCapture",
                "required": false,
                "type": {
                    "name": "MouseEventHandler<HTMLInputElement>"
                }
            },
            "onPasteCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onPasteCapture",
                "required": false,
                "type": {
                    "name": "ClipboardEventHandler<HTMLInputElement>"
                }
            },
            "onPause": {
                "defaultValue": null,
                "description": "",
                "name": "onPause",
                "required": false,
                "type": {
                    "name": "ReactEventHandler<HTMLInputElement>"
                }
            },
            "onPauseCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onPauseCapture",
                "required": false,
                "type": {
                    "name": "ReactEventHandler<HTMLInputElement>"
                }
            },
            "onPlay": {
                "defaultValue": null,
                "description": "",
                "name": "onPlay",
                "required": false,
                "type": {
                    "name": "ReactEventHandler<HTMLInputElement>"
                }
            },
            "onPlayCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onPlayCapture",
                "required": false,
                "type": {
                    "name": "ReactEventHandler<HTMLInputElement>"
                }
            },
            "onPlaying": {
                "defaultValue": null,
                "description": "",
                "name": "onPlaying",
                "required": false,
                "type": {
                    "name": "ReactEventHandler<HTMLInputElement>"
                }
            },
            "onPlayingCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onPlayingCapture",
                "required": false,
                "type": {
                    "name": "ReactEventHandler<HTMLInputElement>"
                }
            },
            "onPointerCancel": {
                "defaultValue": null,
                "description": "",
                "name": "onPointerCancel",
                "required": false,
                "type": {
                    "name": "PointerEventHandler<HTMLInputElement>"
                }
            },
            "onPointerCancelCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onPointerCancelCapture",
                "required": false,
                "type": {
                    "name": "PointerEventHandler<HTMLInputElement>"
                }
            },
            "onPointerDown": {
                "defaultValue": null,
                "description": "",
                "name": "onPointerDown",
                "required": false,
                "type": {
                    "name": "PointerEventHandler<HTMLInputElement>"
                }
            },
            "onPointerDownCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onPointerDownCapture",
                "required": false,
                "type": {
                    "name": "PointerEventHandler<HTMLInputElement>"
                }
            },
            "onPointerEnter": {
                "defaultValue": null,
                "description": "",
                "name": "onPointerEnter",
                "required": false,
                "type": {
                    "name": "PointerEventHandler<HTMLInputElement>"
                }
            },
            "onPointerLeave": {
                "defaultValue": null,
                "description": "",
                "name": "onPointerLeave",
                "required": false,
                "type": {
                    "name": "PointerEventHandler<HTMLInputElement>"
                }
            },
            "onPointerMove": {
                "defaultValue": null,
                "description": "",
                "name": "onPointerMove",
                "required": false,
                "type": {
                    "name": "PointerEventHandler<HTMLInputElement>"
                }
            },
            "onPointerMoveCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onPointerMoveCapture",
                "required": false,
                "type": {
                    "name": "PointerEventHandler<HTMLInputElement>"
                }
            },
            "onPointerOut": {
                "defaultValue": null,
                "description": "",
                "name": "onPointerOut",
                "required": false,
                "type": {
                    "name": "PointerEventHandler<HTMLInputElement>"
                }
            },
            "onPointerOutCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onPointerOutCapture",
                "required": false,
                "type": {
                    "name": "PointerEventHandler<HTMLInputElement>"
                }
            },
            "onPointerOver": {
                "defaultValue": null,
                "description": "",
                "name": "onPointerOver",
                "required": false,
                "type": {
                    "name": "PointerEventHandler<HTMLInputElement>"
                }
            },
            "onPointerOverCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onPointerOverCapture",
                "required": false,
                "type": {
                    "name": "PointerEventHandler<HTMLInputElement>"
                }
            },
            "onPointerUp": {
                "defaultValue": null,
                "description": "",
                "name": "onPointerUp",
                "required": false,
                "type": {
                    "name": "PointerEventHandler<HTMLInputElement>"
                }
            },
            "onPointerUpCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onPointerUpCapture",
                "required": false,
                "type": {
                    "name": "PointerEventHandler<HTMLInputElement>"
                }
            },
            "onProgress": {
                "defaultValue": null,
                "description": "",
                "name": "onProgress",
                "required": false,
                "type": {
                    "name": "ReactEventHandler<HTMLInputElement>"
                }
            },
            "onProgressCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onProgressCapture",
                "required": false,
                "type": {
                    "name": "ReactEventHandler<HTMLInputElement>"
                }
            },
            "onRateChange": {
                "defaultValue": null,
                "description": "",
                "name": "onRateChange",
                "required": false,
                "type": {
                    "name": "ReactEventHandler<HTMLInputElement>"
                }
            },
            "onRateChangeCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onRateChangeCapture",
                "required": false,
                "type": {
                    "name": "ReactEventHandler<HTMLInputElement>"
                }
            },
            "onReset": {
                "defaultValue": null,
                "description": "",
                "name": "onReset",
                "required": false,
                "type": {
                    "name": "FormEventHandler<HTMLInputElement>"
                }
            },
            "onResetCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onResetCapture",
                "required": false,
                "type": {
                    "name": "FormEventHandler<HTMLInputElement>"
                }
            },
            "onResize": {
                "defaultValue": null,
                "description": "",
                "name": "onResize",
                "required": false,
                "type": {
                    "name": "ReactEventHandler<HTMLInputElement>"
                }
            },
            "onResizeCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onResizeCapture",
                "required": false,
                "type": {
                    "name": "ReactEventHandler<HTMLInputElement>"
                }
            },
            "onScrollCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onScrollCapture",
                "required": false,
                "type": {
                    "name": "UIEventHandler<HTMLInputElement>"
                }
            },
            "onSeeked": {
                "defaultValue": null,
                "description": "",
                "name": "onSeeked",
                "required": false,
                "type": {
                    "name": "ReactEventHandler<HTMLInputElement>"
                }
            },
            "onSeekedCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onSeekedCapture",
                "required": false,
                "type": {
                    "name": "ReactEventHandler<HTMLInputElement>"
                }
            },
            "onSeeking": {
                "defaultValue": null,
                "description": "",
                "name": "onSeeking",
                "required": false,
                "type": {
                    "name": "ReactEventHandler<HTMLInputElement>"
                }
            },
            "onSeekingCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onSeekingCapture",
                "required": false,
                "type": {
                    "name": "ReactEventHandler<HTMLInputElement>"
                }
            },
            "onSelectCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onSelectCapture",
                "required": false,
                "type": {
                    "name": "ReactEventHandler<HTMLInputElement>"
                }
            },
            "onStalled": {
                "defaultValue": null,
                "description": "",
                "name": "onStalled",
                "required": false,
                "type": {
                    "name": "ReactEventHandler<HTMLInputElement>"
                }
            },
            "onStalledCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onStalledCapture",
                "required": false,
                "type": {
                    "name": "ReactEventHandler<HTMLInputElement>"
                }
            },
            "onSubmit": {
                "defaultValue": null,
                "description": "",
                "name": "onSubmit",
                "required": false,
                "type": {
                    "name": "FormEventHandler<HTMLInputElement>"
                }
            },
            "onSubmitCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onSubmitCapture",
                "required": false,
                "type": {
                    "name": "FormEventHandler<HTMLInputElement>"
                }
            },
            "onSuspend": {
                "defaultValue": null,
                "description": "",
                "name": "onSuspend",
                "required": false,
                "type": {
                    "name": "ReactEventHandler<HTMLInputElement>"
                }
            },
            "onSuspendCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onSuspendCapture",
                "required": false,
                "type": {
                    "name": "ReactEventHandler<HTMLInputElement>"
                }
            },
            "onTimeUpdate": {
                "defaultValue": null,
                "description": "",
                "name": "onTimeUpdate",
                "required": false,
                "type": {
                    "name": "ReactEventHandler<HTMLInputElement>"
                }
            },
            "onTimeUpdateCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onTimeUpdateCapture",
                "required": false,
                "type": {
                    "name": "ReactEventHandler<HTMLInputElement>"
                }
            },
            "onToggle": {
                "defaultValue": null,
                "description": "",
                "name": "onToggle",
                "required": false,
                "type": {
                    "name": "ToggleEventHandler<HTMLInputElement>"
                }
            },
            "onTouchCancel": {
                "defaultValue": null,
                "description": "",
                "name": "onTouchCancel",
                "required": false,
                "type": {
                    "name": "TouchEventHandler<HTMLInputElement>"
                }
            },
            "onTouchCancelCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onTouchCancelCapture",
                "required": false,
                "type": {
                    "name": "TouchEventHandler<HTMLInputElement>"
                }
            },
            "onTouchEnd": {
                "defaultValue": null,
                "description": "",
                "name": "onTouchEnd",
                "required": false,
                "type": {
                    "name": "TouchEventHandler<HTMLInputElement>"
                }
            },
            "onTouchEndCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onTouchEndCapture",
                "required": false,
                "type": {
                    "name": "TouchEventHandler<HTMLInputElement>"
                }
            },
            "onTouchMove": {
                "defaultValue": null,
                "description": "",
                "name": "onTouchMove",
                "required": false,
                "type": {
                    "name": "TouchEventHandler<HTMLInputElement>"
                }
            },
            "onTouchMoveCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onTouchMoveCapture",
                "required": false,
                "type": {
                    "name": "TouchEventHandler<HTMLInputElement>"
                }
            },
            "onTouchStart": {
                "defaultValue": null,
                "description": "",
                "name": "onTouchStart",
                "required": false,
                "type": {
                    "name": "TouchEventHandler<HTMLInputElement>"
                }
            },
            "onTouchStartCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onTouchStartCapture",
                "required": false,
                "type": {
                    "name": "TouchEventHandler<HTMLInputElement>"
                }
            },
            "onTransitionCancel": {
                "defaultValue": null,
                "description": "",
                "name": "onTransitionCancel",
                "required": false,
                "type": {
                    "name": "TransitionEventHandler<HTMLInputElement>"
                }
            },
            "onTransitionCancelCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onTransitionCancelCapture",
                "required": false,
                "type": {
                    "name": "TransitionEventHandler<HTMLInputElement>"
                }
            },
            "onTransitionEnd": {
                "defaultValue": null,
                "description": "",
                "name": "onTransitionEnd",
                "required": false,
                "type": {
                    "name": "TransitionEventHandler<HTMLInputElement>"
                }
            },
            "onTransitionEndCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onTransitionEndCapture",
                "required": false,
                "type": {
                    "name": "TransitionEventHandler<HTMLInputElement>"
                }
            },
            "onTransitionRun": {
                "defaultValue": null,
                "description": "",
                "name": "onTransitionRun",
                "required": false,
                "type": {
                    "name": "TransitionEventHandler<HTMLInputElement>"
                }
            },
            "onTransitionRunCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onTransitionRunCapture",
                "required": false,
                "type": {
                    "name": "TransitionEventHandler<HTMLInputElement>"
                }
            },
            "onTransitionStart": {
                "defaultValue": null,
                "description": "",
                "name": "onTransitionStart",
                "required": false,
                "type": {
                    "name": "TransitionEventHandler<HTMLInputElement>"
                }
            },
            "onTransitionStartCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onTransitionStartCapture",
                "required": false,
                "type": {
                    "name": "TransitionEventHandler<HTMLInputElement>"
                }
            },
            "onVolumeChange": {
                "defaultValue": null,
                "description": "",
                "name": "onVolumeChange",
                "required": false,
                "type": {
                    "name": "ReactEventHandler<HTMLInputElement>"
                }
            },
            "onVolumeChangeCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onVolumeChangeCapture",
                "required": false,
                "type": {
                    "name": "ReactEventHandler<HTMLInputElement>"
                }
            },
            "onWaiting": {
                "defaultValue": null,
                "description": "",
                "name": "onWaiting",
                "required": false,
                "type": {
                    "name": "ReactEventHandler<HTMLInputElement>"
                }
            },
            "onWaitingCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onWaitingCapture",
                "required": false,
                "type": {
                    "name": "ReactEventHandler<HTMLInputElement>"
                }
            },
            "onWheel": {
                "defaultValue": null,
                "description": "",
                "name": "onWheel",
                "required": false,
                "type": {
                    "name": "WheelEventHandler<HTMLInputElement>"
                }
            },
            "onWheelCapture": {
                "defaultValue": null,
                "description": "",
                "name": "onWheelCapture",
                "required": false,
                "type": {
                    "name": "WheelEventHandler<HTMLInputElement>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/Field.tsx#_Input"] = {
        docgenInfo: _Input.__docgenInfo,
        name: "_Input",
        path: "packages/@react-spectrum/s2/src/Field.tsx#_Input"
    };
} catch (__react_docgen_typescript_loader_error) {}

},{"0":"2d4N0","1":"76f4u","2":"i5Dpk","3":"eiDWI","4":"BxAK2","5":"8GdRl","6":"c4xV7","7":"cq28r","8":"hU11Q","9":"99szq","react/jsx-runtime":"2JzhG","../s2wf-icons/S2_Icon_AlertTriangle_20_N.svg":"gH5vG","../ui-icons/Asterisk":"v93Ct","./CenterBaseline":"hXatv","react-aria-components":"8nuKL","./ContextualHelp":"hfJsD","react":"jEiK2","./Icon":"1OC2a","../intl/*.json":"iU6xz","../style/runtime":"dzhKB","@react-spectrum/utils":"bebxO","@react-aria/utils":"e9Yvo","@react-aria/i18n":"hFrKJ","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"2d4N0":[function() {},{}],"76f4u":[function() {},{}],"i5Dpk":[function() {},{}],"eiDWI":[function() {},{}],"BxAK2":[function() {},{}],"8GdRl":[function() {},{}],"c4xV7":[function() {},{}],"cq28r":[function() {},{}],"hU11Q":[function() {},{}],"99szq":[function() {},{}],"v93Ct":[function(require,module,exports) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Asterisk);
var _jsxRuntime = require("react/jsx-runtime");
var _s2AsteriskSize200Svg = require("./S2_AsteriskSize200.svg");
var _s2AsteriskSize200SvgDefault = parcelHelpers.interopDefault(_s2AsteriskSize200Svg);
var _s2AsteriskSize100Svg = require("./S2_AsteriskSize100.svg");
var _s2AsteriskSize100SvgDefault = parcelHelpers.interopDefault(_s2AsteriskSize100Svg);
var _s2AsteriskSize300Svg = require("./S2_AsteriskSize300.svg");
var _s2AsteriskSize300SvgDefault = parcelHelpers.interopDefault(_s2AsteriskSize300Svg);
function Asterisk(props) {
    let { size = 'M', ...otherProps } = props;
    switch(size){
        case 'M':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2AsteriskSize100SvgDefault.default), {
                ...otherProps
            });
        case 'L':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2AsteriskSize200SvgDefault.default), {
                ...otherProps
            });
        case 'XL':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2AsteriskSize300SvgDefault.default), {
                ...otherProps
            });
    }
}

},{"react/jsx-runtime":"2JzhG","./S2_AsteriskSize200.svg":"7ZPDC","./S2_AsteriskSize100.svg":"eBn0m","./S2_AsteriskSize300.svg":"eovpu","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"7ZPDC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgS2AsteriskSize200 = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 10,
        height: 10,
        viewBox: "0 0 10 10",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            "data-name": "Shape",
            d: "M7.861 7.953c.062.063.1.146 0 .23l-1.293.834c-.1.063-.145.021-.187-.083l-1.6-2.793-2.105 2.314c-.021.04-.083.082-.145 0l-1-1.043c-.1-.062-.083-.125 0-.187l2.375-1.981-2.715-1.026c-.042 0-.1-.083-.063-.188l.707-1.412a.111.111 0 0 1 .136-.074c.02.006.038.018.052.034l2.378 1.54.146-3.043A.11.11 0 0 1 4.638.95a.167.167 0 0 1 .034 0l1.73.23c.1 0 .125.042.1.146l-.814 2.979 2.751-.834c.062-.042.125-.042.167.083l.271 1.542c.02.1 0 .146-.083.146l-2.876.23 1.943 2.481Z",
            fill: "var(--iconPrimary, #222)"
        })
    });
exports.default = SvgS2AsteriskSize200;

},{"react/jsx-runtime":"2JzhG","react":"jEiK2","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"eBn0m":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgS2AsteriskSize100 = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 8,
        height: 8,
        viewBox: "0 0 8 8",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            "data-name": "Shape",
            d: "M6.575 6.555c.055.056.092.13 0 .2l-1.149.741c-.092.056-.129.019-.166-.074L3.834 4.94 1.963 7c-.019.036-.074.073-.129 0l-.889-.927c-.093-.055-.074-.111 0-.166l2.111-1.76L.648 3.24c-.037 0-.092-.074-.056-.167l.63-1.259a.1.1 0 0 1 .121-.066.1.1 0 0 1 .046.03L3.5 3.148l.13-2.7a.1.1 0 0 1 .081-.11.145.145 0 0 1 .03 0l1.537.2c.093 0 .111.036.093.13l-.723 2.646 2.445-.741c.055-.037.111-.037.148.074l.241 1.37c.018.093 0 .13-.074.13l-2.556.2 1.723 2.208Z",
            fill: "var(--iconPrimary, #222)"
        })
    });
exports.default = SvgS2AsteriskSize100;

},{"react/jsx-runtime":"2JzhG","react":"jEiK2","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"eovpu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgS2AsteriskSize300 = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 10,
        height: 10,
        viewBox: "0 0 10 10",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            "data-name": "Shape",
            d: "M8.266 8.324c.07.071.116.164 0 .258l-1.454.938c-.116.071-.163.024-.21-.094l-1.8-3.141-2.367 2.6c-.024.045-.094.092-.163 0l-1.13-1.167c-.118-.07-.094-.141 0-.21l2.671-2.227L.766 4.13c-.047 0-.116-.094-.071-.211l.8-1.593a.124.124 0 0 1 .153-.084.13.13 0 0 1 .058.038l2.669 1.738.164-3.422a.124.124 0 0 1 .1-.14.189.189 0 0 1 .038 0l1.945.258c.118 0 .14.047.118.164l-.915 3.349 3.094-.938c.07-.047.14-.047.187.094l.3 1.734c.023.118 0 .164-.094.164l-3.234.258 2.188 2.785Z",
            fill: "var(--iconPrimary, #222)"
        })
    });
exports.default = SvgS2AsteriskSize300;

},{"react/jsx-runtime":"2JzhG","react":"jEiK2","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"hfJsD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ContextualHelpContext", ()=>ContextualHelpContext);
parcelHelpers.export(exports, "ContextualHelp", ()=>_ContextualHelp);
var _jsxRuntime = require("react/jsx-runtime");
var _actionButton = require("./ActionButton");
var _content = require("./Content");
var _reactAriaComponents = require("react-aria-components");
var _react = require("react");
var _dialog = require("./Dialog");
var _dialogTrigger = require("./DialogTrigger");
var _utils = require("@react-aria/utils");
var _s2IconHelpCircle20NSvg = require("../s2wf-icons/S2_Icon_HelpCircle_20_N.svg");
var _s2IconHelpCircle20NSvgDefault = parcelHelpers.interopDefault(_s2IconHelpCircle20NSvg);
var _s2IconInfoCircle20NSvg = require("../s2wf-icons/S2_Icon_InfoCircle_20_N.svg");
var _s2IconInfoCircle20NSvgDefault = parcelHelpers.interopDefault(_s2IconInfoCircle20NSvg);
// @ts-ignore
var _json = require("../intl/*.json");
var _jsonDefault = parcelHelpers.interopDefault(_json);
var _runtime = require("../style/runtime");
var _popover = require("./Popover");
var _i18N = require("@react-aria/i18n");
var _useSpectrumContextProps = require("./useSpectrumContextProps");
const popover = " . _ca _c-enzrfpb _c-enzwzjc _c-enzykdd _c-enzzrge _c-eo0c6sf _c-1uotwbwg _c-bc1l9oh q-389edk l-389edk Eh Fh Ch Dh";
const ContextualHelpContext = /*#__PURE__*/ (0, _react.createContext)(null);
function ContextualHelp(props, ref) {
    let stringFormatter = (0, _i18N.useLocalizedStringFormatter)((0, _jsonDefault.default), '@react-spectrum/s2');
    [props, ref] = (0, _useSpectrumContextProps.useSpectrumContextProps)(props, ref, ContextualHelpContext);
    let { children, defaultOpen, // containerPadding = 24, // See popover() above. Issue noted in Popover.tsx.
    size = 'XS', crossOffset, isOpen, offset = 8, onOpenChange, placement = 'bottom start', shouldFlip, UNSAFE_className, UNSAFE_style, styles, variant = 'help' } = props;
    // In a FieldLabel we're getting the context's aria-labeledby, so we need to
    // manually set the aria-label after useLabels() to keep the order of label
    // then ContextualHelp variant
    let labelProps = (0, _utils.useLabels)(props);
    let label = stringFormatter.format(`contextualhelp.${variant}`);
    labelProps['aria-label'] = labelProps['aria-label'] ? labelProps['aria-label'] + ' ' + label : label;
    let buttonProps = (0, _utils.filterDOMProps)(props, {
        labelable: true
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _dialogTrigger.DialogTrigger), {
        isOpen: isOpen,
        defaultOpen: defaultOpen,
        onOpenChange: onOpenChange,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _actionButton.ActionButton), {
                slot: null,
                ref: ref,
                size: size,
                ...(0, _utils.mergeProps)(buttonProps, labelProps),
                UNSAFE_style: UNSAFE_style,
                UNSAFE_className: UNSAFE_className,
                styles: styles,
                isQuiet: true,
                children: variant === 'info' ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2IconInfoCircle20NSvgDefault.default), {}) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2IconHelpCircle20NSvgDefault.default), {})
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _popover.Popover), {
                placement: placement,
                shouldFlip: shouldFlip,
                // not working => containerPadding={containerPadding}
                offset: offset,
                crossOffset: crossOffset,
                hideArrow: true,
                UNSAFE_className: popover,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Dialog), {
                    className: (0, _runtime.mergeStyles)((0, _dialog.dialogInner), " . _va _wa _xa _ya"),
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Provider), {
                        values: [
                            [
                                (0, _reactAriaComponents.TextContext),
                                {
                                    slots: {
                                        [(0, _reactAriaComponents.DEFAULT_SLOT)]: {}
                                    }
                                }
                            ],
                            [
                                (0, _content.HeadingContext),
                                {
                                    styles: " . _ca _c-enzrfpb _c-enzwzjc _c-enzykdd _c-enzzrge _c-eo0c6sf _c-1uotwbwg _c-bc1l9oh _di _dbj _ee _e-1x99dloe _fa _f-1x99dlob ao Aa B-1ya11p4 ya za"
                                }
                            ],
                            [
                                (0, _content.ContentContext),
                                {
                                    styles: " . _ca _c-enzrfpb _c-enzwzjc _c-enzykdd _c-enzzrge _c-eo0c6sf _c-1uotwbwg _c-bc1l9oh _de _dbf _eb _fb _f-1x99dloc an"
                                }
                            ],
                            [
                                (0, _content.FooterContext),
                                {
                                    styles: " . _ca _c-enzrfpb _c-enzwzjc _c-enzykdd _c-enzzrge _c-eo0c6sf _c-1uotwbwg _c-bc1l9oh _de _dbf _eb _fb _f-1x99dloc an Af"
                                }
                            ]
                        ],
                        children: children
                    })
                })
            })
        ]
    });
}
/**
 * Contextual help shows a user extra information about the state of an adjacent component, or a total view.
 */ let _ContextualHelp = /*#__PURE__*/ (0, _react.forwardRef)(ContextualHelp);
try {
    // @ts-ignore
    ContextualHelpContext.displayName = "ContextualHelpContext";
    // @ts-ignore
    ContextualHelpContext.__docgenInfo = {
        "description": "",
        "displayName": "ContextualHelpContext",
        "props": {
            "value": {
                "defaultValue": null,
                "description": "",
                "name": "value",
                "required": true,
                "type": {
                    "name": "ContextValue<ContextualHelpProps, FocusableRefValue<HTMLButtonElement, HTMLButtonElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/ContextualHelp.tsx#ContextualHelpContext"] = {
        docgenInfo: ContextualHelpContext.__docgenInfo,
        name: "ContextualHelpContext",
        path: "packages/@react-spectrum/s2/src/ContextualHelp.tsx#ContextualHelpContext"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    _ContextualHelp.displayName = "_ContextualHelp";
    // @ts-ignore
    _ContextualHelp.__docgenInfo = {
        "description": "Contextual help shows a user extra information about the state of an adjacent component, or a total view.",
        "displayName": "_ContextualHelp",
        "props": {
            "children": {
                "defaultValue": null,
                "description": "Contents of the Contextual Help popover.",
                "name": "children",
                "required": false,
                "type": {
                    "name": "ReactNode"
                }
            },
            "containerPadding": {
                "defaultValue": {
                    value: "12"
                },
                "description": "The placement padding that should be applied between the element and its\nsurrounding container.",
                "name": "containerPadding",
                "required": false,
                "type": {
                    "name": "number"
                }
            },
            "crossOffset": {
                "defaultValue": {
                    value: "0"
                },
                "description": "The additional offset applied along the cross axis between the element and its\nanchor element.",
                "name": "crossOffset",
                "required": false,
                "type": {
                    "name": "number"
                }
            },
            "defaultOpen": {
                "defaultValue": null,
                "description": "Whether the overlay is open by default (uncontrolled).",
                "name": "defaultOpen",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isOpen": {
                "defaultValue": null,
                "description": "Whether the overlay is open by default (controlled).",
                "name": "isOpen",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "offset": {
                "defaultValue": {
                    value: "8"
                },
                "description": "The additional offset applied along the main axis between the element and its\nanchor element.",
                "name": "offset",
                "required": false,
                "type": {
                    "name": "number"
                }
            },
            "placement": {
                "defaultValue": {
                    value: "'bottom'"
                },
                "description": "The placement of the element with respect to its anchor element.",
                "name": "placement",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"top\""
                        },
                        {
                            "value": "\"bottom\""
                        },
                        {
                            "value": "\"start\""
                        },
                        {
                            "value": "\"end\""
                        },
                        {
                            "value": "\"left\""
                        },
                        {
                            "value": "\"right\""
                        },
                        {
                            "value": "\"left bottom\""
                        },
                        {
                            "value": "\"left top\""
                        },
                        {
                            "value": "\"right bottom\""
                        },
                        {
                            "value": "\"right top\""
                        },
                        {
                            "value": "\"top right\""
                        },
                        {
                            "value": "\"bottom right\""
                        },
                        {
                            "value": "\"bottom left\""
                        },
                        {
                            "value": "\"bottom start\""
                        },
                        {
                            "value": "\"bottom end\""
                        },
                        {
                            "value": "\"top left\""
                        },
                        {
                            "value": "\"top start\""
                        },
                        {
                            "value": "\"top end\""
                        },
                        {
                            "value": "\"start top\""
                        },
                        {
                            "value": "\"start bottom\""
                        },
                        {
                            "value": "\"end top\""
                        },
                        {
                            "value": "\"end bottom\""
                        }
                    ]
                }
            },
            "shouldFlip": {
                "defaultValue": {
                    value: "true"
                },
                "description": "Whether the element should flip its orientation (e.g. top to bottom or left to right) when\nthere is insufficient room for it to render completely.",
                "name": "shouldFlip",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "size": {
                "defaultValue": {
                    value: "'XS'"
                },
                "description": "The size of the ActionButton.",
                "name": "size",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"S\""
                        },
                        {
                            "value": "\"XS\""
                        }
                    ]
                }
            },
            "styles": {
                "defaultValue": null,
                "description": "Spectrum-defined styles, returned by the `style()` macro.",
                "name": "styles",
                "required": false,
                "type": {
                    "name": "StylesProp"
                }
            },
            "UNSAFE_className": {
                "defaultValue": null,
                "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_className",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_style": {
                "defaultValue": null,
                "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_style",
                "required": false,
                "type": {
                    "name": "CSSProperties"
                }
            },
            "variant": {
                "defaultValue": {
                    value: "'help'"
                },
                "description": "Indicates whether contents are informative or provides helpful guidance.",
                "name": "variant",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"help\""
                        },
                        {
                            "value": "\"info\""
                        }
                    ]
                }
            },
            "onOpenChange": {
                "defaultValue": null,
                "description": "Handler that is called when the overlay's open state changes.",
                "name": "onOpenChange",
                "required": false,
                "type": {
                    "name": "(isOpen: boolean) => void"
                }
            },
            "key": {
                "defaultValue": null,
                "description": "",
                "name": "key",
                "required": false,
                "type": {
                    "name": "Key"
                }
            },
            "ref": {
                "defaultValue": null,
                "description": "Allows getting a ref to the component instance.\nOnce the component unmounts, React will set `ref.current` to `null`\n(or call the ref with `null` if you passed a callback ref).\n@see {@link https://react.dev/learn/referencing-values-with-refs#refs-and-the-dom React Docs}",
                "name": "ref",
                "required": false,
                "type": {
                    "name": "Ref<FocusableRefValue<HTMLButtonElement, HTMLButtonElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/ContextualHelp.tsx#_ContextualHelp"] = {
        docgenInfo: _ContextualHelp.__docgenInfo,
        name: "_ContextualHelp",
        path: "packages/@react-spectrum/s2/src/ContextualHelp.tsx#_ContextualHelp"
    };
} catch (__react_docgen_typescript_loader_error) {}

},{"0":"7KOlP","1":"a5S2q","2":"gySNW","3":"fGpqW","4":"9Udnz","react/jsx-runtime":"2JzhG","./ActionButton":"hbuyN","./Content":"aBWEm","react-aria-components":"8nuKL","react":"jEiK2","./Dialog":"1TY9V","./DialogTrigger":"7SQlT","@react-aria/utils":"e9Yvo","../s2wf-icons/S2_Icon_HelpCircle_20_N.svg":"c8y5W","../s2wf-icons/S2_Icon_InfoCircle_20_N.svg":"1inb5","../intl/*.json":"iU6xz","../style/runtime":"dzhKB","./Popover":"3Y0dA","@react-aria/i18n":"hFrKJ","./useSpectrumContextProps":"ileU6","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"7KOlP":[function() {},{}],"a5S2q":[function() {},{}],"gySNW":[function() {},{}],"fGpqW":[function() {},{}],"9Udnz":[function() {},{}],"7SQlT":[function(require,module,exports) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * DialogTrigger serves as a wrapper around a Dialog and its associated trigger, linking the Dialog's
 * open state with the trigger's press state. Additionally, it allows you to customize the type and
 * positioning of the Dialog.
 */ parcelHelpers.export(exports, "DialogTrigger", ()=>DialogTrigger);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _dialog = require("./Dialog");
var _interactions = require("@react-aria/interactions");
function DialogTrigger(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.DialogTrigger), {
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dialog.DialogContext).Provider, {
            value: {
                type: props.type || 'modal',
                hideArrow: props.hideArrow,
                placement: props.placement,
                shouldFlip: props.shouldFlip,
                isDismissable: props.isDismissable,
                isKeyboardDismissDisabled: props.isKeyboardDismissDisabled,
                containerPadding: props.containerPadding,
                offset: props.offset,
                crossOffset: props.crossOffset
            },
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _interactions.PressResponder), {
                isPressed: false,
                children: props.children
            })
        })
    });
}
try {
    // @ts-ignore
    DialogTrigger.displayName = "DialogTrigger";
    // @ts-ignore
    DialogTrigger.__docgenInfo = {
        "description": "DialogTrigger serves as a wrapper around a Dialog and its associated trigger, linking the Dialog's\nopen state with the trigger's press state. Additionally, it allows you to customize the type and\npositioning of the Dialog.",
        "displayName": "DialogTrigger",
        "props": {
            "containerPadding": {
                "defaultValue": {
                    value: "12"
                },
                "description": "The placement padding that should be applied between the element and its\nsurrounding container.",
                "name": "containerPadding",
                "required": false,
                "type": {
                    "name": "number"
                }
            },
            "crossOffset": {
                "defaultValue": {
                    value: "0"
                },
                "description": "The additional offset applied along the cross axis between the element and its\nanchor element.",
                "name": "crossOffset",
                "required": false,
                "type": {
                    "name": "number"
                }
            },
            "defaultOpen": {
                "defaultValue": null,
                "description": "Whether the overlay is open by default (uncontrolled).",
                "name": "defaultOpen",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "hideArrow": {
                "defaultValue": null,
                "description": "Whether a popover type Dialog's arrow should be hidden.",
                "name": "hideArrow",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isDismissable": {
                "defaultValue": null,
                "description": "Whether the Dialog is dismissable.",
                "name": "isDismissable",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isKeyboardDismissDisabled": {
                "defaultValue": {
                    value: "false"
                },
                "description": "Whether pressing the escape key to close the popover should be disabled.\n\nMost popovers should not use this option. When set to true, an alternative\nway to close the popover with a keyboard must be provided.",
                "name": "isKeyboardDismissDisabled",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isOpen": {
                "defaultValue": null,
                "description": "Whether the overlay is open by default (controlled).",
                "name": "isOpen",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "offset": {
                "defaultValue": {
                    value: "8"
                },
                "description": "The additional offset applied along the main axis between the element and its\nanchor element.",
                "name": "offset",
                "required": false,
                "type": {
                    "name": "number"
                }
            },
            "placement": {
                "defaultValue": {
                    value: "'bottom'"
                },
                "description": "The placement of the element with respect to its anchor element.",
                "name": "placement",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"start\""
                        },
                        {
                            "value": "\"end\""
                        },
                        {
                            "value": "\"bottom\""
                        },
                        {
                            "value": "\"top\""
                        },
                        {
                            "value": "\"left\""
                        },
                        {
                            "value": "\"right\""
                        },
                        {
                            "value": "\"left bottom\""
                        },
                        {
                            "value": "\"left top\""
                        },
                        {
                            "value": "\"right bottom\""
                        },
                        {
                            "value": "\"right top\""
                        },
                        {
                            "value": "\"top right\""
                        },
                        {
                            "value": "\"bottom right\""
                        },
                        {
                            "value": "\"bottom left\""
                        },
                        {
                            "value": "\"bottom start\""
                        },
                        {
                            "value": "\"bottom end\""
                        },
                        {
                            "value": "\"top left\""
                        },
                        {
                            "value": "\"top start\""
                        },
                        {
                            "value": "\"top end\""
                        },
                        {
                            "value": "\"start top\""
                        },
                        {
                            "value": "\"start bottom\""
                        },
                        {
                            "value": "\"end top\""
                        },
                        {
                            "value": "\"end bottom\""
                        }
                    ]
                }
            },
            "shouldFlip": {
                "defaultValue": {
                    value: "true"
                },
                "description": "Whether the element should flip its orientation (e.g. top to bottom or left to right) when\nthere is insufficient room for it to render completely.",
                "name": "shouldFlip",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "type": {
                "defaultValue": {
                    value: "'modal'"
                },
                "description": "The type of Dialog that should be rendered.",
                "name": "type",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"modal\""
                        },
                        {
                            "value": "\"popover\""
                        },
                        {
                            "value": "\"fullscreen\""
                        },
                        {
                            "value": "\"fullscreenTakeover\""
                        }
                    ]
                }
            },
            "onOpenChange": {
                "defaultValue": null,
                "description": "Handler that is called when the overlay's open state changes.",
                "name": "onOpenChange",
                "required": false,
                "type": {
                    "name": "(isOpen: boolean) => void"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/DialogTrigger.tsx#DialogTrigger"] = {
        docgenInfo: DialogTrigger.__docgenInfo,
        name: "DialogTrigger",
        path: "packages/@react-spectrum/s2/src/DialogTrigger.tsx#DialogTrigger"
    };
} catch (__react_docgen_typescript_loader_error) {}

},{"react/jsx-runtime":"2JzhG","react-aria-components":"8nuKL","./Dialog":"1TY9V","@react-aria/interactions":"dtdXE","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"c8y5W":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M9.988 15.527c-.23.008-.455-.074-.627-.229-.33-.365-.33-.92 0-1.286.17-.158.395-.243.627-.235.236-.01.466.08.633.248.162.168.25.394.242.627.012.235-.07.466-.228.64-.174.165-.408.25-.647.235Z",
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M10 18.75c-4.825 0-8.75-3.925-8.75-8.75S5.175 1.25 10 1.25s8.75 3.925 8.75 8.75-3.925 8.75-8.75 8.75Zm0-16c-3.998 0-7.25 3.252-7.25 7.25s3.252 7.25 7.25 7.25 7.25-3.252 7.25-7.25S13.998 2.75 10 2.75Z",
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M9.992 12.706c-.414 0-.75-.336-.75-.75 0-1.022.07-1.714 1.04-2.683.784-.786.917-1.101.917-1.65 0-.21-.066-1.259-1.374-1.259-1.365 0-1.51 1.156-1.526 1.388-.027.413-.393.72-.797.7-.414-.028-.727-.385-.7-.798.064-.965.777-2.79 3.023-2.79 1.887 0 2.874 1.388 2.874 2.758 0 1.144-.457 1.81-1.357 2.712-.576.576-.6.811-.6 1.622 0 .414-.336.75-.75.75Z",
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef, (0, _icon.IconContext));

},{"react/jsx-runtime":"2JzhG","~/src/Icon":"1OC2a","react":"jEiK2","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"1inb5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M10 18.75c-4.825 0-8.75-3.925-8.75-8.75S5.175 1.25 10 1.25s8.75 3.925 8.75 8.75-3.925 8.75-8.75 8.75Zm0-16c-3.998 0-7.25 3.252-7.25 7.25s3.252 7.25 7.25 7.25 7.25-3.252 7.25-7.25S13.998 2.75 10 2.75Z",
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M10 5.26c.231-.008.456.074.627.229.33.365.33.921 0 1.286-.17.159-.395.243-.626.235-.237.01-.466-.08-.633-.248-.162-.168-.25-.394-.242-.627-.012-.235.07-.465.228-.64.174-.164.408-.25.647-.235ZM10 15.063c-.414 0-.75-.336-.75-.75V9.477c0-.415.336-.75.75-.75s.75.335.75.75v4.835c0 .414-.336.75-.75.75Z",
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef, (0, _icon.IconContext));

},{"react/jsx-runtime":"2JzhG","~/src/Icon":"1OC2a","react":"jEiK2","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}]},[], null, "parcelRequire94c2")

//# sourceMappingURL=Illustrations.9abcbb8d.js.map
